const messagesEN = {
    code: "en",
    messages: {
        cache: {
            management: "Cache Management",
            createNew: "Create New Cache",
            keySearchPlaceholder: "Search key (wildcard supported: *chat*, chat*, *chat)",
            type: "Cache Type",
            actorType: "Actor Type",
            selectAutomation: "Select Automation",
            selectChatbot: "Select Chatbot",
            selectUser: "Select User",
            clearFilters: "Clear Filters",
            deleteSelected: "Delete Selected",
            extendSelected: "Extend Selected Duration",
            makeSelectedNeverExpire: "Make Selected Never Expire",
            deleteAllActorCaches: "Delete All Caches of This Actor",
            emptyState: "No cache found yet",
            editCache: "Edit Cache",
            key: "Cache Key",
            keyPlaceholder: "Example: user_session_123",
            value: "Cache Value",
            stringValuePlaceholder: "String value",
            dataType: "Data Type",
            validityDuration: "Validity Duration",
            neverExpire: "Never expire",
            specifyDuration: "Specify duration",
            specifyDate: "Specify date",
            minutes: "Minutes",
            hours: "Hours",
            days: "Days",
            update: "Update",
            create: "Create",
            bulkExtend: "Bulk Extend Duration",
            bulkExtendInfo: "Validity duration of {count} cache(s) will be extended.",
            newValidityDuration: "New Validity Duration",
            extend: "Extend",
            keyLabel: "Key",
            valueLabel: "Value",
            typeLabel: "Type",
            createdBy: "Created By",
            createdAt: "Created At",
            updatedBy: "Updated By",
            expiresAt: "Expires At",
            actions: "Actions",
            edit: "Edit",
            extendDuration: "Extend Duration",
            makeNeverExpire: "Make Never Expire",
            loadError: "Failed to load cache list",
            updateSuccess: "Cache updated",
            createSuccess: "Cache created",
            saveError: "Failed to save cache",
            deleteCache: "Delete Cache",
            confirmDelete: "Yes, Delete",
            deleteSuccess: "Cache deleted",
            extendSuccess24h: "Cache duration extended by 24 hours",
            extendError: "Failed to extend cache duration",
            deleteActorCaches: "Delete Actor Caches",
            deleteActorCachesConfirm:
                'Are you sure you want to delete all caches of "{actor}"? This action cannot be undone.',
            confirmDeleteAll: "Yes, Delete All",
            countDeleted: "{count} cache(s) deleted",
            bulkDelete: "Bulk Delete",
            bulkDeleteConfirm: "{count} cache(s) will be deleted. Are you sure?",
            bulkMakeNeverExpire: "Bulk Make Never Expire",
            bulkMakeNeverExpireConfirm: "Expiration will be removed from {count} cache(s). Are you sure?",
            makeNeverExpireSuccess: "Cache set to never expire",
            makeNeverExpireError: "Failed to make cache never expire",
            bulkExtendError: "Failed to extend cache durations",
            bulkExtendSuccess: "{count} cache duration(s) extended",
            bulkMakeNeverExpireSuccess: "{count} cache(s) set to never expire",
            deleteCacheConfirm: 'Are you sure you want to delete cache "{key}"?',
            selectedCount: "{count} cache(s) selected",
            valueTitle: "Cache Value: {key}",
            never: "Never",
            automation: "Automation",
            chatbot: "Chatbot",
            user: "User",
            api: "API",
            all: "All",
            public: "Public",
            private: "Private",
        },
        common: {
            cancel: "Cancel",
            save: "Save",
            yes: "Yes",
            no: "No",
            create: "Create",
            delete: "Delete",
            edit: "Edit",
            add: "Add",
            back: "Back",
            active: "Active",
            inactive: "Inactive",
        },
        zoho: {
            SETTING_GROUP: "Settings",
            usermapping: "User Mapping",
        },
        youtubeChannel: {
            youtubeIntegration: "YouTube Integration",
            deleteYoutubeChannelInfo: "Are you sure you want to delete this YouTube channel?",
            youtubeChannels: "YouTube Channels",
            title: "YouTube Comments",
            channelName: "Channel Name",
            channelDetail: "Channel Detail",
            channelDetailDesc: "Manage your YouTube channel",
            youtubeChannel: "YouTube Channel",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            detail: "Detail",
            visibility: "Visibility",
            videos: "Videos",
            comments: "Comments",
            visibilitySettings: "Visibility Settings",
            visibilityDescription: "Set which users and departments can see this channel",
            users: "Users",
            departments: "Departments",
            owners: "Owners",
            selectUsers: "Select users",
            selectDepartments: "Select departments",
            selectOwners: "Select owners",
            deleteChannel: "Delete Channel",
            deleteChannelDescription: "Are you sure you want to delete this YouTube channel?",
            channelUpdatedSuccess: "Channel updated successfully",
            failedUpdateChannel: "Failed to update channel",
            connectedSuccess: "YouTube account connected successfully",
            failedToCreateChannel: "Failed to create channel",
            requiredChannel: "Channel name is required",
            oauthTimeout: "Authorization timed out",
            all: "All",
            new: "New",
            replied: "Replied",
            resolved: "Resolved",
            searchComments: "Search comments",
            noCommentsFound: "No comments found",
            replies: "replies",
            like: "Like",
            reply: "Reply",
            replyToComment: "Reply to Comment",
            writeYourReply: "Write your reply",
            pleaseEnterReply: "Please enter a reply",
            replySuccess: "Reply sent successfully",
            errorSendingReply: "Error sending reply",
            statusUpdated: "Status updated",
            errorUpdatingStatus: "Error updating status",
            errorFetchingComments: "Error fetching comments",
            commentLiked: "Comment liked",
            errorLikingComment: "Error liking comment",
            noVideosFound: "No videos found",
            errorFetchingVideos: "Error fetching videos",
            refresh: "Refresh",
            loadMore: "Load More",
            ensureYouTubeAccount: "Make sure you have a Google/YouTube account",
            ensureYouTubeChannel: "Make sure you have a YouTube channel",
            permissionDesc: "You need to allow Supsis to access your YouTube comments.",
            connectToYouTube: "Connect to YouTube",
            views: "views",
            likes: "likes",
            sync: "Sync",
            commentsSynced: "Comments synced",
            errorSyncingComments: "Error syncing comments",
            pending: "Pending",
            rejected: "Rejected",
            moderation: "Moderation",
            publish: "Publish",
            holdForReview: "Hold for Review",
            reject: "Reject",
            rejectAndBan: "Reject and Ban",
            moderationSuccess: "Moderation successful",
            errorModeration: "Moderation failed",
            videoDetail: "Video Detail",
            duration: "Duration",
            showMore: "Show more",
            showLess: "Show less",
            loadingVideo: "Loading video...",
            videoNotFound: "Video not found",
            goBack: "Go Back",
            errorLoadingVideo: "Error loading video",
            videosSynced: "Videos synced",
            errorSyncingVideos: "Error syncing videos",
            selectVideo: "Select video",
            allVideos: "All Videos",
            selectCommentToPreview: "Select a comment to preview",
            viewDetails: "View Details",
            published: "Published",
            heldForReview: "Held for Review",
        },
        googleBusiness: {
            title: "Google Business Reviews",
            channels: "Google Business Channels",
            channelName: "Channel Name",
            channelDetails: "Channel Details",
            connectToGoogleBusiness: "Connect to Google Business",
            ensureGoogleAccount: "Make sure you have a Google account",
            ensureBusinessProfile: "Make sure you have a Google Business Profile account",
            permissionDesc: "You need to allow Supsis to access your Google Business reviews.",
            requiredChannel: "Channel name is required",
            failedToCreateChannel: "Failed to create channel",
            connectedSuccess: "Google Business account connected successfully",
            oauthTimeout: "Authorization timed out",
            deleteChannelInfo: "Are you sure you want to delete this Google Business channel?",
            deleteChannel: "Delete Channel",
            deleteChannelDescription: "Are you sure you want to delete this Google Business channel?",
            detail: "Detail",
            visibility: "Visibility",
            locations: "Locations",
            reviews: "Reviews",
            accountInfo: "Account Information",
            accountName: "Account Name",
            accountId: "Account ID",
            status: "Status",
            enabled: "Enabled",
            disabled: "Disabled",
            save: "Save",
            channelUpdated: "Channel updated successfully",
            errorUpdatingChannel: "Error updating channel",
            visibilityDescription: "Set which users and departments can see this channel",
            visibleToUsers: "Visible to Users",
            visibleToDepartments: "Visible to Departments",
            selectUsers: "Select users",
            selectDepartments: "Select departments",
            visibilityUpdated: "Visibility settings updated",
            errorUpdatingVisibility: "Error updating visibility settings",
            sync: "Sync",
            refresh: "Refresh",
            locationsSynced: "Locations synced",
            errorSyncingLocations: "Error syncing locations",
            errorFetchingLocations: "Error fetching locations",
            noLocationsFound: "No locations found",
            selectLocation: "Select location",
            allLocations: "All Locations",
            allRatings: "All Ratings",
            all: "All",
            new: "New",
            replied: "Replied",
            resolved: "Resolved",
            noReviewsFound: "No reviews found",
            noComment: "No comment text",
            selectReviewToPreview: "Select a review to preview",
            yourReply: "Your Reply",
            reply: "Reply",
            updateReply: "Update Reply",
            replyToReview: "Reply to Review",
            writeYourReply: "Write your reply",
            pleaseEnterReply: "Please enter a reply",
            replySuccess: "Reply sent successfully",
            errorSendingReply: "Error sending reply",
            statusUpdated: "Status updated",
            errorUpdatingStatus: "Error updating status",
            errorFetchingReviews: "Error fetching reviews",
        },
        googlePlay: {
            title: "Google Play Reviews",
            channels: "Google Play Channels",
            channelName: "Channel Name",
            channelDetails: "Channel Details",
            connectToGooglePlay: "Connect to Google Play",
            ensureGoogleAccount: "Make sure you have a Google account",
            ensurePlayConsole: "Make sure you have a Google Play Console account",
            permissionDesc: "You need to allow Supsis to access your Google Play reviews.",
            requiredChannel: "Channel name is required",
            failedToCreateChannel: "Failed to create channel",
            connectedSuccess: "Google Play account connected successfully",
            oauthTimeout: "Authorization timed out",
            deleteChannelInfo: "Are you sure you want to delete this Google Play channel?",
            deleteChannel: "Delete Channel",
            deleteChannelDescription: "Are you sure you want to delete this Google Play channel?",
            detail: "Detail",
            visibility: "Visibility",
            apps: "Apps",
            reviews: "Reviews",
            status: "Status",
            enabled: "Enabled",
            disabled: "Disabled",
            save: "Save",
            channelUpdated: "Channel updated successfully",
            errorUpdatingChannel: "Error updating channel",
            visibilityDescription: "Set which users and departments can see this channel",
            visibleToUsers: "Visible to Users",
            visibleToDepartments: "Visible to Departments",
            selectUsers: "Select users",
            selectDepartments: "Select departments",
            visibilityUpdated: "Visibility settings updated",
            errorUpdatingVisibility: "Error updating visibility settings",
            addApp: "Add App",
            refresh: "Refresh",
            noAppsFound: "No apps found",
            packageName: "Package Name",
            appName: "App Name",
            appNamePlaceholder: "E.g: My App",
            iconUrl: "Icon URL",
            fillRequiredFields: "Please fill in the required fields",
            appAdded: "App added successfully",
            errorAddingApp: "Error adding app",
            syncReviews: "Sync Reviews",
            reviewsSynced: "Reviews synced",
            errorSyncingReviews: "Error syncing reviews",
            removeApp: "Remove App",
            removeAppConfirm: "Are you sure you want to remove {name}? All related reviews will also be deleted.",
            appRemoved: "App removed",
            errorRemovingApp: "Error removing app",
            errorFetchingApps: "Error fetching apps",
            selectApp: "Select app",
            allApps: "All Apps",
            allRatings: "All Ratings",
            all: "All",
            new: "New",
            replied: "Replied",
            resolved: "Resolved",
            noReviewsFound: "No reviews found",
            noComment: "No comment text",
            selectReviewToPreview: "Select a review to preview",
            yourReply: "Your Reply",
            reply: "Reply",
            updateReply: "Update Reply",
            replyToReview: "Reply to Review",
            writeYourReply: "Write your reply (max 350 characters)",
            pleaseEnterReply: "Please enter a reply",
            replyTooLong: "Reply cannot exceed 350 characters",
            replySuccess: "Reply sent successfully",
            errorSendingReply: "Error sending reply",
            statusUpdated: "Status updated",
            errorUpdatingStatus: "Error updating status",
            errorFetchingReviews: "Error fetching reviews",
            deviceInfo: "Device Information",
            device: "Device",
            appVersion: "App Version",
            manufacturer: "Manufacturer",
        },
        googleDrive: {
            title: "Google Drive",
            googleDriveChannels: "Google Drive Channels",
            googleDriveIntegration: "Google Drive Integration",
            channelName: "Channel Name",
            channelInfo: "Channel Info",
            channelSettings: "Channel Settings",
            connectedAccount: "Connected Account",
            storageQuota: "Storage Quota",
            connectToGoogleDrive: "Connect to Google Drive",
            ensureGoogleAccount: "Make sure you have a Google account",
            ensureGoogleDriveAccess: "Make sure you have Google Drive access",
            permissionDesc: "You need to allow Supsis to access your Google Drive files.",
            requiredChannel: "Channel name is required",
            failedToCreateChannel: "Failed to create channel",
            connectedSuccess: "Google Drive account connected successfully",
            oauthTimeout: "Authorization timed out",
            deleteGoogleDriveChannelInfo: "Are you sure you want to delete this Google Drive channel?",
            deleteChannel: "Delete Channel",
            deleteChannelDescription: "Are you sure you want to delete this Google Drive channel?",
            driveExplorer: "Drive Explorer",
            myDrive: "My Drive",
            sharedDrives: "Shared Drives",
            searchFiles: "Search files...",
            noSharedDrives: "No shared drives found",
            noFiles: "No files found",
            loadMore: "Load More",
            filesSelected: "files selected",
            downloadToSupsis: "Download to Supsis",
            fileDownloaded: "File downloaded successfully",
            errorLoadingFiles: "Error loading files",
            errorLoadingDrives: "Error loading drives",
            errorSearching: "Error searching",
            errorDownloading: "Error downloading file",
            fileName: "File Name",
            fileSize: "Size",
            modifiedTime: "Modified Time",
            selectFile: "Select File",
            selectFileFromGoogleDrive: "Select file from Google Drive",
            selectChannel: "Select Channel",
            noChannelsAvailable: "No accessible Google Drive channels found",
            selectedFiles: "Selected Files",
            upload: "Upload",
            selectUploadMethod: "Select upload method:",
            uploadFromComputer: "Upload from Computer",
            downloadingFiles: "Downloading files...",
            myChannel: "Mine",
            manageWhoCanAccess: "Manage who can access this channel",
            download: "Download",
            openInNewTab: "Open in New Tab",
            openInGoogleDrive: "Open in Google Drive",
            fileType: "File Type",
            owner: "Owner",
            previewNotAvailable: "Preview not available for this file type",
            byocTitle: "Use Your Own Google Cloud Credentials",
            byocDescription:
                "For Google Drive integration, you need to create OAuth client credentials from your own Google Cloud Console.",
            clientId: "OAuth Client ID",
            clientIdPlaceholder: "xxxxxxxx.apps.googleusercontent.com",
            clientIdRequired: "Client ID is required",
            clientSecret: "OAuth Client Secret",
            clientSecretPlaceholder: "GOCSPX-xxxxxxxxxx",
            clientSecretRequired: "Client Secret is required",
            redirectUriCopied: "Redirect URI copied",
            setupGuideTitle: "Setup Guide (click to expand)",
            setupStep1: "Go to Google Cloud Console and create a new project or select an existing one.",
            setupStep2: "Navigate to APIs & Services > Credentials section.",
            setupStep3:
                'Click "+ CREATE CREDENTIALS" > "OAuth client ID". Select "Web application" as the application type.',
            setupStep4: "Add the following URL to the Authorized redirect URIs section:",
            setupStep5: 'Enable "Google Drive API" from APIs & Services > Library.',
            setupStep6: "Copy the Client ID and Client Secret values and paste them in the fields above.",
        },
        appStore: {
            title: "App Store Reviews",
            channels: "App Store Channels",
            channelName: "Channel Name",
            channelDetails: "Channel Details",
            connectToAppStore: "Connect to App Store",
            credentials: "API Credentials",
            credentialsHelp: "Enter your App Store Connect API credentials. You can create an API key from",
            issuerId: "Issuer ID",
            issuerIdPlaceholder: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
            keyId: "Key ID",
            keyIdPlaceholder: "XXXXXXXXXX",
            privateKey: "Private Key (.p8 file content)",
            privateKeyPlaceholder: "-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----",
            requiredField: "This field is required",
            validateCredentials: "Validate Credentials",
            credentialsValid: "Credentials are valid",
            credentialsInvalid: "Invalid credentials",
            pleaseValidateFirst: "Please validate your credentials first",
            failedToCreateChannel: "Failed to create channel",
            connectedSuccess: "App Store account connected successfully",
            deleteChannelInfo: "Are you sure you want to delete this App Store channel?",
            deleteChannel: "Delete Channel",
            deleteChannelDescription: "Are you sure you want to delete this App Store channel?",
            detail: "Detail",
            visibility: "Visibility",
            apps: "Apps",
            reviews: "Reviews",
            status: "Status",
            enabled: "Enabled",
            disabled: "Disabled",
            save: "Save",
            channelUpdated: "Channel updated successfully",
            errorUpdatingChannel: "Error updating channel",
            visibilityDescription: "Set which users and departments can see this channel",
            visibleToUsers: "Visible to Users",
            visibleToDepartments: "Visible to Departments",
            selectUsers: "Select users",
            selectDepartments: "Select departments",
            visibilityUpdated: "Visibility settings updated",
            errorUpdatingVisibility: "Error updating visibility settings",
            syncApps: "Sync Apps",
            refresh: "Refresh",
            noAppsFound: "No apps found",
            appsAutoFetch:
                "Apps are automatically fetched from App Store Connect. Click 'Sync Apps' to refresh the list.",
            appsSynced: "Apps synced successfully",
            errorSyncingApps: "Error syncing apps",
            syncReviews: "Sync Reviews",
            reviewsSynced: "Reviews synced",
            errorSyncingReviews: "Error syncing reviews",
            errorFetchingApps: "Error fetching apps",
            selectApp: "Select app",
            allApps: "All Apps",
            all: "All",
            new: "New",
            replied: "Replied",
            resolved: "Resolved",
            noReviewsFound: "No reviews found",
            noComment: "No comment text",
            anonymous: "Anonymous",
            selectReviewToPreview: "Select a review to preview",
            yourReply: "Your Reply",
            reply: "Reply",
            edit: "Edit",
            delete: "Delete",
            editReply: "Edit Reply",
            replyToReview: "Reply to Review",
            writeYourReply: "Write your reply",
            pleaseEnterReply: "Please enter a reply",
            replySuccess: "Reply sent successfully",
            errorSendingReply: "Error sending reply",
            deleteResponse: "Delete Response",
            deleteResponseConfirm: "Are you sure you want to delete this response?",
            responseDeleted: "Response deleted successfully",
            errorDeletingResponse: "Error deleting response",
            statusUpdated: "Status updated",
            errorUpdatingStatus: "Error updating status",
            errorFetchingReviews: "Error fetching reviews",
            territory: "Territory",
            region: "Region",
        },
        chatWindow: {
            descending: "Descending",
            ascending: "Ascending",
            filterTable: "Filter",
            switchToLiveSupportMode: "Switch to Live Support Mode",
            switchToLiveSupportModeConfirmation: "Do you want to switch to live support mode to view this contact?",
            thereIsNoChatContent: "No chat content available.",
            thereIsNoChatContentDsc: "You can view the chat content and send messages here.",
            interactions: "Interactions:",
            departments: "Departments",
            channels: "Channels",
            date: "Date",
            lastChatStatus: "Last Chat Status",
            all: "All",
            queued: "Queued",
            open: "Open",
            closed: "Closed",
            private: "Private",
            chatbot: "Chatbot",
            lostMissed: "Lost / Missed",
            interaction: "Interaction",
            myActiveInbox: "My Active Inbox",
            activeQueueInbox: "Active + Queue Inbox",
            chatbotActiveInbox: "Chatbot Active Inbox",
            myDepartmentsActiveInbox: "My Departments Active Inbox",
            notInteractedYesterday: "No interactions yesterday",
            queueInbox: "Queue Inbox",
            whatsappActiveInbox: "WhatsApp Active Inbox",
            socialMediaActiveInbox: "Social Media Active Inbox",
            missedThisMonth: "Missed Chats This Month",
            chooseAFileOrDragItHere: "Choose a file or drag it here!",
            watching: "Watching",
            selectFilter: "Select Filter",
            clearAll: "Clear All",
            me: "Me",
            today: "Today",
            yesterday: "Yesterday",
            thisWeek: "This Week",
            lastWeek: "Last Week",
            last7Days: "Last 7 Days",
            last30Days: "Last 30 Days",
            thisMonth: "This Month",
            lastMonth: "Last Month",
            last24h: "Last 24 Hours",
            custom: "Custom",
            startMessage: "Start Message",
            goToAgentReport: "Go to Agent Report",
            agentDetail: "Agent Detail",
            agentList: "Agent List",
            selectedFilter: "Selected Filter",
            groupBy: "Group",
            owner: "Owner",
            none: "No Group",
            agent: "Agent",
            department: "Department",
            tag: "Tag",
            website: "Website",
            channel: "Channel",
            platform: "Platform",
            answerStatus: "Answer Status",
            sortBy: "Sort",
            lastPostAbove: "Last Post Above",
            newChatsAbove: "New Chats Above",
            oldChatsAbove: "Old Chats Above",
            live: "Live",
            systemStatus: "System Status",
            refresh: "Refresh",
            close: "Close",
            totalCustomers: "Total Customers",
            totalAnswered: "Total Answered",
            waitingAnswer: "Waiting Answer",
            totalAgentInChat: "Total Agent In Chat",
            onlineAgentCount: "Online Agent Count",
            totalCustomer: "Total Customer",
            answered: "Answered",
            unanswered: "Unanswered",
            noContactWasFoundMatchingTheCurrentFilters: "No contact was found matching the current filters.",
            you: "You",
            others: "Others",
            queue: "Queue",
            chatbotContact: "Chatbot",
            closedContact: "Closed",
            myInteractions: "My Interactions",
            special: "Custom",
            allInteractions: "All Contacts",
            waiting: "Waiting",
            departmentToWhichItIsAffiliated: "Department to which it is affiliated",
            hiddenChatsWarning: "There are {count} chats you cannot see in this list",
            clickToSeeDetails: "Click to see details",
            viewDetails: "View Details",
            hiddenChatsDetails: "Hidden Chats Details",
            totalHiddenChats: "Total Hidden Chats",
            examples: "Examples",
            reasons: {
                visitorNotFound: "Visitor not found",
                noChannelAccess: "You don't have access to this channel",
                ownedByOtherNotChannelOwner: "Owned by another user (You are not the channel owner)",
                ownedByOtherNoChannel: "Owned by another user (No channel)",
                noOwnerAdminOnly: "No owner chat (Only admins and channel owners can see)",
            },
        },
        chat: {
            inbox: "Inbox",
            layouts: {
                chat: "Chat Layout",
                table: "Table Layout",
                kanban: "Kanban Layout",
            },
            filters: {
                allContacts: "All Contacts",
                myInbox: "My Inbox",
                myContacts: "My Contacts",
                missed: "Missed",
                unanswered: "Unanswered",
                unassigned: "Unassigned",
                chatbot: "Chatbot",
            },
            groups: {
                views: "Views",
                customFilters: "Custom Filters",
                team: "Team",
                contacts: "Contacts",
                system: "System",
            },
            sidebar: {
                tabScreen: "Tab Screen",
                search: "Search",
                addNewFilter: "Add new filter",
                edit: "Edit",
                showInTable: "Show in Table Mode",
                showInKanban: "Show in Kanban Mode",
                rename: "Rename",
                makePublic: "Make Public",
                makePrivate: "Make Private",
                moveToTop: "Move to Top",
                moveToBottom: "Move to Bottom",
                delete: "Delete",
                renameFilterTitle: "Rename Filter",
                filterNamePlaceholder: "Enter filter name",
                positionUpdateError: "Error updating position",
                filterNameEmpty: "Filter name cannot be empty",
                filterNameUpdated: "Filter name updated",
                filterNameUpdateError: "Error updating filter name",
                filterVisibilityUpdateError: "Error updating filter visibility",
                filterMadePrivate: "Filter set to private",
                filterMadePublic: "Filter set to public",
                filterMovedToTop: "Filter moved to top",
                filterMovedToBottom: "Filter moved to bottom",
                filterMoveError: "Error moving filter",
                onlyCreatorOrRootCanDeletePublic: "Only the creator or root user can delete public filters",
                deleteFilterTitle: "Delete Filter",
                deleteFilterConfirm: 'Are you sure you want to delete the filter "{name}"?',
                deleteFilterOk: "Delete",
                deleteFilterCancel: "Cancel",
                filterDeleted: "Filter deleted",
                filterDeleteError: "Error deleting filter",
                websiteAnalytics: "Website Analytics",
            },
            gridContactList: {
                emptyConversationsTitle: "No Chat Found",
                emptyConversationsDescription:
                    "You don't have an active chat yet. You can start a new chat from the customer page.",
                markAsUnanswered: "Mark as Unanswered",
                markAsAnswered: "Mark as Answered",
                removeVIP: "Remove VIP",
                markAsVIP: "Mark as VIP",
                markAsRead: "Mark as Read",
                markAsUnread: "Mark as Unread",
                closeChat: "Close Chat",
                markedAsAnswered: "Marked as answered",
                markedAsUnanswered: "Marked as unanswered",
                operationFailed: "Operation failed",
                markedAsVIP: "Marked as VIP",
                vipRemoved: "VIP removed",
                markedAsUnread: "Marked as unread",
                markedAsRead: "Marked as read",
                confirmCloseChat: "Are you sure you want to end the chat?",
                chatClosed: "Chat closed",
            },
            tableContactList: {
                editFilter: "Edit Filter",
                chatStatus: "Chat Status",
                grouping: "Grouping",
                allContacts: "All Contacts",
                groupNone: "None",
                groupTag: "Tag",
                groupDepartment: "Department",
                groupChannel: "Channel",
                groupPlatform: "Platform",
                groupOwner: "Owner",
                groupUsers: "Participants",
                groupAnswerStatus: "Answer Status",
                statusAll: "All",
                statusOpen: "Open",
                statusClosed: "Closed",
                statusUnknown: "Unknown",
                copyLabel: "Copy",
                filterCreatedSuccess: "Filter created successfully",
                filterCreatedNameDuplicate:
                    'Name "{createName}" was already in use. Filter was created as "{filterName}".',
                filterCreateFailed: "Filter could not be created",
                filterCreateError: "An error occurred while creating the filter.",
                platformSupsis: "Supsis",
                platformEmail: "Email",
                platformWhatsapp: "WhatsApp",
                platformWeb: "Web",
                platformInstagram: "Instagram",
                platformTelegram: "Telegram",
                platformMessenger: "Messenger",
                platformMetaLeads: "Meta Leads",
                platformTrendyol: "Trendyol",
                platformLinkedin: "LinkedIn",
                answerStatusAnswered: "Answered",
                answerStatusUnanswered: "Unanswered",
            },
            kanbanContactList: {
                filterHide: "Hide Filters",
                filterAdd: "Add Filter",
                broadcast: "Broadcast",
                broadcastSelectPlaceholder: "Select broadcast...",
                loading: "Loading...",
                broadcastNotFound: "No broadcast found",
                broadcastTitle: "Title",
                broadcastDate: "Date",
                broadcastStatus: "Status",
                broadcastProgress: "Progress",
                refresh: "Refresh",
                kanbanLoading: "Loading Kanban...",
                deletedUser: "Deleted User",
                unowned: "Unowned",
                activeInChat: "Active (In Chat)",
                newInQueue: "New (In Queue)",
                agentDown: "Agent Down",
                closed: "Closed",
                blocked: "Blocked",
                unblocked: "Unblocked",
                groupsLoadError: "Error loading groups",
                dataLoadError: "Error loading data",
                broadcastsLoadError: "Error loading broadcasts",
                dataRefreshed: "Data refreshed",
                refreshError: "Error during refresh",
                unknownContact: "Unknown Contact",
                assigned: "Unassigned",
                platformMobile: "Mobile",
                broadcastStatusCreated: "Created",
                broadcastStatusScheduled: "Scheduled",
                broadcastStatusQueued: "Queued",
                broadcastStatusRunning: "Sending",
                broadcastStatusCompleted: "Completed",
                broadcastStatusFailed: "Failed",
                broadcastStatusCancelled: "Cancelled",
                metaLeadNewLead: "New Lead",
                metaLeadInitialContact: "Initial Contact",
                metaLeadNeedsAssessment: "Needs Assessment",
                metaLeadProposalSent: "Proposal Sent",
                metaLeadProposalReview: "Proposal Review",
                metaLeadNegotiation: "Negotiation",
                metaLeadDecisionStage: "Decision Stage",
                metaLeadClosure: "Closure",
                metaLeadFollowUp: "Follow Up",
                broadcastSent: "Sent",
                broadcastDelivered: "Delivered",
                broadcastRead: "Read",
                broadcastFailed: "Failed",
                broadcastEdited: "Edited",
                broadcastDeleted: "Deleted",
                triggerTypeApi: "API",
                triggerTypeBroadcast: "Broadcast",
                triggerTypeAutomation: "Automation",
                emptyGroup: "No contacts in this group",
                loadMore: "Load more...",
                groupSelectTitle: "Select Grouping Field",
                searchPlaceholder: "Search...",
                categoryBasic: "Basic",
                categoryDemographic: "Demographic",
                categoryTags: "Tags & Category",
                categoryMeta: "Meta Leads",
                categoryBroadcast: "Broadcast",
                categoryOther: "Other",
                fieldAnswerStatus: "Answer Status",
                fieldLastConversationStatus: "Chat Status",
                fieldOwner: "Owner",
                fieldUsers: "Participants",
                fieldChannel: "Channel",
                fieldPlatform: "Platform",
                fieldCountry: "Country",
                fieldCity: "City",
                fieldBrowser: "Browser",
                fieldPreferredLang: "Language",
                fieldTags: "Tags",
                fieldDepartment: "Department",
                fieldMetaLeadStatus: "Lead Status",
                fieldMetaLeadAdName: "Ad Name",
                fieldMetaLeadAdsetName: "Ad Set",
                fieldMetaLeadCampaignName: "Campaign",
                fieldMetaLeadFormName: "Form Name",
                fieldMetaLeadPlatform: "Meta Platform",
                fieldLastBroadcastStatus: "Broadcast Status",
                fieldLastBroadcastReason: "Broadcast Reason",
                fieldBlockedSnapshot: "Block Status",
                fieldLastTriggerType: "Trigger Type",
                fieldZohoLeadStatus: "Zoho Lead Status",
                fieldZohoLeadSource: "Zoho Lead Source",
                broadcastTriggerSuccess: "Replied to broadcast message!",
                broadcastTriggerWaiting: "Waiting for response...",
                unknownUser: "Unknown User",
                unread: "Unread",
                platformIg: "Instagram",
                platformFb: "Facebook",
            },
            gridContactListToolBar: {
                chatStatus: "Chat Status",
                sortBy: "Sort By",
                all: "All",
                open: "Open",
                closed: "Closed",
                allStatus: "All",
                lastActivity: "Last Activity",
                createdAt: "Created At",
                unknown: "Unknown",
            },
            chatCloseSettings: {
                selectPhone: "Select Phone",
                selectPhoneDescription: "Which phone do you want to call {number} with?",
                call: "Call",
                unnamedChannel: "Unnamed Channel",
                typeVisitorName: "Type visitor name...",
                webphoneCall: "Call with Webphone",
                hideSystemMessages: "Hide System Messages",
                chatbotDebugMode: "Chatbot Debug Mode",
                createTask: "Create Task",
                showProfile: "Show Profile",
                sendCapiEvent: "Send CAPI Event",
                noPhoneNumber: "No phone number found to call",
                noWebphoneChannel: "No webphone channel found",
                webphoneCalling: "Calling {number} with Webphone...",
                unknown: "Unknown",
                channelTypeKirmiziSantral: "Red Central",
                channelTypeTelnyx: "Telnyx",
                channelTypeNetgsm: "NetGSM",
                channelTypeWebPhone: "Web Phone",
                platformWeb: "Web",
                platformWhatsapp: "WhatsApp",
                platformWhatsappBusiness: "WhatsApp Business",
                platformInstagram: "Instagram",
                platformInstagramV2: "Instagram V2",
                platformMessenger: "Messenger",
                platformTelegram: "Telegram",
                platformTrendyol: "Trendyol",
                platformEmail: "Email",
                platformSms: "SMS",
                vipCustomerTooltip: "★ VIP Customer",
            },
            contactDetail: {
                removeVIPTooltip: "Remove VIP",
                markAsVIPTooltip: "Mark as VIP (VIP marked users will always be displayed at the top in chats).",
                customerOwnership: "Customer Ownership",
                ownershipDescription: "When customer ownership is assigned, only the owner and full admins can see it",
                unowned: "Unowned",
                assignToMe: "Assign to Me",
                removeOwnership: "Remove Ownership",
                dragPlaceholder: "Move here",
                currentConversationDepartment: "Current Conversation Department",
                pastInteractionDepartments: "Past Interaction Departments",
                createdAt: "Created At",
                updatedAt: "Updated At",
                zohoSync: "Zoho Synchronization",
                zohoSyncQuestion: "Do you want to perform contact change operations in Zoho as well?",
                basicInfo: "Contact Information",
                loginInfo: "Contact Form Information",
                profileFields: "Profile Fields",
                systemInfo: "System Information",
            },
            contactDetailItem: {
                removeOwnership: "Remove Ownership",
                assignOwnershipToMe: "Assign Ownership to Me",
                vipCustomer: "VIP Customer",
                contentCopiedSuccess: "Content copied successfully!",
                invalidEmail: "Invalid email address!",
                invalidValue: "Invalid value!",
            },
            filtersSection: {
                addFilter: "Add Filter",
                all: "All",
                open: "Open",
                closed: "Closed",
                relevance: "Relevance",
                lastActivityNewest: "Newest Activity",
                lastActivityOldest: "Oldest Activity",
                noParticipant: "No Participant",
                ownershipFilter: "Ownership Filter",
                metaReferral: "Meta Referral",
                userStatus: "User Status",
                unowned: "Unowned",
                fromAds: "From Ads",
                notFromAds: "Not From Ads",
                blockedUsers: "Blocked Users",
                unblockedUsers: "Unblocked Users",
                unread: "Unread",
                read: "Read",
                yes: "Yes",
                no: "No",
                answered: "Answered",
                unanswered: "Unanswered",
                active: "Active",
                lost: "Lost",
                new: "New",
                chatbot: "Chatbot",
                closedStatus: "Closed",
                platform: "Platform",
                channel: "Channel",
                department: "Department",
                tag: "Tag",
                participant: "Participant",
                ownership: "Ownership",
                lastActivityTime: "Last Activity Time",
                fullName: "Full Name",
                email: "Email",
                phone: "Phone",
                vipCustomer: "VIP Customer",
                hasVIP: "Has VIP",
                noVIP: "No VIP",
                operatingSystem: "Operating System",
                browser: "Browser",
                ipAddress: "IP Address",
                visitingPage: "Visiting Page",
                adInteraction: "Ad Interaction",
                blockedStatus: "Blocked Status",
                connectionTime: "Connection Time",
                createdAt: "Created At",
                updatedAt: "Updated At",
                readStatus: "Read Status",
                missedChat: "Missed Chat",
                answerStatus: "Answer Status",
                lastConversationStatus: "Last Conversation Status",
                lastTriggerState: "Last Trigger State",
                type: "Type",
                name: "Name",
                enterTriggerName: "Enter trigger name...",
                zohoInfo: "Zoho Info",
                id: "ID",
                enterContactOrLeadId: "Enter Contact or Lead ID...",
                broadcastMessage: "Broadcast Message",
                today: "Today",
                yesterday: "Yesterday",
                thisWeek: "This Week",
                lastWeek: "Last Week",
                last7Days: "Last 7 Days",
                last30Days: "Last 30 Days",
                thisMonth: "This Month",
                lastMonth: "Last Month",
            },
            filterChip: {
                operator: "Operator:",
                enterText: "Enter text...",
                enterNumber: "Enter number...",
                type: "Type",
                value: "Value",
                enterValue: "Enter value...",
                addFilter: "Add Filter",
                equals: "Equals",
                contains: "Contains",
                startsWith: "Starts With",
                endsWith: "Ends With",
                greaterThan: "Greater Than",
                lessThan: "Less Than",
                greaterThanOrEqual: "Greater Than Or Equal",
                lessThanOrEqual: "Less Than Or Equal",
                between: "Between",
                custom: "Custom",
                select: "Select",
            },
            filterPanel: {
                backToChat: "Back to Chat View",
                publicFilter: "Public Filter",
                privateFilter: "Private Filter",
                editFilterName: "Edit Filter Name",
                contactsFound: " contacts found",
                enterFilterName: "Enter filter name",
                filterSuggestions: "Filter Suggestions",
                private: "Private",
                public: "Public",
                createFilter: "Create Filter",
                update: "Update",
                changeToPublic: "Change to Public",
                changeToPrivate: "Change to Private",
                delete: "Delete",
                clearSearch: "Clear Search",
                previous: "Previous",
                next: "Next",
                searchTerm: "Search Term:",
                whichFieldToSearch: "Which field would you like to search in?",
                contactId: "Contact ID",
                conversationId: "Conversation ID",
                noSearchAllFields: "No, search in all fields",
                yesSearchOnlyField: "Yes, search only in {field}",
                search: "Search",
                allFields: "All Fields",
                fullname: "Full name",
                email: "Email",
                whatsappNumber: "WhatsApp Number",
                phone: "Phone",
                contactIdField: "contact ID field",
                conversationIdField: "Conversation ID",
                searchAllFieldsPlaceholder: "Enter what you want to search in all fields",
                searchFullnamePlaceholder: "Enter what you want to search by Full Name",
                searchEmailPlaceholder: "Enter what you want to search by Email",
                searchWhatsappPlaceholder: "Enter what you want to search by WhatsApp",
                searchPhonePlaceholder: "Enter what you want to search by Phone",
                searchContactIdPlaceholder: "Enter the Contact ID you want to search",
                searchConversationIdPlaceholder: "Enter the Conversation ID you want to search",
                searchPlaceholder: "Search",
                edited: " (Edited)",
                unnamedFilter: "Unnamed Filter",
                all: "All",
                open: "Open",
                closed: "Closed",
                unknown: "Unknown",
                filterUpdatedSuccess: "Filter updated successfully",
                filterUpdatedDescription: 'Filter "{name}" has been updated.',
                filterUpdateFailed: "Filter could not be updated",
                filterUpdateError: "An error occurred while updating the filter.",
                filterSavedSuccess: "Filter saved successfully",
                filterSavedDescription:
                    'The name "{createName}" was already in use. Filter was created as "{filterName}".',
                filterCreatedDescription: 'Filter "{filterName}" has been created.',
                filterSaveFailed: "Filter could not be saved",
                filterSaveError: "An error occurred while saving the filter.",
                aiFilterCreatedSuccess: "AI Filter created successfully",
                aiFilterCreatedDescription:
                    'The name "{createName}" was already in use. Filter was created as "{filterName}" and applied.',
                aiFilterCreatedApplied: 'Filter "{filterName}" has been created and applied.',
                aiFilterCreateFailed: "Filter could not be created",
                aiFilterCreateError: "An error occurred while creating the AI filter.",
                phoneDetected: "Phone Number Detected",
                emailDetected: "Email Address Detected",
                idFormatDetected: "ID Format Detected",
                contactIdDetected: "Contact ID Detected",
                conversationIdDetected: "Conversation ID Detected",
                searchMode: "Search Mode",
                phoneDetectedMessage:
                    "The value you entered looks like a phone number. Would you like to search only in the phone number field?",
                emailDetectedMessage:
                    "The value you entered looks like an email address. Would you like to search only in the email field?",
                idFormatDetectedMessage:
                    "The value you entered looks like an ID format. Which field would you like to search in?",
                phoneField: "phone number field",
                emailField: "email field",
                conversationIdFieldName: "conversation ID field",
                idField: "ID field",
                deleteFilter: "Delete Filter",
                deleteFilterConfirm:
                    'Are you sure you want to delete the filter "{name}"? This action cannot be undone.',
                cancel: "Cancel",
                filterDeletedSuccess: "Filter deleted successfully",
                filterDeletedDescription: 'Filter "{name}" has been deleted.',
                filterDeleteFailed: "Filter could not be deleted",
                filterDeleteError: "An error occurred while deleting the filter.",
                visibilityUpdatedSuccess: "Visibility updated successfully",
                visibilityUpdatedDescription: 'Filter has been set to "{visibility}".',
                visibilityUpdateFailed: "Visibility could not be updated",
                visibilityUpdateError: "An error occurred while updating the filter.",
                publicVisibility: "public",
                privateVisibility: "private",
            },
            contactList: {
                noContactsFound: "No Contacts Found",
                unknownContact: "Unknown Contact",
                unknown: "Unknown",
                fullName: "Full Name",
                platform: "Platform",
                email: "Email",
                phone: "Phone",
                tags: "Tags",
                status: "Status",
                lastActivity: "Last Activity",
                answerStatus: "Answer Status",
                channel: "Channel",
                owner: "Owner",
                vip: "VIP",
                connectionTime: "Connection Time",
                unread: "Unread",
                departments: "Departments",
                operatingSystem: "Operating System",
                browser: "Browser",
                countryCity: "Country - City",
                ipAddress: "IP Address",
                visitingPage: "Visiting Page",
                lastConversationDate: "Last Conversation Date",
                blockedStatus: "Blocked Status",
                lastConversationParticipants: "Last Conversation Participants",
                preferredLanguage: "Preferred Language",
                createdAt: "Created At",
                updatedAt: "Updated At",
                broadcastStatus: "Broadcast Status",
                broadcastAnswer: "Broadcast Answer",
                zohoContactId: "Zoho Contact ID",
                zohoLeadId: "Zoho Lead ID",
                profileFields: "Profile Fields",
                closed: "Closed",
                open: "Open",
                unknownStatus: "Unknown",
                answered: "Answered",
                unanswered: "Unanswered",
                unreadStatus: "Unread",
                readStatus: "Read",
                vipStatus: "VIP",
                normal: "Normal",
                blocked: "Blocked",
                today: "Today",
                yesterday: "Yesterday",
                enqueued: "Enqueued",
                sent: "Sent",
                delivered: "Delivered",
                read: "Read",
                deleted: "Deleted",
                failed: "Failed",
                replied: "Replied",
                notReplied: "Not Replied",
                jsonProperty: "JSON Property",
                jsonCopiedSuccess: "JSON content copied successfully!",
            },
        },
        form: {
            title: {
                titleSettings: "Title Settings",
                fullNameSettings: "Full Name Settings",
                emailSettings: "Email Settings",
                addressSettings: "Address Settings",
                phoneSettings: "Phone Settings",
                datePickerSettings: "Date Picker Settings",
                shortTextSettings: "Short Text Settings",
                longTextSettings: "Long Text Settings",
                dropDownListSettings: "Drop Down List Settings",
                singleChoiceSettings: "Single Choice Settings",
                multipleSelectionSettings: "Multiple Selection Settings",
                numberSettings: "Number Settings",
                hourSettings: "Hour Settings",
                spinnerSettings: "Spinner Settings",
                sendSettings: "Send Settings",
                starRatingSettings: "Star Rating Settings",
                ratingScaleSettings: "Rating Scale Settings",
                separationElementSettings: "Separation Element Settings",
                fileUploadSettings: "File Upload Settings",
                imageSettings: "Image Settings",
            },
            lineColor: "Line Color",
            separatorColorInfo: "Select or enter the color of the separator (e.g., #RRGGBB)",
            separatorHeight: "Separator Height",
            separatorHeightInfo: "Enter the height of the separator",
            bottomSpace: "Bottom Space",
            bottomSpaceInfo: "Add space below the separator",
            topSpace: "Top Space",
            topSpaceInfo: "Add space above the separator",
            sideSpace: "Side Space",
            sideSpaceInfo: "Add space to the left and right of the separator",
            onlyImageUpload: "You can only upload an image!",
            imageSizeLimit: "Your image size must be at most 5MB!",
            image: "Image",
            size: "Size",
            width: "Width",
            height: "Height",
            imageAlignment: "Image Alignment",
            wide: "Wide",
            small: "Small",
            textAlignment: "Text Alignment",
            chooseHorizontalAlignment: "Choose how to align this title horizontally.",
            headerSize: "Header Size",
            addSmallTextBelowHeader: "Add a smaller text below the header",
            subHeaderText: "Subheader Text",
            subLabel1: "Sub Label(1)",
            subLabel2: "Sub Label(2)",
            validPhoneNumber: "Please enter a valid phone number",
            masked: "Masked",
            copyField: "Copy Field",
            copyFieldDescription: "Create a copy of this field while keeping all its saved settings",
            enterQuestion: "Enter a question",
            notRequired: "Not Required",
            addDescriptionBelowField: "Add a short description below the field",
            setDefault: "Set as Default",
            pleaseSelect: "Please Select",
            placeholder: "Placeholder",
            required: "Required",
            fieldEmptyError: "Do not allow the form to be submitted if this field is empty",
            subLabels: "Sub Labels",
            addressLine1: "Address Line 1",
            addressLine2: "Address Line 2",
            postalCode: "Postal Code",
            stateProvince: "State / Province",
            chooseLabelAlignment: "Choose how to align the label text horizontally",
            right: "RIGHT",
            left: "LEFT",
            top: "TOP",
            labelAlignment: "Label Alignment",
            fieldLabel: "Field Label",
            read: "Read",
            itemsPerPage: "items/page",
            downloadAllDataAsPDF: "Download All Data as PDF",
            downloadAllDataAsExcel: "Download All Data as Excel",
            downloadSelectedDataAsPDF: "Download Selected Data as PDF",
            downloadSelectedDataAsExcel: "Download Selected Data as Excel",
            selectItemToViewDetails: "Select an item to view details.",
            deleteFormConfirm:
                "If you delete this form, all data associated with the form will be permanently deleted. Are you sure you want to continue?",
            redicetFormAnswer: "FORWARD FORM ANSWERS",
            redicetFormAnswerDesc:
                "When forwarding form answers to the ticket system, please make sure to request a phone number or e-mail address from the user in the form. This information is important for faster and more effective communication with the user.",
            redicetFormAnswerDesc2: "Form answers are routed to the system as tickets",
            rediectAnswersToTicket: "Redirect Incoming Answers to Ticket",
            errorTicketMode: "Error updating ticket mode:",
            formView: "View Form",
            formEdit: "Update Form",
            totalResponse: "Total Response",
            totalUnreadResponse: "Total Unread Response",
            singleChoice: "Single Choice",
            totalReadResponse: "Total Read Responses",
            totalArchivedResponse: "Total Archived Response",
            _delete: "Delete",
            inbox: "Inbox",
            edit: "Edit",
            forms: "Forms",
            formsDesc: "You can manage your forms here.",
            createaForm: "Create Form",
            allForms: "All Forms",
            formPublish: {
                shareFast: "SHARE FAST",
                shareFastDesc: "Direct form link and social sharing",
                add: "ADD",
                addDesc: "Various web page embed options",
                assignForm: "ASSIGN FORM",
                assignFormDesc: "Assign your forms to others",
                emails: "EMAILS",
                emailsDesc: "Reminders and instant sharing",
                prefill: "PREFILL",
                prefillDesc: "Pre-populate your forms",
                pdf: "PDF",
                pdfDesc: "Download fillable PDF",
                platforms: "PLATFORMS",
                platformsDesc: "Third-party publish options",
                linkToYour: "LINK TO YOUR FORM",
                linkToYourDesc: "Your form has been securely published and is ready for use at this address.",
                shareWithLink: "SHARE WITH LINK",
                publicForm: "Public Form",
                copyLink: "COPY LINK",
                openInNewTab: "OPEN IN NEW TAB",
                linkCopied: "Link Copied",
                codeCopied: "Code Copied",
                iframe: "IFRAME",
                iframeDesc: "Add the form to your page with iFrame",
                openWindow: "OPEN WINDOW",
                openWindowDesc: "Link to a popup form",
                formAddDesc: "Copy and paste this snippet into your code and embed your form on your website.",
            },
            formSettings: {
                enterNameForm: "Enter a name for this form",
                selectStatusForm: "Select the status of your form",
                disabled: "Disabled",
                disableSpecifiedTime: "Disable at a specified time or when the response limit is reached",
                disableFormResponse: "Disable when Form Response limit is reached",
                pageShownAfterForm: "The page shown after the form is submitted",
                formNotFound: "Form not found.",
                errorLoadingform: "An error occurred while loading the form.",
                formUpdated: "The form title was updated successfully.",
                formErrorUpdated: "An error occurred while updating the form header",
                formSettings: "FORM SETTINGS",
                changeFormStateAndProperties: "Change form state and properties",
                title: "Title",
                newFormSettings: "New Form Settings",
                formStatus: "Form Status",
                activateOrDeactivate: "Activate or deactivate your form",
                effective: "EFFECTIVE",
                yourFromIsVisible: "Your form is currently visible and can receive form responses",
                emails: "EMAILS",
                emailsDesc: "Send autoresponder emails and notification emails",
                conditions: "CONDITIONS",
                conditionsDesc: "Conditional logic section that triggers actions based on form inputs",
                thankYouPage: "THANK YOU PAGE",
                thankYouPageDesc: "The page shown after submitting the form",
                integretions: "INTEGRATIONS",
                integretionsDesc: "Connect your form to other applications",
            },
            clickToDeleteYourLogo: "Click to delete your logo",
            create: "Create",
            settings: "Settings",
            load: "Publish",
            insertFormField: "Insert Form Field",
            addYourLogo: "Add Your Logo",
            surveyElements: {
                surveyElements: "Survey Elements",
                dataTable: "Data Table",
                starRating: "Star Rating",
                evaluationScale: "Evaluation Scale",
            },
            pageElements: {
                pageElements: "Page Elements",
                separationElement: "Separation Element",
                partitionCollapse: "Partition Collapse",
                pageBreak: "Page Break",
            },
            basicElements: {
                basicElements: "Basic Elements",
                shortText: "Short Text",
                longText: "Long Text",
                paragraph: "Paragraph",
                dropDownList: "Dropdown List",
                singleChoice: "Signle Choice",
                multipleSelection: "Multiple Selection",
                number: "Number",
                image: "İmage",
                fileUpload: "File Upload",
                hour: "Hour",
                spinner: "Spinner",
                send: "Send",
            },
            formElements: {
                formElements: "Form Elements",
                title: "Title",
                fullName: "Full Name",
                email: "Email",
                address: "Address",
                phone: "Phone",
                datePicker: "Date Picker",
                appointment: "Appointment",
                signature: "Signature",
                productList: "Product List",
            },
            startWithaBlankForm: "Start with a blank form",
            startFromScratch: "Start From Scratch",
            createOrTransferaForm: "Create or transfer a form to start collecting data",
            createForm: "Create a Form",
            trashBin: "Trash Bin",
            formAutomations: "Form Automations",
            trashBinList: {
                title: "Trash Bin",
                description: "Your deleted forms are listed here",
                loading: "Loading deleted forms...",
                restore: "Restore",
                permanentDelete: "Permanently Delete",
                delete: "Delete",
                emptyTitle: "Trash bin is empty",
                emptyDescription: "No deleted forms found",
                totalResponses: "Total Responses",
                unread: "Unread",
                read: "Read",
                archived: "Archived",
                restoreConfirmDescription:
                    "Are you sure you want to restore this form? The form and all its data will be added to the active forms list.",
                deleteConfirmDescription:
                    "Are you sure you want to permanently delete this form? This action cannot be undone and all data associated with the form will be deleted.",
                deletedToday: "Deleted today",
                deletedYesterday: "Deleted yesterday",
                deletedDaysAgo: "Deleted {count} days ago",
                deletedWeeksAgo: "Deleted {weeks} weeks ago",
                deletedMonthsAgo: "Deleted {months} months ago",
                restoreSuccess: "Form restored successfully",
                restoreError: "An error occurred while restoring the form",
                deleteSuccess: "Form permanently deleted",
                deleteError: "An error occurred while deleting the form",
            },
        },
        automation: {
            deleteAutomationsTitle: "Delete Automations",
            deleteAutomationsConfirmation:
                "Are you sure you want to delete {count} automations? This action cannot be undone.",
            automationsMoveError: "Error occurred while moving automations",
            noAutomationToMove: "No automation found to move",
            deleteCategoryConfirmation:
                'Are you sure you want to delete the "{categoryName}" category? Automations in this category will be moved to the "{generalCategory}" category.',
            automationsMovedToCategory: '{count} automations moved to "{categoryName}" category',
            automationImportedSuccessfully: "{name} automation imported successfully",
            automationPasteError: "Error occurred while pasting automation",
            invalidAutomationExport: "No valid Supsis automation export found in clipboard",
            invalidAutomationJSON: "No valid automation JSON found in clipboard",
            clipboardNotSupported: "Clipboard access is not supported in this browser",
            automationJSONCopyError: "Error occurred while copying automation",
            automationCopiedToClipboardFallback: "Automation copied to clipboard as JSON (fallback method)",
            automationCopiedToClipboard:
                "Automation copied to clipboard as JSON. You can paste it with Ctrl+V in another customer panel.",
            automationCopyError: "Error occurred while copying automation",
            automationCopied: "Automation copied",
            automationMoveError: "Error occurred while moving automation",
            automationMovedToCategory: 'Automation moved to "{categoryName}" category',
            categoryDeletedSuccessfully: "Category deleted successfully",
            categoryDeleteError: "Error occurred while deleting category",
            automationsDeleteError: "Error occurred while deleting automations",
            automationsDeletedSuccessfully: "Automations Deleted Successfully",
            categoryUpdatedSuccessfully: "Category updated",
            categoryUpdateError: "Error occurred while updating category",
            categorySaveError: "Error occurred while saving category",
            categoryCreatedSuccessfully: "Category created. You can drag automations to this category.",
            categoryNameAlreadyExists: "A category with this name already exists",
            categoryNameRequired: "Category name cannot be empty",
            moveAllAutomations: "Move All Automations",
            deleteAutomations: "{count} automations deleted",
            selectedAutomations: "{count} automations selected",
            pasteInfoMessage:
                "Automation copied to clipboard detected! Create a new automation by pasting with <strong>Ctrl+V</strong> right away.",
            categoryName: "Category Name",
            categoryNamePlaceholder: "Enter category name",
            editCategory: "Edit Category",
            deleteCategory: "Delete Category",
            createCategory: "Add Category",
            publishAutomation: "Published",
            unpublishAutomation: "Stopped",
            timerAutomation: "Scheduled",
            eventAutomation: "Event",
            deleteAutomation: "Delete Automation",
            changeCategory: "Change Category",
            copyAutomation: "Copy Automation",
            copyAutomationAsJSON: "Copy as JSON",
            emptyCategoryMessage: "You can add automations to the category by dragging them here",
            newAutomation: "New Automation",
            whenFormSubmitted: "When a form is submitted",
            taskCreated2: "Task Created",
            waitingTaskCreation: "Waiting Task Creation...",
            calendarEventCreated: "Event created in the calendar",
            calendarEventUpdated: "Event updated in the calendar",
            calendarEventDeleted: "Event deleted in the calendar",
            reservationCreated: "Reservation created",
            reservationDateChanged: "Reservation date changed",
            reservationDeleted: "Reservation deleted",
            chatLost: "When chat is lost",
            webchatCompleted: "When web chat is completed",
            instagramCompleted: "When chat from Instagram channel is completed",
            messengerCompleted: "When chat from Messenger channel is completed",
            whatsappCompleted: "When chat from WhatsApp channel is completed",
            telegramCompleted: "When chat from Telegram channel is completed",
            chatAssignedToAgent: "When chat is assigned to an agent",
            profileButtonClicked: "When the automation button is clicked from the profile",
            operatedTask: "Task being run",
            totalAutomations: "Total {count} automations",
            totalAutomationsWithHidden: "Total {total} automations ({visible} visible)",
            tableSelection: "Table Selection",
            selectTable: "Select Table",
            whichTableAutomationAddRecords:
                "Which table do you want to run the automation when a record is added? Please select.",
            whichTableAutomationUpdateRecords:
                "When a record is updated in which table do you want to run the automation? Please select.",
            whichTableAutomationDeletedRecords:
                "From which table do you want to run the automation when a record is deleted? Please select.",
            whichTableAutomationClickRecords:
                "In which table do you want to run the automation when the automation button on a record is clicked? Please select.",
            selectAtLeastOneField: "At least one field must be selected",
            generalCategory: "General",
            configureTrackFields: "Configure Track Fields",
            configureMessageFilter: "Configure Message Filter",
            makeFreeTier: "Make Free Tier",
            revertFreeTier: "Revert Free Tier",
            webhook: "Webhook",
            system: "System",
            freeTierTooltip:
                "This automation is within the free tier. Automation usage will not be deducted from your quota.",
            freeTierBadge: "Free Tier",
            trackFieldsLabel: "Fields to Track",
            trackFieldsSelectPlaceholder: "If no field is selected, all fields will be tracked",
            selectFieldPlaceholder: "Select field",
            tableMustBeSelectedFirst: "Table must be selected for the automation first",
            fieldsLoadError: "Error loading fields",
            trackFieldsUpdated: "Track fields updated",
            updateError: "Error during update",
            automationMadeFreeTier: "Automation set to free tier",
            makeFreeTierError: "Error setting free tier",
            automationRevertedToNormalTier: "Automation reverted to normal tier",
            revertFreeTierError: "Error reverting to normal tier",
            wrongPassword: "Wrong password!",
            configLoadError: "Error loading configuration",
            messageFilterConfigUpdated: "Message filter configuration updated",
            freeTierPasswordPrompt: "Enter password to make free tier:",
            planStatus: "Plan Status",
            scheduled: "Scheduled",
            completed: "Completed",
            cancelled: "Canceled",
            startTest: "Start Test",
            unpublish: "Unpublish",
            whenMessagePicked: "When a message is selected via the chat interface",
            whenTaskCompleted: "When a task is completed",
            whenTaskDeleted: "When a task is deleted",
            whenTaskAssigneeChanged: "When a task assignee is changed",
            whenTaskPriorityChanged: "When a task priority is changed",
            whenTaskDueDateChanged: "When the due date of a task is changed",
            whenTaskStatusChanged: "When a task status is changed",
            whenTaskArchived: "When a task is archived",
            whenTagAdded: "When a tag is added to the task",
            whenTagRemovedTask: "When a tag is removed from a task",
            whenTagChecklist: "When a task checklist is completed",
            whenReminderActivated: "When a reminder is activated",
            whenTicketCreated: "When Ticket Created",
            whenTicketStageChanged: "When a ticket stage is changed",
            whenTicketAssigneeChanged: "When a ticket assignee is changed",
            whenTicketClosed: "When a ticket is closed",
            whenTicketUpdated: "When a ticket is updated",
            whenVoiceAgentCallStarted: "When a voice agent call is started",
            whenVoiceAgentCallEnded: "When a voice agent call is ended",
            whenVoiceAgentCallAnalyzed: "When a voice agent call is analyzed",
            archivingDate: "Archiving Date",
            autoPlanAndTaskHistory: "Automation Plan and Task History",
            automation: "Automation",
            botScenario: "Bot Scenario",
            nameSurname: "First Name Last Name",
            phone164: "*Enter in E164 format. For example: 905396667744",
            whichWpChannels: "Which Whatsapp Channels to Add?",
            findContact: "Find Contact",
            findContacts: "Find Contacts",
            offsetDesc: "Skip the first N contacts. Default value is '0'. Use this to scroll through the contacts.",
            limitDesc: "Maximum number of contacts to return after offset. Default value is '10'. Use this to paginate",
            contact: "Contact",
            selectAction: "Select Action",
            addMethod: "Add Method",
            selectField: "Select Field",
            schedulerRunningPlanEx: "Scheduler Running Plan Example",
            schedulerPlanner: "Scheduler Planner",
            taskCreated: "Task Created?",
            taskStatus: "Task Statuses",
            terminateReason: "Termination Reason",
            taskDuration: "Task Duration",
            taskWakeUpCount: "Task WakeUp Count",
            completedAt: "Completed",
            cancelledAt: "Canceled",
            nextRunAt: "Next Run",
            configSchedulerAuto: "Configure Timer for Automation",
            saveChanges: "Save Changes",
            catchAllWebhooks: "Catch All Webhooks from this URL",
            webhookDataExPreview: "Webhook Data Sample Preview (will be shown after sending request)",
            webhookUrlCopied: "Webhook URL copied to clipboard",
            selectAnBlock: "Select a Block",
            dataFormats: "Data Formats",
            whenRecordCreated: "When a record is created",
            whenRecordUpdated: "When a record is updated",
            whenRecordDelete: "When a record is deleted",
            whenRecordAutomation: "When a record automation button  is clicked",
            whenWebhookTriggered: "When a webhook is triggered",
            whenChatCreated: "When a chat is created",
            whenChatClosed: "When a chat is closed",
            whenChatRated: "When a chat is rated",
            whenNewContactCreated: "When a new contact is created",
            whenContactUpdate: "When a contact update",
            whenContactPropUpdate: "When a contact-property update",
            whenNewTagAdded: "When a new tag added",
            whenTagRemoved: "When a tag is removed",
            whenNewEmailReceived: "When a new email is received",
            whenNewTaskCreated: "When a new task is created",
            whenNewMetaleadCreated: "When a new meta-lead is created",
            whenNewAgentCreated: "When a new agent is created",
            whenAgentOnline: "When an agent comes online",
            whenAgentOffline: "When an agent goes offline",
            whenAgentStatusChanged: "When an agent's status changes",
            whenAgentLogin: "When an agent logs in",
            whenNewInvoiceCreated: "When a new invoice is created",
            whenNewWpReceived: "When a new whatsapp message is received",
            whenNewReservationCreated: "When a new reservation is created",
            whenNewChatbotReceived: "When a new chatbot message is received",
            chatWebhookAutomation: "Catch a Webhook And Run an Automation",
            automationName: "Automation Name",
            supsisObject: "Supsis Object",
            selectModule: "Select Module",
            bodyType: "Body Type",
            selectBodyType: "Select Body Type",
            selectMethod: "Select Method",
            trigger: "Trigger",
            published: "Published",
            createdAt: "Created At",
            action: "Action",
            type: "Type",
            view: "View",
            createTimerAutomation: "Create Timer Automation",
            createEventBasedAutomation: "Create Event Based Automation",
            createWebhookAutomation: "Create Webhook Automation",
            createAnEventAutomation: "Create an Event Automation",
            automationsCouldNotBeDeleted: "Automations Could Not Be Deleted",
            timerAutomationCreatedSuccessfully: "Timer Automation Created Successfully",
            eventAutomationCreatedSuccessfully: "Event Automation Created Successfully",
            webhookAutomationCreatedSuccessfully: "Webhook Automation Created Successfully",
            automationsCouldNotBeFetched: "Automations Could Not Be Fetched ",
            automationPublishedStateUpdatedSuccessfully: "Automation Published State Updated Successfully",
            automationPublishedStateCouldNotBeUpdated: "Automation Published State Could Not Be Updated",
            automations: "Automations",
            allAutomations: "All Automations",
            scheduledAutomations: "Scheduled Automations",
            eventBasedAutomations: "Event Based Automations",
            buttonAutomations: "Button Automations",
            webhookAutomations: "Webhook Automations",
            analytics: "Analytics",
            insights: "Insights",
            trash: "Trash Bin",
            sandboxPage: {
                title: "Deleted Automation Scenarios",
                description:
                    "Automations that are not restored will be permanently deleted by the system within 30 days",
                emptyState: "No deleted automations in trash",
                unnamedAutomation: "Untitled Automation",
                restore: "Restore",
                timerAutomation: "Timer Automation",
                eventAutomation: "Event Automation",
                webhook: "Webhook",
                buttonAutomation: "Button Automation",
                tableButtonAutomation: "Table Button Automation",
                chatbotAutomation: "Chatbot Automation",
                unknown: "Unknown",
                user: "User",
                restoreConfirmTitle: "Are You Sure You Want to Restore This Automation?",
                restoreConfirmContent: "{name} automation will be restored.",
                restoreSuccess: "Automation restored",
                restoreFailed: "Restore failed",
                loadError: "Error loading deleted automations",
            },
            insightsPage: {
                title: "Automation Statistics",
                selectAutomation: "Select Automation",
                dateRange: "Date Range",
                datePlaceholderStart: "Start",
                datePlaceholderEnd: "End",
                lastWeek: "Last Week",
                lastMonth: "Last Month",
                last3Months: "Last 3 Months",
                statusFilter: "Status Filter",
                statusScheduled: "Scheduled",
                statusRunning: "Running",
                statusWaitingReply: "Waiting Reply",
                statusDone: "Completed",
                statusFailed: "Failed",
                statusCancelled: "Cancelled",
                clearFilters: "Clear Filters",
                refreshData: "Refresh Data",
                activeFilters: "Active Filters:",
                totalTasks: "Total Tasks",
                executedTasks: "Executed Tasks",
                successRate: "Success Rate",
                successfulTasks: "Successful Tasks",
                avgDuration: "Average Duration",
                avgWorkDuration: "Average Work Duration",
                activeTasks: "Active Tasks",
                runningNow: "Running Now",
                dailyTaskExecution: "Daily Task Execution",
                statusDistribution: "Status Distribution",
                durationDistribution: "Duration Distribution",
                terminateReasons: "Termination Reasons",
                automationPerformance: "Automation Performance",
                view: "View",
                automationName: "Automation Name",
                executionCount: "Execution Count",
                actions: "Actions",
                totalTasksLegend: "Total Tasks",
                successfulLegend: "Successful",
                failedLegend: "Failed",
                taskCount: "Task Count",
                ms: "ms",
                sec: "sec",
                min: "min",
                hour: "hr",
                automationsLoadError: "An error occurred while loading automations",
                insightsLoadError: "An error occurred while loading statistics",
            },
            settingsWidget: {
                viewActivityLogs: "View Activity Logs",
                activityLogsTitle: "Activity Logs",
                activityLogsEmpty: "No activity records yet",
                activityLogsLoadError: "An error occurred while loading activity logs",
                exportedToClipboard: "Automation exported to clipboard",
                settings: "Settings",
            },
            enablePreFilters: "Enable Pre-Filters",
            preFilterDescription:
                "Pre-filters allow you to determine when the automation should run. When enabled, the automation will only trigger for events that match your defined conditions.",
            preFilters: "Pre-Filters",
            executionRules: "Execution Rules",
            preFilterInfo:
                "With pre-filters, you can determine when the automation should run. The automation will only trigger for events that match your defined conditions.",
            preFiltersSaved: "Pre-filters saved successfully",
            preFiltersSaveError: "Error saving pre-filters",
            configurePreFilters: "Configure Pre-Filters",
            preFiltersConfiguration: "Pre-Filter Configuration",
            executionPrivacyTitle: "Execution Permission",
            executionPrivacyDescription:
                "Which users or departments can execute this automation? If left empty, all users can execute it.",
            executionPrivacyPublic: "All users can execute this automation",
            configureExecutionPrivacy: "Configure Execution Permission",
            executionPrivacyConfiguration: "Execution Permission Configuration",
            executionPrivacySaved: "Execution permission saved successfully",
            executionPrivacySaveError: "Error occurred while saving execution permission",
            makePublicExecution: "Make Public",
            makePublicExecutionConfirmTitle: "Are you sure you want to make this automation public?",
            makePublicExecutionConfirmContent:
                "After this operation, all representatives will be able to execute this automation.",
            madePublicExecution: "Automation has been made public",
            editDescription: "Edit Description",
            addDescription: "Add description...",
            descriptionPlaceholder: "Enter automation description...",
            descriptionSaved: "Description saved successfully",
            descriptionSaveError: "Error occurred while saving description",
            permissions: {
                title: "Access Permissions",
                mode: "Permission Mode",
                publicMode: "Public",
                customMode: "Custom",
                publicModeDesc: "All users can access and edit this automation.",
                customModeDesc: "Only specified users and departments can access this automation.",
                confirmPublicMode: "Switch to Public Mode",
                confirmPublicModeDesc:
                    "After this operation, all users will be able to access this automation. Do you want to continue?",
                addUser: "Add User",
                addDepartment: "Add Department",
                selectUser: "Select user",
                selectDepartment: "Select department",
                add: "Add",
                targetHeader: "User/Department",
                matrixInfo: "Select the permissions you want to grant for each user or department.",
                noTargetsAdded: "No users or departments have been added yet. Add one above to grant permissions.",
                confirmRemoveTarget: "Remove Permission",
                confirmRemoveTargetDesc: "Are you sure you want to remove permissions for this user or department?",
                saveSuccess: "Access permissions saved successfully",
                saveError: "An error occurred while saving access permissions",
                unknownUser: "Unknown User",
                unknownDepartment: "Unknown Department",
                noReadAccess: "You do not have access to this automation.",
                usersTab: "Users",
                departmentsTab: "Departments",
                authorizedUsers: "Authorized Users",
                otherUsers: "Other Users",
                authorizedDepartments: "Authorized Departments",
                otherDepartments: "Other Departments",
                cannotChangeOwnPermission: "You cannot change your own permission",
                you: "You",
                customPermissionDefined: "Custom permission defined for this user",
                customPermission: "Custom Permission",
                grantPermission: "Grant Permission",
                revokePermission: "Remove Permission",
                applyToOthers: "Apply to Other Automations",
                applyToOthersDesc: "Apply these permission settings to other automations you select",
                applyToOthersTitle: "Apply Permission Settings to Other Automations",
                applyToOthersWarning:
                    "The existing permission settings of the selected automations will be replaced with this automation's settings.",
                selectAll: "Select All",
                selectedCount: "{count} automations selected",
                applyToSelected: "Apply to Selected",
                noAutomationsFound: "No automations found",
                searchPlaceholder: "Search automation or category...",
                applySuccess: "Permission settings applied to {count} automations successfully",
                applyFailed: "Failed to apply permission settings to {count} automations",
                applyError: "Error applying permission settings",
                groups: {
                    basic: "Basic",
                    flow: "Flow",
                    meta: "Info",
                    publish: "Publish",
                    actions: "Actions",
                    plan: "Plan",
                    filter: "Filter",
                },
                scopes: {
                    read: "View",
                    readDesc: "Permission to view the automation",
                    flowUpdate: "Edit Flow",
                    flowUpdateDesc: "Permission to add, remove, and edit automation blocks",
                    metaUpdate: "Edit Info",
                    metaUpdateDesc: "Permission to edit automation name, description, and category",
                    publish: "Publish",
                    publishDesc: "Permission to publish and unpublish the automation",
                    delete: "Delete",
                    deleteDesc: "Permission to delete the automation",
                    duplicate: "Duplicate",
                    duplicateDesc: "Permission to duplicate the automation",
                    planView: "View Plans",
                    planViewDesc: "Permission to view automation execution plans",
                    planCancel: "Cancel Plan",
                    planCancelDesc: "Permission to cancel scheduled plans",
                    reschedule: "Reschedule",
                    rescheduleDesc: "Permission to reschedule automation",
                    prefilterUpdate: "Edit Filter",
                    prefilterUpdateDesc: "Permission to edit pre-filter configuration",
                },
            },
            blocks: {
                REPLY_TRENDYOL_QUESTION: "Reply Trendyol Question",
                START_POINT: "START POINT",
                AI_ASSISTANT: "AI ASSISTANT",
                FEEDBACK_AI_ASSISTANT: "FEEDBACK AI ASSISTANT",
                INSERT_TO_SYSTEM_PROMPT: "INSERT TO SYSTEM PROMPT",
                BOT_RESPONSE: "BOT RESPONSE",
                AI_CALL: "AI CALL",
                TAVILY_WEB_SEARCH: "WEB SEARCH (TAVILY)",
                OPENAI_WEB_SEARCH: "WEB SEARCH (OPENAI)",
                AI_BOT_RESPONSE: "AI RESPONSE (GPT-4o)",
                AI_CLASSIFICATION: "AI CLASSIFICATION",
                AI_MENU_FLOW: "AI MENU",
                OTP_WHATSAPP_FLOW: "OTP Whatsapp",
                OTP_SMS_FLOW: "OTP SMS",
                RUN_JAVASCRIPT: "RUN JAVASCRIPT",
                OTP_MAIL_FLOW: "OTP MAIL",
                AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
                PLATFORM_FLOW: "PLATFORM",
                DEFAULT_FALLBACK: "DEFAULT FALLBACK",
                DEFAULT_TIMEOUT: "DEFAULT TIMEOUT",
                AI_FUNCTIONS: "AI FUNCTIONS",
                FILTER: "FILTER",
                FLOW: "FLOW",
                ATTACHMENT_INPUT: "ATTACHMENT INPUT",
                USER_INPUT: "USER INPUT",
                GO_TO_STEP: "GO TO STEP",
                WEBHOOK: "WEBHOOK",
                SEND_JSON_RESPONSE: "RESPOND TO WEBHOOK",
                SET_ATTRIBUTE: "SET ATTRIBUTE",
                QUESTION: "QUESTION",
                CLOSE_CHAT: "CLOSE CHAT",
                CREATE_TICKET: "CREATE TICKET",
                TICKET_UPDATE: "UPDATE TICKET",
                TRANSFER_CHAT: "TRANSFER CHAT",
                TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
                TAG_CHAT: "ADD TAG",
                CACHE_WRITE: "CACHE WRITE",
                CACHE_READ: "CACHE READ",
                CACHE_EXTEND: "CACHE EXTEND",
                CACHE_DELETE: "CACHE DELETE",
                YOUTUBE_REPLY_COMMENT: "Reply Comment",
                YOUTUBE_UPDATE_COMMENT_STATUS: "Update Comment Status",
                YOUTUBE_SET_MODERATION_STATUS: "Set Moderation Status",
                GOOGLE_BUSINESS_REPLY_REVIEW: "Reply Review",
                GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS: "Update Review Status",
                GOOGLE_PLAY_REPLY_REVIEW: "Reply Review",
                GOOGLE_PLAY_UPDATE_REVIEW_STATUS: "Update Review Status",
                APP_STORE_REPLY_REVIEW: "Reply Review",
                APP_STORE_UPDATE_REVIEW_STATUS: "Update Review Status",
                APP_STORE_DELETE_REVIEW_RESPONSE: "Delete Review Response",
                REMOVE_TAG: "REMOVE TAG",
                SET_DEPARTMENT: "SET DEPARTMENT",
                SEND_TRANSCRIPT: "SEND TRANSCRIPT",
                SEND_SMS: "SEND SMS",
                SEND_MAIL: "SEND MAIL",
                CREATE_EVENT: "CREATE EVENT",
                CREATE_RESERVATION: "CREATE RESERVATION",
                RESERVATION_OPEN_URL: "Reservation Open Url",
                RESERVATION_SELECT_DAY: "Select reservation day",
                RESERVATION_EVENT_LIST: "Reservation list visitor",
                RESERVATION_SELECT_TIME: "Select reservation time",
                CREATE_TASK: "CREATE TASK",
                UPDATE_TASK: "UPDATE TASK",
                SHOPIFY_SHOW_PRODUCTS: "SHOPIFY SHOW PRODUCTS",
                SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY PRODUCT AVAILABILITY",
                SHOPIFY_ORDER_STATUS: "SHOPIFY ORDER STATUS",
                AKINON_SHOW_PRODUCTS: "AKINON SHOW PRODUCTS",
                AKINON_FIND_PRODUCT: "AKINON FIND PRODUCT",
                AKINON_ORDER_STATUS: "AKINON ORDER STATUS",
                AKINON_SELECT_ORDER: "AKINON SELECT ORDER",
                AKINON_SELECT_SIZE: "AKINON SELECT SIZE",
                AKINON_FIND_NEAREST_STOCK: "SHOW STORE STOCK",
                AKINON_FIND_NEAREST_STORES: "SHOW NEAREST STORES",
                AKINON_SHOW_DISCOUNT_CODES: "SHOW DISCOUNT CODES",
                SUPPRESSION_ADD: "BLOCK CONTACT",
                SUPPRESSION_REMOVE: "UNBLOCK CONTACT",
                ADD_TO_SEGMENT: "Add to Segment",
                REMOVE_FROM_SEGMENT: "Remove from Segment",
                IDEASOFT_SELECT_ORDER: "SELECT ORDER",
                IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
                IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
                TSOFT_SELECT_ORDER: "SELECT ORDER",
                TSOFT_ORDER_STATUS: "GET ORDER STATUS",
                TICIMAX_V2_SELECT_ORDER: "SELECT ORDER",
                TICIMAX_V2_ORDER_STATUS: "GET ORDER STATUS",
                IKAS_GET_MEMBER_INFO: "Get Member Details",
                IKAS_SELECT_ORDER: "Select Order",
                IKAS_ORDER_STATUS: "Fetch Order Status",
                GET_LOCATION: "GET LOCATION",
                FALLBACK: "FALLBACK",
                TIMEOUT: "TIMEOUT",
                SUCCESS: "SUCCESSFUL",
                FAILURE: "FAIL",
                PROBEL_SELECT_BRANCH: "Select Branch",
                PROBEL_SELECT_CLINIC: "Select Polyclinic",
                PROBEL_SELECT_DAY: "Select Appointment Day",
                PROBEL_SELECT_HOUR: "Select Appointment Time",
                PROBEL_MAKE_APPOINTMENT: "Make Appointment",
                PROBEL_CANCEL_APPOINTMENT: "Appointment Cancellation",
                PROBEL_GET_PATIENT_TOKEN: "Get Patient Token",
                PROBEL_FILL_INFO: "Get MERNIS Information",
                PROBEL_SELECT_APPOINTMENT: "Select Appointment",
                SEND_WP_BUSINESS_MESSAGE: "SEND WHATSAPP MESSAGE",
                MESSENGER_SEND_MESSAGE: "Messenger Send Message",
                INSTAGRAM_SEND_MESSAGE: "Instagram Send Message",
                INSTAGRAM_COMMENT_REPLY: "REPLY COMMENT",
                INSTAGRAM_COMMENT_DELETE: "DELETE COMMENT",
                INSTAGRAM_COMMENT_SHOW: "SHOW COMMENT",
                INSTAGRAM_COMMENT_HIDE: "HIDE COMMENT",
                INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "REPLY AS PRIVATE",
                ASSIGN_OWNER: "Assign Owner",
                LOOP: "Loop",
                LOOP_NEXT: "Loop Next Item",
                LOOP_BREAK: "Break Loop",
                LOOP_CONTINUE: "Continue Next Loop",
                LOOP_FINISH: "Finish Loop",
                SLEEP: "Sleep",
                NOOP: "Noop",
                CATCH_WEBHOOK: "Catch Webhook",
                TERMINATE_AUTOMATION: "Terminate Automation",
                OPEN_AI: "OPEN_AI",
                CREATE_CONTACT: "Create Contact",
                UPDATE_CONTACT: "Update Contact",
                FIND_CONTACTS: "Find Contacts",
                FIND_CONTACT: "Find Contact",
                FIND_CHATS: "Find Chats",
                FIND_CHAT: "Find Chat",
                WAIT_FOR: "Wait For",
                STRING_FORMAT: "Format String",
                NUMBER_FORMAT: "Format Number",
                DATE_FORMAT: "Format Date",
                RECORDS_FROM_CSV: "Records From CSV",
                MESSAGE_RECEIVED: "Message Received",
                ASK_AI: "Artificial Intelligent",
                OPENROUTER_RESPONSE: "OpenRouter AI Response",
                OPENAI_RESPONSE: "Generate with OpenAI",
                GOOGLE_AI_RESPONSE: "Generate with Google AI",
                ANTHROPIC_RESPONSE: "Generate with Anthropic",
                MISTRAL_RESPONSE: "Generate with Mistral",
                AZURE_RESPONSE: "Generate with Azure",
                BEDROCK_RESPONSE: "Generate with AWS Bedrock",
                COHERE_RESPONSE: "Generate with Cohere",
                XAI_RESPONSE: "Generate with xAI",
                DEEPINFRA_RESPONSE: "Generate with DeepInfra",
                TOGETHER_RESPONSE: "Generate with Together",
                FIREWORKS_RESPONSE: "Generate with Fireworks",
                SILICONFLOW_RESPONSE: "Generate with SiliconFlow",
                PARASAIL_RESPONSE: "Generate with Parasail",
                NEBIUS_RESPONSE: "Generate with Nebius",
                ALIBABA_RESPONSE: "Generate with Alibaba",
                XIAOMI_RESPONSE: "Generate with Xiaomi",
                SAMBANOVA_RESPONSE: "Generate with SambaNova",
                MOONSHOT_RESPONSE: "Generate with Moonshot",
                MINIMAX_RESPONSE: "Generate with MiniMax",
                NVIDIA_RESPONSE: "Generate with NVIDIA",
                TABLE_CREATE_RECORD: "Create Record",
                TABLE_DELETE_RECORD: "Delete Record",
                TABLE_UPDATE_RECORD: "Update Record",
                TABLE_FIND_RECORD: "Find Record",
                TABLE_FIND_RECORDS: "Find Records",
                ZOHO_FIND_RECORDS_BY_PHONE: "Zoho Find Record (with Phone)",
                ZOHO_ADD_ATTACHMENT_TO_RECORD: "Zoho Add Attachment",
                ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD: "Zoho Upload Image to Field",
                ZOHO_CREATE_RECORD: "Zoho Create Record",
                GET_SUPSIS_RECORD_BY_ID: "Get Record",
                SHOW_WIDGET: "Show Widget",
                META_SEND_CAPI_EVENT: "Send CAPI Event",
                GOOGLE_DRIVE_UPLOAD_FILE: "Upload File",
                GOOGLE_DRIVE_DOWNLOAD_FILE: "Download File",
                GOOGLE_DRIVE_GET_FILE_INFO: "Get File Info",
                GOOGLE_DRIVE_DELETE_FILE: "Delete File",
                FALLIMENTO: "FAIL",
                PLATTFORM_FLOW: "PLATTFORM",
                PUNTO_INICIO: "START POINT",
                SUCCESSO: "SUCCESS",
                autoForwardToOwnerForce: "Auto forward to owner (even when chatbot is active)",
            },
            openrouterResponse: "OpenRouter AI Response",
            selectProvider: "Select Provider",
            modelName: "Model",
            modelHint: "E.g.: google/gemini-2.0-flash-001, openai/gpt-4o",
            systemInstructions: "System Instructions (Optional)",
            systemInstructionsPlaceholder: "Tell the AI how to behave...",
            promptPlaceholder: "Write your question for the AI...",
            advancedSettings: "Advanced Settings",
            temperatureHint:
                "Lower values produce more consistent responses, higher values produce more creative responses (0-2)",
            maxTokens: "Max Tokens",
            maxTokensHint: "Maximum number of tokens to generate",
            maxTokensPlaceholder: "Default: Model limit",
            selectChannel: "Select Channel (Optional)",
            autoSelectChannel: "Auto select",
            automationPublishedStateUpdatedSupdatedSuccessfully: "Automation published state updated successfully",
            automationsCouldNouldNotBeFetched: "Automations could not be fetched",
            automazioni: "Automations",
            cancelado: "Cancelled",
            webhookAutomationCutomationCreatedSuccessfully: "Webhook Automation Created Successfully",
        },
        modules: {
            kanbanSettings: {
                title: "Settings",
                column: "Column Settings",
                selectField: "Select a field",
                selectFieldPlaceholder: "Select a field",
                card: "Card Settings",
                selectFields: "Select fields to show in card",
                cancel: "Cancel",
                save: "Save",
                kanban: "Kanban Settings",
            },
            createFailed: "Module creation failed",
            createSuccess: "Module created successfully",
            moduleDeletedSuccessfully: "Module deleted successfully.",
            deleteModuleTitle: "Delete Module",
            deleteModuleContent: "Are you sure you want to delete this module?",
            modules: "Modules",
            editModule: "Edit Module",
            editRelation: "Edit Relation",
            updateSuccess: "Module updated successfully",
            updateFailed: "Module update failed",
            relations: "Relations",
            modulesSettings: "Module Settings",
            displayName: "Display Name",
            description: "Description",
            table: "Table",
            menuApiSettings: "Menu and API Settings",
            icon: "Icon",
            save: "Save",
            exampleIcon: "Ex: extension, home",
            newModule: "New Module",
            newRelation: "New Relation",
            moduleName: "Module Name",
            apiName: "API Name",
            type: "Type",
            apiAccess: "API Access",
            actions: "Actions",
            module: "Module",
            relation: "Relation",
            moduleRelationName: "Module/Relation Name",
            moduleRelationTable: "Module/Relation Table",
            showInMainMenu: "Show in Main Menu",
            apiEnabled: "API Enabled",
            settings: "Settings",
            createModule: "Create Module",
            relationType: "Relation Type",
            relationTypeTableToTable: "Table to Table",
            relationTypeTableToStandart: "Table to Standard Module",
            relationTypeStandartToTable: "Standard Module to Table",
            fromColumn: "From",
            toColumn: "To",
            apiDoc: "API Doc",
            standartModule: "Standart Module",
            customTable: "Custom Table",
            localField: "Local Field",
            showingRemoteFieldInList: "Showing Remote Field In List",
            relationSettings: "Relation Settings",
            remoteField: "Remote Field",
            localFieldType: "Local Field Type",
            standart: "Standart",
            custom: "Custom",
            contact: "Contact",
            viewRecord: "Open",
            recordDetail: "Record Detail",
            recordNotFound: "Record or table information not found",
            relatedLists: "Related Lists",
            recordViewer: "Record Viewer",
            priority_high: "High",
            priority_highest: "Highest",
            priority_low: "Low",
            priority_lowest: "Lowest",
            priority_medium: "Medium",
        },
        tables: {
            enterWidgetName: "Enter widget name",
            widgetName: "Widget Name",
            renameWidget: "Rename Widget",
            assistantCapabilities: "Assistant Capabilities",
            addNewFieldsToTable: "Can add new fields to the table",
            editExistingFields: "Can edit existing fields",
            deleteUnnecessaryFields: "Can delete unnecessary fields",
            filterRecords: "Can filter records",
            groupRecords: "Can group records",
            hideFieldsCapability: "Can hide fields",
            createConditionalFormatting: "Can create conditional formatting",
            createCalculationFormulas: "Can create calculation formulas",
            createSampleRecords: "Can create sample records",
            examplePrompt:
                "Example: Add Name, Surname, Email, and Phone fields for customer information to this table...",
            supsisAssistantTables: "Supsis Assistant: Tables",
            supsisAssistantWritePrompt: "Describe what you want the Supsis Assistant to do",
            supsisAssistantExamplePrompt:
                "Create a table to track meetings. Include fields such as meeting topic, date, participants, responsible person, decisions made, and follow-up actions.",
            sendSupsisAssistant: "Send to Supsis Assistant",
            examplePromptsTitle: "Example Requests:",
            examplePrompts: {
                addCustomerInfoFields:
                    "Add Name, Surname, Email, and Phone fields for customer information to this table.",
                addOrderFields:
                    "Add Product Name, Quantity, Unit Price, Total Amount, and Order Date fields to the orders table.",
                addBirthDateField: "Add a Birth Date field to this table and set the date format to DD/MM/YYYY.",
                updateStatusField:
                    "Update the Status field, make it a dropdown with options: Pending, Processing, Completed, Cancelled.",
                replaceAddressFields:
                    "Delete the Address field and add Address Line 1, Address Line 2, District, City, and Postal Code fields instead.",
                alignTextFields:
                    "Center align all text fields and limit the maximum length of texts to 100 characters.",
                addAutoIncrementID: "Add an auto-incrementing ID field with the prefix PRD- for the product.",
                addTotalAmountFormula:
                    "Add the Total Amount field as a formula to calculate the product of quantity and unit price.",
                createActiveCustomersFilter: "Create a filter to show only active customers.",
                filterRecentUsers: "Filter users who registered in the last 30 days.",
                groupByStatus: "Group records by the Status column.",
                hideAllExceptDeliveryAndOrderNo: "Hide all fields except Delivery Date and Order Number.",
                colorCodeOrders:
                    "Color delayed orders in red, those to be delivered today in yellow, and completed ones in green.",
                highlightHighPaymentRecords: "Highlight records with a payment amount over 1000 TL in purple.",
                groupAndHighlightUnpaidOrders: "Group by order date and show unpaid ones in red.",
                createSampleRecords: "Create 10 sample records in this table.",
                addSampleRecordsForAliAndAhmet: "Add 5 sample records with customer names Ali and Ahmet.",
                createRandomSampleOrders: "Create 20 sample order records with random statuses.",
                hrCandidateTracking:
                    "I want to create a candidate tracking software (ATS) for our HR processes. Include everything an ATS should have. Use Turkish field names.",
                crmModuleCreation:
                    "Create all necessary modules for Customer Relationship Management (CRM). Include customer information, meeting records, and opportunity management.",
                realEstatePortfolioManagement:
                    "I want to set up a real estate portfolio management system. It should handle property details, customer requests, and sales tracking.",
                schoolManagementSystem:
                    "I want to manage student, teacher, and class schedule tracking for a school management system. Use Turkish field names.",
                projectManagementSystem:
                    "I want to create a project management system. Include tasks, team members, time tracking, and reporting features.",
                inventoryAndWarehouseManagement:
                    "I want to build a system for stock and warehouse management. It should handle product check-ins/outs, stock levels, and supplier tracking.",
                serviceAndMaintenanceTracking:
                    "I want a service and maintenance tracking system. It should manage customer devices, maintenance history, and technician assignments.",
                restaurantManagementSystem:
                    "I want to set up a restaurant management system. Include table tracking, order management, kitchen display, and billing operations.",
            },
            createAppWithSupsisAssistant: "Create App with Supsis Assistant",
            noWidgets: "No widgets added",
            widgetLoadError: "Widget could not be loaded",
            createDashboardSupsisAssistant: "Create Dashboard with Supsis Assistant",
            youtubeDesc: "Embed Youtube videos into your panel",
            iframeDesc: "Embed external web content into your panel",
            countdownDesc: "Add a countdown timer to track important deadlines",
            countdown: "Countdown",
            textDesc: "Add custom text content to your panel",
            numbersDesc: "Get a quick overview of all number columns",
            numbers: "Numbers",
            addWidget: "Add Widget",
            graphDesc: "Create a graph widget to visualize data in your tables",
            graph: "Graph",
            suggested: "Suggested",
            upload: "Upload",
            otherTables: "Other Tables",
            noTablesFound: "No tables found",
            renameView: "Rename View",
            enterNewViewName: "Enter New View Name",
            viewNameRequired: "View Name Required.",
            viewRenamedSuccess: "View renamed successfully.",
            viewRenameError: "An error occurred while renaming the view.",
            deleteView: "Delete View",
            confirmDeleteView: "Are you sure you want to delete this view?",
            viewDuplicatedSuccess: "View duplicated successfully.",
            viewDuplicateError: "An error occurred while duplicating the view.",
            duplicateView: "Duplicate View",
            confirmDuplicateView: "Are you sure you want to duplicate this view?",
            viewDeletedSuccess: "View deleted successfully.",
            viewDeleteError: "An error occurred while deleting the view.",
            creationDate: "Creation Date",
            today: "Today",
            month: "Month",
            week: "Week",
            day: "Day",
            table: "Table",
            kanban: "Kanban",
            calendar: "Calendar",
            colorBy: "Color By",
            startDateField: "Start Date Field",
            endDateField: "End Date Field (Optional)",
            eventCardFields: "Event Card Fields",
            selectColorField: "Select Color Field",
            selectStartDateField: "Select Start Date Field",
            selectEndDateField: "Select End Date Field",
            cancel: "Cancel",
            save: "Save",
            kanbanNotAvailable: "Kanban View Not Available",
            needDropdownField:
                "To use the Kanban view, you need at least one static dropdown field in your table. You can add a new field or edit an existing one from the table settings.",
            notAvailable: "Calendar View Not Available",
            needDateField:
                "You need at least one date field in your table to use calendar view. You can add a new field or edit an existing one from table settings.",
            switchToTable: "Switch to Table View",
            calendarSettings: "Calendar Settings",
            operator: "Operator",
            conditionalColor: "Conditional Color",
            groupField: "Group Field",
            selectDirection: "Select Direction",
            showEmptyGroups: "Show Empty Groups",
            clearGrouping: "Clear Grouping",
            applyGrouping: "Apply Grouping",
            sortDirection: "Sort Direction",
            downloadSelectedRecords: "Download Selected Records",
            downloadSelected: "Download Selected",
            downloadSelectedWithCount: "Download Selected ({count})",
            downloadThisPage: "Download This Page",
            downloadAll: "Download All",
            downloadRecords: "Download Records",
            downloadRecordsSettings: "Download Records - Settings",
            recordLimitExceededTooltip: "Record limit reached. You need to upgrade your plan to import records.",
            zebraMode: "Zebra Mode",
            viewName: "View Name",
            enterViewName: "Enter View Name",
            enterDesc: "Enter Description",
            runWebhookAutomation: "Run Webhook Automation",
            downloadAllRecords: "Download All Records",
            deleteRecords: "Delete Records",
            editRecords: "Update Records",
            duplicateRecords: "Duplicate Records",
            selected: "Selected",
            sureDeleteRecords: "Are you sure you want to delete records?",
            selectedRecordSucs: "Selected records were deleted successfully.",
            errorDeletingRecords: "An error occurred while deleting records.",
            sureCopyRecords: "Are you sure you want to copy the records?",
            copyRecords: "Copy Records",
            recordsCopiedSucs: "The selected records were copied successfully.",
            recordsCopiedError: "An error occurred while copying the selected records.",
            viewSucsCreated: "The view was created successfully.",
            editMultipleRecords: "Edit Multiple Records",
            importRecords: "Import Records",
            importHasStarted:
                "Import has started. It may take a few minutes depending on the size of your data. Please wait...",
            anErrorImport: "An error occurred during import.",
            recordCreated: "Create Record",
            recordUpdated: "Update Record",
            recordDeleted: "Delete Record",
            noAutomationDefined: "No automation defined yet",
            nameTheAutomationAdd: "Name the automation that will run when a record is added to this table:",
            nameTheAutomationUpdate: "Name the automation that will run when a record in this table is updated:",
            nameTheAutomationDelete: "Name the automation that will run when a record is deleted from this table:",
            editField: "Edit Field",
            sort: "Sort",
            sortAscending: "Sort A-Z",
            sortDescending: "Sort Z-A",
            clearSort: "Clear Sort",
            markAsIdentifierField: "Mark as Identifier Field",
            runAI: "Run AI",
            ascending: "Ascending",
            descending: "Descending",
            createField: "Create Field",
            insertBefore: "Insert Before",
            insertAfter: "Insert After",
            goToRelatedAuto: "Go to Related Automation",
            permission: "Permission",
            lockField: "Lock Field",
            hideField: "Hide Field",
            deleteField: "Delete Field",
            watchVideo: "Watch Video",
            uploadError: "Upload Error",
            updateError: "Update Error",
            invalidValue: "Invalid value. Please use the correct format.",
            errorUpdatingRecord: "An error occurred while updating the record.",
            errorCreatingView: "An error occurred while creating the view.",
            datetimeOptions: "Date Time Options",
            numberOptions: "Number Options",
            currencyOptions: "Currency Options",
            dropdownOptions: "Dropdown Options",
            automationButtonOptions: "Automation Button Options",
            defaultLabel: "Default Label",
            disableWhenClicked: "Disable When Clicked",
            fieldSucsCreate: "Field Created Successfully",
            fieldCreatingFailed: "An error occurred while creating the field",
            fieldSucsUpdate: "Field Updated Successfully",
            fieldUpdatingFailed: "An error occurred while updating the field",
            showAll: "Show All",
            hideAll: "Hide All",
            searchFields: "Search Fields",
            firstRowHeader: "First Row Contains Header",
            separatorCharacter: "Separator Character",
            comma: "Comma",
            semicolon: "Semicolon",
            tableFieldOrFileColumns: "Table Field / File Columns Mapping",
            exampleResultPreview: "Example Result Preview",
            errorProcessingFile: "An error occurred while processing the file",
            newView: "New View",
            selectedMenuItem: "Selected menu item:",
            deleteTable: "Delete Table",
            sureDeleteTable: "Are you sure you want to delete this table?",
            deleteTableSucs: "The table was deleted successfully.",
            deleteTableError: "Error deleting table:",
            editTable: "Edit Table",
            createNewField: "Create New Field",
            tables: "Tables",
            tableName: "Table Name",
            description: "Description",
            createTable: "Create Table",
            createNewTable: "Create New Table",
            allTables: "All Tables",
            myTables: "My Tables",
            myFavorites: "My Favorites",
            errorCreatingTable: "Error creating table:",
            customerTable: "Customer Table",
            customerTableDesc: "Default customer table",
            leadTracking: "Lead Tracking",
            leadTrackingDesc: "Lead tracking table",
            todoList: "Todo List",
            todoListDesc: "List for tracking tasks",
            approvalReq: "Approval Request",
            approvalReqDesc: "Management of approval requests",
            eventSchedule: "Event Schedule",
            eventScheduleDesc: "Planning upcoming events",
            inventoryList: "Inventory List",
            inventoryListDesc: "Keeps track of product stocks",
            bookingForm: "Reservation Form",
            bookingFormDesc: "Tracking reservations",
            bugTracker: "Bug Tracker",
            bugTrackerDesc: "Tracking software bugs",
            employeeDirectory: "Employee Guide",
            employeeDirectoryDesc: "Includes employee information",
            errorPullTable: "Error pulling table data.",
            newRecordSucs: "New record created successfully.",
            failedNewRecord: "Failed to create a new record:",
            newRecordCreateError: "An error occurred while creating a new record.",
            recordCount: "Record Count",
            increaseLimit: "Increase Limit",
            newRecord: "New Record",
            imports: "Import",
            exports: "Export",
            download: "Download",
            automateYourData: "Automate Your Data",
            recordUpdatedSucs: "Record Updated Successfully",
            failedToUpdateRecord: "Failed to Update Record",
            recordUpdatingError: "Error updating record",
            mainTable: "Main Table",
            filter: "Filter",
            hideFields: "Hide Fields",
            saveAsView: "Save As View",
            search: "Search",
            create: "Create",
            left: "Left",
            center: "Center",
            right: "Right",
            selectTimezone: "Select time zone",
            createFieldSucs: "Field created successfully.",
            failedCreateField: "Failed to create field:",
            createFieldError: "An error occurred while creating the field.",
            addCondition: "Add Condition",
            applyFilter: "Apply Filter",
            fieldType: "Field Type",
            alignment: "Alignment",
            blankTable: "Blank Table",
            templates: "Templates",
            timezone: "Time Zone",
            timeFormat: "Time Format",
            includeTime: "Include Time",
            decimalFormat: "Decimal Format",
            currencySymbol: "Currency Symbol",
            mode: "Mode",
            statics: "Static",
            dynamic: "Dynamic",
            multipleSelection: "Multiple Selection",
            addOption: "Add Option",
            text: "Text",
            longText: "Long Text",
            number: "Number",
            currency: "Currency",
            datetime: "Date & Time",
            dropdown: "Dropdown List",
            checkbox: "Checkbox",
            email: "Email",
            phone: "Phone",
            file: "File",
            image: "Image",
            video: "Video",
            audio: "Audio",
            color: "Color",
            automationButton: "Automation Button",
            permissions: {
                title: "Table Privacy Settings",
                mode: "Permission Mode",
                publicMode: "Public",
                customMode: "Custom",
                publicModeDesc: "In this mode, all users have full access to the table.",
                customModeDesc: "In this mode, only certain users and departments have access to the table.",
                confirmPublicMode: "Switch to Public Mode",
                confirmPublicModeDesc:
                    "If you switch to public mode, all custom permissions will be deleted. Do you want to continue?",
                addUser: "Add User",
                addDepartment: "Add Department",
                selectUser: "Select User",
                selectDepartment: "Select Department",
                add: "Add",
                matrixInfo:
                    "You can manage permissions for users and departments from the matrix below. The checked boxes mean authorized.",
                targetHeader: "User / Department",
                noTargetsAdded: "No users or departments added yet",
                confirmRemoveTarget: "Remove Target",
                confirmRemoveTargetDesc: "Are you sure you want to remove this user/department from the permissions?",
                saveSuccess: "Permission settings saved successfully",
                saveError: "Error saving permission settings",
                unknownUser: "Unknown User",
                unknownDepartment: "Unknown Department",
                noPermission: "You don't have permission to do this action",
                groups: {
                    basic: "Basic Permissions",
                    record: "Record Permissions",
                    view: "View Permissions",
                    page: "Page Permissions",
                    field: "Field Permissions",
                    widget: "Widget Permissions",
                    importExport: "Import/Export",
                },
                scopes: {
                    tableRead: "View",
                    tableReadDesc: "View table",
                    tableMetaEdit: "Table Edit",
                    tableMetaEditDesc: "Edit table name, category and description",
                    recordCreate: "Record Create",
                    recordCreateDesc: "Create a new record",
                    recordUpdate: "Record Update",
                    recordUpdateDesc: "Update existing records",
                    recordDelete: "Record Delete",
                    recordDeleteDesc: "Delete records",
                    viewCreate: "View Create",
                    viewCreateDesc: "Create a new view",
                    viewUpdate: "View Update",
                    viewUpdateDesc: "Update existing views",
                    viewDelete: "View Delete",
                    viewDeleteDesc: "Delete views",
                    pageRead: "Page View",
                    pageReadDesc: "View special pages",
                    pageCreate: "Page Create",
                    pageCreateDesc: "Create a new page",
                    pageUpdate: "Page Update",
                    pageUpdateDesc: "Update existing pages",
                    pageDelete: "Page Delete",
                    pageDeleteDesc: "Delete pages",
                    fieldCreate: "Field Create",
                    fieldCreateDesc: "Create a new field",
                    fieldUpdate: "Field Update",
                    fieldUpdateDesc: "Update existing fields",
                    fieldDelete: "Field Delete",
                    fieldDeleteDesc: "Delete fields",
                    widgetCreate: "Widget Create",
                    widgetCreateDesc: "Create a new widget",
                    widgetUpdate: "Widget Update",
                    widgetUpdateDesc: "Update existing widgets",
                    widgetDelete: "Widget Delete",
                    widgetDeleteDesc: "Delete widgets",
                    bulkImport: "Bulk Import",
                    bulkImportDesc: "Bulk import records",
                    export: "Export",
                    exportDesc: "Export records",
                },
            },
            trashBin: "Trash Bin",
            pasteInfoDetected: "A table copied to clipboard was detected! Paste with Ctrl+V to create a new table.",
            addCategory: "Add Category",
            editCategory: "Edit Category",
            deleteCategory: "Delete Category",
            moveAllTables: "Move All Tables",
            dragTablesToCategory: "Drag tables here to add them to this category",
            deleteProtectionActive: "Delete protection active",
            copyTable: "Copy Table",
            copyAsJSON: "Copy as JSON",
            changeCategory: "Change Category",
            turnOffDeleteProtection: "Turn Off Delete Protection",
            turnOnDeleteProtection: "Turn On Delete Protection",
            privacySettings: "Privacy Settings",
            categoryName: "Category Name",
            categoryNamePlaceholder: "Enter category name",
            categoryUpdate: "Update",
            categoryCreate: "Create",
            categoryNameRequired: "Category name cannot be empty",
            categoryAlreadyExists: "A category with this name already exists",
            categoryCreated: "Category created. You can drag tables to this category.",
            categorySaveError: "Error saving category",
            categoryUpdated: "Category updated",
            categoryUpdateError: "Error updating category",
            deleteCategoryConfirm: "Delete Category",
            deleteCategoryConfirmContent:
                'Are you sure you want to delete "{name}"? Tables in this category will be moved to "General".',
            categoryDeleted: "Category deleted",
            categoryDeleteError: "Error deleting category",
            tableMovedToCategory: 'Table moved to "{name}" category',
            tableMoveError: "Error moving table",
            tableProtectedWarning: "This table is protected from deletion. Remove protection first to delete.",
            deleteProtectionEnabled: "Delete protection enabled",
            deleteProtectionDisabled: "Delete protection disabled",
            protectionUpdateError: "Error updating protection status",
            tableCopied: "Table copied",
            tableCopyError: "Error copying table",
            tableJsonCopied: "Table copied to clipboard as JSON. You can paste with Ctrl+V in another customer panel.",
            tableJsonCopiedFallback: "Table copied to clipboard as JSON (fallback method)",
            tableJsonCopyError: "Error copying table as JSON",
            clipboardNotSupported: "Clipboard access is not supported in this browser",
            noValidTableJson: "No valid table JSON found in clipboard",
            noValidSupsisExport: "No valid Supsis table export found in clipboard",
            tableImported: '"{name}" table imported successfully',
            tablePasteError: "Error pasting table",
            noTablesToMove: "No tables to move",
            tablesMovedToCategory: '{count} tables moved to "{name}" category',
            tablesMoveError: "Error moving tables",
            noPermissionEditPrivacy: "You don't have permission to edit this table's privacy settings",
            sandboxTitle: "Deleted Table Scenarios",
            sandboxDesc: "Deleted tables are automatically permanently deleted after 30 days in the trash",
            sandboxEmpty: "No deleted tables in trash",
            unnamedTable: "Unnamed Table",
            restore: "Restore",
            permanentlyDelete: "Permanently Delete",
            unknown: "Unknown",
            user: "User",
            restoreTableConfirm: "Are you sure you want to restore this table?",
            restoreTableContent: "{name} table will be restored.",
            tableRestored: "Table restored",
            restoreFailed: "Restore failed",
            permanentlyDeleteConfirm: "Are you sure you want to permanently delete this table?",
            permanentlyDeleteContent: "{name} table will be permanently deleted. This action cannot be undone.",
            yesPermanentlyDelete: "Yes, Permanently Delete",
            tablePermanentlyDeleted: "Table permanently deleted",
            permanentDeleteFailed: "Permanent delete failed",
            deletedTablesLoadError: "Error loading deleted tables",
            seperatorCharacter: "Separator Character",
            semicolan: "Semicolon",
            createViewaFiltering:
                "Create Views to continue filtering, sorting, and hiding fields without changing the Main Table.",
            pleaseUpdateSelected: "Please select the field you want to update for the selected records.",
            pleaseSelectedNewValue: "Please enter the new value for the selected field.",
            ascendente: "Ascending",
            centro: "Center",
            colore: "Color",
            colour: "Color",
            company: "Company",
            createFailed: "Failed to create module",
            createSuccess: "Module created successfully",
            destra: "Right",
            dinamico: "Dynamic",
            discendente: "Descending",
            dynamisch: "Dynamic",
            failCreateField: "Failed to create field:",
            failToUpdateRecord: "Failed to update record",
            immagine: "Image",
            individual: "Individual",
            izquierda: "Left",
            priority_high: "High",
            priority_highest: "Highest",
            priority_low: "Low",
            priority_lowest: "Lowest",
            priority_medium: "Medium",
            rechts: "Right",
            sinistra: "Left",
            statica: "Static",
            tabelle: "Table",
        },
        plans: {
            manageWithChatbot: "Manage with Chatbot",
            manageInbox: "Manage Inbox",
            commentManagement: "Manage Comments",
            privateReplyMessage: "Private Reply Comments",
            mentionTicket: "Convert Mentions to Tickets",
            week: "Week",
            readyContents: "Ready Contents",
            webhookIntegration: "Webhook Integration",
            businessChannel: "WhatsApp Business Channel",
            confirmationFeature: "Confirmation Feature",
            specialReporting: "Special Reporting",
            aiAssistant: "AI Assistant",
            flexibleBilling: "Flexible Billing",
            automaticReservation: "Automatic Reservation",
            taskManagement: "Task Management",
            calendarIntegration: "Calendar Integration",
            activeChatbot: "Active Chatbot",
            smsIntegration: "SMS Integration",
            mailIntegration: "Mail Integration",
            startChatWithVisitor: "Start Chat With Visitor",
            whatsappManaging: "Whatsapp Management",
            automaticChatbotButton: "Automatic Button/Chatbot",
            personalizedBroadcasts: "Personalized Broadcasts",
            chatWithNonContacts: "Chat With Non-Contacts",
            broadcastMessaging: "Broadcast Messaging",
            perBroadcast: "Per Broadcast",
            extraPricePerMessage: "Extra Price Per Message",
            smartTrigger: "Smart Trigger",
            telegramIntegration: "Telegram Integration",
            instagramIntegration: "Instagram Integration",
            ticketFeature: "Ticket Feature",
            storage: "Storage",
            onePanelManagement: "One Panel Management",
            isolatedDatabaseConnection: "Isolated Database Connection",
            removeLogo: "Remove Supsis Logo",
            chatBaloonCustomization: "Chat Balloon Customization",
            chatAndNotifications: "Chat and Notifications",
            unlimited: "Unlimited",
            specialCustomerSupport: "Special Customer Support",
            softwareSupport: "Software Support",
            standardSupport: "Standard Support",
            teamChatIntegration: "Team Chat Integration",
            fileAndVoiceShare: "File and Voice Share",
            instantVisitor: "Instant Visitor Tracking",
            detailedReporting: "Detailed Reporting",
            normalreporting: "Normal Reporting",
            noExtraCosts: "No Extra Costs",
            accessibleToAllAgents: "Accessible to All Agents",
            dataSecurity: "Data Security",
            autoTranslate: "Auto Translate",
            chatbotVersionHistory: "Chatbot Version History",
            chatbotStory: "Chatbot Story",
            freeAgent: "Free Agent",
            stableAgentCount: "Stable Agent Count",
            stableChannelCount: "Stable Channel Count",
            chipPlans: "Affordable Plans",
            generalPlan: "General Plan",
            specialPlan: "Special Plan",
            currentPlan: "Current Plan",
            selected: "Selected",
            popular: "Popular",
            trialPkg: "Trial Package",
            support: "24/7 Support",
            flexiblePricing: "Flexible Pricing",
            rightToCancel: "Right to Cancel Anytime",
            unlimitedCBScenario: "Unlimited Chatbot Scenarios",
            freeFirstScenario: "Free First Scenario",
            unlimitedLearn: "Unlimited Chatbot Training",
            allPlatformIntegration: "Integration with All Platforms",
            detailedReports: "Detailed Reports",
            aiSupport: "AI Support",
            creativeAI: "Fast and Realistic AI Chat Assistant",
            unlimitedSession: "Unlimited Sessions Simultaneously",
            assistantFromWebsite: "Creating Assistant from Website",
            assistantFromDoc: "Creating Chatbot from Document",
            mobileApp: "Mobile App",
            commentManage: "Manage Comments",
        },
        messenger: {
            channel: "Messenger Channel",
            manageChannel: "Manage Channel",
            channelDetail: "Channel Detail",
            integrationTitle: "Messenger Integration",
            deleteDesc: "Are you sure you want to delete the Messenger channel?",
            channels: "Messenger Channels",
            connectMessenger: "Connect to Messenger",
            detail: "Detail",
            visibility: "Visibility",
            settings_group: "Settings",
            commentsettings: "Comment Management",
            commentSettingsTitle: "Messenger Comment Management",
            commentSettingsDesc: "Manage your Messenger comments",
            adoptimization: "Ad Optimization",
        },
        instagram: {
            channel: "Instagram Channel",
            detail: "Detail",
            visibility: "Visibility",
            settings_group: "Settings",
            commentsettings: "Comment Management",
            commentSettingsTitle: "Instagram Comment Management",
            commentSettingsDesc: "Manage your Instagram comments",
            commentSettingsTicket: "Ensures that incoming comments are recorded in the system as tickets.",
            commentSettingsChatbot: "Select which chatbot scenario incoming comments should be directed to.",
            leads: "Leads",
            forms: "Forms",
            showAllInstagramChannels: "Show All Instagram Channels",
            showAllLinkedinChannels: "Show All Linkedin Channels",
            showAllTelegramChannels: "Show All Telegram Channels",
            adoptimization: "Ad Optimization",
            brand: "Brand",
            questions: "Questions",
        },
        calendar: {
            calendarsDesc: "Avoid schedule conflicts.",
            generalAvailability: "General Availability",
            generalAvailabilityDesc: "Specify the times when you are regularly available for appointments.",
            appointDuration: "Appointment duration",
            appointDurationDesc: "How long should each appointment last?",
            customDuration: "Custom Duration",
            descriptionDesc:
                "Add a note describing your service. Your note will appear on your booking page and in confirmation emails.",
            resForm: "Booking Form",
            resFormDesc: "Customize the form that people will use to book an appointment.",
            addField: "Add Field",
            addAnItem: "Add an Item",
            saveItem: "Save Item",
            planningTimeframe: "Planning Timeframe",
            planningTimeframeDesc: "Limit the time frame in which an appointment can be made.",
            availableAtMoment: "Available Now",
            startAndEndDate: "Start and end dates",
            maxNumberAppoint: "Maximum number of days after which an appointment can be made",
            howLongMinAppoint: "How long before the start of the appointment a minimum appointment can be booked",
            planningIntervalStartEnd: "Planning interval start and end dates",
            startTime: "Start Time",
            done: "Done",
            receivedAppointInterval: "Received Appointment Interval",
            receivedAppointIntervalDesc: "Manage received appointments to appear in your calendar.",
            interimTime: "Interim time",
            interimTimeDesc: "Add time between meeting intervals",
            dayMaxRes: "Maximum number of reservations per day",
            dayMaxResDesc: "Limit the number of booked appointments that can be accepted in a single day",
            customize: "Set Custom",
            noAvatar: "No Avatar",
            organizationName: "Organization Name",
            enterFullAdress: "Enter Full Address",
            noCoverPhoto: "No cover photo",
            enterAboutInfo: "Enter about information",
            service: "Service",
            deleteService: "Delete Service",
            enterGoogleMapsUrl: "Enter Google Maps URL",
            enterLatitude: "Enter latitude",
            enterLongitude: "Enter longitude",
            enterNumber: "Enter phone number",
            uploadAvatar: "Upload Avatar",
            teamMemberDeleteError: "Error deleting team member:",
            setupBookingWebsite: "Setup Booking Website",
            bookingLandingPageBuilder: "Booking Landing Page Builder",
            coverPhoto: "Cover Photo",
            enterOrganizationName: "Enter the organization name",
            about: "About",
            services: "Services",
            deleteServices: "Delete Service",
            selectReservationPlan: "Select Reservation Plan",
            addNewService: "Add New Service",
            addNewMember: "Add New Member",
            fullAddress: "Full Address",
            latitude: "Latitude",
            longitude: "Longitude",
            contactDetails: "Contact Details",
            emailAddress: "Email Address",
            enterEmail: "Enter email address",
            websiteURL: "Website URL",
            enterWebsiteURL: "Enter website URL",
            reservationPolicy: "Reservation Policy",
            enterResPolicy: "Enter booking policy",
            workingHours: "Working Hours",
            selectEndHour: "Select End Time",
            addNewHour: "Add New Hour",
            updateMemberInfo: "Update Member Information",
            errorRecevingData: "Error retrieving data:",
            anonymService: "Anonymous Service",
            unknownPlan: "Unknown Plan",
            errorCreatingMockPage: "Error creating mock page:",
            failedToCreateBookingPage: "Failed to create the booking page",
            fileSizeToolLarge: "File size too large",
            errorLoadingTheLogo: "Error loading the logo:",
            failedToLoadLogo: "Failed to load the logo",
            errorUpdating: "Error updating:",
            failedToUpdate: "Failed to update",
            newMember: "New Member",
            errorLoadingAvatar: "Error loading avatar:",
            avatarFailedToLoad: "Failed to load avatar",
            teamMemberSuccessfullyDeleted: "Team member successfully deleted",
            teamMemberNotDelete: "Failed to delete team member",
            yesDelete: "Yes, Delete",
            sureResDelete: "Are you sure you want to delete this booking?",
            resDetails: "Reservation Details",
            infoPersonMakingRes: "Booking Person's Information",
            appointmentProgram: "Appointment Schedule",
            goToAppointSettings: "Go to Appointment Schedule Settings",
            resPlanCreateSuccess: "Reservation plan created successfully",
            pleaseEnterTitle: "Please enter title",
            sureContinueSaving: "Are you sure you want to continue without saving?",
            appointProgram: "RESERVATION PROGRAM",
            everyMonth: "Every month",
            firstEveryMonth: "First of each month",
            dayOf: "Day",
            notRepeat: "Does not repeat",
            daily: "Everyday",
            weekly: "Once a week",
            monthly: "Once a month",
            annually: "Once a year",
            custom: "Special",
            eventSaved: "Event saved",
            createAppoint: "Create appointment",
            calendarSetting: "Callendar Settings",
            notAuthezord: "You are not authorized to do this",
            notAuthorizedToPerformOperation: "You are not authorized to perform this operation.",
            reservationWebPage: "Reservation Web Page",
            reservationBuilder: "Reservation Website",
            reservationPrograms: "Reservation Programs",
            automations: "Automations",
            addReservationProgram: "Add Reservation Program",
            resPlanError: "Error receiving reservation plans:",
            resDeleteSure: "Are you sure you want to delete this booking program?",
            resDeleteSuccess: "The reservation program was successfully deleted.",
            resDeleteError: "Error deleting the reservation program:",
            unkownUser: "Unknown User",
            eventNotFound: "Event Not Found",
            reservations: "Reservations",
            events: "Events",
            upcoming: "Upcoming",
            past: "Past",
            setting: "Settings",
            delete: "Delete",
            cancel: "Cancel",
            save: "Save",
            close: "Close",
            deleteRepeatEvent: "Delete Repeating Event",
            thisEvent: "This Event",
            thisAndOtherEvent: "This and Following Events",
            allEvent: "All Events",
            ok: "OK",
            googleCalendarLink: "Add to Google Calendar",
            yahooCalendarLink: "Add to Yahoo Calendar",
            subject: "Subject",
            visitor: "Visitor",
            allDay: "All Day",
            title: "Title",
            deleteEvent: "Delete Event",
            deleteEvents: "Delete Events",
            deleteEventsSure: "Are you sure you want to delete events associated with this calendar?",
            deleteEventConfirm: "Are you sure you want to delete this event?",
            notEmptyTitle: "Title cannot be empty!",
            tasks: "Tasks",
            googleConnect: "Connect Google Integration",
            googleDisconnect: "Disconnect Google Integration",
            sure: "Are you sure?",
            disconnectGoogleSure: "Are you sure you want to remove the Google connection?",
            yes: "Yes",
            no: "No",
            customRepeat: "Custom Repeat",
            recurrenceFrequency: "Repeat Frequency:",
            repeatDays: "Repeat on these days:",
            never: "Never",
            thisDate: "On This Date:",
            recurrenceCount: "Recurrence Count:",
            end: "End",
            event: "Event",
            calendars: "Calendars",
            newCalendar: "Create New Calendar",
            changeColor: "Change Color",
            addCalendar: "Add Calendar",
            nameCalendar: "Calendar Name",
            description: "Description",
            change: "Change",
            deleteCalendar: "Delete Calendar",
            deleteCalendarSure: "Are you sure you want to delete the calendar?",
            notEmptyCalendarName: "Calendar name cannot be empty",
            myEvents: "My Events",
            everyoneEvents: "All Events",
            haveEvent: " 's events",
            goCalendar: " Go to Calendar",
            goReservation: " Create Reservation",
            agents: " Agents",
            today: "Today",
            month: "Month",
            week: "Week",
            day: "Day",
            list: "List",
            planingIntervalStartEnd: "Planning interval start and end dates",
            weely: "Weekly",
            annualy: "Annually",
            appointmentDuration: "Appointment Duration",
            appointmentSchedule: "Appointment Schedule",
            calendari: "Calendars",
            customise: "Customise",
            enterOrganisationName: "Enter Organization Name",
            goToAppointmentSettings: "Go to Appointment Settings",
            infoPersonMakingReservation: "Information about the person making the reservation",
            reservationDetails: "Reservation Details",
            sureReservationDelete: "Are you sure you want to delete this reservation?",
            teamMemberNotDeleted: "Team member could not be deleted",
        },
        ticimax: {
            segment: "Segment",
            settings_group: "Settings",
            waitDayFromLastSend: "Wait Day Count from Last Sent Message Per Member",
            automationRuleName: "Automation Rule Name",
            time: "Time",
            year: "Year",
            month: "Month",
            dayOfMonth: "Day of Month",
            day: "Day",
            bySecond: "By Second",
            byMinute: "By Minute",
            byHour: "By Hour",
            byWeekNo: "By Week No",
            byYearDay: "By Year Day",
            byMonthDay: "By Month Day",
            byMonth: "By Month",
            december: "December",
            november: "November",
            october: "October",
            september: "September",
            august: "August",
            july: "July",
            june: "June",
            may: "May",
            april: "April",
            march: "March",
            february: "February",
            january: "January",
            byWeekDay: "By WeekDay",
            interval: "Interval",
            seconds: "Seconds",
            minutes: "Minutes",
            hourly: "Hourly",
            daily: "Daily",
            weekly: "Weekly",
            monthly: "Monthly",
            yearly: "Yearly",
            frequency: "Frequency",
            attributes: {
                vip: "VIP",
                segment: "Segment",
                province: "Province",
                country: "Country",
                phone: "Phone",
                email: "Email",
                fullname: "Full Name",
                couponPercent: "Coupon %",
                lastOrderDate: "Last Order",
                firstOrderDate: "First Order",
                county: "County",
                lastSource: "Last Source",
                firstSource: "First Source",
                lastPaymentType: "Last Payment Method",
                firstPaymentType: "First Payment Method",
                maxOrderAmount: "Maximum Order Amount",
                minOrderAmount: "Minimum Order Amount",
                totalOrderAmount: "Total Order Amount",
                totalOrderCount: "Total Order Count",
                usedCouponAmount: "Coupon Amount",
                usedCouponCount: "Coupon Count",
                tookDayFromLastOrder: "Days Since Last Order",
                isCouponUser: "Is Coupon User",
            },
            createAutomation: "Create Automation",
            previous: "Previous",
            createAutomationDesc: "Create and manage your message automations",
            newTicimaxChannel: "New Ticimax Channel",
            connextToTicimaxXml: "Connect to Ticimax XML Service",
            connectTicimax: "Connect to Ticimax",
            examplePreview: "Example Preview",
            completeAutomationRule: "Complete Automation Rule",
            configureMessage: "Configure Message",
            automationTimer: "Automation Timer",
            findTargetMembers: "Find Target Members",
            createAutomationRule: "Create Automation Rule",
            action: "Action",
            status: "Status",
            triggeredUserCount: "Triggered User Count",
            nextScheduled: "Next Scheduled",
            timerRule: "Timer Rule",
            automationRules: "Automation Rules",
            apply: "Apply",
            searchAMember: "Search a Member",
            segmentedMembersDesc: "List and automate your segmented members",
            manageVisibilityDesc: "Manage who can see the channel",
            xmlOrderListURL: "XML Order List URL",
            manageIntegrationDesc: "Manage your Ticimax integration",
            detail: "Detail",
            ticimaxChannelsTitle: "Ticimax Channels",
            ticimaxDetail: "Ticimax Detail",
            settingsGroup: "Settings",
            visibility: "Visibility",
            members: "Members",
            automation: "Automation",
            integrationChannel: "Integration Channel",
            channelUpdated: "Channel updated successfully",
            channelUpdateFailed: "Failed to update channel",
        },
        notification: {
            taskArchive: "Notification is sent when a task is archived.",
            taskComplet: "Notification is sent when a completed task is closed.",
            adjustNow: "Adjust now",
            chatAssignedMe: "When a chat is assigned to me.",
            ticketAssignedMe: "When a ticket is assigned to me.",
            myChatClosed: "When a chat I own is closed.",
            contactOwner: "When the chat owner changes, when ownership is assigned or removed.",
            tagActionsToVisitor: "When a tag is added or removed from a visitor.",
            ticketCreated: "When a visitor or chatbot creates a ticket.",
            notesActions: "When a note is added or removed from a customer.",
            visitorProfileUpdated: "When a visitor's profile is updated.",
            chatStartedByAnyPlatform: "When a chat is started from any channel.",
            userActions: "When a user is created, updated, or deleted.",
            departmentActions: "When a department is created, updated, or deleted.",
            settingsActions: "When settings are created, updated, or deleted.",
            integrationsActions: "When an integration channel is created, updated, or deleted.",
            loginFormActions: "When the login form is updated or activated.",
            bannedWordActions: "When a banned word is created, updated, or deleted.",
            emailActions: "When an email account is created, updated, or deleted.",
            preparedContentActions: "When prepared content is created, updated, or deleted.",
            roleActions: "When a role is created, updated, or deleted.",
            tagActions: "When a tag is created, updated, or deleted.",
            welcomeMessageActions: "When a welcome message is created, updated, or deleted.",
            webhookActions: "When a webhook is created, updated, or deleted.",
            billingEvents: "When an invoice is created or its status is updated.",
            systemStatus: "When the live support system status is updated.",
            reservationMessageCrud: "When a reservation is created, updated, or deleted.",
            ipAddressWhiteListEvents: "When an allowed IP address is added, updated, or deleted.",
            autoRebalanceEvents: "When an auto rebalance is completed, failed, or disabled.",
            automationActions: "Automation Actions",
            automationCreated: "{user} created an automation named {automation}.",
            automationDeleted: "{user} deleted an automation named {automation}.",
            automationPublished: "{user} published an automation named {automation}.",
            automationUnpublished: "{user} unpublished an automation named {automation}.",
            automationUpdated: "{user} updated an automation named {automation}.",
            automationCreatedNotification: "When an automation is created.",
            automationDeletedNotification: "When an automation is deleted.",
            automationPublishedNotification: "When an automation is published.",
            automationUnpublishedNotification: "When an automation is unpublished.",
            automationUpdatedNotification: "When an automation is updated.",
            taskAssignedMe: "When a task is assigned to me.",
            workflowCreated: "When a workflow is created.",
            workflowDeleted: "When a workflow is deleted.",
            createdTask: "When a task is created.",
            deletedTask: "When a task is deleted.",
            chatbotStoryCrud: "When a chatbot story is created, updated, or deleted.",
            chatbotForwardAgent: "The chatbot forwards a chat to an agent.",
            userSegmentCrud: "When a user segment is created, updated, or deleted.",
            chatbotCreditLow: "When the chatbot credit is low.",
            wpCreditLow: "When WhatsApp credit falls below 100 TL.",
            wpCustomerGroupCrud: "When a WhatsApp customer group is created, updated, or deleted.",
            wpBroadcastMessageStatus: "When a WhatsApp broadcast message is started, completed, or canceled.",
            wpTemplateMesssageCrud: "When a WhatsApp template message is created, updated, or deleted.",
            whatsappQrChannelStatusUpdated: "When the WhatsApp QR channel connection status is updated.",
            activityTypeLabels: {
                "chat-assign": "When a chat is assigned to me",
                "ticket-assign": "When a ticket is assigned to me",
                "task-assign": "When a task is assigned to me",
                "task-complet": "When a task is completed",
                "chat-close-own": "When chat that I own is closed",
                "tag-actions-to-visitor": "Tags added or removed from a contact",
                "create-ticket":
                    "Ticket is created by visitor or chatbot. Also, when a send offline message is sent from the chat window",
                "note-actions-to-visitor": "Notes added or removed from a contact",
                "visitor-profile-updates": "Visitor profile updates",
                "chat-start": "Chat is started on any platform by contact or agent",
                "user-crud": "User is created, updated or deleted",
                "department-crud": "Department is created, updated or deleted",
                "settings-crud": "Settings are created, updated or deleted",
                "integration-channel-crud": "Integration channel is created, updated or deleted",
                "login-form-crud": "Login form is updated or activated or deactivated",
                "banned-word-crud": "Banned word is created, updated or deleted",
                "email-account-crud": "Email account is created or deleted",
                "prepared-content-crud": "Prepared content is created or deleted",
                "role-crud": "Role is created, updated or deleted",
                "tag-crud": "Tag is created, updated or deleted",
                "welcome-message-crud": "Welcome message is created, updated or deleted",
                "webhook-crud": "Webhook is created, updated or deleted",
                "automation-created": "Automation is created",
                "automation-deleted": "Automation is deleted",
                "automation-published": "Automation is published",
                "automation-unpublished": "Automation is unpublished",
                "automation-updated": "Automation is updated",
                "billing-events": "Billing events",
                "task-workflow-crud": "Task workflow is created, updated or deleted",
                "task-crud": "Task is created, updated or deleted",
                "system-status": "System online or offline status changes",
                "chatbot-story-crud": "Chatbot story is created, updated or deleted",
                "chatbot-forward-chat": "Chatbot forwards a chat to agent",
                "chatbot-user-segment-crud": "User segment is created, updated or deleted",
                "chatbot-credit-low": "When chatbot credit is low",
                "whatsapp-credit-low": "When whatsapp credit is low",
                "whatsapp-customer-group-crud": "When whatsapp customer group is created, updated or deleted",
                "whatsapp-broadcast-message-crud": "When whatsapp broadcast message is sent or completed or cancelled",
                "whatsapp-template-message-crud": "When whatsapp template message is created, updated or deleted",
                "form-created": "Form is created",
                "form-updated": "Form is updated",
                "form-deleted": "Form is deleted",
                "form-restored": "Form is restored",
                "form-downloaded": "Form is downloaded",
                "user-role-changed": "User role is changed",
                "user-password-changed": "User password is changed",
                "user-email-changed": "User email address is changed",
                "user-name-changed": "User name is changed",
                "user-phone-changed": "User phone is changed",
                "user-disabled": "User is disabled/enabled",
                "role-updated": "Role is updated",
                "task-workflow-updated": "Task workflow is updated",
                "task-workflow-pipeline-stage-added": "Task workflow pipeline stage is added",
                "task-workflow-pipeline-stage-updated": "Task workflow pipeline stage is updated",
                "task-workflow-pipeline-stage-deleted": "Task workflow pipeline stage is deleted",
                "drive-folder-created": "Drive folder is created",
                "drive-folder-deleted": "Drive folder is deleted",
                "drive-folder-renamed": "Drive folder is renamed",
                "drive-file-added": "File is added to Drive",
                "drive-file-deleted": "File is deleted from Drive",
                "task-module-rules-enabled": "Task module rules are enabled",
                "task-module-rules-disabled": "Task module rules are disabled",
                "task-module-rules-rule-added": "Rule is added to task workflow",
                "task-module-rules-rule-deleted": "Rule is deleted from task workflow",
                "task-module-rules-rule-updated": "Rule is updated in task workflow",
                "task-module-rules-rule-enabled": "Rule is enabled in task workflow",
                "task-module-rules-rule-disabled": "Rule is disabled in task workflow",
                "contact-module-rules-enabled": "Contact module rules are enabled",
                "contact-module-rules-disabled": "Contact module rules are disabled",
                "contact-module-rules-rule-added": "Rule is added to contact module",
                "contact-module-rules-rule-updated": "Rule is updated in contact module",
                "contact-module-rules-rule-deleted": "Rule is deleted from contact module",
                "contact-module-rules-rule-enabled": "Rule is enabled in contact module",
                "contact-module-rules-rule-disabled": "Rule is disabled in contact module",
                "developer-token-changed": "Developer token is updated",
                "table-created": "Table is created",
                "table-field-added": "Field is added to table",
                "table-field-updated": "Field is updated in table",
                "table-field-deleted": "Field is deleted from table",
                "table-view-added": "View is added to table",
                "table-view-updated": "View is updated in table",
                "table-view-deleted": "View is deleted from table",
                "table-page-added": "Page is added to table",
                "table-page-updated": "Page is updated in table",
                "table-page-deleted": "Page is deleted from table",
                "table-widget-added": "Widget is added to table page",
                "table-widget-updated": "Widget is updated in table page",
                "table-widget-deleted": "Widget is deleted from table page",
                "table-privacy-changed": "Table privacy settings are updated",
                "web-app-created": "Web application is created",
                "web-app-updated": "Web application is updated",
                "web-app-deleted": "Web application is deleted",
                "web-tab-created": "Web tab is created",
                "web-tab-updated": "Web tab is updated",
                "web-tab-deleted": "Web tab is deleted",
                "module-created": "Module is created",
                "module-updated": "Module is updated",
                "module-deleted": "Module is deleted",
                "relation-created": "Relation is created",
                "relation-updated": "Relation is updated",
                "voice-agent-created": "Voice agent is created",
                "voice-agent-updated": "Voice agent is updated",
                "voice-agent-deleted": "Voice agent is deleted",
                "voice-agent-phone-number-inbound-agent-changed": "Phone number inbound agent is changed",
                "voice-agent-phone-number-outbound-agent-changed": "Phone number outbound agent is changed",
                "voice-agent-batch-call-created": "Batch call is created",
                "voice-agent-knowledge-base-created": "Knowledge base is created",
                "voice-agent-knowledge-base-deleted": "Knowledge base is deleted",
                "table-data-downloaded": "Table data is downloaded",
                "table-data-imported": "Bulk data is imported to table",
                "table-data-batch-updated": "Table data is batch updated",
                "table-data-batch-deleted": "Table data is batch deleted",
                "contact-batch-updated": "Contacts are batch updated",
                "chat-data-downloaded": "Chat history is downloaded",
                "automation-restored": "When automation is restored from trash",
                "waba-supsis-partner-remove": "When WhatsApp Business API V2 partner is removed",
                "waba-supsis-account-deleted": "When WhatsApp Business API V2 account is deleted",
                "waba-supsis-account-violation": "When WhatsApp Business API V2 account violation is detected",
                "waba-supsis-ad-account-linked": "When WhatsApp Business API V2 ad account is linked",
                "waba-supsis-auth-intl-price-eligibility-update":
                    "When WhatsApp Business API V2 international price eligibility is updated",
                "waba-supsis-disabled-update": "When WhatsApp Business API V2 disabled update is made",
                "waba-supsis-mm-lite-terms-signed": "When WhatsApp Business API V2 MM Lite terms are signed",
                "waba-supsis-partner-app-installed": "When WhatsApp Business API V2 partner app is installed",
                "waba-supsis-partner-app-uninstalled": "When WhatsApp Business API V2 partner app is uninstalled",
                "waba-supsis-partner-client-certification-status-update":
                    "When WhatsApp Business API V2 partner client certification status is updated",
                "waba-supsis-business-primary-location-country-update":
                    "When WhatsApp Business API V2 business primary location country is updated",
                "waba-supsis-volume-based-pricing-tier-update":
                    "When WhatsApp Business API V2 volume-based pricing tier is updated",
                "waba-supsis-message-template-components-update":
                    "When WhatsApp Business API V2 message template components are updated",
                "waba-supsis-message-template-status-update":
                    "When WhatsApp Business API V2 message template status is updated",
                waba_supsis_partner_remove: "WhatsApp Business API V2 partner removed",
                waba_supsis_account_deleted: "WhatsApp Business API V2 account deleted",
                waba_supsis_account_violation: "WhatsApp Business API V2 account violation detected",
                waba_supsis_ad_account_linked: "WhatsApp Business API V2 ad account linked",
                waba_supsis_auth_intl_price_eligibility_update:
                    "WhatsApp Business API V2 international price eligibility update",
                waba_supsis_disabled_update: "WhatsApp Business API V2 disabled update",
                waba_supsis_mm_lite_terms_signed: "WhatsApp Business API V2 MM Lite terms signed",
                waba_supsis_partner_added: "WhatsApp Business API V2 partner added",
                waba_supsis_partner_app_installed: "WhatsApp Business API V2 partner app installed",
                waba_supsis_partner_app_uninstalled: "WhatsApp Business API V2 partner app uninstalled",
                waba_supsis_partner_client_certification_status_update:
                    "WhatsApp Business API V2 partner client certification status updated",
                waba_supsis_business_primary_location_country_update:
                    "WhatsApp Business API V2 business primary location country updated",
                waba_supsis_volume_based_pricing_tier_update:
                    "WhatsApp Business API V2 volume-based pricing tier updated",
                waba_supsis_message_template_components_update:
                    "WhatsApp Business API V2 message template components updated",
                waba_supsis_message_template_status_update: "WhatsApp Business API V2 message template status updated",
                waba_supsis_template_category_update: "WhatsApp Business API V2 template category updated",
                waba_supsis_PARTNER_REMOVE: "WhatsApp Business API V2 partner removed",
                waba_supsis_ACCOUNT_DELETED: "WhatsApp Business API V2 account deleted",
                "task-workflow-restored": "When task workflow is restored from trash",
                "task-workflow-permanently-deleted": "When task workflow is permanently deleted from trash",
                "table-deleted": "When table is deleted",
                "table-restored": "When table is restored from trash",
                "table-permanently-deleted": "When table is permanently deleted from trash",
            },
            mobileApp: "Mobile App",
            webPanel: "Web Panel",
            notifications: "Notifications",
            whatsappActions: "Whatsapp Actions",
            chatbotActions: "Chatbot Actions",
            companyActions: "Company Actions",
            crmActions: "CRM Actions",
            basicActions: "Basic Actions",
            notificationSettingsDesc:
                "Choose which notifications you want to receive and where you want to receive them.",
            noNotificationDesc2:
                "Here you will see all notifications related to the jobs, candidates, and talent pools you are following. You can customize notifications by adjusting settings.",
            noNotificationTitle2: "No notifications yet.",
            noNotificationTitle1: "No notifications. Enjoy the silence.",
            adjustSettings: "Adjust settings",
            showAll: "Show all",
            showOnlyUnread: "Show only unread",
            mailWasSent: "Email was sent.",
            mailAdressRemoved: "Email address removed.",
            chatbotPublished: "Version <b>{version}</b> of the chatbot was published by <b>{user}</b>.",
            chatbotDeleted: "<b>{chatbot}</b> chatbot was deleted by <b>{user}</b>.",
            settingsUpdatedWoDetail: "Settings were updated by <b>{user}</b>.",
            noActivityDesc: "There is currently no activity in the system. A few events need to occur",
            noActivityTitle: "No activity yet",
            actionType: "Action Type",
            dateBetween: "Date Between",
            selectActor: "Select User",
            activities: "Activities",
            chatbotCreated: "Chatbot named <b>{chatbot}</b> was created by <b>{user}</b>.",
            taskAddedTags: "<b>{user}</b> added these tags to the task (<b>{taskTitle}</b>): <b>{tags}</b>",
            taskStageChanged:
                "The stage of task <b>{task}</b> was changed from <b>{oldStage}</b> to <b>{newStage}</b> by <b>{user}</b>.",
            taskCreated: "<b>{task}</b> task was created by <b>{user}</b>.",
            contactPropRemoved: "<b>{prop}</b> visitor property was removed by <b>{user}</b>.",
            contactPropAdded: "<b>{prop}</b> visitor property was added by <b>{user}</b>.",
            userRemoved: "<b>{oldUser}</b> user was removed by <b>{user}</b>.",
            loginFormUpdated: "Visitor login form was updated by <b>{user}</b>.",
            loginFormDeactivated: "User login form was deactivated by <b>{user}</b>.",
            loginFormActivated: "User login form was activated by <b>{user}</b>.",
            invoiceRefunded: "Refund process was made by <b>{user}</b>.",
            paymentMethodAdded: "A new payment method was added by <b>{user}</b>.",
            invoicePaymentFailed: "Invoice payment was not accepted by <b>{user}</b>.",
            invoicePaymentReceived: "Invoice payment received by <b>{user}</b>.",
            planStarted: "<b>{user}</b> User started the subscription for <b>{title}</b> (<b>{altTitle}</b>).",
            planStartedAgent:
                "<b>{user}</b> User started the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{details} Representative</b>).",
            planStartedChatbot:
                "<b>{user}</b> User started the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Session</b>).",
            planStartedWhatsapp:
                "<b>{user}</b> User started the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Whatsapp Channels</b>).",
            planStartedWhatsappApi:
                "<b>{user}</b> User started the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Whatsapp Business Channels</b>).",
            PlanCanceled: "<b>{user}</b> User canceled the subscription for <b>{title}</b> (<b>{altTitle}</b>).",
            planCanceledAgent:
                "<b>{user}</b> User canceled the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{details} Representative</b>).",
            planCanceledChatbot:
                "<b>{user}</b> User canceled the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Session</b>).",
            planCanceledWhatsapp:
                "<b>{user}</b> User canceled the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Whatsapp Channels</b>).",
            planCanceledWhatsappApi:
                "<b>{user}</b> User canceled the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Whatsapp Business Channels</b>).",
            invoiceCreated: "Invoice was created by <b>{user}</b>.",
            billingAddressUpdated: "Address information was updated by <b>{user}</b>.",
            taskWorkflowDeleted: "Workflow <b>{workflow}</b> was deleted by <b>{user}</b>.",
            whatsappBroadcastFailed: "Sending of broadcast message titled <b>{title}</b> failed.",
            whatsappBroadcastCancelled: "Sending of broadcast message titled <b>{title}</b> has been cancelled.",
            whatsappBroadcastCompleted:
                "A broadcast message titled <b>{title}</b> has been successfully sent to <b>{numbers}</b> recipients.",
            whatsappBroadcastCreated:
                "A broadcast message titled <b>{title}</b> has been sent to <b>{numbers}</b> recipients by <b>{user}</b>.",
            ticketAssigned: "A ticket has been assigned to <b>{user2}</b> by <b>{user1}</b>.",
            userLoggedIn: "<b>{user}</b> logged into SUPSIS.",
            chatJoined: "<b>{agent}</b> joined the chat with <b>{visitor}</b>.",
            chatForwarded: "Chat with <b>{visitor}</b> was forwarded to <b>{agent}</b> by <b>{user}</b>.",
            chatAssigned: "Chat with <b>{visitor}</b> was assigned to <b>{agent}</b> by the system.",
            customerGroupUpdated: "The group named <b>{group}</b> was updated by <b>{user}</b>.",
            customerGroupRemoved: "The group named <b>{group}</b> was removed by <b>{user}</b>.",
            customerGroupAdded: "The group named <b>{group}</b> was created by <b>{user}</b>.",
            contentRemoved: "Ready content <b>{content}</b> was removed by <b>{user}</b>.",
            contentAdded: "Ready content <b>{content}</b> was added by <b>{user}</b>.",
            channelVisibilityChanged:
                "Visibility of integration channel <b>{channel}</b> was changed by <b>{user}</b>.",
            taskDeleted: "<b>{task}</b> task was deleted by <b>{user}</b>.",
            taskCompleted: "<b>{task}</b> task was completed by <b>{user}</b>.",
            taskArchived: "<b>{user}</b> archived the task <b>{task}</b>.",
            userRemovedToDepartment:
                "<b>{user2}</b> user removed from <b>{department}</b> department by <b>{user1}</b>.",
            userAddedToDepartment: "<b>{user2}</b> user added to <b>{department}</b> department by <b>{user1}</b>.",
            mailAddressAdded: "<b>{email}</b> email address added by <b>{user}</b>",
            settingUpdate: "Updated by <b>{user}</b>:",
            taskWFlowCreated: "<b>{Wflow}</b> task workflow created by <b>{user}</b>.",
            bannedWordRemoved: "<b>{bWord}</b> banned word removed by <b>{user}</b>.",
            bannedWordCreated: "<b>{bWord}</b> banned word created by <b>{user}</b>.",
            taskPriorityUpdated:
                "<b>{user}</b> changed the priority of the task <b>{taskTitle}</b> from <b>{oldPriority}</b> to <b>{newPriority}</b>",
            welcomeMessageRemoved: "<b>{welcome}</b> welcome message removed by <b>{user}</b>.",
            welcomeMessageAdded: "<b>{welcome}</b> welcome message created by <b>{user}</b>.",
            tagRemoved: "<b>{tag}</b> tag removed by <b>{user}</b>.",
            tagAdded: "<b>{tag}</b> tag added by <b>{user}</b>.",
            roleRemoved: "<b>{role}</b> role removed by <b>{user}</b>.",
            roleAdded: "<b>{role}</b> role added by <b>{user}</b>.",
            departmentRemoved: "<b>{department}</b> department removed by <b>{user}</b>.",
            departmentAdded: "<b>{department}</b> department added by <b>{user}</b>.",
            triggerUpdated: "A trigger updated by <b>{user}</b>.",
            triggerRemoved: "A trigger removed by <b>{user}</b>.",
            triggerAdded: "A new trigger created by <b>{user}</b>.",
            webhookRemoved: "The webhook belonging to <b>{user1}</b> was removed by <b>{user2}</b>",
            webhookAdded: "<b>{user1}</b> added the webhook, which was added by <b>{user2}</b>",
            chatClosed: "Chat with <b>{visitor}</b> was ended by <b>{agent}</b>.",
            chatOwnerUpdated: "<b>{agent}</b> reassigned <b>{visitor}</b> from <b>{oldOwner}</b> to <b>{newOwner}</b>.",
            customerOwnershipRemoved:
                "<b>{actor}</b> removed the ownership of <b>{visitor}</b> from <b>{oldOwner}</b>, leaving them unowned.",
            customerOwnershipAssigned:
                "<b>{actor}</b> assigned the ownership of <b>{visitor}</b> from unowned to <b>{newOwner}</b>.",
            customerOwnershipReassigned:
                "<b>{actor}</b> reassigned the ownership of <b>{visitor}</b> from <b>{oldOwner}</b> to <b>{newOwner}</b>.",
            chatOpenedByAgent: "<b>{agent}</b> initiated a <b>{platform}</b> chat with <b>{visitor}</b>.",
            chatOpenedByVisitor: "A <b>{platform}</b> chat was initiated by <b>{visitor}</b>.",
            channelRemoved: "<b>{channel}</b> channel was removed by <b>{agent}</b>.",
            userAdded: "<b>{agent}</b> created a representative named <b>{newAgent}</b>.",
            visitorUnblocked: "<b>{visitor}</b> visitor unblocked by <b>{agent}</b> user.",
            visitorBlocked: "Visitor <b>{visitor}</b> blocked by <b>{agent}</b>.",
            userStatusChanged: "User <b>{name}</b> changed status from <b>{oldStatus}</b> to <b>{newStatus}</b>.",
            channelCreated: "<b>{channel}</b> channel created by <b>{name}</b>.",
            reservationCreatedPlan:
                "<b>{name}</b> User scheduled the appointment named <b>{title}</b> for <b>{date}</b>.",
            reservationUpdatedPlan: "<b>{name}</b> User updated the appointment named <b>{title}</b>.",
            reservationDeletedPlan: "<b>{name}</b> User deleted the appointment named <b>{title}</b>.",
            reservationCreated: "<b>{name}</b> User and <b>{visitor}</b> Visitor with reservation date <b>{date}</b>.",
            reservationDeleted:
                "Appointment scheduled between <b>{name}</b> User and <b>{visitor}</b> Visitor on <b>{date}</b> has been canceled.",
            taskStatusChanged: "When the task status changes",
            taskWorkflowCrud: "Task workflow is created, updated or deleted",
            taskCrud: "Task is created, updated or deleted",
            automationRestored: "{user} restored the automation named {automation} from the trash.",
            automationRestoredNotification: "When automation is restored from the trash.",
            formDeleted: '{user} deleted the form "{formName}" (ID: {formId}).',
            formDeletedPermanent: '{user} permanently deleted the form "{formName}" (ID: {formId}).',
            formRestored: '{user} restored the form "{formName}" (ID: {formId}) from the trash.',
            formCreated: '{user} created the form "{formName}".',
            formUpdated: '{user} updated the form "{formName}".',
            formDownloaded: '{user} downloaded data from the form "{formName}" (ID: {formId}).',
            userRoleChanged: '{actor} changed "{userName}"\'s role from "{oldRoleName}" to "{newRoleName}".',
            userPasswordChanged: '{actor} changed "{userName}"\'s password.',
            userEmailChanged: '{actor} changed "{userName}"\'s email address from "{oldEmail}" to "{newEmail}".',
            userNameChanged: '{actor} changed "{userName}"\'s name from "{oldName}" to "{newName}".',
            userPhoneChanged: '{actor} changed "{userName}"\'s phone number from "{oldPhone}" to "{newPhone}".',
            userDisabled: '{actor} disabled "{userName}".',
            userEnabled: '{actor} enabled "{userName}".',
            roleUpdated: '{actor} updated the role "{roleName}".',
            taskWorkflowUpdated: '{actor} updated the workflow "{workflowTitle}".',
            taskWorkflowPipelineStageAdded: '{actor} added the stage "{stageName}" to the workflow "{workflowTitle}".',
            taskWorkflowPipelineStageUpdated:
                '{actor} updated the stage "{stageName}" in the workflow "{workflowTitle}".',
            taskWorkflowPipelineStageDeleted:
                '{actor} deleted the stage "{stageName}" from the workflow "{workflowTitle}".',
            driveFolderCreated: '{actor} created the folder "{folderName}".',
            driveFolderDeleted: '{actor} deleted the folder "{folderName}".',
            driveFolderRenamed: '{actor} renamed the folder "{oldName}" to "{newName}".',
            driveFileAdded: '{actor} added the file "{fileName}".',
            driveFileDeleted: '{actor} deleted the file "{fileName}".',
            taskModuleRulesEnabled: '{actor} enabled task rules for the workflow "{workflowTitle}".',
            taskModuleRulesDisabled: '{actor} disabled task rules for the workflow "{workflowTitle}".',
            taskModuleRulesRuleAdded: '{actor} added the rule "{ruleName}" to the workflow "{workflowTitle}".',
            taskModuleRulesRuleDeleted: '{actor} deleted the rule "{ruleName}" from the workflow "{workflowTitle}".',
            taskModuleRulesRuleUpdated: '{actor} updated the rule "{ruleName}" in the workflow "{workflowTitle}".',
            taskModuleRulesRuleEnabled: '{actor} enabled the rule "{ruleName}" in the workflow "{workflowTitle}".',
            taskModuleRulesRuleDisabled: '{actor} disabled the rule "{ruleName}" in the workflow "{workflowTitle}".',
            contactModuleRulesEnabled: "{actor} enabled contact module rules.",
            contactModuleRulesDisabled: "{actor} disabled contact module rules.",
            contactModuleRulesRuleAdded: '{actor} added the rule "{ruleName}" to the contact module.',
            contactModuleRulesRuleUpdated: '{actor} updated the rule "{ruleName}" in the contact module.',
            contactModuleRulesRuleDeleted: '{actor} deleted the rule "{ruleName}" from the contact module.',
            contactModuleRulesRuleEnabled: '{actor} enabled the rule "{ruleName}" in the contact module.',
            contactModuleRulesRuleDisabled: '{actor} disabled the rule "{ruleName}" in the contact module.',
            developerTokenChanged: "{actor} updated the developer access token.",
            tableCreated: '{actor} created the table "{tableName}".',
            tableDeleted: '{actor} deleted the table "{tableName}".',
            tableRestored: '{actor} restored the table "{tableName}" from the trash.',
            tablePermanentlyDeleted: '{actor} permanently deleted the table "{tableName}" from the trash.',
            tableFieldAdded: '{actor} added the field "{fieldName}" to the table "{tableName}".',
            tableFieldUpdated: '{actor} updated the field "{fieldName}" in the table "{tableName}".',
            tableFieldDeleted: '{actor} deleted the field "{fieldName}" from the table "{tableName}".',
            tableViewAdded: '{actor} added the view "{viewName}" to the table "{tableName}".',
            tableViewUpdated: '{actor} updated the view "{viewName}" in the table "{tableName}".',
            tableViewDeleted: '{actor} deleted the view "{viewName}" from the table "{tableName}".',
            tablePageAdded: '{actor} added the page "{pageName}" to the table "{tableName}".',
            tablePageUpdated: '{actor} updated the page "{pageName}" in the table "{tableName}".',
            tablePageDeleted: '{actor} deleted the page "{pageName}" from the table "{tableName}".',
            tableWidgetAdded:
                '{actor} added the widget "{widgetTitle}" ({widgetType}) to the page "{pageName}" in the table "{tableName}".',
            tableWidgetUpdated:
                '{actor} updated the widget "{widgetTitle}" ({widgetType}) on the page "{pageName}" in the table "{tableName}".',
            tableWidgetDeleted:
                '{actor} deleted the widget "{widgetTitle}" ({widgetType}) from the page "{pageName}" in the table "{tableName}".',
            tablePermissionChanged: '{actor} updated the privacy settings of the table "{tableName}".',
            tableDataDownloaded: '{actor} downloaded {recordCount} records from the table "{tableName}".',
            tableDataImported: '{actor} imported {successCount}/{recordCount} records into the table "{tableName}".',
            tableDataBatchUpdated:
                '{actor} bulk updated the "{fieldName}" field for {recordCount} records in the table "{tableName}".',
            tableDataBatchDeleted: '{actor} bulk deleted {recordCount} records from the table "{tableName}".',
            contactDataDownloaded: "{actor} downloaded {contactCount} contact records.",
            contactBatchUpdated: "{actor} performed bulk {action} for {contactCount} contacts.",
            chatDataDownloaded: "{actor} downloaded {chatCount} chat history.",
            chatDataDownloadedWithVisitor: '{actor} downloaded chat history with "{visitorName}".',
            visitorTagAdded: "{actor} added {tagNames} tag to {visitorName}.",
            visitorTagRemoved: "{actor} removed {tagNames} tag from {visitorName}.",
            unknownVisitor: "Unknown contact",
            tagsLabel: "Tags",
            webAppCreated: '{actor} created the web application "{appName}" ({appSlug}).',
            webAppUpdated: '{actor} updated the web application "{appName}" ({appSlug}).',
            webAppDeleted: '{actor} deleted the web application "{appName}" ({appSlug}).',
            webTabCreated: '{actor} added the web tab "{tabName}" to {placement}.',
            webTabUpdated: '{actor} updated the web tab "{tabName}".',
            webTabDeleted: '{actor} deleted the web tab "{tabName}" ({placement}).',
            moduleCreated: '{actor} created "{moduleName}" {moduleType}.',
            moduleUpdated: '{actor} updated "{moduleName}" {moduleType}.',
            moduleDeleted: '{actor} deleted "{moduleName}" {moduleType}.',
            relationCreated: '{actor} created the relation "{relationName}".',
            relationUpdated: '{actor} updated the relation "{relationName}".',
            voiceAgentCreated: '{actor} created the voice agent "{agentName}" ({agentId}).',
            voiceAgentUpdated: '{actor} updated the voice agent "{agentName}" ({agentId}).',
            voiceAgentDeleted: '{actor} deleted the voice agent "{agentName}" ({agentId}).',
            voiceAgentPhoneNumberInboundAgentChanged:
                '{actor} changed the inbound call agent for {phoneNumber} to "{agentName}".',
            voiceAgentPhoneNumberOutboundAgentChanged:
                '{actor} changed the outbound call agent for {phoneNumber} to "{agentName}".',
            voiceAgentBatchCallCreated: '{actor} created the batch call "{batchCallName}" ({taskCount} contacts).',
            voiceAgentKnowledgeBaseCreated: '{actor} created the knowledge base "{knowledgeBaseName}".',
            voiceAgentKnowledgeBaseDeleted: '{actor} deleted the knowledge base "{knowledgeBaseName}".',
            webTabCreatedNotification: "When a web tab is created.",
            webTabUpdatedNotification: "When a web tab is updated.",
            webTabDeletedNotification: "When a web tab is deleted.",
            moduleCreatedNotification: "When a module or relation is created.",
            moduleUpdatedNotification: "When a module or relation is updated.",
            moduleDeletedNotification: "When a module or relation is deleted.",
            relationCreatedNotification: "When a relation is created.",
            relationUpdatedNotification: "When a relation is updated.",
            voiceAgentCreatedNotification: "When a voice agent is created.",
            voiceAgentUpdatedNotification: "When a voice agent is updated.",
            voiceAgentDeletedNotification: "When a voice agent is deleted.",
            voiceAgentPhoneNumberInboundAgentChangedNotification:
                "When the inbound call agent for a phone number is changed.",
            voiceAgentPhoneNumberOutboundAgentChangedNotification:
                "When the outbound call agent for a phone number is changed.",
            voiceAgentBatchCallCreatedNotification: "When a batch call is created.",
            voiceAgentKnowledgeBaseCreatedNotification: "When a knowledge base is created.",
            voiceAgentKnowledgeBaseDeletedNotification: "When a knowledge base is deleted.",
            formDeletedNotification: "When a form is deleted.",
            formRestoredNotification: "When a form is restored from the trash.",
            formCreatedNotification: "When a form is created.",
            formUpdatedNotification: "When a form is updated.",
            formDownloadedNotification: "When form data is downloaded.",
            userRoleChangedNotification: "When a user role is changed.",
            userPasswordChangedNotification: "When a user password is changed.",
            userEmailChangedNotification: "When a user email address is changed.",
            userNameChangedNotification: "When a user name is changed.",
            userPhoneChangedNotification: "When a user phone number is changed.",
            userDisabledNotification: "When a user is disabled or enabled.",
            roleUpdatedNotification: "When a role is updated.",
            taskWorkflowUpdatedNotification: "When a workflow is updated.",
            taskWorkflowPermanentlyDeletedNotification: "When a workflow is permanently deleted from the trash.",
            taskWorkflowPipelineStageAddedNotification: "When a new stage is added to a workflow.",
            taskWorkflowPipelineStageUpdatedNotification: "When a workflow stage is updated.",
            taskWorkflowPipelineStageDeletedNotification: "When a stage is deleted from a workflow.",
            driveFolderCreatedNotification: "When a Drive folder is created.",
            driveFolderDeletedNotification: "When a Drive folder is deleted.",
            driveFolderRenamedNotification: "When a Drive folder is renamed.",
            driveFileAddedNotification: "When a file is added to Drive.",
            driveFileDeletedNotification: "When a file is deleted from Drive.",
            taskModuleRulesEnabledNotification: "When task rules are enabled.",
            taskModuleRulesDisabledNotification: "When task rules are disabled.",
            taskModuleRulesRuleAddedNotification: "When a new rule is added to a workflow.",
            taskModuleRulesRuleDeletedNotification: "When a rule is deleted from a workflow.",
            taskModuleRulesRuleUpdatedNotification: "When a workflow rule is updated.",
            taskModuleRulesRuleEnabledNotification: "When a workflow rule is enabled.",
            taskModuleRulesRuleDisabledNotification: "When a workflow rule is disabled.",
            contactModuleRulesEnabledNotification: "When contact module rules are enabled.",
            contactModuleRulesDisabledNotification: "When contact module rules are disabled.",
            contactModuleRulesRuleAddedNotification: "When a new rule is added to the contact module.",
            contactModuleRulesRuleUpdatedNotification: "When a contact module rule is updated.",
            contactModuleRulesRuleDeletedNotification: "When a rule is deleted from the contact module.",
            contactModuleRulesRuleEnabledNotification: "When a contact module rule is enabled.",
            contactModuleRulesRuleDisabledNotification: "When a contact module rule is disabled.",
            developerTokenChangedNotification: "When the developer access token is updated.",
            tableCreatedNotification: "When a new table is created.",
            tableDeletedNotification: "When a table is deleted.",
            tableRestoredNotification: "When a table is restored from the trash.",
            tablePermanentlyDeletedNotification: "When a table is permanently deleted from the trash.",
            tableFieldAddedNotification: "When a new field is added to a table.",
            tableFieldUpdatedNotification: "When a table field is updated.",
            tableFieldDeletedNotification: "When a field is deleted from a table.",
            tableViewActionsNotification: "When a table view is added, updated or deleted.",
            tablePageActionsNotification: "When a table page is added, updated or deleted.",
            tableWidgetActionsNotification: "When a widget is added, updated or deleted on a table page.",
            tablePermissionChangedNotification: "When table privacy settings are updated.",
            tableDataDownloadedNotification: "When table data is downloaded.",
            tableDataImportedNotification: "When records are bulk imported into a table.",
            tableDataBatchUpdatedNotification: "When a bulk update is performed on a table.",
            tableDataBatchDeletedNotification: "When records are bulk deleted from a table.",
            contactBatchUpdatedNotification: "When contacts are bulk updated.",
            chatDataDownloadedNotification: "When chat history is downloaded.",
            webAppCreatedNotification: "When a web application is created.",
            webAppUpdatedNotification: "When a web application is updated.",
            webAppDeletedNotification: "When a web application is deleted.",
            formActions: "When a form is created, updated or deleted.",
            userInfoActions: "When user information, roles, password, email, name, phone or status changes.",
            driveActions: "Drive folder and file operations.",
            developerActions: "When the developer access token is updated.",
            contactModuleRulesActions:
                "When contact module rules are enabled/disabled, or a rule is added, updated, deleted, enabled or disabled.",
            tableActions: "When a table is created, or a field is added, updated or deleted.",
            wabaSupsisPartnerRemove: "When WhatsApp Business API V2 partner is removed.",
            wabaSupsisAccountDeleted: "When WhatsApp Business API V2 account is deleted.",
            wabaSupsisAccountViolation: "When WhatsApp Business API V2 account violation is detected.",
            wabaSupsisAdAccountLinked: "When WhatsApp Business API V2 ad account is linked.",
            wabaSupsisAuthIntlPriceEligibilityUpdate:
                "When WhatsApp Business API V2 international price eligibility is updated.",
            wabaSupsisDisabledUpdate: "When WhatsApp Business API V2 disabled update occurs.",
            wabaSupsisMmLiteTermsSigned: "When WhatsApp Business API V2 MM Lite terms are signed.",
            wabaSupsisPartnerAdded: "When WhatsApp Business API V2 partner is added.",
            wabaSupsisPartnerAppInstalled: "When WhatsApp Business API V2 partner app is installed.",
            wabaSupsisPartnerAppUninstalled: "When WhatsApp Business API V2 partner app is uninstalled.",
            wabaSupsisPartnerClientCertificationStatusUpdate:
                "When WhatsApp Business API V2 partner client certification status is updated.",
            wabaSupsisBusinessPrimaryLocationCountryUpdate:
                "When WhatsApp Business API V2 primary location country is updated.",
            wabaSupsisVolumeBasedPricingTierUpdate:
                "When WhatsApp Business API V2 volume-based pricing tier is updated.",
            wabaSupsisMessageTemplateComponentsUpdate:
                "When WhatsApp Business API V2 message template components are updated.",
            wabaSupsisMessageTemplateStatusUpdate: "When WhatsApp Business API V2 message template status is updated.",
            wabaSupsisTemplateCategoryUpdate: "When WhatsApp Business API V2 template category is updated.",
            chatbotRestored: "Chatbot <b>{chatbot}</b> was restored from the trash by <b>{user}</b>.",
            taskWorkflowRestored: "Workflow <b>{workflow}</b> was restored from the trash by <b>{user}</b>.",
            taskWorkflowPermanentlyDeleted:
                "Workflow <b>{workflow}</b> was permanently deleted from the trash by <b>{user}</b>.",
            userLoggenIn: "<b>{user}</b> logged in to SUPSIS.",
            channelForwardConfigUpdated:
                '{actor} updated the channel forward configuration for "{channelName}" {channelType}.',
            channelZohoConfigUpdated:
                '{actor} updated the Zoho integration configuration for "{channelName}" {channelType}.',
            webhookUpdated: '{actor} updated the webhook "{webhookName}" ({webhookUrl}).',
        },
        search: {
            prefix: {
                jump: "Jump",
                new: "New",
                visitor: "Visitor",
                dm: "DM",
                chatbot: "Chatbot",
                automation: "Automation",
                table: "Table",
                module: "Module",
                message: "Message",
            },
            calendar: "Calendar",
            soundSettings: "Sound Notifications",
            allNotificationSettings: "Notification Settings",
            allNotifications: "All Notifications",
            allActivities: "All Activities",
            workFlow: "Work Flow",
            editTask: "Edit Task",
            tasks: "Tasks",
            todo: "To-Do",
            tapTo: "Press ⇥ for '{prefix}' operations",
            newUsers: "New ⇥ Users",
            newTags: "New ⇥ Tags",
            newRole: "New ⇥ Role",
            newTrigger: "New ⇥ Triggers",
            newDepartment: "New ⇥ Department",
            newTicket: "New ⇥ Ticket",
            jumpSettings: "Jump ⇥ Settings",
            jumpIntegrations: "Jump ⇥ Integrations",
            jumpTeam: "Jump ⇥ Team",
            jumpUsers: "Jump ⇥ Users",
            jumpReport: "Jump ⇥ Report",
            timingSettings: "Timing Settings",
            exampleVisitorMail: "visitor@mail.com",
            languageAndRegion: "Language and Region",
            theme: "Theme",
            appearance: "Appearance",
            color: "Color - Colour",
            background: "Background",
            smart: "Smart",
            teamChat: "Team Chat",
            chatbot: "ChatBot",
            chatbotTraining: "Chatbot Training",
            chatbotUserSegments: "Chatbot User Segments",
            chatbotIntegration: "Chatbot Integrations",
            chatbotEntities: "Chatbot Entities",
            chatbotIntegrationWebHook: "Chatbot Integrations Webhook",
            chatbotArchive: "Chatbot Archive",
            chatbotTemplatesAI: "Chatbot Templates AI",
            chatbotTemplates: "Chatbot Templates",
            chatbotReportsOverall: "Chatbot Reports Overall",
            chatbotReportsAllChats: "Chatbot Reports All Chats",
            chatbotReportsRatingDistribution: "Chatbot Reports Rating Distribution",
            chatbotReportsPaidChats: "Chatbot Reports Paid Chats",
            chatbotReportsBusiestPeriod: "Chatbot Reports Busiest Period",
            chatbotTemplatesAllMessages: "Chatbot Templates All Messages",
            chatbotTemplatesAvarage: "Chatbot Templates Avarage",
            chatbotTemplatesPopularity: "Chatbot Templates Popularity",
            chatbotTemplatesAllUser: "Chatbot Templates All User",
            ticket: "Ticket",
            archives: "Archives",
            tags: "Tags",
            offlineSupportRequests: "Offline Support Requests",
            roles: "Roles",
            users: "Users",
            subjects: "Subjects",
            contents: "Contents",
            welcomeMessages: "Welcome Messages",
            catalog: "Catalog",
            bannedWords: "Banned Words",
            bannedVisitors: "Banned Visitors",
            application: "Application",
            mails: "Mails",
            visitors: "Visitors",
            integrationsWebhook: "Integrations Webhook",
            billing: "Billing",
            reportNew: "Report New",
            integrations: "Integrations",
            chatbotStory: "Chatbot Story",
            searchPlaceHolder: "Search, Jump to or Add...",
            searchAreaTitle: "Search in Supsis",
            searchAreaDesc1: "Search for anything. Just say",
            searchAreaDesc2: "or",
            searchAreaDesc3: "or search anything",
            navigateBtn: "Navigate",
            selectBtn: "Select",
            cancelBtn: "Cancel",
            integration: {
                shouldByInstaPack:
                    "You should buy an Instagram package to create an Instagram channel. Affordable prices are available now.",
                createInstaLimitMax: "You have reached the Instagram channel creation limit. Maximun",
                createInstaContinue:
                    "You can create an Instagram Channel. To continue, upgrade your package or delete some of your Instagram channels.",
                privatePolicy: "Private Policy",
                termsAndCondition: "Terms and Conditions",
                readAndAgree: "I have read and agree",
                shouldByMessengerPack:
                    "You must purchase a Messenger package to create a Messenger channel. You can access the packages with affordable prices immediately.",
                createMessengerLimitMax: "You have reached the Messenger channel creation limit. Maximun",
                createMessengerContinue:
                    "You can create a Messenger Channel. To continue, upgrade your package or delete some of your Messenger channels.",
                selectMessengerAccount: "Select Messenger Account",
                forwardLiveAgents: "👉 Forward Live Agents",
                allDepartments: "All Departments",
                deleteAll: "Delete All",
                wpBusinessAPI: "Integrations - Whatsapp Business API Channels",
                wpV1: "Integrations - Multi Whatsapp Channels",
                instagram: "Integrations - Instagram",
                instagramContactList: "Integrations - Instagram Contact List",
                mail: "Integrations - Mail",
                whatsapp: "Integrations - Whatsapp",
                whatsappContactList: "Integrations - Whatsapp Contact List",
                wpBCRequests: "Integrations - Whatsapp Broadcast Requests",
                wpBCCustomerGroups: "Integrations - Whatsapp Broadcast Customer Groups",
                wpBCTemplates: "Integrations - Whatsapp Broadcast Message Templates",
                chatbot: "Integrations - ChatBot",
                allSections: "All Sections",
                createInstaInstaLimitMax: "You have reached the Instagram channel creation limit. Maximum.",
                createMessengerMessengerLimitMax: "You have reached the Messenger channel creation limit. Maximum.",
                directClientsForward: "👉 Forward Live Agents",
                shouldByByMessengerPack:
                    "You must purchase a Messenger package to create a Messenger channel. You can access the packages with affordable prices immediately.",
                wpBCRichieste: "Integrations - Whatsapp Broadcast Requests",
            },
            settings: {
                settings: "Settings",
                features: "Settings - Features",
                languageAndRegion: "Settings - Language and Region",
                bubbleSettings: "Settings - Bubble Settings",
                bubbleActions: "Settings - Bubble Actions",
                themeSettings: "Settings - Theme Settings",
                visitorLoginForm: "Settings - Visitor Login Form",
                visitorAttribute: "Settings - Visitor Attributes",
                talkSettings: "Settings - Talk Settings",
                autoAssign: "Settings - Auto Assign",
                chatTimingSettings: "Settings - Chat Timing Settings",
                availability: "Settings - Availability",
                websiteIntegration: "Settings - Website Integration",
                developer: "Settings - Developer",
            },
            allAuditLogs: "Audit Logs",
            applicazione: "Application",
            archivi: "Archives",
            audioSettings: "Audio Settings",
            chatbotArchiv: "Chatbot Archive",
            chatbotTemplatesAverage: "Chatbot Templates Average",
            content: "Instant Content",
            contenuti: "Instant Contents",
            departments: "Departments",
            emails: "Mail",
            fondo: "Fund",
            forbiddenWords: "Banned Words",
            integraciones: "Integrations",
            integrationOperations: "Integration Operations",
            integrazioni: "Integrations",
            integrazioniWebhook: "Integrations Webhook",
            intelligent: "Intelligent",
            invoices: "Invoice",
            kalender: "Calendar",
            mail: "Mailer",
            mailMessages: "Mail Messages",
            navigation: "Navigation",
            newReport: "New Report",
            newSection: "New Section",
            ruoli: "Roles",
            soggetti: "Departments",
            tag: "Tag",
            topics: "Topics",
            utenti: "Users",
            visitatori: "Visitors",
            webhookIntegration: "Webhook Integration",
            workflow: "Workflow",
        },
        mail: {
            errorStatus: "Error Status",
            mailSendErrorTitle: "Undelivered Mail",
            mailSendErrorDescription: "Total Undelivered Emails",
            fixGrammarTitle: "Grammar Correction",
            expandTextTitle: "Text Expansion",
            summaryTitle: "Summary",
            changeToneTitle: "Tone Adjustment",
            translationTitle: "Translation",
            replyTitle: "Reply",
            customRequestTitle: "Custom Request Response",
            viewMode: "View Mode",
            singleView: "Single View",
            splitView: "Split View",
            folders: "Folders",
            sendError: "An error occurred while sending the email. Please try again later.",
            visitorCreationError: "Visitor creation failed. Please try again later.",
            onlyImageAllowed: "Only image files are allowed.",
            imageFileTooLarge: "The image file is too large. Maximum size is 10MB.",
            imageUploaded: "Image uploaded successfully.",
            imageUploadError: "An error occurred during image upload.",
            mailAiAssistant: {
                aiCreateSummarized: "Create AI Summary",
                aiSentimentAnalysis: "AI Sentiment Analysis",
                contentRequired: "Email content is required to use this feature",
                grammarFixed: "Grammar has been corrected",
                aiError: "The AI assistant encountered an error",
                contentExpanded: "Email content has been expanded",
                emailSummarized: "Email has been summarized",
                toneChanged: "Tone changed to {tone}",
                emailTranslated: "Email translated into {language}",
                replyGenerated: "Automatic reply generated",
                contentUpdated: "Content has been updated",
                contentRebuilt: "Content has been rebuilt",
                contentRebuildFailed: "Failed to rebuild content",
                customRequestEmpty: "Please enter a request",
                customRequestApplied: "Custom request content has been applied",
                loadingText: "AI Working",
                loadingDescription: "Text is being analyzed, please wait...",
                aiTitle: "Email AI Assistant",
                aiDescription: "AI tools to improve, edit, and analyze your email",
                emptyContentTitle: "No Email Content Found",
                emptyContentDescription: "Email content is required to use AI features.",
                limitedAccessDescription: "Only limited features are available as there is no email content.",
                resultEmotions: "Detected Emotions",
                analysisDescription: "Analysis Explanation",
                recommendationsList: "Improvement Suggestions",
                mailSummarize: "Email Summary",
                aiResponse: "Generated by AI",
                rebuild: "Rebuild",
                applyText: "Apply Text",
                specialRequest: "Custom Request",
                specialRequestPlaceholder: "Enter your custom instructions here...",
                sendRequest: "Send Request",
                fixGrammarTitle: "Fix Grammar",
                fixGrammardescription: "Automatically corrects spelling and grammar issues",
                expandTextTitle: "Expand Text",
                expandTextDescription: "Makes your text more comprehensive and detailed",
                changeToneTitle: "Change Tone",
                changeToneDescription: "Transforms the tone and style of the text to your desired type",
                changeTone_ProfessionalTitle: "Professional",
                changeTone_ProfessionalDescription: "Formal and professional tone for business settings",
                changeTone_FriendlyTitle: "Friendly",
                changeTone_FriendlyDescription: "Warm and sincere approach",
                changeTone_CasualTitle: "Casual",
                changeTone_CasualDescription: "Relaxed and everyday conversational tone",
                changeTone_FormalTitle: "Formal",
                changeTone_FormalDescription: "Highly formal and corporate style",
                changeTone_ConfidentTitle: "Confident",
                changeTone_ConfidentDescription: "Strong and impressive expression style",
                translateTitle: "Translate",
                translateDescription: "Translates your text into different languages",
                generateReplyTitle: "Generate Reply",
                generateReplyDescription: "Automatically generates a suitable response to the received email",
                customPromptTitle: "Custom Request",
                customPromptDescription: "Generates email content based on your custom instructions",
            },
            searchEmail: "Search Mail...",
            emailAttachments: "Attachments ({count})",
            signatureMessage: "Your email signature exists. Would you like to include it in the email content?",
            emailSubject: "Email Subject",
            takeItBack: "Undo",
            fastForward: "Redo",
            addEmoji: "Add Emoji",
            addLink: "Add Link",
            bold: "Bold",
            italic: "Italic",
            underline: "Underline",
            fontFamily: "Font",
            textColor: "Text Color",
            stringFormats: "Text Formats",
            alignLeft: "Align Left",
            alignRight: "Align Right",
            alignCenter: "Center",
            normalText: "Normal text",
            participantList: "{first}, {second}, {third} +{remaining} others",
            noMailFound: "No mail found",
            selectedMail: "{count} mail selected",
            recipientEmailAddress: "Recipient email address",
            CCreceivers: "CC Recipients",
            BCCreceivers: "BCC Recipients",
            emptyStateMessage: "Select a mail or compose a new one",
            broadcastCreatedSuccess: "Broadcast created successfully",
            confirmArchive: "Are you sure you want to archive this broadcast?",
            archive: "Archive",
            cancel: "Cancel",
            archiveSuccess: "Broadcast archived successfully",
            archiveError: "Error archiving broadcast",
            empty: "Empty",
            summerDiscounts: "Summer Discounts",
            opportunities: "Opportunities",
            newMailTemplateCreated: "Create New Email Template.",
            dateRange: "Date Range",
            templateName: "Template Name",
            category: "Category",
            templateUpdateSucs: "The template was updated successfully.",
            templateUpdateError: "An error occurred while updating the template.",
            marketing: "Marketing",
            operational: "Operational",
            custom: "Special",
            pleaseEnterTemplateName: "Please enter the template name",
            pleaseEnterTemplateSubject: "Please enter the template subject",
            pleaseSelectTemplateCategories: "Please select the template category",
            representMails: "Representative Mails",
            otherRepresentMails:
                "You can track incoming and outgoing e-mails to and from other representatives' e-mail addresses.",
            signatureAutoAdd: "Signature auto-add status changed successfully",
            autoAdd: "Automatic Add",
            forwardEmailAddSucs: "Forward email address added successfully.",
            errorAddingForwardEmail: "An error occurred while adding a forward email address.",
            mailAddForward: "Manual Add (forward completed)",
            mailAddForwarding: "Manual Add (I completed forwarding)",
            broadcast: "Publications",
            templates: "Templates",
            composeNewEmail: "Compose new email",
            couldNotUserMail: "Could not send mail because there is no user mail",
            mailAddressReq: "Mail Address Required.",
            emailAddressInvalid: "Mail address invalid.",
            departmentIsNotValid: "Department not valid",
            mailSendNotValid: "Not valid from mail address",
            newMailArrived: "New mail arrived.",
            mailSentSucs: "Mail sent successfully.",
            representativeMails: "Representative Mail",
            routingSteps: "Routing Steps",
            owner: "Owner",
            whereHeDirected: "Where He Directed",
            forwardingEmailAddress: "Forwarding Email Address",
            deleteMailDesc: "This action cannot be undone.",
            deleteMailTitle: "Are you sure you want to delete this email address?",
            gmailForwardMail: "Gmail Mail Forwarding",
            senderMailAddressDesc: "Please Enter Sender Mail Address",
            verified: "Verified",
            notForwarded: "Not Forwarded",
            notVerified: "Not Verified",
            default: "Default",
            isVerified: "Verified",
            forwarding: "Forwarding",
            mailAdress: "Mail Address",
            addSenderAddress: "Add Sender Address",
            outlookForward: "Microsoft (Outlook/Exchange) Forward",
            gmailForward: "Google (Gmail) Forward",
            senderMail: "Sender Mail",
            mailDetail: "Mail Detail",
            mailNotFound: "Mail not found",
            mailSelecting: "Selecting Mail",
            newMail: "New Email",
            myMails: "My Emails",
            inbox: "Inbox",
            sent: "Sent",
            departmentMails: "Department Emails",
            newTemplate: "New Template",
            unread: "Unread",
            unreply: "Unanswered",
            reply: "Reply",
            attachments: "Mail Attachments",
            To: "To",
            From: "From",
            FromName: "From Name",
            placeHolders: "Placeholders",
            attacheFiles: "Attach Files",
            replyAll: "Reply All",
            forward: "Forward",
            deleteThread: "Delete Thread",
            markAsRead: "Mark as Read",
            markAsAllRead: "Mark All as Read",
            emailEditor: "Email Editor",
            integrateYourMail: "Integrate Your Email",
            connect: "Connect",
            departmentMail: "Department Email",
            createMailAddress: "Create Email Address",
            createNewMail: "Create New Email",
            canNotUserMail: "Could not send mail because there is no user mail",
            createNewEmail: "Create New Email",
            ly: "Reply",
            operativ: "Operational",
            ply: "Reply",
        },
        visitor: {
            ownership: "Ownership",
            tags: "Tags",
            visitors: "Visitors",
            bannedVisitors: "Banned Visitors",
            profileFields: "Profile Fields",
            downloadAll: "Download All",
            saveAsCustomerGroup: "Save as Customer Group",
            saveSearchFavorite: "Save search as favorite",
            editOrDeleteFavorite: "Edit or delete favorite",
            mail: "Mail",
            visitorDetail: "Visitor Details",
            selectedUser: "{selectedUser} out of {totalUsers} users selected",
            uncheck: "Uncheck All",
            checkAll: "Check All",
            matchedUsers: "{checkedCount} users matched",
            more: "More",
            exportUsers: "Export Selected Users",
            exportAllUsers: "Export All Users",
            addSegment: "Add Segment",
            deleteCheckedUser: "Delete Selected Users",
            deleteAllUser: "Delete All Users",
            matchedFilter: "Match All Filters",
            visitor: "Visitor",
            deleteUser: "Delete User",
            userData: "User Data",
            lastSession: "Last Session",
            notUserData: "No user data found",
            segments: "Segments",
            addTag: "Add Tag",
            userChats: "User Chats",
            seeAll: "See All",
            confirm: "Confirm",
            manageSegments: "Manage Segments",
            search: "Search",
            manageTags: "Manage Tags",
            allAttributes: "View All Attributes",
            noData: "No data",
            noEmail: "No email",
            noIpAddress: "IP address not found.",
            noWpNumber: "Number not found.",
            filterName: "filter name..",
            matchedContacts: "{chechkedCount} contacts matched",
            channelContacts: "Channel contacts",
            searchInAllFields: "Search in All Fields",
            searchInName: "Search in Name",
            importContacts: "Import Contacts",
            addNewContact: "Add New Contact",
            importContactsTitle: "Import Contacts",
            addSingleContactTitle: "Add Single Contact",
            downloadRecordsSettings: "Download Records - Settings",
            excelExport: "Excel Export",
            exportTotalRecords: "Total {total} records",
            exportCancel: "Cancel",
            whatsappContacts: "WhatsApp Contacts",
            instagramContacts: "Instagram Contacts",
            messengerContacts: "Messenger Contacts",
            linkedinContacts: "LinkedIn Contacts",
            telegramContacts: "Telegram Contacts",
            metaLeadsContacts: "MetaLeads Contacts",
            searchPlaceholderAll: "Type here to search in all fields",
            searchPlaceholderFullname: "Type here to search by name",
            searchPlaceholderEmail: "Type here to search by email",
            searchPlaceholderPhone: "Type here to search by phone",
            searchPlaceholderWhatsapp: "Type here to search by WhatsApp",
            searchPlaceholderDefault: "Search",
            searchFieldAll: "All Fields",
            searchFieldName: "Name",
            searchFieldEmail: "Email",
            searchFieldPhone: "Phone Number",
            searchFieldWhatsapp: "WhatsApp Number",
            searchModePhoneDetected: "Phone Number Detected",
            searchModeEmailDetected: "Email Address Detected",
            searchModeNotPhone: "Not a Phone Number",
            searchModeNotEmail: "Not an Email",
            searchMode: "Search Mode",
            searchModePhoneMessage:
                '"{query}" was detected as a phone number. You are currently in the {field} field. Would you like to search in the phone number field?',
            searchModeEmailMessage:
                '"{query}" was detected as an email address. You are currently in the {field} field. Would you like to search in the email field?',
            searchModeNotPhoneMessage:
                '"{query}" is not in phone number format. Would you like to search in all fields or the name field?',
            searchModeNotEmailMessage:
                '"{query}" is not in email format. Would you like to search in all fields or the name field?',
            unknownTag: "Unknown",
            noRecordsToDownload: "No records to download",
            excelCreatedSuccess: "Excel file created successfully",
            exportCancelled: "Export cancelled",
            excelCreateError: "An error occurred while creating the Excel file",
            yes: "Yes",
            no: "No",
            unowned: "Unassigned",
            whatsappGroupCreatedSuccess: "WhatsApp customer group created successfully.",
            whatsappGroupCreateError: "An error occurred while creating the WhatsApp customer group.",
            mailGroupCreatedSuccess: "Mail customer group created successfully.",
            mailGroupCreateError: "An error occurred while creating the mail customer group.",
            messageHistory: "Message History",
            pastConversations: "Past Conversations",
            defaultUser: "User",
            blockManagement: "Block Management",
            vipCustomer: "VIP Customer",
            startChat: "Start Chat",
            createEvent: "Create Event",
            createTask: "Create Task",
            selectTask: "Select Task",
            webphoneCall: "Call with Webphone",
            capiEventSend: "Send CAPI Event",
            defaultName: "Visitor",
            notAvailable: "N/A",
            relatedList: "Related List",
            adReferrals: "Ad Referrals",
            calls: "Calls",
            generalInfo: "General Information",
            callHistory: "Call History",
            webTab: "Web Tab",
            widgetUrlError: "Widget URL could not be created",
            deleteSuccess: "Visitor deleted successfully.",
            taskStatusUpdateSuccess: "Task status updated successfully",
            taskStatusUpdateError: "An error occurred while updating task status",
            copyToClipboard: "Copied to clipboard",
            noPhoneNumber: "No phone number to call",
            webphoneCalling: "Calling {phoneNumber} with Webphone...",
            filterResultMax5000: "Filter result is limited to a maximum of 5000 contacts",
            onlyContactsPhoneNumber: "Only contacts with phone numbers will be transferred to the group",
            enterGroupName: "Enter group name",
            showInColumns: "Show in Columns",
            sendMailSucs: "Mail Sent Successfully",
            equal: "Equal",
            notEqual: "Not Equal",
            contains: "Contains",
            notContains: "Does not contain",
            startsWith: "Starts with",
            endWith: "Ends with",
            deletedCheckedUser: "Delete selected users",
            userMails: "User Mails",
        },
        chatbotv2: {
            YouTube_Actions: "YouTube Actions",
            Google_Business_Actions: "Google Business Actions",
            Google_Play_Actions: "Google Play Actions",
            App_Store_Actions: "App Store Actions",
            Ticket_Actions: "Ticket Actions",
            Task_Actions: "Task Actions",
            Contact_Actions: "Person Actions",
            Calendar_Actions: "Calendar Actions",
            "T-Soft_Actions": "T-Soft Actions",
            "Ticimax-V2_Actions": "Ticimax Actions",
            TSOFT_SELECT_ORDER: "SELECT ORDER",
            TSOFT_ORDER_STATUS: "GET ORDER STATUS",
            TICIMAX_V2_SELECT_ORDER: "SELECT ORDER",
            TICIMAX_V2_ORDER_STATUS: "GET ORDER STATUS",
            Ikas_Actions: "Ikas Actions",
            IKAS_GET_MEMBER_INFO: "Get Member Details",
            IKAS_SELECT_ORDER: "Select Order",
            IKAS_ORDER_STATUS: "Get Order Status",
            CUSTOM_BLOCK: "Custom Block",
            CUSTOM_BLOCKDesc:
                "Execute custom JavaScript code with configurable parameters. Extend your chatbot by using blocks shared from the marketplace.",
            exampleOutput: "Example Output",
            outputSchema: "Output Schema (JSON)",
            IDEASOFT_PRODUCT_SEARCH: "Product Search",
            FEEDBACK_AI_ASSISTANTDesc:
                "Supsis AI Artificial Intelligence Assistant is an intelligent solution that optimizes customer service and business processes. It provides 24/7 service by automatically responding to customer inquiries, offers multilingual support, and integrates with platforms like WhatsApp, Instagram, and Facebook. It facilitates sales, marketing, and appointment scheduling processes while offering personalized experiences to increase customer satisfaction. This assistant, which enhances efficiency and cost savings, provides businesses with a modern and effective customer service solution through fast and accurate information flow.",
            INSERT_TO_SYSTEM_PROMPTDesc:
                "The Insert to System Prompt block allows the chatbot to insert a message into the system prompt. The message is inserted into the system prompt at the specified position. The message is inserted into the system prompt at the specified position. The message is inserted into the system prompt at the specified position.",
            API_REQUESTDesc:
                "This block defines the structure and parameters used to send a request to an API. The API Request URL specifies the address where the data will be sent, while the method (GET, POST, etc.) determines the type of request. Headers include authentication and content type information, Body Type defines the format of the data being sent, and the Body section contains the main data to be sent to the API. Finally, the Example Response shows an example of the expected response from the API. This block facilitates API integrations and automates data exchange.",
            BOT_RESPONSEDesc:
                "The Bot’s Response block enhances interaction by responding to the user with different content types such as text, images, and files. This block is used to send plain text messages (Text), randomly selected text variants (Random Text), images (Image), or files (File). It also provides button responses to offer options to the user: Gallery presents interactive displays with images and descriptions; Button offers options and is persistent across all platforms; Quick Reply allows the user to make quick selections and disappears after selection. Gallery supports unlimited buttons on the website platform, while only one card can be sent on WhatsApp. On Instagram and Messenger, each gallery card is sent as a separate message. Quick Reply offers more than 3 buttons on Instagram and Messenger, and the buttons appear above the message box.",
            TAVILY_WEB_SEARCHDesc:
                "Web search allows retrieving information from various websites through AI-powered systems. When a search query is entered, the most relevant results are scanned based on the specified search depth, providing information tailored to the user's needs. Raw content, images, and image descriptions can also be included for a more comprehensive information transfer. Additionally, the obtained data can be summarized or presented in its raw form. Users can filter search results by including specific domains, ensuring access to information from the most reliable sources. Thus, AI-powered web searches optimize the process of obtaining fast and accurate information.",
            OPENAI_WEB_SEARCHDesc:
                "Web search allows retrieving information from various websites through AI-powered systems. When a search query is entered, the most relevant results are scanned based on the specified search depth, providing information tailored to the user's needs. Raw content, images, and image descriptions can also be included for a more comprehensive information transfer. Additionally, the obtained data can be summarized or presented in its raw form. Users can filter search results by including specific domains, ensuring access to information from the most reliable sources. Thus, AI-powered web searches optimize the process of obtaining fast and accurate information.",
            AI_BOT_RESPONSEDesc:
                "This system enables AI to generate personalized responses based on user inputs and predefined instructions; it provides accurate and comprehensive answers using pre-prepared templates while recording user feedback to improve future responses.",
            AI_CLASSIFICATIONDesc:
                "The AI Classification Block analyzes user messages and categorizes them into predefined categories, automatically triggering relevant actions. Automatic classification ensures correct routing based on message content, while flexible category management allows adding or editing categories. Classified data is filtered to take the most appropriate actions based on user requests. Additionally, Instagram messages and comments can be classified through this block, enabling automated responses or actions.",
            DEFAULT_TIMEOUTDesc:
                "The default timeout is triggered at the start of the scenario and takes precedence if it is shorter than the local timeout duration; to use only the local timeout, the default must be deleted. The timeout duration cannot exceed the session duration, and multiple timeouts can be used in conjunction with user inputs. This structure, triggered when no response is received from the user, is suitable for sending reminder messages or restarting specific flows.",
            FILTERDesc:
                "The Supsis AI platform allows chatbots to filter user data based on customized attributes, user information (name, email, phone, language, time zone, gender, etc.), and visitor profile information (country, IP, referrer, visit address, etc.). Filtering operations enable the creation of complex conditions using 'and' and 'or' operators; for example, providing live support during working hours or offering special responses based on specific countries, phone numbers, or visit addresses. These features analyze user behavior, enabling the chatbot to provide more personalized, fast, and effective responses, thereby increasing customer satisfaction and optimizing chatbot efficiency.",
            ATTACHMENT_INPUTDesc:
                "The File Input block allows the chatbot to securely store and generate a downloadable URL for files received from users; this URL can be shared via channels like email or WhatsApp. The user can only send files in a defined file input; otherwise, the system redirects to the local or default 'Otherwise' flow. Images, audio, video, documents, or other attachments are supported, and the system automatically initiates the relevant process for each file type, redirecting the file to relevant units if necessary.",
            USER_INPUTDesc:
                "The User Input block allows the chatbot to process, validate, and save data received from users, triggering relevant actions. Global keywords are valid everywhere, while local keywords work in specific steps. Inputs can be validated using regex and saved to the user profile. The confidence level determines how the chatbot responds to inputs. With the 'Go to Block' and 'Send Message' buttons, users can be directed to specific steps or interact with the chatbot. This structure enables the chatbot to manage user interactions more efficiently.",
            GO_TO_STEPDesc:
                "The Go to Step Action is a mechanism that directs chatbot users to predefined steps. Dynamic routing ensures users are directed to the correct flow based on their queries or triggered actions. Block name editing ensures the flow is understandable and connections are easily managed. Users can edit block names from the block or within the block. The 'Go to Step' action is particularly useful for organizing transitions in complex chatbot flows. The Go to Block button type works similarly, directing users who click the defined button to a predefined block. The Go To selection determines the block the button will direct to, optimizing the user experience.",
            WEBHOOKDesc:
                "The Webhook Action facilitates data sharing between the chatbot and external systems. It directs the user flow based on successful and failed scenarios. In a successful scenario, the user flow continues when data is successfully sent; in a failed scenario, an error message is displayed, and the user is redirected. Webhook integration enables interaction with external systems and data exchange. Webhooks enhance the chatbot's flexibility and enrich the flow. For integration, adjustments must be made according to the system's API documentation.",
            SET_ATTRIBUTEDesc:
                "The Set Attribute block allows data received from users to be saved to their profile card, classifying data as static, dynamic, or special. Static data saves fixed values, dynamic data saves information that changes based on user inputs, and special data saves randomly generated values (e.g., random numbers or OTP). User and visitor profile information is collected and stored during user interactions, making it available for future interactions. This block is useful for managing user data and providing more personalized and accurate responses.",
            ASSIGN_OWNERDesc:
                "The Assign Owner Block is used to assign an ongoing chat to a selected representative through the chatbot. The assignment algorithm determines the most suitable representative based on the number of contacts they have and specific date ranges. Additionally, assignments can be made only to online representatives, and certain representatives can be excluded from the assignment pool. This process is synchronized with Zoho CRM, saving the assigned representative's data to the CRM system, thereby managing customer support processes more efficiently.",
            QUESTIONDesc:
                "The Question block allows the chatbot to ask users questions and validate and process their responses. When the user provides the correct answer, the successful scenario is triggered, and the flow continues. If the user provides an incorrect answer, the failed scenario is activated, giving the user another chance to respond. Additionally, user responses are validated using validation parameters, and correct data is saved to the profile card. For example, email addresses are validated, and correctly formatted information is saved to the profile card. In case of incorrect responses, the user is given the opportunity to correct them. This feature makes the chatbot's interaction with users more personalized and accurate.",
            TRANSFER_TO_CHATBOTDesc:
                "The Transfer to Chatbot block directs the user to a predefined different chatbot flow, offering a personalized experience. Users can transition from one flow to another and are directed to the correct scenario based on their needs. Scenario selection uses filtering and tagging processes to ensure users are directed to the correct flow based on their specific attributes. This feature provides flexible and dynamic responses to user requests.",
            TAG_CHATDesc:
                "The Add Tag block adds tags to profiles based on user interactions, enabling segmentation and chatbot filtering. User inputs are analyzed to direct them to the correct department, followed by representative transfer. Tags are used to optimize customer support and sales processes.",
            REMOVE_TAGDesc:
                "The Remove Tag block removes unnecessary or outdated tags from user profiles, ensuring chatbot analyses remain current and accurate. Tags are automatically cleaned, making segmentation and data management more efficient.",
            SET_DEPARTMENTDesc:
                "The Set Department block automatically or manually directs users to the correct department based on their needs. The appropriate department is determined based on user selections or system data, tags are added for segmentation, and representative transfer is performed if necessary.",
            SEND_TRANSCRIPTDesc:
                "The Send Transcript block automatically sends a record of the chat with the user to a specified email address, contributing to support and analysis processes. The transcript can be sent to the email address in the user profile card or a manually entered address.",
            SEND_SMSDesc:
                "The Send SMS block enables the sending of automated and personalized messages using Supsis's integration with Postacell or another SMS provider. The SMS content is dynamically generated using the phone number in the user's profile card and system data. For integration and additional information, contact live support or info@supsis.com.",
            SEND_MAILDesc:
                "The Send Mail block enables automated email sending using information collected through the chatbot. Personalized email content can be created based on attributes in the user's profile card. The email subject and content can be dynamically customized, and automatic notifications can be sent to both users and relevant teams for support requests. Supsis's email module integrates with existing mail infrastructures, simplifying the process.",
            CREATE_EVENTDesc:
                "The Create Event block automatically adds events to users' calendars through the chatbot. The event title, description, and duration are determined using data from the user's profile information, and event owners and additional representatives can be assigned. Automatic notifications inform participants, and event details can be managed through calendar integrations (Google Calendar, Microsoft Teams), speeding up the process and optimizing time management.",
            CREATE_RESERVATIONDesc:
                "The Create Reservation block automatically initiates a reservation process using attributes from the user's profile card or manually entered form data. Information from the user's profile, such as email addresses, can be used for calendar events, and event details can be retrieved from these attributes. This block organizes information received through the reservation form by interacting with other blocks and initiates the reservation process, making it faster and more personalized.",
            RESERVATION_OPEN_URLDesc:
                "The View Reservation Screen block lists available appointments for the user through a predefined reservation calendar. The user can view available appointments on the calendar through this screen. Additionally, predefined duration options (e.g., 5 minutes, 15 minutes, 30 minutes) can be selected for the appointment duration. This feature only works on website chatbots and offers users convenient reservation options.",
            RESERVATION_SELECT_DAYDesc:
                "The Select Reservation Day block offers users a selection of weekly reservation days, and the selected reservation day is saved in the system. Relevant information is automatically retrieved from the user's profile card attributes, and the reservation day is determined. This block offers users options through buttons, directing them to the appropriate reservation day. This process is personalized with user-specific information and integrated with the event calendar.",
            RESERVATION_EVENT_LISTDesc:
                "The Customer Reservation List quickly and efficiently presents reservation data associated with users' email information. This process is performed using a specific customer's email address, and all reservations linked to that email address are listed for the user.",
            RESERVATION_SELECT_TIMEDesc:
                "The Select Reservation Time block offers users available times for the selected reservation day. The user selects a suitable time from the available options for the previously selected day. This block lists available times for the day based on data received from the Select Reservation Day block and offers options to the user. The selected reservation time is saved in the system and integrated appropriately using the user's profile information and attributes.",
            CREATE_TASKDesc:
                "The Create Task block automatically or manually adds tasks to the Task Management Module based on user requests. The task title, description, urgency level, workflow, and pipeline (column) are determined and assigned to relevant representatives. Tasks personalized with information from the user's profile card are notified to relevant individuals through system and email notifications. Google Calendar and Microsoft Teams integrations make the process easy to track. For example, when a customer requests additional information, the chatbot automatically creates a task in the 'Awaiting Contact' column of the sales process and notifies the relevant representative.",
            GET_LOCATIONDesc:
                "The Get Location Module allows the chatbot to collect geographic location information from users. When requesting location information from the user, a special message is displayed, and the location's latitude and longitude are saved to the profile card. The user can share their location manually by entering an address or selecting it on the map. This feature is particularly useful in e-commerce, logistics, and delivery sectors, personalizing the user experience. For example, an e-commerce chatbot can use this module to collect a delivery address from the user and complete the process.",
            SUPPRESSION_ADDDesc:
                "The Suppression block blocks a user on a specified platform (WhatsApp, Web Visitor, Instagram, Messenger). The value of the user to be blocked can be automatically retrieved from attributes or entered manually. Blocking can be applied to inbound (message reception), outbound (message sending), or both. For example, to block a user causing discomfort on WhatsApp, 'WhatsApp' is selected as the platform, the user's phone number is specified, and both inbound and outbound blocking are activated.",
            SUPPRESSION_REMOVEDesc:
                "The Remove Suppression block unblocks a previously blocked user on a specified platform (WhatsApp, Web, Instagram, etc.) using the value used for blocking (e.g., phone number, user ID). The value for unblocking can be automatically retrieved from the profile card attributes. This allows the unblocking process to be performed quickly and automatically.",
            SEND_WP_BUSINESS_MESSAGEDesc:
                "The Send WhatsApp Message block enables sending personalized messages to users using the WhatsApp Business API. When this action is triggered, a message is sent through the WhatsApp channel using a predefined template. The message content can be personalized using attributes from the profile card and manual inputs. The number to be sent can be entered manually or automatically retrieved from user information. Templates are approved formats in the WhatsApp Business API, and existing templates can be selected or new ones created. Variables within the template can be used to create personalized messages. Additionally, media files (JPEG, PNG, etc.) can be added to messages. This block enables automated message sending for scenarios like campaign messages, support requests, or special notifications.",
            MESSENGER_SEND_MESSAGEDesc:
                "This block allows the CHATBOT to send messages via Messenger. The CHATBOT can send messages containing text, images, or other media types to a specific recipient.",
            INSTAGRAM_SEND_MESSAGEDesc:
                "This block allows the CHATBOT to send direct messages via the Instagram platform. The CHATBOT can send messages containing text or media to a specific user.",
            INSTAGRAM_COMMENT_REPLYDesc:
                "This block is used to reply to a comment on an Instagram post. The CHATBOT can interact by replying to a specific comment.",
            INSTAGRAM_COMMENT_DELETEDesc:
                "This block is used to delete a comment on an Instagram post. The CHATBOT can remove unwanted or inappropriate comments.",
            INSTAGRAM_COMMENT_SHOWDesc:
                "This block is used to view a comment on an Instagram post. The CHATBOT can review a specific comment and see other users' opinions.",
            INSTAGRAM_COMMENT_HIDEDesc:
                "This block is used to hide a comment on an Instagram post. The CHATBOT can make a specific comment invisible, preventing followers from seeing it.",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATEDesc:
                "This block is used to reply to a comment on an Instagram post with a private message (DM). The CHATBOT can send a private response to the commenter, establishing a more personal communication.",
            TABLE_CREATE_RECORDDesc:
                "This block adds a new record to a specific table. Using information received from the user or other attributes in the system, a new record is created and added to the relevant table. Adding a new record is used for processes such as creating new customer information or product records.",
            TABLE_DELETE_RECORDDesc:
                "This block deletes a record from the data table. When the user wants to remove a record that is no longer valid or contains errors, this block is triggered. The deleted record is completely removed from the table and cannot be recovered. For example, this process is used to delete a customer's record or an invalid order.",
            TABLE_UPDATE_RECORDDesc:
                "This block updates the content of a record in the table. When the user wants to change information in an existing record, this block can be used. For example, this process is used to update a customer's address or product price. This operation only changes the specified record and does not affect other records in the table.",
            TABLE_FIND_RECORDDesc:
                "This block allows finding a specific record in the data table. When the user wants to search for specific data (e.g., a username or product ID) recorded in the table, this block is used. The search process allows users to quickly access a specific record.",
            TABLE_FIND_RECORDSDesc:
                "This block displays existing records in the table to the user. When the user wants to see all records in the table or filtered records based on specific criteria, this block is used. The listing process can include operations such as sorting and filtering data.",
            ADD_TO_SEGMENTDesc:
                "The Add to Segment Action allows adding users to defined segments after they go through specific steps. This action helps analyze user behavior by dividing it into segments and creating custom reports. Users are added to appropriate segments through the segment selection bar, and new segments can be created from the chatbot menu. For example, when a VIP customer makes a special campaign query, the Add to Segment action adds the user to the VIP segment. Segment reports can be reviewed through reporting, providing detailed data on which segments users are added to and their requests.",
            REMOVE_FROM_SEGMENTDesc:
                "The Remove from Segment Action is used to remove users from specific segments. This action updates segments, enabling more accurate analysis of users on a segment basis. Users are automatically removed from the relevant segment after selecting the segment to be removed through the segment selection bar. Segment updates and analyses of removed users can be performed through reporting, allowing clearer tracking of segment changes and user behavior.",
            privateMessageDescription: "Private messages can only be viewed by agents and remain hidden from visitors.",
            PRIVATE_MESSAGE: "Private Message",
            aiPrompt: "Prompt",
            variants: "Variants",
            importSuccess: "Template imported successfully",
            importFailed: "Error importing template",
            creatingBlank: "Creating blank ChatBOT...",
            untitledChatbot: "Untitled ChatBOT",
            errorCreating: "Error creating ChatBOT",
            typeAutomationTitle: "Type the automation title",
            typeStoryTitle: "Write a Story Title",
            setUpYourChatbot: "Set Up Your Chatbot",
            setUpYourChatbotDesc: "Train your chatbot with data, use our ready-to-use templates or start from scratch.",
            blankBot: "Blank Bot",
            blankBotDesc: "Create a blank chatbot that you can train and customize later.",
            aiBotDesc: "Create a RAG-powered AI chatbot. Add a knowledge base and choose your LLM model.",
            recommended: "Recommended",
            websiteDesc: "Scan your website content to get answers to popular user questions.",
            yourNeedEnterYourOpenAi:
                "You need to enter your OpenAI API key to create an automated chatbot that crawls your website.",
            createOpenAiKey: "Create API Key",
            aiKnowledge: "Artificial Intelligence Knowledge",
            modalUsage: "Modal Usage",
            usedContentSources: "Content Sources Used",
            websites: "Websites",
            articles: "Articles",
            faq: "FAQ",
            files: "Files",
            functions: "Functions",
            settings: "Settings",
            disableAi: "Disable AI",
            enableAi: "Enable Artificial Intelligence",
            lastEdited: "Last Edited",
            state: "Status",
            frequentlyAskedQuestions: "Frequently Asked Questions (FAQ)",
            faqIsCreated: "FAQ Created",
            selectKnowEnabled: "Enabling the selected knowledge bases...",
            selectKnowDisabled: "Disabling the selected knowledge bases...",
            selectKnowNotEnabled: "The selected knowledge bases are not enabled.",
            selectKnowNotDisabled: "The selected knowledge bases are not disabled.",
            answered: "Answered",
            addFile: "Add File",
            fileDeleted: "Files deleted",
            fileDeletedFailed: "There was a problem deleting files",
            noFileAdded: "No file added",
            aiFunctions: "AI Functions",
            addFunction: "Add Function",
            aiFunctionCreateHint:
                "Do not use Turkish characters when creating AI functions. Use only English letters, numbers and underscores in function names.",
            builtInFunctionsTitle: "Built-in Functions",
            builtInFunctionsDesc: "These are predefined functions that can be used by artificial intelligence.",
            builtInFunctionsOptionButtonsTitle: "AI Can Send Messages with Buttons",
            builtInFunctionsOptionButtonsDesc:
                "Allows the AI to show clickable buttons to the user. When active, the AI can offer option buttons to the user.",
            builtInFunctionsCloseConversationTitle: "AI Can End the Conversation",
            builtInFunctionsCloseConversationDesc:
                "Allows the AI to end the conversation when appropriate. When active, the AI can close the chat.",
            builtInFunctionsTransferChatTitle: "AI Can Transfer to Live Support",
            builtInFunctionsTransferChatDesc:
                "Allows the AI to transfer the conversation to live support when needed. When active, the AI can transfer the conversation to a human agent.",
            parameterCount: "Parameter Count",
            auto: "Auto",
            usedByAI: "Used by AI",
            Zoho_Actions: "Zoho Actions",
            File_Actions: "File Actions",
            Google_Drive_Actions: "Google Drive Actions",
            Artificial_Intelligence: "Artificial Intelligence",
            Data_Formatters: "Data Formatters",
            Loop_Actions: "Loop Actions",
            usedByAi: "Used by AI",
            notUsed: "Not in use",
            saveAndClose: "Save and Close",
            contentPreview: "Content Preview",
            addContent: "Add Content",
            populerUserQuestion: "Scan your website content to get answers to popular user questions.",
            enterUrlAddress: "Enter a URL address",
            sharingYourUrl: "By sharing your URL, you confirm that you have the necessary rights to share its content.",
            pageSelected: "Selected Pages",
            trainChatbot: "Train the chatbot",
            thereAreOnePages: "There is 1 page inside",
            categoryDesc: "Category. Choose which one to use to train your AI model.",
            scarpOrAddContent: "Scrap or add content, which AI Assist can use to respond to your customers' queries",
            noContentAdded: "No Content Added",
            howItWorks: "How It Works",
            editEntries: "Edit Entries",
            newEntries: "New Entries",
            chatbotManagement: "Chatbot Manegement",
            chatbotScenarioList: "Chatbot Scenario List",
            exportDiagramToClipboard: "Export Diagram To Clipboard",
            exportDiagram: "Export Diagram",
            exportDiagramDescription:
                "Select the components you want to export. This data will be copied to the clipboard and can be imported into another scenario.",
            diagram: "Diagram",
            diagramExportDesc: "Chatbot flow diagram (required)",
            aiSettings: "AI Settings",
            aiSettingsExportDesc: "AI model settings, prompt and parameters",
            aiFunctionsExportDesc: "Select AI functions to export",
            knowledgeBase: "Knowledge Base",
            knowledgeBaseExportDesc: "Select knowledge base types to export",
            webPages: "Web Pages",
            noKnowledgeBase: "No knowledge base found to export",
            selectAll: "Select all",
            exportToClipboard: "Copy to Clipboard",
            exportSuccess: "Scenario successfully copied to clipboard",
            exportError: "An error occurred during export",
            exportDataFetchError: "Error fetching export data",
            model: "Model",
            topP: "Top P",
            toolChoice: "Tool Choice",
            prompt: "Prompt",
            selectedStory: "{count} story selected",
            B2Cargo_Actions: "B2Cargo Actions",
            Holiday_Plus_Actions: "Holiday+ Actions",
            Meta_Actions: "Meta Actions",
            b2cargo_login_user: "Login User",
            b2cargo_product_status: "Product Status",
            HOLIDAY_PLUS_GET_ROOMS: "LIST ROOMS",
            HOLIDAY_PLUS_GET_HOTELS: "LIST HOTELS",
            ZOHO_CREATE_RECORD: "Zoho Create Record",
            suppressionRemoved: "Suppression Removed",
            suppressionAdded: "Suppression Added",
            didntSuppression: "You didn't make any suppression.",
            whatsappIntegrationTitle: "Whatsapp V1 and Whatsapp V2 Integration",
            whatsappApiIntegrationTitle: "Whatsapp Business API Integration",
            ReadyTemplateBadge: "Ready Template",
            readyTemplates: "Ready Templates",
            regex: "Regex",
            regexDescription: "Catch everything with Regex",
            chatbotLogo: "Chatbot Logo",
            chatbotName: "ChatBot Name",
            allSecnario: "Chatbot Scenario List",
            ChatbotScenarioList: "Chatbot Scenario List",
            Scenario: "Scenario",
            filters: {
                equal: "is equal to",
                not_equal: "isn't equal",
                contain: "contain",
                not_contain: "not contain",
                starts_with: "starts with",
                ends_with: "ends with",
                empty: "is empty",
                non_empty: "non empty",
                longer_than: "longer than",
                shorter_than: "shorter than",
                less_than: "less than",
                less_or_equal: "less or equal",
                greater_than: "greater than",
                greater_or_equal: "greater or equal",
            },
            planRequired: "{integratable} Plan Required",
            noDefaultStoryTitle: "Default Story",
            noDefaultStory: "There is no default story.\n Would you like to make default this story?",
            noMessage: "No Message",
            loading: "Loading",
            loadMore: "Load More",
            hostname: "Host name",
            goToStory: "go to story",
            noResultFound: "No results found",
            checkYourFilterCombination: "Check your filter combination",
            clearYourSearch: "clear your search",
            andTryAgain: "and try again",
            allTemplates: "All Templates",
            allAITemplates: "All AI Templates",
            templatesFromTheIndustry: "Templates from the Industry",
            basicTemplate: "Basic Template",
            proTemplate: "Advanced Template",
            withBot: "& Bot",
            userWithBot: "User & Bot",
            chatDetail: "Chat details",
            allUserDetail: "See all user details",
            sessionData: "Session data",
            supsisChatWidget: "Supsis Chat Widget",
            integratedWith: "Integrated with :   ",
            botStory: "Bot story",
            integration: "Integration",
            Users: "Users",
            user_id: "User ID",
            categories: "Categories",
            worksWith: "Works with",
            importBot: "Import bot",
            keyFeatures: "Key features",
            importing: "importing",
            comingSoon: "Coming Soon",
            pickStory: "Pick a story",
            conversationId: "Chat ID",
            integrateStoryWithSupsisWidget: "Integrate Supsis Widget With Chatbot Story",
            integrateStoryWithWhatsapp: "Integrate Whatsapp With Chatbot Story",
            integrateStoryWithInstagram: "Integrate Instagram with Chatbot Story",
            selectIntegratingStory: "Select the story that will be integrated",
            install: "Install",
            attr: {
                owner: "Owner",
                trendyol_question: "Product Question",
                trendyol_question_id: "Product Question ID",
                trendyol_product_id: "Product ID",
                trendyol_product: "Product Data",
                weekday: "Weekday",
                email: "E-mail",
                phone: "Phone",
                language: "Language",
                timezone: "Timezone",
                gender: "Gender",
                country: "Country",
                referrer: "Referrer",
                department: "Department",
                url: "URL",
                id: "ID",
                conversationId: "Conversation ID",
                channelId: "Channel ID",
                ip: "IP",
                last_seen: "Last Seen",
                name: "Name",
                user_id: "User ID",
                message: "Message",
                akinon_brand: "Brand",
                akinon_order_id: "Order Id",
                akinon_product_id: "Product Id",
                akinon_user_id: "User Id",
                akinon_user_name: "User Name",
                akinon_user_email: "User Email",
                akinon_invoice_url: "Invoice Url",
                akinon_order_status: "Order Status",
                akinon_order_price: "Order Price",
                akinon_shipper_name: "Shipper Name",
                akinon_product_size: "Product Size",
                akinon_sku: "Sku",
                akinon_product_url: "Product Url",
                akinon_product_title: "Product Title",
                akinon_product_image: "Product Image",
                akinon_product_stock: "Product Stock",
                akinon_order_date: "Order Date",
                akinon_track_number: "Track Number",
                akinon_track_url: "Track Url",
                akinon_latitude: "Latitude",
                akinon_longitude: "Longitude",
                ideasoft_user_id: "Member Id",
                ideasoft_invoice_url: "Invoice Url",
                ideasoft_order_id: "Order ID",
                ideasoft_order_status: "Order Status",
                ideasoft_order_price: "Order Price",
                ideasoft_shipper_name: "Shipper Name",
                ideasoft_product_size: "Product Size",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Product Url",
                ideasoft_product_title: "Product Title",
                ideasoft_product_image: "Product Image",
                ideasoft_product_stock: "Product Stock",
                ideasoft_order_date: "Order Date",
                ideasoft_track_number: "Track Number",
                ideasoft_track_url: "Track Url",
                offline_mode: "Offline Mode",
                available_agents: "Available Agents",
                platform: "Platform",
                probel_sube_kodu: "Branch Code",
                probel_brans_adi: "Branch Name",
                probel_brans_kodu: "Branch Code",
                probel_doktor_adi: "Doctor Name",
                probel_doktor_kodu: "Doctor Code",
                probel_poliklinik_adi: "Polyclinic Name",
                probel_poliklinik_kodu: "Polyclinic Code",
                probel_randevu_tarihi: "Appointment Date",
                probel_date: "Appointment Date",
                probel_randevu_saati: "Appointment Time",
                probel_randevu_id: "Appointment ID",
                probel_hasta_token: "Patient Token",
                probel_kimlik_tipi: "Identity Type",
                probel_kimlik_no: "Identity No",
                probel_hasta_adi: "Patient Name",
                probel_hasta_soyadi: "Patient Surname",
                probel_hasta_cinsiyet: "Gender",
                probel_hasta_dogum_tarihi: "Date of Birth",
                probel_hasta_telefon: "Phone",
                hour: "Hour",
                segments: "Segments",
                tags: "Tags",
                ticket: "Ticket",
                metaReferrals: "Meta Referrals",
                idleUserTime: "User Last Action (Second)",
                ai_class_result: "AI Class Result",
                meta_comment_id: "Meta Comment ID",
                meta_comment: "Meta Comment",
                meta_post_id: "Meta Post ID",
                last_meta_post_id: "Last Meta Post ID",
                last_meta_post_caption: "Last Meta Post Caption",
                last_meta_post_type: "Last Meta Post Type",
                visitor_trigger_type: "Visitor Trigger Type",
                visitor_trigger_name: "Visitor Trigger Name",
                b2cargo_companyCode: "Company Code",
                b2cargo_takipNo: "Tracking Number",
                b2cargo_takipseri: "Tracking Serial",
                b2cargo_evrakdurum: "Order Status",
                b2cargo_teslimtar: "Delivery Date",
                b2cargo_gonderen: "Sender Name",
                b2cargo_aliciAdi: "Receiver Name",
                b2cargo_cikisIl: "Province of Departure",
                b2cargo_varisIl: "Province of Arrival",
                b2cargo_teslim: "Product Status",
                b2cargo_urun: "Product Type",
                b2cargo_atfTarih: "Product ATF Date",
                b2cargo_palet: "Product Palette",
                b2cargo_koli: "Product Parcel",
                b2cargo_kg: "Product WEIGHT",
                b2cargo_desi: "Product DESI",
                b2cargo_zimmetno: "Debit No",
                b2cargo_varissube: "Arrival Branch",
                b2cargo_atfDurum: "ATF State",
                holiday_plus_room_id: "Room ID",
                holiday_plus_room_title: "Room Title",
                holiday_plus_room_description: "Room Description",
                holiday_plus_room_size: "Room Size",
                holiday_plus_room_price: "Room Price",
                holiday_plus_room_price_offer: "Room Price Offer",
                holiday_plus_room_discount_price: "Room Discount Price",
                holiday_plus_selected_hotel_id: "Selected Hotel ID",
                holiday_plus_checkin: "Check In",
                holiday_plus_checkout: "Check Out",
                holiday_plus_child_count: "Child Count",
                holiday_plus_adult_count: "Adult Count",
                holiday_plus_child_dates: "Child Dates",
                reservation_time: "Reservation Time",
                reservation_day: "Reservation Day",
            },
            storyList: "Story List",
            stories: "Stories",
            templates: "Templates",
            aitemplates: "AI Templates",
            integrations: "Integrations",
            all: "All",
            installed: "Installed",
            remainingMessageDesc: "Remaining free messages : ",
            openAISiteRoutingDescStart: "You can click the link ",
            openAISiteRoutingDescEnd: "to get an api key.",
            integrationOK: "Integrated",
            artificialIntelligence: "Artificial Intelligence",
            integratePlatform: "Chatbot can be integrated with {integretable}.",
            integrateOpenAIWithChatbot: "Integrate Chat GPT-4o With Chatbot",
            integrateChatBotWithChatGPT3: "Integration of ChatBot With Chat GPT-4o",
            archive: "Archive",
            reports: "Reports",
            userSegments: "User Segments",
            blockMarket: "Block Market",
            sandbox: "Trash",
            sandboxPage: {
                title: "Chatbot Deleted Scenarios",
                description: "Your deleted scenarios will be automatically removed after 30 days in the trash",
                emptyState: "No deleted scenarios in trash",
                unnamedScenario: "Untitled Scenario",
                restore: "Restore",
                permanentlyDelete: "Permanently Delete",
                unknown: "Unknown",
                user: "User",
                restoreConfirmTitle: "Are You Sure You Want to Restore This Scenario?",
                restoreConfirmContent: "{story} scenario will be restored.",
                restoreSuccess: "Scenario restored successfully",
                restoreError: "Restore failed",
                permanentDeleteConfirmTitle: "Are You Sure You Want to Permanently Delete This Scenario?",
                permanentDeleteConfirmContent:
                    "This action cannot be undone. The scenario will be permanently deleted.",
                permanentDeleteSuccess: "Scenario permanently deleted",
                permanentDeleteError: "Delete operation failed",
                loadError: "Error loading deleted scenarios",
            },
            customBlocks: "Custom Blocks",
            createNewBlock: "Create New Block",
            marketplace: "Marketplace",
            myBlocks: "My Blocks",
            importedBlocks: "Imported Blocks",
            pendingApproval: "Pending Approval",
            searchBlocks: "Search blocks...",
            unknownBlock: "Unknown Block",
            aiModelsComparison: "AI Model Comparison",
            aiModelsChangeModel: "Change model",
            aiModelsRecommended: "Recommended",
            aiModelsEconomic: "Economic",
            aiModelsCodex: "Codex",
            comingSoonVectorIntro: "With OpenAI Vector Storage, you can train your chatbot with your custom content.",
            comingSoonStep1Title: "Upload Your Files",
            comingSoonStep1Desc: "Add your PDF, Word, Excel, text files or other documents to the system.",
            comingSoonStep2Title: "Automatic Processing",
            comingSoonStep2Desc: "Your files are analyzed by OpenAI and converted to vector format.",
            comingSoonStep3Title: "Smart Responses",
            comingSoonStep3Desc:
                "Your chatbot provides accurate and meaningful responses based on the content you uploaded.",
            comingSoonTip:
                "Tip: As you add more content, your chatbot's knowledge base expands and can provide more comprehensive responses.",
            comingSoonGotIt: "Got it",
            imageProcessingSettings: {
                title: "Image Processing Settings",
                description: "Determine how images sent to the chatbot will be processed.",
                processingMode: "Processing Mode",
                processWithBlock: "Process with Block",
                processWithBlockDesc: "Route images to local block flow",
                processWithAI: "Process with AI",
                processWithAIDesc: "Process images with artificial intelligence",
                fallbackBlock: "Fallback Block",
                fallbackBlockDesc: "Block to redirect to when an error occurs during image processing",
                fallbackBlockPlaceholder: "Select fallback block",
                directJumpBlock: "Direct Jump Block",
                directJumpBlockDesc: "Route all images directly to this block",
                directJumpBlockPlaceholder: "Select direct jump block (optional)",
                aiProcessingMode: "AI Processing Mode",
                processIndividual: "Process One by One",
                processIndividualDesc: "Send each image to AI separately",
                processParallel: "Process in Parallel",
                processParallelDesc: "Collect images within a certain time and send them together",
                bufferTime: "Buffer Duration (seconds)",
                bufferTimeDesc: "Time to wait for collecting images",
                saveSuccess: "Image processing settings updated successfully",
                saveError: "Error occurred while saving settings",
            },
            utility: "Utility",
            dataTransform: "Data Transform",
            custom: "Custom",
            mostUsed: "Most Used",
            topRated: "Top Rated",
            newest: "Newest",
            uses: "uses",
            import: "Import",
            imported: "Imported",
            noBlocksFound: "No blocks found!",
            pending: "Pending",
            approved: "Approved",
            rejected: "Rejected",
            published: "Published",
            draft: "Draft",
            publish: "Publish",
            unlist: "Unlist",
            confirmDeleteBlock: "Are you sure you want to delete this block?",
            noBlocksCreated: "No blocks created yet",
            blockPublished: "Block published successfully",
            blockUnlisted: "Block unlisted successfully",
            blockDeleted: "Block deleted successfully",
            cannotDeleteActiveBlock: "Cannot delete block with active usage",
            noDescription: "Matches no synonyms",
            noImportedBlocks: "No imported blocks",
            confirmRemoveImport: "Are you sure you want to remove this import?",
            remove: "Remove",
            importRemoved: "Import removed successfully",
            changelogPlaceholder: "Enter changelog (optional)",
            creator: "Creator",
            viewDetails: "View Details",
            approve: "Approve",
            reject: "Reject",
            noPendingBlocks: "No pending blocks",
            enterRejectionReason: "Enter rejection reason",
            rejectBlock: "Reject Block",
            blockApproved: "Block approved successfully",
            blockRejected: "Block rejected",
            blockImported: "Block imported successfully",
            parameters: "Parameters",
            noParameters: "No parameters required",
            ratings: "Ratings",
            writeReview: "Write your review...",
            selectOrTypeCategory: "Select or type category",
            category: "Category",
            description: "Description",
            tags: "Tags",
            submitRating: "Submit Rating",
            noRatings: "No ratings yet",
            latest: "Latest",
            pinned: "Pinned",
            editBlock: "Edit",
            createBlock: "Create Block",
            basicInfo: "Basic Info",
            blockName: "Block Name",
            enterBlockName: "Enter block name",
            enterDescription: "Enter description",
            icon: "Icon",
            addTags: "Add tags",
            javascriptCode: "JavaScript Code",
            addParameter: "Add Parameter",
            parameterName: "Parameter name (variable)",
            parameterLabel: "Display label",
            parameterDescription: "Description (help text)",
            defaultValue: "Default value",
            allowAutoUpdate: "Auto-update output schema on execution",
            visibility: "Visibility",
            allowedSiteIds: "Allowed Site IDs",
            enterSiteIds: "Enter site IDs",
            saveDraft: "Save Draft",
            fillRequired: "Please fill required fields",
            blockUpdated: "Block Updated",
            blockCreated: "Block created",
            selectCustomBlock: "Select Custom Block",
            selectCustomBlockDesc: "Choose a custom block from your imported blocks",
            browseBlockMarket: "Browse Block Market",
            outputPreview: "Output Preview",
            blockNotFound: "Block not found",
            pleaseSelectRating: "Please select a rating",
            ratingSubmitted: "Rating submitted",
            addSegment: "Add Segment",
            addToSegment: "Add To Segment",
            removeFromSegment: "Remove From Segment",
            plansVTippyContent:
                "Billing for this package will be done at the beginning of each month, and in case you wish to cancel, your usage will be charged until the beginning of the month and your package will expire.<br><br>The package price is exclusive of VAT.<br><br>Package changes are reflected in the invoice the next day.",
            segmentName: "Segment Name",
            sameSegment: "There is a segment with the same name!",
            usersInSegment: "Users In Segment",
            noUsersAdded: "No users added",
            updateSegment: "Update Segment",
            newSegment: "New Segment",
            queriesSelected: "queries selected",
            userQuery: "User Query",
            date: "Date",
            unmatched: "Unmatched",
            goToChat: "Go to Chat",
            selectStory: "Select Story",
            selectBlock: "Select Block",
            training: "Training",
            trainingAlert:
                "To implement the changes you made on the bot training page, you need to publish the new version of the scenario you modified",
            unmatchedPhrases: "Unmatched Phrases",
            ignored: "Ignored",
            story: "Story",
            timePeriod: "Time Period",
            wholeTimeSpan: "Whole time span",
            selectAStory: "Select a story",
            searchUserQuery: "Search user query",
            time: {
                today: "Today",
                yesterday: "Yesterday",
                last7: "Last 7 Days",
                last30: "Last 30 Days",
                "this-month": "This Month",
                "last-month": "Last Month",
                "last-3-month": "Last 3 Month",
                "this-year": "This Year",
                "last-year": "Last Year",
                custom: "Choose a Different Date",
            },
            emailProvider: "Email provider",
            triggerFromAnywhere: "Trigger from anywhere",
            allIntegrations: "All Integrations",
            integrateYourCBwithChatWidget: "Integrate your chatbot with Chat Widget.",
            integrateYourCBwithChatGpt3: "Chatbot can be integrated with GPT-4o. GPT-4o api key required.",
            integrateYourCBwithWebHook: "Pass chat information between ChatBot and your web services with ease.",
            integrateYourCBwithIntegratable: "Pass chat information between ChatBot and {integratable} with ease.",
            addWebhook: "Add Webhook",
            editWebhook: "Edit Webhook",
            newWebhook: "New Webhook",
            webhookTitle: "Webhook Title",
            webhookUrl: "Webhook Url",
            webhookToken: "Webhook Token",
            webhookUsername: "Webhook Username",
            webhookPassword: "Webhook Password",
            moveBlock: "Move",
            copyBlock: "Copy",
            addFilter: "Add Filter",
            addFilterGroup: "Add Filter Group",
            clearFilter: "Clear Filter",
            in: "in",
            and: "and",
            or: "or",
            chatbot: "Chatbot",
            allStories: "All Stories",
            addBot: "Create Bot",
            testBot: "Test Your Bot",
            editName: "Edit Name",
            search: "Search in your story…",
            typeMoreThan3Char: "Type in at least 3 character",
            expand: "Expand",
            expandAll: "Expand All",
            noMatchingItem: "No matching item",
            hint: "Hint",
            select: "Select",
            navigate: "Navigate",
            dismiss: "Dismiss",
            choseAttribute: "Chose Attribute",
            selectReply: "Select Reply",
            preview: "Preview",
            lastUpdate: "Last Update",
            newStory: "New Story",
            updateStory: "Update Story",
            storyDescription: "Story Description",
            storyTitle: "Story Title",
            deleteSingleBlock: "Delete Single Block",
            deleteWithChildren: "Delete With Children",
            startTestFromHere: "Start Test From Here",
            copyBlockId: "Copy Block Id",
            gotoLiveLink: "Go to Live Link",
            copyBlockIdSuccessfull: "Block Id copied to clipboard",
            collapse: "Collapse",
            collapseAll: "Collapse All",
            snDelay: "{delay} sec delay",
            addPayload: "Add Payload",
            previewModeCaution:
                "You're now previewing one of your story's versions. You can't save changes in the preview mode!",
            enterText: "Enter text...",
            trackpad: "Trackpad",
            navigation: "Navigation",
            navigationDesc: "Please choose your navigation mode.It is up to you if it will be trackpad or mouse.",
            botSetting: "Bot Setting",
            botSettingDesc:
                "Please set confidence level. This is a percentage between 0 and 100. The level defines correctness of chatbot interprets which are related to user inputs.",
            languageSettingsDesc: "Please make sure that Bot's language which it responses is your preferred language.",
            mouse: "Mouse",
            Interactions: "Interactions",
            Actions: "Actions",
            Supsis_Actions: "Supsis Actions",
            Table_Actions: "Table Actions",
            Cache_Actions: "Cache Actions",
            Shopify_Actions: "Shopify Actions",
            Akinon_Actions: "Akinon Actions",
            IdeaSoft_Actions: "Ideasoft Actions",
            START_POINT: "START POINT",
            API_REQUEST: "API REQUEST",
            AI_ASSISTANT: "AI ASSISTANT",
            FEEDBACK_AI_ASSISTANT: "FEEDBACK AI ASSISTANT",
            INSERT_TO_SYSTEM_PROMPT: "INSERT TO SYSTEM PROMPT",
            BOT_RESPONSE: "BOT RESPONSE",
            AI_CALL: "AI CALL",
            TAVILY_WEB_SEARCH: "WEB SEARCH",
            AI_BOT_RESPONSE: "AI RESPONSE (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Template Blocks",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            RUN_JAVASCRIPT: "RUN JAVASCRIPT",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "DEFAULT FALLBACK",
            DEFAULT_TIMEOUT: "DEFAULT TIMEOUT",
            AI_FUNCTIONS: "AI FUNCTIONS",
            FILTER: "FILTER",
            addNewFilter: "Add new filter",
            FLOW: "FLOW",
            ATTACHMENT_INPUT: "ATTACHMENT INPUT",
            USER_INPUT: "USER INPUT",
            GO_TO_STEP: "GO TO STEP",
            WEBHOOK: "WEBHOOK",
            SET_ATTRIBUTE: "SET ATTRIBUTE",
            QUESTION: "QUESTION",
            CLOSE_CHAT: "CLOSE CHAT",
            CREATE_TICKET: "CREATE TICKET",
            TRANSFER_CHAT: "TRANSFER CHAT",
            TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
            TAG_CHAT: "ADD TAG",
            CACHE_WRITE: "CACHE WRITE",
            CACHE_READ: "CACHE READ",
            CACHE_EXTEND: "CACHE EXTEND",
            CACHE_DELETE: "CACHE DELETE",
            YOUTUBE_REPLY_COMMENT: "YOUTUBE REPLY COMMENT",
            YOUTUBE_UPDATE_COMMENT_STATUS: "YOUTUBE UPDATE COMMENT STATUS",
            YOUTUBE_SET_MODERATION_STATUS: "YOUTUBE SET MODERATION STATUS",
            GOOGLE_BUSINESS_REPLY_REVIEW: "GOOGLE BUSINESS REPLY REVIEW",
            GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS: "GOOGLE BUSINESS UPDATE REVIEW STATUS",
            GOOGLE_PLAY_REPLY_REVIEW: "GOOGLE PLAY REPLY REVIEW",
            GOOGLE_PLAY_UPDATE_REVIEW_STATUS: "GOOGLE PLAY UPDATE REVIEW STATUS",
            APP_STORE_REPLY_REVIEW: "APP STORE REPLY REVIEW",
            APP_STORE_UPDATE_REVIEW_STATUS: "APP STORE UPDATE REVIEW STATUS",
            APP_STORE_DELETE_REVIEW_RESPONSE: "APP STORE DELETE REVIEW RESPONSE",
            REMOVE_TAG: "REMOVE TAG",
            SET_DEPARTMENT: "SET DEPARTMENT",
            SEND_TRANSCRIPT: "SEND TRANSCRIPT",
            SEND_SMS: "SEND SMS",
            SEND_MAIL: "SEND MAIL",
            CREATE_EVENT: "CREATE EVENT",
            CREATE_RESERVATION: "CREATE RESERVATION",
            RESERVATION_OPEN_URL: "Reservation Open Url",
            RESERVATION_SELECT_DAY: "Select reservation day",
            RESERVATION_EVENT_LIST: "Reservation list visitor",
            RESERVATION_SELECT_TIME: "Select reservation time",
            CREATE_TASK: "CREATE TASK",
            SHOPIFY_SHOW_PRODUCTS: "SHOPIFY SHOW PRODUCTS",
            SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY PRODUCT AVAILABILITY",
            SHOPIFY_ORDER_STATUS: "SHOPIFY ORDER STATUS",
            AKINON_SHOW_PRODUCTS: "AKINON SHOW PRODUCTS",
            AKINON_FIND_PRODUCT: "AKINON FIND PRODUCT",
            AKINON_ORDER_STATUS: "AKINON ORDER STATUS",
            AKINON_SELECT_ORDER: "AKINON SELECT ORDER",
            AKINON_SELECT_SIZE: "AKINON SELECT SIZE",
            AKINON_FIND_NEAREST_STOCK: "SHOW STORE STOCK",
            AKINON_FIND_NEAREST_STORES: "SHOW NEAREST STORES",
            AKINON_SHOW_DISCOUNT_CODES: "SHOW DISCOUNT CODES",
            SUPPRESSION_ADD: "BLOCK CONTACT",
            SUPPRESSION_REMOVE: "UNBLOCK CONTACT",
            IDEASOFT_SELECT_ORDER: "SELECT ORDER",
            IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
            IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
            SEND_WP_BUSINESS_MESSAGE: "SEND WHATSAPP MESSAGE",
            MESSENGER_SEND_MESSAGE: "Messenger Send Message",
            INSTAGRAM_SEND_MESSAGE: "Instagram Send Message",
            INSTAGRAM_COMMENT_REPLY: "REPLY COMMENT",
            INSTAGRAM_COMMENT_DELETE: "DELETE COMMENT",
            INSTAGRAM_COMMENT_SHOW: "SHOW COMMENT",
            INSTAGRAM_COMMENT_HIDE: "HIDE COMMENT",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "REPLY AS PRIVATE",
            TABLE_CREATE_RECORD: "Create Record",
            TABLE_DELETE_RECORD: "Delete Record",
            TABLE_UPDATE_RECORD: "Update Record",
            TABLE_FIND_RECORD: "Find Record",
            TABLE_FIND_RECORDS: "Find Records",
            followingAttributesFilled: "The following attributes will come filled.",
            GET_LOCATION: "GET LOCATION",
            FALLBACK: "FALLBACK",
            TIMEOUT: "TIMEOUT",
            SUCCESS: "SUCCESS",
            FAILURE: "FAILURE",
            message: "Message",
            condition: "Condition",
            score: "Score",
            equal: "Equal",
            not_equal: "isn't equal",
            contain: "Contain",
            not_contain: "Not contain",
            starts_with: "starts with",
            ends_with: "ends with",
            empty: "empty",
            longer_than: "longer than",
            shorter_than: "shorter than",
            less_than: "less than",
            less_than_equal: "less than equal",
            greater_than: "greater than",
            greater_than_equal: "greater than equal",
            value: "Value",
            failures: "Failures",
            email: "Email",
            name: "Name",
            username: "Username",
            source: "Source",
            language: "Language",
            timezone: "TimeZone",
            region: "Region",
            country: "Country",
            referrer: "Referrer",
            url: "Url",
            ip: "Ip",
            city: "City",
            lastSeen: "Last seen",
            userId: "User ID",
            selectStep: "Select Step",
            keywords: "Keywords",
            userSays: "User Says",
            addKeyword: "Add Keyword",
            addUserMessage: "Add User Message",
            set: "Set",
            to: "To",
            gender: "Gender",
            go_to_failure: "Go to failure",
            go_to_success: "Go to success",
            untilFilled: "Until Filled",
            time1: "Once",
            time2: "2 times",
            time3: "3 times",
            time4: "4 times",
            time5: "5 times",
            any: "Any",
            anytext: "Any Text",
            anytextDescription: "Matches only words + spaces",
            alphanumeric: "Alphanumeric",
            integer: "Integer",
            no: "No",
            number: "Number",
            phone: "Phone",
            yes: "Yes",
            yesNo: "Yes - No",
            anyDescription: "Matches anything that is non-empty.",
            alphanumericDescription: "Matches both letters and numerals",
            integerDescription: "Matches an integer number",
            numberDescription: "Matches ordinal and cardinal number",
            phoneDescription: "Matches phone number",
            yesDescription: "Matches yes synonyms",
            yesNoDescription: "Matches yes and no synonyms",
            emailDescription: "Matches e-mail",
            urlDescription: "Matches URL",
            temperature: "Temperature",
            askWhenInvalid: "Ask When Invalid",
            applyFilter: "Apply Filter",
            RANDOM_TEXT: "Random Text",
            AI_RANDOM_TEXT: "AI Random Text",
            AI_IMAGE: "AI Image",
            QUICK_REPLY: "Quick Reply",
            FILE: "File",
            notificationMessageStartSuccess: "The block ",
            notificationMessageEndSuccess: " has been added",
            notificationMessageStartError: "An error occurred, the block ",
            notificationMessageEndError: " has not been added",
            blockChangedWannaUpdate: "Wanna update changed",
            responses: "Responses",
            TEXT: "Text",
            IMAGE: "Image",
            GALLERY: "Gallery",
            BUTTON: "Button",
            flow: "Flow",
            passive: "Passive",
            chooseAttributeType: "Choose Attribute Type",
            imageAttachment: "Image Attachment",
            audioAttachment: "Audio Attachment",
            videoAttachment: "Video Attachment",
            documentAttachment: "Document Attachment",
            anyAttachment: "Any Attachment",
            typeAttributeValue: "Type Attribute Value",
            typeSearchValue: "Type Search Value",
            addAttribute: "Add Attribute",
            addAttributeDescription:
                "The attribute’s name can only contain alphanumeric characters which are letters A-Z, numbers 0-9, dash or underscore.",
            male: "Male",
            USER_DATA: "User Data",
            CUSTOM_ATTRIBUTES: "CUSTOM ATTRIBUTES",
            enterBotResponseHere: "Enter Bot Response Here...",
            enterPrivateBotResponseHere: "Enter the private message the bot will send ...",
            addCard: "Add Card",
            addButton: "Add Button",
            typeCardTitle: "Type Card Title",
            typeCardDescription: "Type Card Description",
            dragAndDropBrowse: "Drag And Drop Browse",
            dragAndDropBrowseFile: "Upload File",
            button: "Button",
            enterYourMessage: "Enter Your Message",
            imageView: "Image View",
            imageUploading: "Image Uploading",
            fileUploading: "File Uploading...",
            clickToChooseNewImage: "Click To Choose New Image",
            clickToChooseNewFile: "Click To Choose New File",
            removeTheExistingOne: "Remove The Existing One",
            validateResponseWithEntity: "Validate Response With Entity",
            actionOnFailureInput: "Action On Failure Input",
            askNextQuestion: "Ask the next question",
            goToSuccessBlock: "Go To Success Block",
            goToFailureBlock: "Go To Failure Block",
            saveResposeToAttribute: "Save Respose To Attribute",
            selectReplyType: "Select Reply Type",
            questionVariants: "Question Variants",
            systemEntities: "System Entities",
            delay: "delay",
            retrySectionTextPart: "Ask ",
            retrySectionText: " , if user's response is invalid",
            addNextQuestion: "Add Next Question",
            typeBlockTitle: "Type block title",
            versionHistory: "Version History",
            restore: "Restore",
            versionName: "Version Name",
            restoreModalText:
                "This action will restore the selected version. Are you sure you want to restore this version?",
            restoreVersion: "Restore Version",
            newVersion: "New Version",
            synonymMustBeUnique: "Synonym Must Be Unique",
            save: "Save",
            entries: "Entries",
            youHaveNoEntries: "You Have No Entries",
            inputsCantBeEmpty: "Inputs Can't Be Empty",
            entryNamesMustBeUnique: "Entry Names Must Be Unique",
            entityNameMustBeUnique: "Entity Name Must Be Unique",
            synonyms: "Synonyms",
            entities: "Entities",
            title: "Title",
            entryName: "Entry Name",
            entityhasbeenUpdatedSuccessfully: "Entity Has Been Updated Successfully",
            emptyError: "Entries Can't Be Empty",
            entityNameCantBeEmpty: "Entity Can't Be Empty",
            allChats: "All Chats",
            paidChats: "Paid Chats",
            busiestPeriod: "Busiest Period",
            ratingDistribution: "Rating Distribution",
            allMessages: "All Messages",
            avarageMessages: "Avarage Messages",
            popularity: "Popularity",
            allUsers: "All Users",
            interactionName: "Interaction Name",
            numberOfMessage: "Number Of Message",
            ofAllUsersMessage: "% Of All Users Message",
            totalData: "Total Data",
            avgData: "Avg Data",
            exportToCsv: "Export To CSV",
            exportToExcel: "Export To Excel",
            inMaintenance: "In Maintenance",
            ADD_TO_SEGMENT: "Add to Segment",
            REMOVE_FROM_SEGMENT: "Remove from segment",
            users: "Users",
            webhookName: "Webhook Name",
            webHookUrl: "Webhook url",
            webHookToken: "Webhook token",
            delete: "Delete",
            basicAuth: "Basic Auth",
            requiredFieldsCannotBeLeftBlank: "Required Fields Cannot Be Empty",
            headerValue: "Value",
            yourVerificationToken: "Token",
            yourWebHookName: "Your Webhook Name",
            yourWebHookUrl: "Your Webhook Url",
            enterKey: "Enter Key",
            password: "Password",
            saveSuccessfully: "Your transaction has been successfully saved",
            urlTypeError: "Please Fill In The Field Correctly (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "OpenAI Chat GPT-4 Api Key Required.",
                apiKeyDesc:
                    "Chatbot + Chat GPT-4 integration requires Api Key. Please get your api-key or use the api key below for trial. You can use only 20 message for trial.",
                getApiKey: "Get Open AI Api Key",
                typeApiKey: "Type in Api key",
                ownApiKey: "Own OpenAI Api Key",
                trialApiKey: "Trial Api Key (Restricted as 20 Message)",
                useOurTrial: "Use Our Free Trial",
                twentyMessages: "You can try by using 20 Messages as free.",
                enableChatGpt3: "Enable Chat GPT-4",
            },
            META_SEND_CAPI_EVENT: "SEND CAPI EVENT",
            META_SEND_CAPI_EVENTDesc:
                "Sends conversion events for ad optimization using Meta Conversions API (CAPI). Helps improve the performance of your Instagram and Messenger ads.",
            Messaging_Actions: "Messaging Actions",
            B2CARGO_LOGIN_USER: "User Login",
            B2CARGO_PRODUCT_STATUS: "Product Status",
            plans: "Plans",
            chatBotPlans: "Chatbot Plans",
            OPENAI_WEB_SEARCH: "WEB SEARCH (OPENAI)",
            ASSIGN_OWNER: "Assign Owner",
            Probel_Actions: "Probel Actions",
            PROBEL_SELECT_BRANCH: "Select Branch",
            PROBEL_SELECT_CLINIC: "Select Polyclinic",
            PROBEL_SELECT_DAY: "Select Appointment Day",
            PROBEL_SELECT_HOUR: "Select Appointment Time",
            PROBEL_MAKE_APPOINTMENT: "Create Appointment",
            PROBEL_CANCEL_APPOINTMENT: "Cancel Appointment",
            PROBEL_GET_PATIENT_TOKEN: "Get Patient Token",
            PROBEL_FILL_INFO: "Get MERNIS Info",
            PROBEL_SELECT_APPOINTMENT: "Select Appointment",
            TICKET_UPDATE: "TICKET UPDATE",
            cardInfos: "Card Info",
            ficheros: "Files",
            file: "File",
            fileCancellato: "File deleted",
            impostazioni: "Settings",
            risposta: "Reply",
            setUpUpYourChatbot: "Set up your chatbot",
            setUpUpYourChatbotDesc:
                "Train your chatbot with data, use our ready-to-use templates or start from scratch.",
            yourNeedEnterEnterYourOpenAi:
                "You need to enter your OpenAI API key to create an automated chatbot that crawls your website.",
            overall: "Overall",
            aiModels: "AI Models",
            ragSettings: "RAG Settings",
            plugins: "Plugins",
            supsisRag: "Supsis RAG",
            aiDisabledSuccess: "AI Assistant Disabled",
            aiEnabledSuccess: "AI Assistant Enabled",
            aiUpdateError: "Failed to update AI disable setting",
            disableAiAssistant: "Disable AI Assistant",
            aiListenerDelay: "AI Listener Delay (ms)",
            aiListenerDelayDesc:
                "The time the AI assistant will wait before intervening. Gives the user time to type a message.",
            scenarios: "Scenarios",
            selected: "Selected",
            intelligence: "Intelligence",
            speed: "Speed",
            input: "Input",
            output: "Output",
            reasoningTokens: "Reasoning tokens",
            pricing: "PRICING",
            per1mTokens: "PER 1M TOKENS",
            cachedInput: "Cached Input",
            context: "CONTEXT",
            window: "Window",
            modelsDisclaimer:
                "Models are listed according to OpenAI API documentation. Prices and features vary by plan/region.",
            llmModelOpenRouter: "LLM Model (OpenRouter)",
            activeModel: "Active Model",
            aiPluginsTitle: "AI Plugins",
            aiPluginsSubtitle:
                "These plugins only work in Supsis RAG (OpenRouter) mode. You can turn each plugin on and off independently.",
            jsonRepair: "JSON Repair",
            responseHealingDesc:
                "Automatically repairs faulty JSON responses from LLMs. Fixes issues such as missing parentheses, commas, markdown wrapping or mixed text, ensuring you always get valid, parseable JSON.",
            ragMethod: "RAG Method",
            openaiRag: "OpenAI RAG",
            active: "Active",
            openaiRagDesc:
                "Automatic retrieval with OpenAI's file_search tool. Requires OpenAI API key. Compatible with all existing chatbots.",
            supsisRagDesc:
                "Our own embedding infrastructure with MongoDB Voyage AI. You can use all LLMs via OpenRouter. Offers many more model options.",
            new: "New",
            openRouterChannel: "OpenRouter Channel",
            openRouterChannelDesc: "An OpenRouter channel is mandatory for Supsis RAG. Select or create a channel.",
            noOpenRouterChannel: "No OpenRouter channel yet.",
            createOpenRouterChannelDesc: "Create a channel from Integrations > LLM Channels > OpenRouter section.",
            embeddingModel: "Embedding Model",
            embeddingModelDesc: "The model to be used to convert knowledge base data into vectors.",
            selectOpenRouterChannel: "Select OpenRouter channel",
            filesCompleted: "files completed",
            dontLeavePageUpload: "Do not leave the page, upload is in progress...",
            openFile: "Open file",
            functionNameNoTurkish: "Function name cannot contain Turkish characters!",
            readOnlyMode: "Read-Only Mode",
            publishedVersionReadOnly: "Published version - Read only",
            fullScreen: "Full Screen",
            exitFullScreen: "Exit Full Screen",
            supsisAssistant: "Supsis Assistant",
            availableLibraries: "Available Libraries:",
            availableVariables: "Available Variables:",
            parametersAutoAvailable:
                "Parameters you define below can automatically be used as variables in the code. You can access them directly by their name.",
            definedParametersUsage: "Defined Parameters and Usage:",
            directUsage: "Direct Usage:",
            readAllParameters: "Read all parameters:",
            parametersAutoInjected: "Parameters are automatically injected:",
            parametersAutoInjectedDesc:
                "Every parameter you define (e.g., apiUrl, timeout) is automatically added to your code as a const variable. You can use them directly!",
            parameterNameVariable: "Parameter name (variable)",
            parameterLabelDisplay: "Display label",
            isHidden: "Is Hidden?",
            parameterDescriptionHelp: "Description (help text)",
            exampleOutputDesc:
                "Define a sample output that your block will return. This allows users to see your block's output in the attribute selector.",
            outputSchemaHelp:
                "Enter a sample JSON output that your block will return. This will appear in the attribute selector.",
            allowAutoUpdateHelp: "When enabled, the output schema is automatically updated every time the block runs.",
            publicEveryone: "Public - Open to everyone",
            unlistedLinkOnly: "Unlisted - Accessible only via link",
            privateSpecificSites: "Private - Open only to specific sites",
            allowedSiteIdsHelp: "Only customers with the specified site IDs can see this block.",
            importJsonSchemaDesc: "Paste a JSON example, we will automatically create your parameters:",
            tip: "Tip:",
            jsonSchemaTip:
                "Each field in the JSON will be added as a parameter. Type is detected automatically (string → text, number → number, boolean → boolean, array → array).",
            systemAttributeSelect: "Select System Attribute",
            attributeSearch: "Search attribute...",
            defineStructuredJsonSchema: "Define Structured JSON Schema",
            structuredJsonSchemaDesc: "Paste a sample JSON to create the structure:",
            editStructuredJsonSchema: "Edit Structured JSON Schema",
            fieldName: "Field Name",
            displayName: "Display Name",
            isRequired: "Is Required?",
            aiWizard: "AI Wizard",
            aiWizardDesc: "Tell us what you want to do, and we'll create the JavaScript code and parameters for you.",
            aiWizardExample:
                'e.g. "Create a block that fetches weather information from an API and returns it." or "Write code that extracts the phone number from the incoming message with regex."',
            writeRequestHere: "Write your request here...",
            processing: "Processing...",
            stop: "Stop",
            applyCode: "Apply Code",
            copyCode: "Copy Code",
            rebuild: "Rebuild",
            aiWizardError: "The assistant encountered an error. Please try again.",
            aiAssistantPrepared: "The AI assistant has prepared this code and parameters for you.",
            applyCodeHelp: "Transfers code to the monaco editor. (Overwrites your existing code)",
            applyParametersHelp: "Parameters will be added to your current parameter list.",
            usedLibraries: "Used Libraries:",
            usedLibrariesHelp: "You can use these libraries in your code.",
            saveAnswerToAttribute: "Save answer to attribute?",
            selectAgent: "Select agent",
            enterAgentIdOrAttribute: "Enter agent ID or use attribute",
            callingNumber: "Calling Number",
            selectCallingNumber: "Select calling number",
            enterCallingNumberE164:
                "Enter the calling number in E.164 format (e.g., +905551234567) or use an attribute",
            calledNumber: "Called Number",
            enterCalledNumberE164: "Enter the called number in E.164 format (e.g., +905551234567) or use an attribute",
            waitForCallEnd: "Wait Until Call Ends",
            variableName: "Variable name",
            variableValueOrAttribute: "Variable value or attribute",
            addVariable: "Add Variable",
            classificationMode: "Classification Mode:",
            textMode: "Text Mode",
            imageMode: "Image Mode",
            classificationImageUrlPlaceholder:
                "Additional instructions, special conditions, or info that will affect classification (optional)",
            classificationImagePlaceholder: "Image URL",
            tagAddingDesc:
                "Tags are used to categorize your visitors. You can add tags to your visitors manually or automatically using conditions. You can also use tags to trigger actions in your chatbot.",
            tagsToAdding: "Tags to add",
            assignmentMethod: "Assignment Method",
            algorithmicAssignment: "Algorithmic Assignment",
            staticAssignment: "Static Assignment",
            agentToAssign: "Agent to assign",
            selectAgentPlaceholder: "Select representative",
            unownedRemoveOwner: "Unowned (Remove Owner)",
            agentAssignmentHelp: "The selected representative must be compatible with channel and department settings",
            leastContact: "The one with the least contact",
            agentContactRangeHelp: "The time range to look at the number of contacts representatives have",
            distributeOnlyToOnline: "Distribute Only to Online Agents",
            agentsToExclude: "Agents to Exclude",
            agentsExcludeHelp: "Selected representatives will be excluded from the assignment pool",
            zohoCrmSync: "Zoho CRM Synchronization",
            zohoCrmSyncHelp: "The assigned user will be synchronized in Zoho CRM.",
            online: "online",
            promptSettings: "Prompt Settings",
            cacheManagement: "Cache Management",
            blockCannotBeChild: "The {draggingType} block can't be a child of the {blockType} block",
            toolsNotSupported: "Tools not supported",
            tag: "Tag",
            link: "Link",
            preventDefault: "Prevent Default",
            whatsapp: "WhatsApp",
            trendyol: "Trendyol",
            whatsappBusinessApi: "WhatsApp Business API",
            instagram: "Instagram",
            telegram: "Telegram",
            facebook: "Facebook",
            twitter: "Twitter",
            skype: "Skype",
            shopify: "Shopify",
            slack: "Slack",
            segment: "Segment",
            copyBlockAsJson: "Copy Block as JSON",
            pasteBlockFromClipboard: "Paste Block from Clipboard",
            douYouWannaDeleteItem: "Do you want to delete this item?",
            douYouWannaDeleteWithChildren: "Do you want to delete with children?",
            blockDetails: "Block Details",
            uninstall: "Uninstall",
            installationOK: "Installed",
            chatWidget: "Chat Widget",
            webhooks: "Webhooks",
            integrateStoryWithTelegram: "Integrate Story with Telegram",
            optional: "optional",
            aiBot: "AI Bot",
            englishTurkish: "ENGLISH/TURKISH",
            train: "Train",
            tuneChatbot: "Tune Chatbot",
            uncheckAll: "Uncheck All",
            selectPlaceToCopy: "Select the right place to copy",
            selectPlaceToAdd: "Select the right place to add",
            selectPlaceToMove: "Select the right place to move",
            previewMode: "Preview Mode",
            notPublished: "Not Published",
            blockJsDesc: "This block executes JavaScript code with the parameters you define.",
            jsSecurityNotice: "Some JavaScript features are restricted for security reasons.",
            outputSchemaJson: "Output Schema (JSON)",
            example: "Example:",
            newFieldAdd: "Add New Field",
            saveToAttribute: "Save to Attribute",
            selectFallbackModel: "Select fallback model...",
            loadingModels: "Loading models...",
            openaiChannelExists: "OpenAI channel exists. You can proceed.",
            openaiChannelNotFound: "OpenAI channel not found.",
            createOpenaiChannelDesc: "Create an OpenAI channel from Integrations > OpenAI section.",
            embedding: "Embedding",
            company_name: "Company Name",
            company_about_us: "About us",
            company_email: "Email",
            company_phone: "Phone",
            company_address: "Company Address",
            instagram_url: "Instagram",
            youtube_url: "Youtube",
            linkedin_url: "Linkedin",
            facebook_url: "Facebook",
            twitter_url: "Twitter",
            privacy_url: "Privacy Policy (URL)",
            pricing_url: "Pricing (URL)",
            contactUs: "Contact Us",
            aboutUs: "About Us",
            importJsonSchema: "Import JSON Schema",
            enterChangelog: "Enter changelog (optional)",
            publishBlock: "Publish Block",
            defineSchema: "Define Schema",
            detailedSettings: "Detailed Settings",
            noStructureDefined: "No structure defined yet. Click 'Define Schema' button.",
            javascriptAssistant: "JavaScript Assistant",
            youCanDo: "What you can do",
            sendingMessage: "Sending message",
            chatTransfer: "Chat transfer",
            chatClosing: "Chat closing",
            apiRequests: "API requests",
            contactOperations: "Contact operations",
            attributeUpdating: "Attribute updating",
            examplePrompt1: "Send API request and show response to user",
            examplePrompt2: "Validate and save data received from user",
            examplePrompt3: "Make GET request to URL in parameters and return result",
            generateCode: "Generate Code",
            parameterValidation: "Parameter validation",
            manualAttributeEdit: "Edit Attribute Manually",
            manualAttributeEntry: "Enter attribute value manually:",
            orderStatus: "ORDER STATUS",
            selectABlock: "Select a block",
            regexTemplates: "Regex Templates",
            chooseASegment: "Choose a Segment",
            noSegmentFound: "No segment found",
            chooseATag: "Choose a Tag",
            noTagFound: "No tag found",
            userEntities: "User Entities",
            noWebhookFound: "No webhook found",
            chooseAWebhook: "Choose a webhook",
            sendFile: "Send file",
            voiceRecord: "Voice record",
            connect: "Connect",
            connectedCount: "Connected ({count})",
            instagramIntegration: "Instagram Chatbot Integration",
            messengerIntegration: "Messenger Chatbot Integration",
            trendyolIntegration: "Trendyol Chatbot Integration",
            linkedinIntegration: "Linkedin Chatbot Integration",
            telegramQrIntegration: "Telegram QR Chatbot Integration",
            forwardLiveAgents: "Forward Live Agents",
            deleteTokenConfirm: "Do you really want to delete the token?",
            integratedStoryRevoked: "In that case integrated story will be revoked!",
            tokenLostPermanently: "The token will be lost permanently!",
            tuneYourChatbot: "Tune your chatbot",
            tuneChatbotDesc: "Add final tweaks to achieve better results.",
            customizeWelcomeMessage: "Customize your welcome message",
            setupAttributes: "Set up attributes",
            attributeValue: "Attribute value",
            setupChatbot: "Set up chatbot",
            complete: "Complete",
            continue: "Continue",
            someContents: "Some contents...",
            question: "Question",
            answer: "Answer",
            chatbotExpert: "Chatbot Design Expert",
            connecting: "Connecting...",
            chatbotAssistantWelcome: "Hello! I am your Supsis Chatbot Assistant 👋",
            howCanIHelpChatbot: "How can I help you with your chatbot design?",
            createNewBot: "Create new bot",
            optimizeBot: "Optimize bot",
            addAiFeature: "Add AI feature",
            processingActions: "Processing actions...",
            chatbotAssistantInputPlaceholder: "What do you want to do for your chatbot design?",
            connectionEstablished: "Connection established",
            agentBusyWait: "Agent is currently busy, please wait...",
            connectionEstablishedHelp: "Connection established successfully! How can I help you?",
            aiThinking: "AI is thinking...",
            sessionStateUpdated: "Session state updated",
            diagramUpdated: "Diagram updated",
            aiBotWizardTitle: "AI Bot Wizard",
            wizardStepTitleRag: "Select RAG Method",
            wizardStepDescRag: "Select the method your AI chatbot will use for knowledge base search.",
            wizardStepTitleEmbedding: "Select Embedding Model",
            wizardStepDescEmbedding: "The model to be used to convert knowledge base data into vectors.",
            wizardStepTitleLlm: "Select LLM Model",
            wizardStepDescLlm: "Select the AI model your chatbot will use. You can change it later.",
            loadModels: "Load Models",
            retry: "Retry",
            routingStrategy: "Routing Strategy",
            fallbackModels: "Fallback Models",
            fallbackModelsDesc: "Backup models to use if the primary model fails.",
            backup: "Back",
            connected: "Connected",
        },
        coupon: {
            code: "Code",
            discount: "Discount",
            endDate: "End Date",
            name: "Name",
            email: "Email",
            phone: "Phone",
            add: "Add Coupon",
            coupons: "Coupons",
            couponDeleted: "Coupon Deleted",
            limit: "Limit",
            visitorBan: "Visitor has been blocked.",
            visitorUnBlock: "Block has been removed.",
        },
        instagramTitle: "Click the button below to enable Instagram Features.",
        instegramFunctionActive: "Enable Instagram Feature",
        ChatBOT: "Chat Bot",
        WhatsappContacts: "Whatsapp Contacts",
        InstagramContacts: "Instagram Contacts",
        MessengerContacts: "Messenger Contacts",
        LinkedinContacts: "Linkedin Contacts",
        TelegramContacts: "Telegram Contacts",
        volumeUp: "Volume Up",
        minimize: "Minimize",
        maximize: "Maximize",
        auditLogs: {
            auditLogsTitle: "Audit Logs",
            auditLogsSub:
                "Audit logs allow you to track events that have occurred in your company over the last 30 days.",
            actor: "Actor",
            actorSelect: "Select actor",
            actorSystem: "System (Supsis Ai)",
            actorChatbot: "Chatbot",
            actorApi: "API",
            actorVisitor: "Any Visitor",
            actorAgent: "Any Agent",
            adminUserSuffix: "(Admin User)",
            activityType: {
                blocked: "Blocked",
                unblocked: "Unblocked",
                "chat-opened": "Chat opened",
                "chat-closed": "Chat closed",
                "chat-rating": "Chat rated",
                "chat-assigned-to-user": "Chat assigned to user",
                "chat-forwarded-to-user": "Chat forwarded to user",
                "contact-owner-updated": "Contact owner updated",
                "user-joined-to-chat": "User joined chat",
                "ticket-assigned-to-user": "Ticket assigned to user",
                online: "Online",
                offline: "Offline",
                "page-changed": "Page changed",
                "create-ticket": "Ticket created",
                "video-calling-started": "Video call started",
                "video-calling-closed": "Video call closed",
                "voice-calling-started": "Voice call started",
                "voice-calling-closed": "Voice call closed",
                "visitor-tag-added": "Visitor tag added",
                "visitor-tag-removed": "Visitor tag removed",
                "note-created": "Note created",
                "note-updated": "Note updated",
                "visitor-profile-updated": "Visitor profile updated",
                "user-added": "User added",
                "user-removed": "User removed",
                "user-status-changed": "User status changed",
                "user-logged-in": "User logged in",
                "user-added-to-department": "User added to department",
                "user-removed-from-depart": "User removed from department",
                "user-role-changed": "User role changed",
                "user-password-changed": "User password changed",
                "user-email-changed": "User email changed",
                "user-name-changed": "User name changed",
                "user-phone-changed": "User phone changed",
                "user-disabled": "User disabled",
                "user-enabled": "User enabled",
                "settings-updated": "Settings updated",
                "whatsapp-broadcast-created": "WhatsApp broadcast created",
                "whatsapp-broadcast-completed": "WhatsApp broadcast completed",
                "whatsapp-broadcast-canceled": "WhatsApp broadcast canceled",
                "whatsapp-broadcast-failed": "WhatsApp broadcast failed",
                "whatsapp-v1-bot-state-changed": "WhatsApp v1 bot state changed",
                "whatsapp-v2-bot-state-changed": "WhatsApp v2 bot state changed",
                "channel-created": "Channel created",
                "channel-removed": "Channel removed",
                "channel-visibility-changed": "Channel visibility changed",
                "channel-zoho-config-updated": "Channel Zoho config updated",
                "channel-forward-config-updated": "Channel forward config updated",
                "login-form-activated": "Login form activated",
                "login-form-deactivated": "Login form deactivated",
                "login-form-updated": "Login form updated",
                "chatbot-created": "Chatbot created",
                "chatbot-deleted": "Chatbot deleted",
                "chatbot-restored": "Chatbot restored from trash",
                "chatbot-published": "Chatbot published",
                "chatbot-webhook-added": "Chatbot webhook added",
                "chatbot-webhook-removed": "Chatbot webhook removed",
                "banned-word-added": "Banned word added",
                "banned-word-removed": "Banned word removed",
                "mail-address-added": "Email address added",
                "mail-address-removed": "Email address removed",
                "mail-was-sent": "Email sent",
                "content-added": "Content added",
                "content-removed": "Content removed",
                "role-added": "Role added",
                "role-removed": "Role removed",
                "role-updated": "Role updated",
                "department-added": "Department added",
                "department-removed": "Department removed",
                "tags-added": "Tags added",
                "tags-removed": "Tags removed",
                "trigger-added": "Trigger added",
                "trigger-removed": "Trigger removed",
                "trigger-updated": "Trigger updated",
                "welcome-message-added": "Welcome message added",
                "welcome-message-removed": "Welcome message removed",
                "customer-group-added": "Customer group added",
                "customer-group-removed": "Customer group removed",
                "customer-group-updated": "Customer group updated",
                "webhook-added": "Webhook added",
                "webhook-removed": "Webhook removed",
                "webhook-updated": "Webhook updated",
                "contact-prop-added": "Contact property added",
                "contact-prop-removed": "Contact property removed",
                "invoice-created": "Invoice created",
                "invoice-updated": "Invoice updated",
                "invoice-payment-received": "Invoice payment received",
                "invoice-payment-failed": "Invoice payment failed",
                "invoice-refunded": "Invoice refunded",
                "invoice-deleted": "Invoice deleted",
                "payment-method-added": "Payment method added",
                "billing-address-updated": "Billing address updated",
                "plan-started": "Plan started",
                "plan-canceled": "Plan canceled",
                "task-workflow-created": "Task workflow created",
                "task-workflow-deleted": "Task workflow deleted",
                "task-workflow-restored": "Task workflow restored from trash",
                "task-workflow-permanently-deleted": "Task workflow permanently deleted",
                "task-workflow-updated": "Task workflow updated",
                "task-workflow-pipeline-stage-added": "Task workflow stage added",
                "task-workflow-pipeline-stage-updated": "Task workflow stage updated",
                "task-workflow-pipeline-stage-deleted": "Task workflow stage deleted",
                "task-created": "Task created",
                "task-deleted": "Task deleted",
                "task-stage-changed": "Task stage changed",
                "task-workflow-changed": "Task workflow changed",
                "task-assigned-to-user": "Task assigned to user",
                "task-update-priority": "Task priority updated",
                "task-added-tags": "Tags added to task",
                "task-removed-tags": "Tags removed from task",
                "task-update-title": "Task title updated",
                "task-update-description": "Task description updated",
                "task-update-start-date": "Task start date updated",
                "task-update-end-date": "Task end date updated",
                "task-update-owner": "Task owner updated",
                "task-added-followers": "Followers added to task",
                "task-removed-followers": "Followers removed from task",
                "task-added-collaborators": "Collaborators added to task",
                "task-update-checklist": "Task checklist updated",
                "task-added-subtask": "Subtask added to task",
                "task-removed-subtask": "Subtask removed from task",
                "task-added-attachment": "Attachment added to task",
                "task-comment-added": "Comment added to task",
                "task-comment-updated": "Task comment updated",
                "task-comment-deleted": "Task comment deleted",
                "task-completed": "Task completed",
                "task-archived": "Task archived",
                "task-restored": "Task restored from trash",
                "task-unarchived": "Task unarchived",
                "chatbot-credit-low": "Chatbot credit low",
                "chatbot-credit-done": "Chatbot credit depleted",
                "system-status": "System status",
                "whatsapp-credit-low": "WhatsApp credit low",
                "reservation-created-plan": "Reservation plan created",
                "reservation-updated-plan": "Reservation plan updated",
                "reservation-deleted-plan": "Reservation plan deleted",
                "reservation-created": "Reservation created",
                "reservation-updated": "Reservation updated",
                "reservation-deleted": "Reservation deleted",
                "white-list-added": "Whitelist added",
                "white-list-removed": "Whitelist removed",
                "site-suspended": "Site suspended",
                "site-dead": "Site disabled",
                "site-enabled": "Site enabled",
                custom: "Custom activity",
                "auto-rebalance-success": "Auto balance reload successful",
                "auto-rebalance-failed": "Auto balance reload failed",
                "auto-rebalance-disabled": "Auto balance reload disabled",
                "automation-created": "Automation created",
                "automation-deleted": "Automation deleted",
                "automation-restored": "Automation restored from trash",
                "automation-published": "Automation published",
                "automation-unpublished": "Automation unpublished",
                "automation-updated": "Automation updated",
                "form-created": "Form created",
                "form-updated": "Form updated",
                "form-deleted": "Form deleted",
                "form-restored": "Form restored from trash",
                "form-downloaded": "Form data downloaded",
                "table-created": "Table created",
                "table-deleted": "Table deleted",
                "table-restored": "Table restored from trash",
                "table-permanently-deleted": "Table permanently deleted",
                "table-field-added": "Table field added",
                "table-field-updated": "Table field updated",
                "table-field-deleted": "Table field deleted",
                "table-view-added": "Table view added",
                "table-view-updated": "Table view updated",
                "table-view-deleted": "Table view deleted",
                "table-page-added": "Table page added",
                "table-page-updated": "Table page updated",
                "table-page-deleted": "Table page deleted",
                "table-widget-added": "Table widget added",
                "table-widget-updated": "Table widget updated",
                "table-widget-deleted": "Table widget deleted",
                "table-permission-changed": "Table permissions changed",
                "table-data-downloaded": "Table data downloaded",
                "table-data-imported": "Table data imported",
                "table-data-batch-updated": "Table data batch updated",
                "table-data-batch-deleted": "Table data batch deleted",
                "contact-data-downloaded": "Contact data downloaded",
                "contact-batch-updated": "Contact data batch updated",
                "chat-data-downloaded": "Chat data downloaded",
                "voice-agent-created": "Voice agent created",
                "voice-agent-updated": "Voice agent updated",
                "voice-agent-deleted": "Voice agent deleted",
                "voice-agent-phone-number-inbound-agent-changed": "Inbound call agent changed",
                "voice-agent-phone-number-outbound-agent-changed": "Outbound call agent changed",
                "voice-agent-batch-call-created": "Voice agent batch call created",
                "voice-agent-knowledge-base-created": "Voice agent knowledge base created",
                "voice-agent-knowledge-base-updated": "Voice agent knowledge base updated",
                "drive-folder-created": "Drive folder created",
                "drive-folder-deleted": "Drive folder deleted",
                "drive-folder-renamed": "Drive folder renamed",
                "drive-file-added": "Drive file added",
                "drive-file-deleted": "Drive file deleted",
                "task-module-rules-rule-added": "Task module rule added",
                "task-module-rules-rule-updated": "Task module rule updated",
                "task-module-rules-rule-deleted": "Task module rule deleted",
                "task-module-rules-rule-enabled": "Task module rule enabled",
                "task-module-rules-rule-disabled": "Task module rule disabled",
                "task-module-rules-enabled": "Task module rules enabled",
                "task-module-rules-disabled": "Task module rules disabled",
                "contact-module-rules-rule-added": "Contact module rule added",
                "contact-module-rules-rule-updated": "Contact module rule updated",
                "contact-module-rules-rule-deleted": "Contact module rule deleted",
                "contact-module-rules-rule-enabled": "Contact module rule enabled",
                "contact-module-rules-rule-disabled": "Contact module rule disabled",
                "contact-module-rules-enabled": "Contact module rules enabled",
                "contact-module-rules-disabled": "Contact module rules disabled",
                "module-created": "Module created",
                "module-updated": "Module updated",
                "module-deleted": "Module deleted",
                "relation-created": "Relation created",
                "relation-updated": "Relation updated",
                "relation-deleted": "Relation deleted",
                "web-app-created": "Web app created",
                "web-app-updated": "Web app updated",
                "web-app-deleted": "Web app deleted",
                "web-tab-created": "Web tab created",
                "web-tab-updated": "Web tab updated",
                "web-tab-deleted": "Web tab deleted",
                "developer-token-created": "Developer token created",
                "developer-token-changed": "Developer token changed",
            },
            activityTypeSelect: "Select activity type",
            dateRange: "Date Range",
            startDate: "Start date",
            endDate: "End date",
            reset: "Reset",
            filter: "Filter",
            activeFilters: "Active Filters:",
            auditLogsTable: "Audit Logs",
            noActivityYet: "No activity yet",
            ipAddress: "IP Address",
            tablePagination: {
                goto: "Go",
                pagePer: " / page",
                total: "Total",
                prev5: "Previous 5 Pages",
                next5: "Next 5 Pages",
                cut: "Cut",
                copy: "Copy",
                insertRowAbove: "Insert row above",
                insertRowBelow: "Insert row below",
                removeRow: "row(s) removed",
                emptyRow: "row(s) emptied",
                emptyColumn: "column(s) emptied",
                emptyCell: "Empty cell",
                leftFixedColumnTo: "Fix column to left",
                cancelLeftFixedColumnTo: "Cancel fix column to left",
                rightFixedColumnTo: "Fix column to right",
                cancelRightFixedColumnTo: "Cancel fix column to right",
            },
        },
        task: {
            taskID: "Task ID",
            completeTask: "Complete Task",
            closedTasks: "Closed Tasks",
            moveToArchive: "Move to Archive",
            changeWorkflow: "Move to Another Workflow",
            selectWorkflow: "Select Workflow",
            taskNumber: "Task #",
            priority_lowest: "Lowest",
            priority_low: "Low",
            priority_medium: "Medium",
            priority_high: "High",
            priority_highest: "Highest",
            workflowActions: "Workflow Actions",
            workflowTitle: "Workflow Title",
            deleteTask: "Delete Task",
            selectOption: "Select an Option",
            notAuthorizedCreateTask: "You are not authorized to create a task",
            notAuthorizedCreateTaskDesc: "You are not authorized to perform this task.",
            goToMessage: "Go to message",
            goToChat: "Go to chat",
            showVisitor: "Show Visitor",
            closeTheTask: "Close Task",
            sureAddCompletedList: "Are you sure you want to add the task to the Completed List?",
            success: "Success",
            successDesc: "New field added successfully.",
            moveAndDeleteTask: "Move and Delete Tasks",
            justDelete: "Just Delete",
            selectColumnMoveTask: "Select the column where you want to move the tasks",
            todos: "Things to do",
            inProgress: "In Progress",
            approval: "Approved",
            addAComment: "Add a comment...",
            deleteComment: "Are you sure you want to delete the comment?",
            edited: "Edited",
            comments: "Comments",
            addComment: "Add Comment",
            workflow: "Workflow",
            workflowDetail: "Workflow Detail",
            workflowPerm: "Workflow Permissions",
            perm: "Permissions",
            detail: "Details",
            userPerm: "User Permissions",
            deleteCard: "Delete Card",
            createCard: "Create Card",
            editCard: "Edit Card",
            dragCard: "Drag Card",
            allWorkflow: "All Workflows",
            createworkflow: "Create Workflow",
            editDragActive: "Edit Active",
            editSortOrder: "Edit Sort Order",
            deleteWorkflow: "Are You Sure You Want to Delete This Workflow?",
            permEditTask: "You Do Not Have Permission to Edit This Task",
            permEditTaskDes: "Contact Your Administrator for Editing Permissions.",
            createTaskError: "You Do Not Have Permission to Create Tasks",
            createTaskErrorDesc: "Contact Your Administrator for Task Creation Permissions.",
            moveTaskError: "You Do Not Have Permission to Change Task Status",
            moveTaskErrorDesc: "Contact Your Administrator for Task Status Change Permissions.",
            deleteTaskError: "You Do Not Have Permission to Delete Tasks",
            deleteTaskErrorDesc: "Contact Your Administrator for Task Deletion Permissions",
            permissionError: "You do not have permission to create tasks",
            permissionErrorDesc: "Please contact your administrator for task creation permissions",
            whatsappContactProfileTitle: "{name} / {number} Profile",
            createTaskVisitor: "Create Task (Visitor)",
            editWorkflow: "Edit Workflow",
            visitor: "Visitor Profile",
            createTaskMessage: "Create Task (Message)",
            createStage: "Create Stage",
            stagesAndStatuses: "Stages and Statuses",
            workflowCreateDesc: "Workflow Description",
            subTasks: "Subtasks",
            followers: "Followers",
            collaborators: "Collaborators",
            addRelations: "Add Relations",
            relations: "Relations",
            main: "Main",
            name: "Name",
            completedOfCheck: "{completed} of {total} tasks completed",
            workflowUpdateMs: "Workflow Successfully Updated",
            taskUpdateMs: "Task Successfully Updated",
            workflowCreatedMs: "Workflow Successfully Created",
            workflowCreateError: "Workflow Could Not Be Created",
            taskCreatedMs: "Task Successfully Created",
            settingsDesc3:
                "Additionally, the Supsis task module allows you to create your own workflow with customizable automation, enabling you to manage tasks more effectively and enhance collaboration within the team.",
            settingsDesc4:
                "This way, you can track each of your tasks in detail, assign tasks to team members, and overall manage your business processes more efficiently. The Supsis task module provides you with a comprehensive solution for task management and team coordination.",
            settingsDesc2:
                "The Supsis task module leaves no task overlooked. You can filter tasks based on any parameter, track workloads for each workflow stage, and organize your calendar to align with your schedules.",
            settingsDesc1:
                "The Tasks module allows you to organize collaborative work, delegate tasks, and track your team's progress. You can customize your tasks according to your needs by selecting any view and create your own custom workflows with automations.",
            taskModuleSettingsTitle: "Task Module Settings",
            high: "High",
            medium: "Medium",
            low: "Low",
            priority: "Priority",
            addExistsSubtask: "Add Existing Subtask",
            addSubtask: "Add Subtask",
            add: "Add",
            newCheckList: "New Checklist",
            subtaskTitle: "Subtask Title",
            view: "View",
            attachFiles: "Attach Files",
            createTaskDesc: "Task Description",
            title: "Title",
            createWorkflow: "Create Workflow",
            editTask: "Edit Task",
            createTask: "Create Task",
            deleteColumnCont: "Are you sure you want to delete this column?",
            changeStage: "Change Stage",
            filterBar: {
                searchTasksPlaceholder: "Search in tasks...",
                otherUsers: "Other Users",
                searchUserPlaceholder: "Search user...",
                filter: "Filter",
                clearFilters: "Clear filters",
                apply: "Apply",
                prioritySelection: "Task Priority Selection",
                priorityDescription:
                    "You can filter tasks by priority level. Select the priority levels you want to filter tasks.",
                aboutPriorityLevels: "About Priority Levels",
                priorityInfoText:
                    "Priority levels indicate the importance of tasks. High priority tasks show work that your team should focus on first, while low priority tasks indicate less urgent work.",
                userSelection: "User Selection",
                assigneesDescription:
                    "You can filter by users assigned to tasks. Select the users you want to see only tasks assigned to them.",
                unassigned: "Unassigned",
                ownerSelection: "Task Owner Selection",
                ownerDescription: "You can filter by task owners. Select the users to see only tasks they own.",
                searchOwnerPlaceholder: "Search task owner...",
                followersSelection: "Task Followers Selection",
                followersDescription:
                    "You can filter by task followers. Select the users to see only tasks they follow.",
                searchFollowerPlaceholder: "Search follower...",
                creatorSelection: "Task Creator Selection",
                creatorDescription:
                    "You can filter by who created the task or system. Select users or system types to filter tasks.",
                createdBySystem: "Created by System",
                createdByUsers: "Created by Users",
                searchCreatorPlaceholder: "Search user...",
                filterByCreatedDate: "Filter by Created Date",
                today: "Today",
                thisWeek: "This Week",
                thisMonth: "This Month",
                startDate: "Start Date",
                endDate: "End Date",
                aboutDateFilter: "About Date Filter",
                filterByStartDate: "Filter by Start Date",
                filterByEndDate: "Filter by End Date",
                overdueTasks: "Overdue Tasks",
                showOverdueTasks: "Show overdue tasks",
                importantInfo: "Important Info",
                filterByUpdateDate: "Filter by Update Date",
                taskTags: "Task Tags",
                searchTagPlaceholder: "Search tag...",
                tagsLoading: "Loading tags...",
                noTagsMatchingSearch: "No tags matching search criteria.",
                noTagsCreated: "No tags created yet.",
                aboutTags: "About Tags",
                pipelineSelection: "Pipeline Status Selection",
                searchPipelinePlaceholder: "Search pipeline...",
                order: "Order",
                pipelinesLoading: "Loading pipelines...",
                noPipelinesMatchingSearch: "No pipelines matching search criteria.",
                noPipelinesCreated: "No pipelines created yet.",
                aboutPipelines: "About Pipelines",
                selected: "selected",
                closeTask: "Close Task",
                tabPriorities: "Priority",
                tabOwners: "Task Owner",
                tabFollowers: "Task Followers",
                tabCreatedBy: "Creator",
                tabCreatedDate: "Created Date",
                tabUpdateDate: "Update Date",
                tabStartDate: "Start Date",
                tabEndDate: "End Date",
                tabTags: "Tags",
                tabOverdue: "Overdue Tasks",
                tabStatus: "Status",
                priorityLowest: "Lowest Priority",
                priorityLow: "Low Priority",
                priorityMedium: "Medium Priority",
                priorityHigh: "High Priority",
                priorityHighest: "Highest Priority",
                createdByApi: "Tasks created by API",
                createdByChatbot: "Tasks created by Chatbot",
                createdByAutomation: "Tasks created by Automation",
                dateRangeCreatedDescription:
                    "Set start and end dates to filter tasks created within your selected date range. This filter filters tasks by their creation date (createdAt).",
                dateInfoCreatedText:
                    "The date filter limits results by task creation date. This way you can easily find tasks created within a specific time period.",
                dateRangeStartDescription:
                    "Set the start date to filter tasks created within your selected date range. This filter filters tasks by their start date (startDate).",
                dateInfoStartText:
                    "The date filter limits results by task start date. This way you can easily find tasks that will start within a specific time period.",
                dateRangeEndDescription:
                    "Set the end date to filter tasks created within your selected date range. This filter filters tasks by their end date (endDate).",
                dateInfoEndText:
                    "The date filter limits results by task end date. This way you can easily find tasks that will end within a specific time period.",
                dateRangeUpdateDescription:
                    "Set start and end dates to filter tasks updated within your selected date range. This filter filters tasks by their update date (updatedAt).",
                dateInfoUpdateText:
                    "The date filter limits results by task last update date. This way you can easily find tasks updated within a specific time period.",
                overdueDescription:
                    "You can filter tasks whose due date has passed and are still incomplete. When this filter is active, only overdue tasks will be displayed.",
                overdueDetail:
                    "Tasks whose due date has passed and are still incomplete will be displayed when this filter is active. These tasks are usually the ones your team needs to address as soon as possible.",
                overdueInfoText:
                    "Overdue tasks are tasks whose due date has passed but are not yet completed. These tasks indicate important work that your team needs to pay attention to.",
                tagsDescription:
                    "You can filter tasks by their tags. Tasks with the tags you select will be displayed.",
                tagsInfoText:
                    "Tags help you categorize tasks and find them more easily. If you select multiple tags, tasks with any of the selected tags will be displayed.",
                pipelineDescription:
                    "You can filter tasks by pipeline status. By selecting the pipelines you want, you can see only tasks in those stages.",
                pipelinesInfoText:
                    "Pipelines show which stage tasks are in. If you select multiple pipelines, tasks in any of the selected pipelines will be displayed.",
            },
            assignees: "Assignees",
            owner: "Owner",
            stage: "Stage",
            writeSomething: "Write something",
            selectAssginee: "Select Assignee",
            assignee: "Assignee",
            enterNewTaskDesc: "Enter New Task Description",
            enterNewTaskTitle: "Enter New Task Title",
            task: "Tasks",
            deleteTaskCont: "Are you sure you want to delete these tasks?",
            deleteWorkFlowCont: "Are you sure you want to delete this Workflow?",
            completed: "Completed",
            todo: "ToDo",
            kanbanBoard: "Kanban Board",
            listView: "List View",
            taskNotifications: "Task Notifications",
            reports: "Reports",
            workflowSettings: "Workflow Settings",
            trashBin: "Trash Bin",
            taskReports: {
                title: "Task Reports",
                selectWorkflow: "Select workflow",
                filters: "Filters",
                clear: "Clear",
                dateRange: "Date Range:",
                dateRangePlaceholder: "Start - End",
                assignees: "Assignees:",
                selectUser: "Select user",
                unassigned: "Unassigned",
                priority: "Priority:",
                selectPriority: "Select priority",
                emptyTitle: "Select Workflow to View Reports",
                emptyDescription: "Select a workflow from above to view task reports.",
                loadingTitle: "Preparing Report",
                loadingSubtitle: "Analyzing task data...",
                tasksClosed: "tasks closed",
                tasksUpdated: "tasks updated",
                tasksCreated: "tasks created",
                upcomingDeadlines: "Upcoming Deadlines",
                statusOverview: "Status overview",
                statusOverviewSubtitle: "View your tickets status at a glance.",
                totalTickets: "Total tickets",
                priorityDistribution: "Priority Distribution",
                teamWorkload: "Team workload",
                tooltipTasks: "{name}: {count} tasks ({percentage}%)",
                errorTitle: "Error Loading Report",
                retry: "Try Again",
                last7Days: "Last 7 days",
                dateRangeIn: "between {start} - {end}",
                upcomingCount: "{count} items have upcoming deadlines (next 7 days)",
                upcomingCountZero: "0 items have upcoming deadlines (next 7 days)",
                upcomingInRange: "{count} items have deadlines ({start} - {end})",
                upcomingInRangeZero: "0 items have deadlines ({start} - {end})",
                invalidWorkflowId: "Invalid Workflow ID format: {id}",
                loadSuccess: "Report data loaded successfully.",
                unknownError: "An unknown error occurred",
                error: "Error",
            },
            taskNotification: {
                title: "Task Notification Settings",
                description: "You can manage your task notification settings from here.",
            },
            workflowSandbox: {
                title: "Deleted Workflows",
                description: "Workflows that are not used for 30 days are automatically deleted by the system",
                emptyState: "No deleted workflows in trash",
                unnamedWorkflow: "Unnamed Workflow",
                restore: "Restore",
                permanentlyDelete: "Permanently Delete",
                unknown: "Unknown",
                user: "User",
                restoreConfirmTitle: "Are you sure you want to restore this workflow?",
                restoreConfirmContent: "{title} workflow will be restored.",
                restoreSuccess: "Workflow restored successfully",
                restoreFailed: "Restore failed",
                deleteConfirmTitle: "Are you sure you want to permanently delete this workflow?",
                deleteConfirmContent: "{title} workflow will be permanently deleted. This action cannot be undone.",
                deleteOkText: "Yes, Permanently Delete",
                cancel: "Cancel",
                deleteSuccess: "Workflow permanently deleted",
                deleteFailed: "Permanent delete failed",
                loadError: "Error loading deleted workflows",
            },
            archivingDate: "Archiving Date",
            taskDesc: "Task Description",
            archiveAndTrash: "Archive and Trash",
            trash: "Trash",
            loading: "Loading...",
            startDate: "Start Date",
            endDate: "End Date",
            clearFilter: "Clear Filter",
            noArchivedTasks: "No archived tasks found",
            noDeletedTasks: "No deleted tasks found",
            total: "Total",
            error: "Error",
            moveToBoard: "Move to Board",
            unarchive: "Unarchive",
            taskMovedToBoard: "Task moved to board",
            taskMoveError: "Error moving task to board",
            taskDeleted: "Task deleted",
            taskDeleteError: "Error deleting task",
            taskUnarchived: "Task unarchived",
            taskUnarchiveError: "Error unarchiving task",
            aprobado: "Approved",
            kanbanSettings: {
                cancel: "Cancel",
                card: "Card Settings",
                column: "Column Settings",
                kanban: "Kanban Settings",
                save: "Save",
                selectField: "Select a field",
                selectFieldPlaceholder: "Select a field",
                selectFields: "Select fields to show in card",
                title: "Settings",
            },
            notAuthorisedCreateTask: "You are not authorized to create a task",
            notAuthorisedCreateTaskDesc: "You are not authorized to perform this task.",
        },
        permissionErrors: {
            userCreate: "You do not have permission to add users. Please consult your administrator.",
            userRead: "You do not have permission to view users. Please consult your administrator.",
            userUpdate: "You do not have permission to update users. Please consult your administrator.",
            userDelete: "You do not have permission to delete users. Please consult your administrator.",
            visitorBlock: "You do not have permission to block visitors. Please consult your administrator.",
            visitorUnblock: "You do not have permission to unblock visitors. Please consult your administrator.",
            visitorDetailRead: "You do not have permission to view visitor details. Please consult your administrator.",
            visitorListRead: "You do not have permission to view visitor lists. Please consult your administrator.",
            visitorDelete: "You do not have permission to delete visitors. Please consult your administrator.",
            visitorExcel: "You do not have permission to get Excel output. Please consult your administrator.",
            visitorUpdate: "You do not have permission to update visitors. Please consult your administrator.",
            bannedVisitorRead:
                "You do not have permission to view banned visitors list. Please consult your administrator.",
            bannedWordCreate: "You do not have permission to add banned words. Please consult your administrator.",
            bannedWordRead: "You do not have permission to view banned words. Please consult your administrator.",
            bannedWordDelete: "You do not have permission to delete banned words. Please consult your administrator.",
            chatRead: "You do not have permission to view chats. Please consult your administrator.",
            chatUpdate: "You do not have permission to edit chats. Please consult your administrator.",
            archiveRead: "You do not have permission to view archives. Please consult your administrator.",
            roleCreate: "You do not have permission to add roles. Please consult your administrator.",
            roleRead: "You do not have permission to view roles. Please consult your administrator.",
            roleUpdate: "You do not have permission to update roles. Please consult your administrator.",
            roleDelete: "You do not have permission to delete roles. Please consult your administrator.",
            departmentCreate: "You do not have permission to add departments. Please consult your administrator.",
            departmentRead: "You do not have permission to view departments. Please consult your administrator.",
            departmentUpdate: "You do not have permission to update departments. Please consult your administrator.",
            departmentDelete: "You do not have permission to delete departments. Please consult your administrator.",
            preparedContentCreate:
                "You do not have permission to create prepared content. Please consult your administrator.",
            preparedContentRead:
                "You do not have permission to view prepared content. Please consult your administrator.",
            preparedContentUpdate:
                "You do not have permission to update prepared content. Please consult your administrator.",
            preparedContentDelete:
                "You do not have permission to delete prepared content. Please consult your administrator.",
            welcomeCreate: "You do not have permission to create welcome messages. Please consult your administrator.",
            welcomeRead: "You do not have permission to view welcome messages. Please consult your administrator.",
            welcomeUpdate: "You do not have permission to update welcome messages. Please consult your administrator.",
            welcomeDelete: "You do not have permission to delete welcome messages. Please consult your administrator.",
            settingCreate: "You don't have permission to create settings. Please consult with your administrator.",
            settingRead: "You don't have permission to view settings. Please consult with your administrator.",
            settingUpdate: "You don't have permission to update settings. Please consult with your administrator.",
            settingDelete: "You don't have permission to delete settings. Please consult with your administrator.",
            reportCreate: "You don't have permission to create reports. Please consult with your administrator.",
            reportRead: "You don't have permission to view reports. Please consult with your administrator.",
            reportUpdate: "You don't have permission to update reports. Please consult with your administrator.",
            reportDelete: "You don't have permission to delete reports. Please consult with your administrator.",
            offlineSupportRequestCreate:
                "You don't have permission to create offline support requests. Please consult with your administrator.",
            offlineSupportRequestRead:
                "You don't have permission to view offline support requests. Please consult with your administrator.",
            offlineSupportRequestUpdate:
                "You don't have permission to respond to offline support requests. Please consult with your administrator.",
            offlineSupportRequestDelete:
                "You don't have permission to delete offline support requests. Please consult with your administrator.",
            catalogCreate: "You don't have permission to create catalogs. Please consult with your administrator.",
            catalogRead: "You don't have permission to view catalogs. Please consult with your administrator.",
            catalogUpdate: "You don't have permission to update catalogs. Please consult with your administrator.",
            catalogDelete: "You don't have permission to delete catalogs. Please consult with your administrator.",
            chatbotStoryCreate:
                "You don't have permission to create chatbot stories. Please consult with your administrator.",
            chatbotStoryRead:
                "You don't have permission to view chatbot stories. Please consult with your administrator.",
            chatbotStoryUpdate:
                "You don't have permission to update chatbot stories. Please consult with your administrator.",
            chatbotStoryDelete:
                "You don't have permission to delete chatbot stories. Please consult with your administrator.",
            chatbotTemplateRead:
                "You don't have permission to view chatbot templates. Please consult with your administrator.",
            chatbotTemplateAiRead:
                "You don't have permission to view AI chatbot templates. Please consult with your administrator.",
            chatbotIntegrationsRead:
                "You don't have permission to view chatbot integrations. Please consult with your administrator.",
            chatbotArchiveRead:
                "You don't have permission to view chatbot archives. Please consult with your administrator.",
            chatbotEntitiesRead:
                "You don't have permission to view chatbot entities. Please consult with your administrator.",
            chatbotEntitiesCreate:
                "You don't have permission to create chatbot entities. Please consult with your administrator.",
            chatbotEntitiesUpdate:
                "You don't have permission to update chatbot entities. Please consult with your administrator.",
            chatbotEntitiesDelete:
                "You don't have permission to delete chatbot entities. Please consult with your administrator.",
            chatbotReportRead: "You do not have permission to view Chatbot Reports. Please contact your administrator.",
            chatbotTrainRead: "You do not have permission to view Chatbot Training. Please contact your administrator.",
            chatbotSegmentCreate:
                "You do not have permission to create Chatbot User Segments. Please contact your administrator.",
            chatbotSegmentRead:
                "You do not have permission to view Chatbot User Segments. Please contact your administrator.",
            chatbotSegmentUpdate:
                "You do not have permission to update Chatbot User Segments. Please contact your administrator.",
            chatbotSegmentDelete:
                "You do not have permission to delete Chatbot User Segments. Please contact your administrator.",
            integrationsRead:
                "You do not have permission to view Integrations Page. Please contact your administrator.",
            whatsappIntegrationRead:
                "You do not have permission to view Whatsapp Integration Page. Please contact your administrator.",
            instagramIntegrationRead:
                "You do not have permission to view Instagram Integration Page. Please contact your administrator.",
            telegramIntegrationRead:
                "You do not have permission to view Telegram Integration Page. Please contact your administrator.",
            integrationCreate: "You do not have permission to enable Integrations. Please contact your administrator.",
            triggerCreate: "You do not have permission to create Triggers. Please contact your administrator.",
            triggerRead: "You do not have permission to view Triggers. Please contact your administrator.",
            triggerUpdate: "You do not have permission to update Triggers. Please contact your administrator.",
            triggerDelete: "You do not have permission to delete Triggers. Please contact your administrator.",
            billingRead: "You don't have permission to view the bills. Please contact your administrator.",
            taskCreate: "You don't have permission to create tasks. Please contact your administrator.",
            taskRead: "You don't have permission to view tasks. Please contact your administrator.",
            taskUpdate: "You don't have permission to update tasks. Please contact your administrator.",
            taskDelete: "You don't have permission to delete tasks. Please contact your administrator.",
            calendarCreate:
                "You don't have permission to create calendar/reservation. Please contact your administrator.",
            calendarRead: "You don't have permission to view calendar/reservation. Please contact your administrator.",
            calendarUpdate:
                "You don't have permission to update calendar/reservation. Please contact your administrator.",
            calendarDelete:
                "You don't have permission to delete calendar/reservation. Please contact your administrator.",
            mailCreate: "You don't have permission to create mails. Please contact your administrator.",
            mailRead: "You don't have permission to view mails. Please contact your administrator.",
            mailUpdate: "You don't have permission to update mails. Please contact your administrator.",
            mailDelete: "You don't have permission to delete mails. Please contact your administrator.",
        },
        message: {
            artificialIntelligence: "Artificial Intelligence",
            channelSettings: "Channel Settings",
            apiKeyMode: "API Key Mode",
            byokTitle: "Use My Own API Key (BYOK)",
            byokDesc: "Use the API key from your OpenRouter account",
            supsisKeyTitle: "Let Supsis AI Provide API Key",
            supsisKeyDesc: "Use API key provided by Supsis",
            openrouterApiKey: "OpenRouter API Key",
            openrouterApiKeyHint: "You can get your API key from the OpenRouter Dashboard.",
            noChannels: "No channels yet",
            createFirstChannel: "Click 'Add Channel' to create your first channel.",
            createChannel: "Create Channel",
            providerInfo: "Provider Info",
            channels: "Channels",
            channelCreatedSuccessfully: "Channel created successfully",
            channelUpdatedSuccessfully: "Channel updated successfully",
            channelDeletedSuccessfully: "Channel deleted successfully",
            failedToSaveChannel: "Failed to save channel",
            failedToDeleteChannel: "Failed to delete channel",
            apiKeyRequired: "API key is required",
            deleteChannelConfirm: "Are you sure you want to delete this channel?",
            copiedToClipboard: "Copied to clipboard",
            appBreadcrumb: {
                tasks: "Tasks",
                broadcastLabel: "Broadcast Message",
                walletBalanceTooltip: "Your Wallet Balance: {amount}₺",
                broadcastStatusCreated: "Created",
                broadcastStatusScheduled: "Scheduled",
                broadcastStatusQueued: "Queued",
                broadcastStatusRunning: "Sending",
                broadcastStatus: "Status",
                broadcastProgress: "Progress",
            },
            confirmDeleteRedStationIntegration: "Are you sure you want to delete this Kırmızı Santral channel?",
            enterRedStationIntegration: "Enter your Kırmızı Santral API credentials",
            redStationIntegration: "Kırmızı Santral Integration",
            copyChannelID: "Copy Channel ID",
            redStationChannels: "Kırmızı Santral Channels",
            bannedUserError: "An error occurred while adding the ban.",
            bannedUserSuccess: "Ban added successfully.",
            selectAtLeastOneOption: "Please select at least one option.",
            enterValidValue: "Please enter a valid value.",
            enterValidIpAddress: "Please enter a valid IP address.",
            enterValidVisitorId: "Please enter a valid visitor ID.",
            enterValidWhatsappNumber: "Please enter a valid WhatsApp number.",
            invalidEmailAddress: "Please enter a valid email address.",
            bannedUser: "Banned",
            unbannedUser: "Not Banned",
            banModalDescription: "Enter platform and value to ban the user.",
            exampleNumber: "Example Number: 905551111111",
            clearSelectedFiltersTooltip: "Clears the selected filter values on the page",
            minutesText: "{count} minutes",
            secondsText: "{count} seconds",
            downloadCooldownWarning: "Please wait {time} to create a new download request.",
            excelExportReceiveQuestion: "How would you like to receive the Excel file?",
            sendToMe: "Send to Me",
            sendToSomeoneElse: "Send to Someone Else",
            enterEmailAddress: "Enter email address",
            exportRequestSuccess: "Your request has been created, we will send it to you via email as soon as possible",
            maxDateRangeWarning: "Selected Date Range Can Be Maximum 45 Days",
            ticketOnlyMail:
                "This request can only be responded to via email. Messages sent via WhatsApp cannot be forwarded.",
            cardInfoUpdateError: "An error occurred while updating card information",
            billingInfoSavedSuccessfully: "Your billing information has been successfully saved",
            billingInfoSaveError: "Error saving billing information:",
            paymentInfoSavedSuccessfully: "Your payment information has been successfully saved",
            annualDiscount: "Get 20% discount on annual purchases",
            annualDiscountDescription: "You can make significant savings by choosing an annual subscription.",
            payOnlyForUsedFeatures: "Pay only for what you use",
            payOnlyForUsedFeaturesDescription: "Pay only for the features you use, don't pay for more.",
            cancelAnytime: "Cancel anytime",
            cancelAnytimeDescription: "No need for long-term contracts, you can cancel whenever you want.",
            noPermissionDescription: "You do not have permission to perform this action.",
            creditCardRequired: "Credit Card Information Required",
            creditCardRequiredDescription:
                "You have paid subscriptions. You can continue by entering your credit card information or by canceling your subscriptions.",
            creditCardRequiredDescription2:
                "You need to enter credit card information because you have paid subscriptions in your account.",
            subscriptionManagement: "Subscription Management",
            addCreditCard: "Add Card Information",
            transferOwnership: "Transfer Ownership and Redirect",
            errorLoadingAgents: "An error occurred while loading agents",
            pleaseFillRequiredFields: "Please fill in the required fields",
            callStartedSuccessfully: "Call started successfully",
            errorStartingCall: "An error occurred while starting the call",
            errorLoadingData: "An error occurred while loading data",
            errorLoadingDataPhoneNumbers: "An error occurred while loading phone numbers",
            noVariablesFound:
                "No variables found in the prompt. Variables should be in <code v-pre>{{ variable_name }}</code> format.",
            aiVoiceAgentSpecialVariables: "Special Variable Values",
            addAiVoiceAgentChannel: "Add Channel",
            multiLanguageSupport: "Multi-language support",
            customerService247: "24/7 customer service",
            autoCallAnswer: "Automatic call answering",
            aiVoiceAgentChannelRequired: "AI Voice Agent Channel Required",
            aiVoiceAgentChannelRequiredDescription: "You need to add an AI Voice Agent channel to use this feature.",
            aiVoiceAgentChannelRequiredDescription2:
                "AI Voice Agent is an artificial intelligence-powered assistant that can make phone calls with your customers.",
            startCall: "Start Call",
            selectContactFieldPlaceholder: "Select contact information",
            aiVoiceAgentVariableValuePlaceholder: "Enter value",
            aiVoiceAgentVariables: "Agent's Variable Information",
            aiVoiceAgentVariableManual: "Manual",
            aiVoiceAgentVariableContact: "Contact Information",
            toNumberHelpText: "Must be in E.164 format. Example: +905321234567",
            toNumber: "Number to Call",
            selectAiVoiceAgentHelpText: "If not selected, the number's default outgoing agent will be used",
            selectAiVoiceAgent: "Select agent (optional)",
            aiVoiceAgent: "Agent",
            selectFromNumber: "Select caller number",
            fromNumber: "Caller Number",
            startAiCall: "Start Call with AI Voice Agent",
            aiCall: "Make Call with AI Voice Agent",
            groupByNone: "No grouping applied",
            groupByAgent: "Group contacts by the agents from their last session",
            groupByDepartment: "Group contacts by the department selected in their last session",
            groupByChannel: "Group contacts by the channel they came from",
            groupByPlatform: "Group contacts by the platform they came from",
            groupByWebsite: "Group contacts by the website they came from",
            groupByTag: "Group contacts by their tags",
            groupByAnswerStatus: "Group contacts by their answer status from their last session",
            groupByOwner: "Group contacts by their owners",
            changeGroupBy: "Change Grouping Mode",
            changeSortMode: "Change Sorting Mode",
            selectIcon: "Select Icon",
            iconPickerTitle: "Icon Picker",
            searchIconPlaceholder: "Search icon...",
            profileFieldsDescriptionChat: "Click to customize your profile fields",
            createCommentSuccess: "Comment created successfully",
            createCommentError: "An error occurred while creating the comment",
            updateCommentSuccess: "Comment updated successfully",
            updateCommentError: "An error occurred while updating the comment",
            deleteCommentSuccess: "Comment deleted successfully",
            deleteCommentError: "An error occurred while deleting the comment",
            formSubmission: "Form Submission",
            selectForm: "Select Form",
            updateOwnerUsers: "Update Owners",
            updateOwnerUsersDesc:
                "Do you want to update the owners of this user? You can transfer them to another user or leave them ownerless.",
            deposit: "Deposit",
            creditUsage: "Credit Usage",
            businessMarketing: "Marketing",
            businessUtility: "Utility",
            businessAuthentication: "Authentication",
            businessService: "Service",
            incomingSessionMessage: "Incoming Message",
            outgoingSessionMessage: "Outgoing Message",
            freeTierConversation: "Free Tier Conversation (FTC)",
            chatStart: "Start Chat",
            wpMessage: "Whatsapp QR Bulk Message",
            pin: "Pin",
            rename: "Rename",
            browserSpeechRecognitionNotSupported:
                "Your browser does not support speech recognition. We recommend using the Chrome browser.",
            spaceKeyReleaseToSave: "It will be saved when you release the space key",
            spaceKeyHint: "You can speak by holding down the space key",
            listeningInProgress: "Listening...",
            speakNow: "Speak now...",
            toggleAllPermissions: "Enable/Disable All Role Permissions",
            rolePermissions: "Role Permissions",
            roleSaved: "Role saved.",
            creatingRole: "Creating role...",
            savingRole: "Saving role...",
            editRole: "Edit Role",
            newRoleCreate: "New Role Create",
            descriptionEmail:
                "Automatically adds the visitor's email address in chat to the message box and allows you to send it",
            exampleEmail: "Example: @email hello",
            nameDescription:
                "Automatically adds the visitor's name in chat to the message box and allows you to send it",
            exampleName: "Example: @name hello",
            pmDescription:
                "Allows you to send a private message. Only other customer representatives can see these messages, visitors cannot.",
            examplePm: "Example: pm: This message is private",
            chatShortcuts: "Chat Shortcuts",
            showSystemStatus: "Show System Status",
            showMore: "Show More",
            showLess: "Show Less",
            endChatWizard: "End Session Wizard",
            terminationError: "An error occurred",
            profileFieldsUpdateError: "Error occurred while updating profile fields",
            profileFieldsUpdated: "Profile fields updated",
            aiSuggestionError: "AI suggestions could not be retrieved",
            profileFieldsDescription:
                "You can fill in the customized profile fields for this person to provide your team with more information.",
            categoryTags: "You can add tags to this person to quickly categorize them.",
            manageTags: "Manage Tags",
            enterNote: "Enter Note",
            noteDescription:
                "You can add notes about this person. These notes will also be visible after the conversation.",
            suggestedProfileFields: "Suggested Profile Fields:",
            suggestedTags: "Suggested Tags",
            suggestedNote: "Suggested Note:",
            applyAll: "Apply All",
            aiSuggestionTitle: "AI Suggestions",
            aiSuggestion: "Supsis Asistan Suggestions",
            searchItem: "Search Item",
            makeSelection: "Make Selection",
            channel: "Channel",
            taskClosingDate: "Task Closing Date",
            confirmDeleteTask: "Are you sure you want to delete this task?",
            taskDeletedSuccess: "Task successfully deleted",
            taskDeleteError: "Error occurred while deleting task",
            selectColumns: "Select the Columns You Want to See in the Table",
            linkedinChannels: "LinkedIn Channels",
            updateLinkedinChannelDesc: "Update your LinkedIn channel",
            deleteLinkedinChannel: "Delete LinkedIn Channel",
            confirmDeleteLinkedinChannel: "Are you sure you want to delete this LinkedIn channel?",
            contactIdPlaceholder: "Contact ID",
            contactId: "Contact ID",
            enterOwnerId: "Enter Owner ID",
            selectOwner: "Select Owner",
            dynamic: "Dynamic",
            owner: "Owner",
            addCollaborator: "Add Collaborator",
            dynamicValue: "Dynamic Value",
            selectCollaborator: "Select Collaborator",
            collaborator: "Collaborator",
            collaborators: "Collaborators",
            addFollower: "Add Follower",
            selectFollower: "Select Follower",
            followers: "Followers",
            follower: "Follower",
            addAssignee: "Add Assignee",
            selectUser: "Select User",
            assignees: "Assignees",
            assignee: "Assignee",
            pipelineStage: "Pipeline Stage",
            selectPipelineStage: "Select Pipeline Stage",
            title: "Title",
            taskTitle: "Task Title",
            description: "Description",
            taskDescription: "Task Description",
            priority: "Priority",
            selectPriority: "Select Priority",
            workflow: "Workflow",
            selectWorkflow: "Select Workflow",
            packagePurchase: "Package Purchase",
            upcomingInvoice: "Upcoming Invoice",
            invoiceUpdated: "Invoice Updated",
            invoiceMarkedInvalid: "Invoice marked as invalid.",
            invoiceUpdateError: "Invoice Update Error",
            invoiceMarkInvalidError: "An error occurred while marking the invoice as invalid.",
            refunded: "Refunded",
            paid: "Paid",
            pending: "Pending",
            unpaid: "Unpaid",
            paymentFailed: "Payment Failed",
            paymentProcessError: "An error occurred during the payment process.",
            paymentSuccessful: "Payment Successful",
            paymentProcessSuccessful: "Payment process completed successfully.",
            invoiceRefund: "Invoice Refund",
            invoiceRefundedSuccessfully: "Invoice has been refunded successfully.",
            invoicePaymentError: "Invoice Payment Error",
            invoicePaymentProcessError: "An error occurred during the invoice payment process.",
            invoicePaid: "Invoice Paid",
            invoiceMarkedAsPaid: "Invoice has been successfully marked as paid.",
            invoicePriceUpdateError: "An error occurred while updating the invoice price.",
            invoicePriceUpdatedSuccessfully: "Invoice price has been updated successfully.",
            invoicePdf: "Invoice PDF",
            viewInvoice: "View Invoice",
            makePayment: "Make Payment",
            socialMedia: "Social Media",
            web: "Web",
            email: "Email",
            sms: "SMS",
            crm: "CRM",
            ecommerce: "E-Commerce",
            utilities: "Utilities",
            advertising: "Advertising",
            cancelPlanTitle: "Plan cancellation",
            cancelPlanDescription:
                "After the plan cancellation, your package usage will continue until the end of the day.",
            voteSuccess: "Vote saved successfully",
            voteSuccessDescription: "Your request has been received to add {integrationName} integration to Supsis",
            companyName: "Company Name",
            company: "Company",
            languageTitle1: "Default Panel Language",
            languageTitle2: "Default Messaging Language",
            languageTitle3: "Region & Time Zone",
            languageTitle4: "Automatic Customer Language Setting",
            languageTitle5: "WebChat Customer Messaging Language Selection",
            languageDesc1: "Sets the language of the Supsis AI panel",
            languageDesc2: "You can change the default messaging language from here.",
            languageDesc3: "Sets the region and time zone",
            languageDesc4: "Enables automatic detection of the customer messaging language with AI support.",
            languageDesc5:
                "Activates the feature to allow the customer to select their spoken language in the WebChat channel.",
            featuresTitle1: "Department Selection",
            featuresTitle2: "Show Number of Customers Waiting in Line",
            featuresTitle3: "Banned Word Restriction",
            featuresTitle4: "Allow Customers to Create Tickets",
            featuresTitle5: "Voice Call",
            featuresTitle6: "Video Call",
            featuresTitle7: "Voice Message Sending (Agent)",
            featuresTitle8: "Voice Message Sending (Customer)",
            featuresTitle9: "Automatic Call Transfer",
            featuresTitle10: "Show Chat Between Representatives",
            featuresTitle11: "File Sending (Agent)",
            featuresTitle12: "WebChat File Sending (Customer)",
            featuresTitle13: "Allow Message Sending Before Representative Connects",
            featuresTitle14: "Hide System Messages from Representatives",
            featuresTitle15: "Allow Customer to Delete Personal Information",
            featuresTitle16: "Customer Online Notification",
            featuresTitle17: "Automatic Translation",
            featuresTitle18: "Visitor Auto Login",
            featuresTitle19: "WebChat Location Sharing (Customer)",
            featuresTitle20: "Location Sharing (Representative)",
            featuresTitle21: "Chat AI Copilot",
            featuresTitle22: "Queueing Unowned Conversations",
            featuresTitle23: "Hide Contact Information",
            featuresDesc1: "Mandatory routing to departments based on topics selected by the customer.",
            featuresDesc2: "Shows customers their position in line when representatives are busy.",
            featuresDesc3:
                "Prevents representatives from sending banned words defined in the system to customers when the banned word restriction is active.",
            featuresDesc4: "Activates the option to create a ticket in the WebChat bubble.",
            featuresDesc5: "Activates the voice call feature in the WebChat bubble.",
            featuresDesc6: "Activates the video call feature in the WebChat bubble.",
            featuresDesc7: "Enables representatives to send voice messages.",
            featuresDesc8: "Enables customers to send voice messages in the WebChat channel.",
            featuresDesc9: "Automatically assigns waiting calls to available representatives.",
            featuresDesc10: "Displays the conversation panel between representatives.",
            featuresDesc11: "Enables representatives to send files.",
            featuresDesc12: "Enables customers to send files in the WebChat channel.",
            featuresDesc13: "Allows customers to send messages before a representative connects.",
            featuresDesc14: "Hides system messages from representatives, preventing customers from seeing them.",
            featuresDesc15:
                "Enables customers to delete their personal information with a single click in the WebChat bubble.",
            featuresDesc16:
                "Notifies representatives with a system message when a customer leaves or returns to the WebChat channel.",
            featuresDesc17: "Automatically translates messages from customers into the representative's language.",
            featuresDesc18: "Starts the conversation as soon as the visitor clicks the bubble.",
            featuresDesc19: "Enables customers to share their location in the WebChat channel.",
            featuresDesc20: "Enables representatives to share their location.",
            featuresDesc21:
                "Enables representatives to use AI assistance for correcting typos, changing the tone of messages, and generating AI-supported responses.",
            featuresDesc22: "Enables this feature to keep individuals without ownership in the queue.",
            featuresDesc23: "Prevents representatives from viewing customers' phone numbers and email addresses.",
            featuresTitle24: "Session End Wizard",
            featuresDesc24: "Shows the session termination wizard to agents before closing the conversation",
            groupBy: "Group By",
            privacyPolicyAndTerms: "Privacy Policy / Terms of Service",
            privacyPolicyTitle: "Privacy Policy for Supsis Live Support & Chatbot Systems",
            privacyPolicyDescription:
                "This Privacy Policy describes how Softcand Yazılım Hizmetleri A.S. (“Softcand,” “we,” “us,” or “our”) collects, uses, and discloses information about users (“you” or “your”) of the Supsis web application (“Supsis”). This Privacy Policy applies to the information we collect when you use Supsis; this information is valid when accessed through our website, mobile applications, or other platforms where the Privacy Policy is published.",
            informationWeCollect: "Information We Collect",
            weCollectFollowingInformation: "We collect the following information",
            customerAccountInformation: "Customer Account Information",
            customerAccountData:
                "When creating a Supsis account, we collect the following data: first name, last name, phone number, and email address.",
            userInformation: "User Information",
            userProvidedInformation:
                "Information provided by users of the application, including first name, last name, and email address.",
            dataDeletionProcess: "Data Deletion Process",
            dataDeletionProcedures: "We follow these procedures for data deletion",
            automaticDeletion: "Automatic Deletion",
            automaticDeletionInfo:
                "Customer accounts are automatically deleted when closed or after six months of inactivity.",
            directRequest: "Direct Request",
            directRequestInfo: "Customers can request the deletion of all their data by contacting us directly.",
            websiteVisitorDataDeletion: "Website Visitor Data Deletion",
            websiteVisitorDataDeletionInfo:
                "Website visitors can delete their data, including chat history, messages, and files, directly through the web chat interface.",
            howToContactUs: "How to Contact Us",
            contactChannels: "You can reach us through the following channels",
            dataProcessingAndSharing: "Data Processing and Sharing",
            handleCustomerData: "We process customer data as follows",
            noThirdPartySharing: "No Third Party Sharing",
            noThirdPartySharingInfo:
                "Supsis does not share customer data with any third-party organization, company, or individual.",
            promotionalEmails: "Promotional Emails",
            promotionalEmailsInfo:
                "We may send promotional emails to customers; they can choose to opt-out of these emails.",
            visitorAndConversationData: "Visitor and Conversation Data",
            noSharingVisitorData: "We do not share or use customer visitor and chat information.",
            thirdPartyServices: "Third Party Services",
            googleOAuth: "Google OAuth",
            googleCalendar: "Google Calendar",
            googleCalendarInfo:
                "Supsis uses Google Calendars to enable calendar-related functionalities within the application. Data synchronized from calendars is not shared with anyone and is only visible to the user. When Google OAuth is terminated, all synchronized events from Supsis and Google Calendar are automatically deleted.",
            googleAccountPublicProfile: "Google Account Public Profile",
            googleAccountPublicProfileInfo:
                "Supsis collects name and email information to verify and authenticate users during login. This information is not stored after verification.",
            changesToPrivacyPolicy: "Changes to this Privacy Policy",
            privacyPolicyUpdateInfo:
                "We may update this Privacy Policy from time to time. If we make material changes, we will notify you through our website or other communication channels.",
            privacyPolicyContactInfo:
                "If you have any questions about this Privacy Policy, please contact us at m@softcand.com.",
            termsOfServiceTitle: "Terms of Service for Supsis Live Support & Chatbot Systems",
            lastUpdated: "Last updated",
            inEffect: "In effect",
            importantTerms:
                "Important: These Terms of Service, which include our Privacy Policy, form a binding contract between the person named during the 'Sign up' process as the user of the Service (“you”) and Softcand Yazılım Hizmetleri Anonim Şirketi (trading as Supsis or Supsis Live Support or Supsis Live Support and Chatbot Systems) (“us”) and govern your use of our websites located at supsis.com (product landing page), softcand.com (company webpage) or supsis.live (product app) or beta.supsis.live (product app beta version). For that reason, these Terms are important and you should ensure that you read them carefully and contact us with any questions before you use the Service.",
            termsDescription:
                "These Terms of Service govern your use of our websites located at supsis.com (product landing page), softcand.com (company webpage) or supsis.live (product app) or beta.supsis.live (product app beta version).",
            applicationOfTerms: "Application of Terms",
            termsApplyToAllUsers:
                "These Terms apply to all users of the Service, whether you are using the Service on your own behalf or on behalf of another individual or organization.",
            termsUpdateNotice:
                "We may update or change the Terms at any time at our discretion. If we change the Terms, we will notify you by alerting you through our web platform and by email.",
            termsDisagreementNotice:
                "You must agree to be bound by the updated Terms by clicking your acceptance in the notice presented to you before continuing to use the Service.",
            consumerRightsNotice:
                "If you are classified as a 'consumer' under applicable law, you may have legal rights under that local law which would prohibit all or parts of some of the limitations and exclusions set out in these Terms from applying to you, and where prohibited they will not apply to you.",
            theService: "The Service",
            serviceGrant:
                "We grant you a non-exclusive, worldwide, non-transferable, revocable right to use the Service in accordance with these Terms.",
            serviceAccess:
                "You may access and use the Service (including any incidental copying that occurs as part of that use) in accordance with these Terms.",
            serviceAgentAppointment:
                "When you log into the Service and connect a social media account to the Service, you appoint us as your agent in respect of that Account to conduct actions on your behalf, at your direction (such as responding to a direct message on Instagram or another Platform) in providing the Service to you.",
            additionalAccountsAppointment:
                "When you connect additional Accounts to the Service, you also appoint us as your agent in respect of those accounts to undertake the activities within the scope of the Agency.",
            accountControl:
                "You warrant that you control each Account and that you are authorized to appoint us as your agent with authority to undertake the activities within the scope of the Agency on your behalf for each Account.",
            serviceAffiliation:
                "You acknowledge and agree that the Service is not affiliated with or authorized by Instagram, Facebook, Twitter or any other social media service for which we supply the Service and that any access to each Platform (including via the Service) is governed by the applicable Platform's Terms of Use.",
            serviceLinks:
                "The Service contains links to other websites as well as Content added by people other than us. We do not endorse, sponsor or approve any such user-generated Content or any Content available on any linked website.",
            contentMonitoring:
                "We do not have any obligation to monitor, edit or remove Content uploaded or posted by our users to the Service and then posted to an Account on any of the Platforms.",
            serviceControl:
                "You acknowledge and agree that: (1) we retain control over the Service and may alter, amend or cease the operation of the Service at any time in our sole discretion (we will give you reasonable notice of any alteration that materially adversely affects the functionality of the Service); (2) the Service may be unavailable from time to time (including for maintenance purposes) and, to the extent possible, we will notify you of any scheduled downtime; and (3) we may refuse to publish Content that you add to the Service that we consider, acting reasonably, does not comply with section 3 of these Terms.",
            yourRightsAndObligations: "Your Rights and Obligations",
            contentAdditionRestriction:
                "You must not add any Content to the Service: (1) unless you hold all necessary rights, licenses and consents to do so; (2) that would cause you or us to breach any law or regulation or any other legally enforceable rule, code or other obligation; (3) that is or that we, acting reasonably, consider to be spam, obscene, inappropriate, defamatory, disparaging, indecent, seditious, offensive, pornographic, threatening, abusive, liable to incite racial hatred, unlawful, discriminatory, blasphemous, in breach of confidence or in breach of any privacy law; (4) that would bring us, or the Service, into disrepute; or (5) that infringes the intellectual property or other rights of any person.",
            restrictionsOnServiceUse:
                "You must not: (1) attempt to duplicate or replicate, or reproduce, modify or prepare derivative works of, the Service, Content that we publish on or in relation to the Service or any other material that you do not own or for which you do not have a relevant license; (2) distribute viruses or code that is otherwise malicious; (3) use the Service to publish information that is misleading or deceptive; (4) access another person's Account on our Service without their permission; (5) alter, disable, interfere with or circumvent any aspect of the Service or test or reverse-engineer the Service in order to find limitations, vulnerabilities or evade filtering capabilities; or (6) do anything designed to affect access to or the integrity of the Service.",
            payments: "Payments",
            paymentAcknowledgment: "You acknowledge and agree that:",
            paymentMethodDebit:
                "We will debit your nominated payment method on the specified billing date (the day that your trial period ends) each month, year or other billing period (as applicable) for the next billing period in advance, unless you cancel the Service prior to this date; and",
            cancellationPolicy:
                "If you cancel the Service, you will continue to have access to the Service until your next billing date, and any refund of any monies paid for the current billing period is at our discretion (that is, payments are non-refundable, except at our discretion).",
            intellectualProperty: "Intellectual Property",
            contentDefinition:
                "In these Terms, 'Content' includes material in text, audio, graphic, pictorial and video form, or any combination of material, in any form.",
            intellectualPropertyRightsTransfer:
                "Nothing in these Terms constitutes a transfer of any intellectual property rights. You acknowledge and agree that, as between you and us, we own all intellectual property rights in the Service (that is, we own the rights to the applications we make available to you – we do not own intellectual property rights to your Content – see below in 5(3)).",
            userContentRights:
                "We acknowledge that as between you and us, you own or have a license to all intellectual property rights in the Content that you provide to the Service or otherwise provide to us for the purpose of providing the Service.",
            grantLicense:
                "You grant us a perpetual, non-exclusive, royalty-free, irrevocable, worldwide and transferable right and license to use, in any way (including by posting to an Account on any Platform as directed by you): (a) Content that you add to the Service; and (b) profile content on social media Platforms associated with your Account (including, without limitation, by reproducing, changing or adapting, and communicating that Content to the public) for the purposes of providing you with the Service.",
            subLicense:
                "We may sub-license the license in paragraph 5(4) to third party service providers who assist us in providing the Service.",
            moralRights:
                "In some countries in which the Service operates, local law recognizes that authors of Content may have 'moral rights' in respect of the Content. Examples of moral rights can include the right to be attributed as the author of Content, the right to object to false attribution of the authorship of content and the right to object to derogatory treatment of Content in some circumstances.",
            licenseSurvival: "The license in paragraph 5(4) will survive any termination of these Terms.",
            rightsRepresentation:
                "You represent and warrant to us that you have all necessary rights to grant the licenses and other commitments set out in this clause 5.",
            warranties: "Warranties",
            warrantiesAcknowledgment: "You represent and warrant to us that:",
            accountOwnership: "All Accounts, on any Platform, added to the Service are owned or controlled by you;",
            serviceUsageAgreement: "You will use the Service in accordance with these Terms; and",
            legalCapacity: "You have the legal capacity and the authority to enter into these Terms.",
            liability: "Liability",
            liabilityForLoss:
                "You are liable for any loss or damage caused if you breach your obligations under these Terms or you fail to use reasonable care in your use of the Service. Your liability will be reduced to the extent that we cause or contribute to that loss or damage by our own breach of these Terms or our own failure to use reasonable care in providing the Service.",
            indemnification:
                "You indemnify us for any loss or damage we suffer as a result of your breach of these Terms (including the warranties you give us under these Terms), or any willful misconduct, unlawful acts or negligence in your use or misuse of the Service.",
            exclusionOfLiability:
                "To the full extent permitted by law, and subject where applicable to clauses 7(5) and 7(6) of these Terms, we exclude all liability for all claims, expenses, loss, damage and costs made against or incurred by you directly or indirectly arising out of or in connection with your use of the Service or your inability to use the Service, including in respect of economic loss, loss of data, interruption of business or any consequential or incidental damages.",
            totalLiabilityLimit:
                "To the full extent permitted by law, and subject where applicable to clauses 7(5) and 7(6) of these Terms, our total liability to you for breach of contract under these Terms, for tort (including negligence), or for any other cause is limited to an amount equal to the total aggregate fee paid or payable by you for the Service for the one month period immediately preceding the day upon which our liability arose.",
            exclusionOfTerms:
                "To the full extent permitted by law, and subject where applicable to clause 7(6) and 7(7) of these Terms, we exclude all terms, representations, warranties, conditions, guarantees or obligations (whether express or implied) other than those expressly set out in these Terms.",
            statutoryObligations:
                "In some jurisdictions, legislation may require that certain warranties, conditions, guarantees or obligations relating to the Service are implied into these Terms or imposed on our supply of the Service ('statutory obligations'). Further, the legislation may prohibit, or render void, other terms that have the effect of excluding, limiting or modifying imposed terms, or the exercise of rights and remedies, or the recovery of compensation, otherwise available to you where we breach an imposed term ('statutory prohibition').",
            statuteProhibition:
                "If legislation referred to in clause 7(6) applies to these Terms as accepted by you, or to the Service as provided to you, nothing in these Terms is intended to be, or operates as, a statutory prohibition. In particular, no part of these Terms is intended to limit our liability where that part would be a statutory prohibition.",
            termination: "Termination",
            terminationAutomatic:
                "These Terms terminate automatically if, for any reason, we cease to operate the Service.",
            terminationNotice:
                "We may otherwise terminate or suspend your access to the Service immediately, on notice to you, if in our reasonable opinion, you have breached these Terms in any way.",
            cancelService:
                "You may cancel the Service at any time by notifying us, and you can continue to access the Service until the end of your current billing period.",
            terminationRights: "All rights granted to you in these Terms cease upon termination.",
            assignmentRestriction:
                "You must not assign, sublicense or otherwise deal in any other way with any of your rights under these Terms.",
            invalidProvision:
                "If a provision of these Terms is invalid or unenforceable, it is to be read down or severed to the extent necessary without affecting the validity or enforceability of the remaining provisions.",
            expenseResponsibility:
                "Each party must at its own expense do everything reasonably necessary to give full effect to this Agreement and the events contemplated by it.",
            governingLaw:
                "These Terms are governed by the laws of Turkey and each party submits to the jurisdiction of the courts of Turkey.",
            privacyPolicyTab: "Privacy Policy",
            termsAndConditionsTab: "Terms and Conditions",
            deleteOperation: "Delete Operation",
            deleteConfirmationMessage: "Are you sure you want to delete this filter?",
            deleteSuccess: "Filter deleted successfully",
            filterSavedSuccessfully: "Filter saved successfully",
            filterCreatedMessage:
                "The filter you just created, {filterName}, is now available here and can be used anytime.",
            copyImage: "Copy Image",
            copyText: "Copy Text",
            translateVisitorMessage: "Translate Message",
            replyMessage: "Reply",
            downloading: "Downloading file...",
            downloadSuccess: "File downloaded successfully",
            downloadFailed: "File download failed",
            filterName: "Filter Name",
            enterFilterName: "Enter the filter name",
            selectVisibility: "Select visibility",
            public: "Public",
            private: "Private",
            includeExistingFilters: "Include existing filters",
            includeSearchTerm: "Include search term",
            includeSortOrder: "Include sort order",
            includeGroupingSelection: "Include grouping selection",
            saveFilter: "Save the filter",
            ban: "Ban",
            forwardToDepartmentAndAssign: "Forward to Department and Assign",
            storageSpace: "Storage Space",
            cancelled: "Cancelled",
            running: "Running",
            paused: "Paused",
            queued: "Queued",
            scheduled: "Scheduled",
            metaLead: "Meta Lead",
            agent: "Agent",
            invoice: "Invoice",
            whatsapp: "WhatsApp",
            chatbot: "Chatbot",
            webhook: "Webhook",
            table: "Table",
            tag: "Tag",
            low: "Low",
            lowest: "Lowest",
            medium: "Medium",
            high: "High",
            highest: "Highest",
            createDepartment: "Create Department",
            goToLink: "Go to Link",
            emailAddressYouProvide: "An account already exists with the email address you provided.",
            channelPrivacyPolicyNotMet: "Channel privacy policy not met",
            userIsNotInDepartment: "User is not in department",
            currentDepartment: "Current Department",
            validDepartment: "Valid Department",
            youCanForwardToThisDepartment: "You can forward to this department",
            goToSettings: "Go to Settings",
            changeDepartmentAndForward: "Change Department and Forward",
            selectDepartmentToForwardAgent:
                "Please select which department you would like to route the conversation through for the agent named {selectAgentName}.",
            selectDepartmentToForward: "Select Department to Forward",
            packageConfirmationMessage:
                "Are you sure you want to purchase the package? The package you purchase is subject to real-time charges. You can continue to use it for one year after cancellation. The price of this product is exclusive of 20% VAT.",
            packagePurchaseConfirmation:
                "Are you sure you want to purchase the package? Monthly packages will be charged at the beginning of each month. The package usage will end after the cancellation date. The price of this product is exclusive of 20% VAT.",
            annualPurchaseDiscount: "Catch the 30% discount offer on annual purchases!",
            customerTables: "Customer Tables",
            formIntegration: "Form Integration",
            automationIntegration: "Automation Integration",
            remainingAutomationTask: "Remaining Automation Task",
            createUserError: "An error occurred while creating the user",
            sendTemplateMessage: "Send Template Message",
            startChatWithDifferentChannel: "Start Chat with Different Channel",
            whatsappChatStarter: "Whatsapp Chat Starter",
            pressEnterToJoin: "Press Enter to join the chat",
            pressEnterToStartChat: "Press Enter to start chat",
            cannotSendMessage: "You cannot send message to this person",
            cannotSendSessionMessage: "You cannot send session message to this person",
            conversationNotInYourDepartments: "This conversation does not belong to any of your departments",
            customizeImage: "If you want to customize the image",
            clickToUpload: "Click here to upload a picture",
            uploadNote: "Following are the file formats and their respective sizes which are accepted for upload",
            imageSize: "The image could not be uploaded because it is more than 2 MB",
            videoSize: "The video could not be uploaded because it is more than 20 MB",
            documentSize: "The document could not be uploaded because it is more than 2 MB",
            uploading: "Image uploading, please wait...",
            uploadSuccess: "Image uploaded successfully",
            note: "Note",
            gridView: "Grid View",
            completedTasks: "Completed Tasks",
            system: "System",
            destroyedBy: "Destroyed By",
            brand: "Brand",
            questions: "Questions",
            channelCreatedSuccess: "Channel created successfully",
            channelCreatedError: "Failed to create channel",
            plans: {
                types: {
                    supsis: "Agent Packages",
                    chatbot: "Chatbot",
                    automation: "Automation",
                    customer_tables: "Customer Table",
                    mail: "Email",
                    tasks: "Tasks",
                    form: "Form",
                    whatsapp: "WhatsApp Web (QR)",
                    whatsapp_business: "WhatsApp Business API",
                    instagram: "Instagram",
                    messenger: "Messenger",
                    meta_lead: "Meta Lead",
                    trendyol: "Trendyol",
                    artificial_intelligence: "Artificial Intelligence",
                    webhook: "Webhook",
                    telegram: "Telegram",
                    webphone: "Web Phone",
                },
            },
            vipCustomerDescription:
                "Marking this person as a VIP customer moves them to the top of the queue and ensures they receive priority service.",
            switchOn: "On",
            switchOff: "Off",
            ownerDescription:
                "This feature indicates the owner of a person. Regardless of the owner's status (online or offline), opened chats are always assigned to their owner. Owned contacts can only be viewed by their respective owner.",
            permissionError: "You do not have permission to perform this action!",
            copySuccess: "Content copied successfully!",
            unowned: "Unowned",
            add: "Add",
            copy: "Copy",
            cancel: "Cancel",
            edit: "Edit",
            update: "Update",
            search: "Search",
            save: "Save",
            jsonPreview: "JSON PREVIEW",
            enterNewValue: "Enter new value",
            updatePreferredLanguage: "Update Preferred Language",
            updateTags: "Update Tags",
            updateEmail: "Update Email",
            enterNewEmail: "Enter new email",
            deleteConfirmation: "Delete Confirmation",
            confirmDelete: "Are you sure you want to delete this feature?",
            yesDelete: "Yes, Delete",
            vipCustomer: "★ VIP Customer",
            takeControlFromChatbot: "Take Control from Chatbot",
            enterJoin: "You can join the chat by pressing the Enter key",
            watchChat: "Watch Chat",
            untitledAutomation: "👉 Untitled Profile Click Automation",
            event: "Event",
            chatbotSettings: "Chatbot Routing Settings",
            chatbotScenarioNotFound: "Chatbot Scenario Not Found",
            noChatbotScenario: "No chatbot scenario found in the system.",
            scenarioNotFound: "Scenario not found",
            descNotAvailable: "Description Not Available",
            lastRegulation: "Last Regulation",
            taskCreator: "Task Creator",
            noPermission: "You do not have permission to create tasks.",
            notAppointed: "Not Appointed",
            changeStage: "Change Stage",
            selectedCandidates: "1 selected candidate(s)",
            coverPhotoRemove: "Remove Cover Photo",
            coverPhotoSet: "Set as Cover Photo",
            autoTransfer: "Automatically Transfer Your Contacts to Zoho",
            autoTransferDescription:
                "Contacts coming to this channel are automatically transferred to the Zoho CRM Contact Module. Those transferred to Zoho activate Zoho widgets.",
            zohoChannelRequiredTitle: "Zoho CRM Channel Required",
            zohoChannelRequiredContent: "You do not have a Zoho CRM channel. Click here to add one immediately.",
            okText: "Add Zoho CRM Channel",
            cancelText: "Cancel",
            forceQueueForNoOwnerContacts: "Force No Owner Contacts to Wait in Queue",
            autoForwardToOwnerForce: "Force Owned Contacts to Forward to Owner (Even When Chatbot is Active)",
            autoForwardToOwnerForceDescription:
                "In all cases, owned contacts are automatically forwarded to their owner. They are neither kept in queue nor transferred to chatbot. Even if this setting is off, if chatbot is not active in the system, they will still be forwarded to their owner.",
            forceQueueDescription:
                "Only owned contacts are automatically assigned, forcing no owner contacts to wait in the queue. ",
            showNoOwnerContactsToAdmins: "Show No Owner Contacts Only to Admins",
            showNoOwnerContactsDescription: "No owner contacts are visible only to admins.",
            autoAssignOwner: "Automatic Contact Ownership",
            autoAssignOwnerDescription:
                "When the chat is automatically assigned to a representative, it is also assigned as an owner.",
            creator: "Creator",
            hideShow: "Hide / Show",
            url: "URL",
            cannedMessages: "Canned Messages",
            templateMessages: "Template Messages",
            chatbots: "Chatbots",
            noCannedMessages: "No Canned Messages Found",
            filterToFindMore: "You can find more canned messages by changing your filters.",
            runPrompt: "Run Prompt",
            noLeadsFound: "No leads found for this person",
            deals: "Deals",
            noDealsFound: "No deals found for this person",
            loadingDeals: "Loading deals",
            salesOrders: "Sales Orders",
            noSalesOrdersFound: "No sales orders found for this person",
            loadingSalesOrders: "Loading sales orders",
            contacts: "Contacts",
            noContactsFound: "No contacts found for this phone number",
            loadingContacts: "Loading contacts",
            zohoCRM: "Zoho CRM",
            viewContact: "View Contact",
            noNotesAdded: "No notes added yet",
            attachments: "Attachments",
            addNewNote: "Add New Note",
            savingg: "Saving...",
            warningFillFields: "Please fill in the title and content fields.",
            successNoteAdded: "Note added successfully.",
            errorAddingNote: "An error occurred while adding the note.",
            noteTitle: "Note Title",
            noteContent: "Note Content",
            selectPreferredAgent: "Select the preferred agent you want to assign to the visitor.",
            postOperations: "Post Operations",
            loadingPostOperations: "Loading post operations",
            noPostOperations: "No post operations found for this person",
            postOperationDetails: "Post Operation Details",
            noMediaDocuments: "No media or documents available for this person.",
            selectionLimitError: "You can select a maximum of 30 items.",
            showNote: "Show Note to Everyone",
            hideNote: "Hide Note",
            updateNote: "Update Note",
            addUserNote: "Add a note about the user",
            privateNote: "Private Note",
            metaReferrals: "Meta Referrals",
            noMetaReferrals: "No meta ad interactions found.",
            searchPrompt: "Search for something.",
            noRecentResults: "No recent results found.",
            contactInfo: "Contact Information",
            noPropertiesAdded: "No properties added yet.",
            propertyAddedUpdated: "Property successfully added/updated.",
            propertyError: "An error occurred while adding/updating the property.",
            propertyDeleted: "Property successfully deleted.",
            propertyDeleteError: "An error occurred while deleting the property.",
            zohoSynchronization: "Zoho Synchronization",
            zohoSyncConfirmation: "Do you want to make changes to the person in Zoho as well?",
            hideOtherInfo: "Hide Other Information",
            showOtherInfo: "Show Other Information",
            whatsappChatStart: "Start WhatsApp Chat",
            ownership: "Customer Ownership",
            countryAndLanguage: "Country, Language",
            calendarEvent: "Calendar Event",
            reservation: "Reservation",
            contact: "Contact",
            user: "User",
            customerOwnership: "Customer Ownership",
            ownerless: "Ownerless",
            preferredDepartment: "Preferred Department",
            flowluTransfer: "Transfer to Flowlu",
            mergeSuccess: "Merge operation completed successfully.",
            visitorOwnershipWarning: "This visitor is owned by another user.",
            newAutomation: "New Automation",
            automations: "Automations",
            createProfileAutomation: "Create Profile Automation",
            profileButtonClicked: "Profile button clicked",
            profileButtonDescription: "This automation will be triggered when a profile button is clicked.",
            automationName: "Automation name",
            create: "Create",
            dayRange: "Day Range",
            hourRange: "Hour Range",
            last24Hours: "Last 24 Hours",
            today: "Today",
            yesterday: "Yesterday",
            thisWeek: "This week",
            lastWeek: "Last week",
            last7Days: "Last 7 days",
            last30Days: "Last 30 days",
            thisMonth: "This month",
            lastMonth: "Last month",
            startDateTime: "Start Date Time",
            endDateTime: "End Date Time",
            complaint: "Complaint",
            opens: "Opens",
            clicks: "Clicks",
            mockData: "(Mock Data)",
            preferredRepresentative: "Select Preferred Agent",
            forwardToDepartment: "Forward to Department",
            toMobileAgents: "To Mobile Agents",
            noMediaAndDocuments: "This user has no media or documents",
            reportBug: "Report a Bug",
            waitingForReply: "Waiting Answer",
            memorySize: "Storage Size",
            usedMemory: "Used Storage",
            availableMemory: "Available Storage",
            memoryLimit: "Storage Limit",
            memoryLimitPrice: "Price for additional storage",
            telegramBotIsReachable: "Reaching Telegram Bot Service",
            telegramBotIsHealthy: "Telegram Bot Service is healthy",
            telegramBotIsUnhealthy: "Telegram Bot Service has an error",
            pieView: "Pie View",
            chartView: "Chart View",
            tableView: "Table View",
            lastUpdate: "Last Update",
            task: "Task",
            filterBy: "By Filter",
            watchAllLive: "Watch All Live",
            sessionsUnique: "Sessions (Unique Users)",
            sessionsAll: "Sessions (All Users)",
            moreFeaturesDesc:
                "More features, more integrations, more agents! Take action now to better manage your team and grow your business to its maximum potential!",
            metaLeadForms: "Meta Lead Forms",
            metaLeadsConnectedSucs: "Meta Leads connected successfully",
            failedToConnectMetaLeads: "Failed to connect to Meta Leads",
            forbiddenChannel: "Banned Channel",
            forbiddenChannelDesc: "You are not allowed to view this channel",
            firstContact: "First Contact",
            needsAnalysis: "Needs Analysis",
            offerSent: "Offer Sent",
            offerReview: "Offer Review",
            decisionPhase: "Decision Phase",
            personDeleted: "Person Deleted",
            metaLeadsIntegration: "Meta Leads Integration",
            phoneNumberIsInvalid: "Phone number is invalid.",
            addAnItem: "Add an item",
            saveItem: "Save Item",
            customItem: "Custom Item",
            backgroundPhoto: "Background Image",
            whenYouActivateFeature: "When you activate this feature, it will not appear on the booking page",
            logo: "Logo",
            noLogo: "No Logo",
            addTeamMember: "Add Team Member",
            timezone: "Time Zone",
            selectDayys: "Select Day(s)",
            selectStartHour: "Select Start Time",
            selectEndHour: "Select End Time",
            moveLeft: "Move Left",
            moveRight: "Move Right",
            reply: "Reply",
            replyToAll: "Reply to All",
            deleteThreadMessage: "Delete Thread Message",
            totalEmailsBounced: "Total Emails Bounced",
            totalEmailsComplained: "Total emails complained about",
            untilNowTotalEmailOpens: "Total email opens so far",
            untilNowTotalEmailLinkClicks: "Total email link clicks so far",
            uniqueClicks: "Unique Clicks",
            untilNowTotalUniqueEmail: "Total unique email link clicks so far (per recipient)",
            emailCampaignTimeline: "Email Campaign Timeline",
            receivedBroadcasts: "Received Broadcasts",
            groupDeletedSuccessfully: "Group deleted successfully",
            verify: "Verify",
            done: "Done",
            pleaseSelectAnEmailAddress: "Please select an email address.",
            goBack: "Go Back",
            show: "Show",
            vueEmailEditor: "Vue Email Editor (Demo)",
            saveDesign: "Save Design",
            exportHTML: "Export HTML",
            saveAsEmailCustomerGroup: "Save as Email Customer Group",
            saveAsWhatsappCustomerGroup: "Save as Whatsapp Customer Group",
            deleteModalFormDesc:
                "If you delete this form, all data for the form will be permanently deleted. Are you sure you want to continue?",
            todo: "Things to do",
            inProgress: "In Progress",
            approval: "Approval",
            completed: "Completed",
            transactionType: "Transaction Type",
            previousBalance: "Previous Balance",
            nextBalance: "Next Balance",
            amount: "Amount",
            wpIntegrationChannelRequired: "Whatsapp Web Integration Channel Required.",
            wpIntegrationChannelRequiredDesc:
                "Chatbot + Whatsapp Web integration requires Whatsapp Web Channel. Please create a new channel.",
            wabaIntegrationChannelRequired: "Whatsapp Business Integration Channel Required.",
            wabaIntegrationChannelRequiredDesc:
                "Chatbot + Whatsapp Business API integration requires Whatsapp Web Channel. Please create a new channel.",
            instaIntegrationChannelRequired: "Instagram Integration Channel Required.",
            instaIntegrationChannelRequiredDesc:
                "Chatbot + Instagram integration requires Instagram Channel. Please create a new channel.",
            createWpChannel: "Create Whatsapp Web Channel",
            createWabaChannel: "Create Whatsapp Business API Channel",
            createInstaChannel: "Create Instagram Channel",
            failedToDeleteGroup: "Failed to delete group",
            failedToDeleteGroups: "Failed to delete groups",
            failedToFetchGroupContacts: "Failed to fetch group contacts",
            mailAddressDeletedSuccessfully: "Mail Address Successfully Deleted",
            defaultMailAddressChangedSuccessfully: "The default mail address was changed successfully",
            mailAddressAlreadyRegistered: "The mail address cannot be already registered or empty.",
            pleaseVerifyByClicking: "Please verify by clicking the link sent to your e-mail address.",
            signSucsRegistered: "Signature successfully registered",
            myContacts: "My Contacts",
            unanswered: "Missed",
            emailBroadcasts: "Email Broadcasts",
            monthlyLimit: "Monthly Limit",
            totalShipments: "Total Shipments",
            shippingStatus: "Shipping Status",
            lastAction: "Last Action",
            receiver: "Receiver",
            delivered: "Delivered",
            opened: "Opened",
            clicked: "Clicked",
            bounced: "Feedback",
            clickedLinks: "Clicked Links",
            reason: "Reason",
            timer: "Timer",
            implemented: "Implemented?",
            module: "Module",
            excelDownload: "Download Excel",
            serviceFeatures: "Service Features",
            mailAddressDeletedSucs: "Mail address deleted successfully",
            inputSearchText: "Enter search text",
            createRecord: "Create Record",
            separatorCharacter: "Separator Character",
            exampleResultPreview: "Example Result Preview",
            importRecords: "Import Records",
            equals: "Equal",
            notEquals: "Not Equal",
            startsWith: "Starts with",
            endsWith: "Ends with",
            greaterThan: "More",
            lessThan: "Less than",
            before: "Before",
            after: "After",
            is: "is",
            isNot: "is not",
            empty: "Empty",
            notEmpty: "Not Empty",
            isOneOf: "One of",
            between: "Between",
            field: "Field",
            records: "Record",
            addIntegration: "Add Integration",
            chatbotScenarioReleased: "Chatbot Scenario released",
            chatbotScenarioHasBeenCanceled: "Chatbot Scenario has been canceled",
            titleAndDesc: "Title & Description",
            templateAndMailSelection: "Template & Mail Selection",
            peopleToSend: "People to Send To",
            submissionPlans: "Submission Plan",
            summary: "Summary",
            broadcastTitle: "Broadcast Title",
            sentByEmail: "Sent Email",
            emailTemplate: "Email Template",
            onlyPeopleWithEmail: "Only people with an email address are eligible for sending.",
            sendNow: "Send Now",
            plan: "Plan",
            senderEmail: "Sender Email",
            totalBuyer: "Total Buyer",
            estimatedDuration: "Estimated Duration",
            person: "Person",
            shippingIsNowComplete: "Shipping is complete!",
            back: "Back",
            customerName: "Customer's Name",
            customerEmail: "Customer's Email",
            customValue: "Custom Value",
            selectMailTemplate: "You must select a mail template.",
            youMustSelectSendingMailAddress: "You must select the sending mail address.",
            youMustSelectCustomerGroupSend: "You must select the customer group to send to.",
            createBroadcast: "Create Broadcast",
            broadcastDetails: "Broadcast Details",
            youCanCheckYourEmailStatus:
                "You can check your email status by upgrading your plan. You can check your email status by upgrading your plan.",
            sentDetails: "Sent details",
            failed: "It failed",
            total: "Total",
            totalEmailsProcessed: "Total emails processed",
            totalEmailsDelivered: "Total emails sent",
            toAvailableAgents: "For Available Agents",
            toAvailableDepartments: "For Available Departments",
            toWithAgentAndDepartment: "With Agent and Department",
            toMobilAgents: "To Mobile Agents",
            toPreferredAgents: "To Preferred Agents",
            searchAgent: "Search Agent",
            searchDepartment: "Search Department",
            searchMobileAgent: "Search Mobile Agent",
            searchAgentOrDepartment: "Search agent or department",
            searchPreferredAgent: "Search for the preferred Agent",
            noAgentsAvailableToForward: "No agents available to forward",
            noDepartmentsAvailableToForward: "No Departments available to forward",
            checkChannelVisibilityTitle: "Check your channel visibility settings",
            checkChannelVisibilityDescription:
                "If you cannot see some departments, check your channel visibility settings",
            goToChannelSettings: "Go to channel settings",
            noMobileAgentsAvailableToForward: "No Mobile Agents Available to Forward",
            noPreferredAgentsAvailableToForward: "No preferred Agents available to forward",
            ifYouSendThisConversationToTheQueue:
                "If you send this chat to the queue, it will remove you from the chat and place the chat in the queue. If automatic chat assignment is enabled, the chat will be assigned to an appropriate agent and may be transferred back to you.",
            ifAutomaticChatAssignmentIsDisabled:
                "If automatic chat assignment is disabled, the call will remain in the queue. Authorized staff can take the call from the queue.",
            sendQueue: "Send to Queue",
            agentName: "Agent Name",
            departmentName: "Department Name",
            toQueue: "Queue",
            mobile: "Mobile",
            noGrouping: "No Grouping",
            groupByThis: "Group By This",
            selectGroupingCriteria: "Select Grouping Criteria",
            activeUsers: "Active Users",
            passiveUsers: "Passive Users",
            noPlatform: "No Platform Specified",
            noRole: "Role Unspecified",
            noDepartment: "No Department Specified",
            addUsersToDepartment: "Add users to department",
            removeFromDepartment: "Remove from department",
            moveToDepartment: "Move to department",
            noUsersInDepartment: "No users in this department",
            selectAtLeastOneUser: "Select at least one user",
            departmentUsersUpdated: "Users updated",
            copyToDepartment: "Also add to department",
            userAlreadyInDepartment: "User is already in this department",
            removeUserFromDepartmentConfirm: "Are you sure you want to remove this user from the department?",
            bulkUpdateProgress: "Bulk update progress",
            usersUpdated: "updated",
            collapseAll: "Collapse All",
            expandAll: "Expand All",
            allDepartments: "All Departments",
            moveToAllDepartments: "Move to All Departments",
            copyToAllDepartments: "Also Add to All Departments",
            noLanguage: "No Language Specified",
            group2: "Group",
            groupedByStatus: "Grouped by Status",
            grouping: "Grouping",
            activeSubjects: "Active Subjects",
            passiveSubjects: "Passive Subjects",
            groupSubjects: "Group Subjects",
            showAll: "Show All",
            onlyActive: "Only Active",
            onlyPassive: "Only Passive Ones",
            selectTimezone: "Select time zone",
            userFilter: "User Filter",
            confidenceScore: "Confidence Score",
            chatbotLanguage: "Chatbot Language",
            botScenerio: "Bot Scenario",
            selectTemplate: "Select Template",
            importFromReadyTemplates: "Import from Ready Templates",
            classification: "Classification",
            addClassification: "Add Classification",
            expressionClassified: "Expression to be Classified",
            zohoModuleName: "Zoho Module Name",
            selectModule: "Select Module",
            standardFields: "Standard Fields",
            selectStandardField: "Select Standard Field",
            customFields: "Custom Fields",
            selectCustomFields: "Select Custom Field",
            aiFunction: "Artificial Intelligence Function",
            aiFunctionDesc: "Manage AI function to perform actions based on user input.",
            functionName: "Function Name",
            functionDesc: "Function Description",
            addParameter: "Add Parameter",
            chooseAiStory: "Choose an AI story",
            chatbotAiPromptDesc:
                "Artificial intelligence learns and determines how it should behave by being given instructions about a specific task or problem using the 'prompt' feature.",
            enterPrompt: "Enter Prompt.",
            aiParameterTunings: "AI Parameter Tunings",
            aiParameterTuningsDesc:
                "You can tune AI parameters to make the AI more responsive and accurate. These parameters are used to control the behavior of the AI and how it responds to user inputs.",
            temperature: "Temperature",
            temperatureDesc:
                "Which sampling temperature to use, between 0 and 2. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic.",
            topDesc:
                "As an alternative to sampling by temperature, so-called kernel sampling, the model considers the results of tokens with the top_p probability mass. So 0.1 means that only tokens with the top 10% probability mass are considered. We usually recommend changing this or the temperature, but not both.",
            toolChoices: "Tool Options",
            noneDesc: "None means that the model will not invoke any tool and will instead generate a message",
            autoDesc:
                "Automatic mode is the default value and means that the model can choose between generating a message or invoking one or more agents.",
            requiredDesc: "Required mode is that the model must call one or more agents before responding to the user",
            createArticles: "Create Article",
            createArticlesDesc: "Create articles to help your users find answers to their questions.",
            articlesTitle: "Article Title",
            articlesContent: "Article Content",
            createFaq: "Create a Frequently Asked Questions (FAQ)",
            createFaqDesc:
                "Create a new FAQ for your chatbot. This will help your chatbot answer the user's questions.",
            question: "Question",
            saveAndClose: "Save and Close",
            contentPreview: "Content preview",
            updateChannelDesc6: "Update Whatsapp business api channel",
            newWabaChannel: "New Whatsapp Business Channel",
            newWabaChannelDesc: "Create a new channel for Whatsapp business api",
            upgradePackageTitle: "Upgrade your package and avoid limits",
            upgradePackageDescription:
                "More features, more integrations, more agents! Take action now to better manage your team and bring your business to its maximum potential!",
            upgradePackage: "Upgrade",
            deleteSelected: "Delete selected files",
            newFolder: "New Folder",
            newFile: "New File",
            noFilesFound: "No files were found in this folder",
            uploadFile: "Upload File",
            enterFolderName: "Please enter folder name",
            folderName: "Folder Name",
            dropFileHere: "Drop files here",
            createFolder: "Create Folder",
            fileUploadingError: "An error occurred while uploading the file",
            fileUploadingSucs: "Folder created successfully",
            folderNameNotEmpty: "Folder name cannot be empty",
            deleteFolder: "Delete Folder",
            sureDeleteFolder: "Are you sure you want to delete this folder and all files in it?",
            deletionSucs: "Deletion successful",
            deleteFile: "Delete File",
            sureDeleteFile: "Are you sure you want to delete this file?",
            deletionError: "An error occurred during the deletion process",
            selectFile: "Select File",
            moreThanOneSelect: "You can select more than one file",
            selectAnFile: "Select a file",
            bulkSms: "Bulk SMS",
            sendBulkSmsCustomers: "Send bulk SMS to your customers",
            writeYourMessage: "Write Your Message Here.",
            sendSms: "Send SMS",
            sendSmsYourCustomers: "Send sms to your customers",
            manageChannelDetail: "Manage channel information",
            details: "Details",
            teamGramChannels: "TeamGram Channels",
            newTeamGramIntegration: "New TeamGram Integration",
            teamGramIntegration: "TeamGram Integration",
            notMoreThanOneTeamGramChannels: "You cannot create more than one TeamGram Channel",
            teamGramDetail: "TeamGram Detail",
            manageYourTeamGramIntegration: "Manage Your TeamGram Integration",
            trendyolChannels: "Trendyol Channels",
            trendyolStoreIntegration: "Trendyol Store Integration",
            trenyolStoreConnection: "Connect your Trendyol store.",
            deleteTrendyolIntegration: "Delete Trendyol Integration",
            sureDeleteTrendyolIntegration:
                "Are you sure you want to delete Trendyol integration? This action is irreversible.",
            trendyolStoreChannel: "Trendyol Store Channel",
            deleteTrendyolChannel: "Delete Trendyol Channel",
            channelUpdatedSucs: "Channel Updated Successfully.",
            failedUpdateChannel: "Failed to Update Channel.",
            trendyolStoreIntegrationDetail: "Trendyol Store Integration Detail",
            configureTrendyolStoreIntegrationDetail: "Configure Your Trendyol Store Integration",
            trenyolStoreProductQuestManage: "Trendyol Store - Product Inquiry Management",
            trendyolStoreDesc: "You can use the following settings to manage inquiries for Trendyol store products.",
            zohoCrmChannels: "Zoho CRM Channels",
            zohoPersonalChannel: "Zoho Personal Channels",
            connectZoho: "Connect to Zoho CRM",
            updateChannelDesc5: "Update Zoho CRM Channel",
            zohoCrmIntegration: "Zoho CRM Integration",
            sureDeleteZohoChannel: "Are you sure you want to delete the Zoho CRM channel?",
            createNotMoreThanOneZohoChannels: "You cannot create more than one Zoho Channel",
            removeZohoLink: "Remove Zoho Link",
            connectToZoho: "Connect to Zoho",
            chatClosed: "Chat closed",
            scoreChat: "Chat rated",
            createdTicket: "Ticket created",
            updatedTicket: "Ticket updated",
            newUserCreated: "New user created",
            updateUser: "User updated",
            deleteUsers: "User deleted",
            changeStatusRepresent: "The representative's status has been changed",
            incomingMessage: "Incoming message",
            outgoingMessage: "Outgoing message",
            createdNewTicket: "New ticket created",
            bitrix24Channels: "Bitrix24 Channels",
            sureDeleteBitrixChannel: "Are you sure you want to delete the Bitrix24 channel?",
            bitrix24Integrations: "Bitrix24 Integration",
            notCreateMoreThenOneChannel: "You cannot create more than one Ideasoft channel",
            connectToBitrix24: "Connect to Bitrix24",
            connectToBitrix24Api: "Connect to the Bitrix24 API",
            updateChannel: "Update channel",
            updateChannelDesc: "Update the Bitrix24 API channel",
            yourBitrix24Domain: "Your Bitrix24 domain name",
            bitrix24ConnectedSucs: "Bitrix24 successfully connected",
            failedToConnectBitrix24: "Failed to connect to Bitrix24",
            failedToCreateChannel: "Failed to create channel",
            holidayPlusChannels: "Holiday+ Channels",
            newHolidayPlusIntegration: "New Holiday+ Integration",
            holidayPlusIntegrations: "Holiday+ Integrations",
            notCreateMoreThanOneHolidayChannel: "You cannot create more than one Holiday+ channel",
            holidayPlusDetail: "Holiday+ Details",
            manageHolidayPlusIntegration: "Manage your Holiday+ integration",
            ideasoftChannels: "Ideasoft Channels",
            connectToIdeasoft: "Connect to Ideasoft",
            connectToIdeasoftApi: "Connect to the Ideasoft API",
            updateChannelDesc2: "Update the WhatsApp Business API channel",
            ideasoftIntegration: "Ideasoft Integration",
            sureDeleteIdeasoftChannel: "Are you sure you want to delete the Ideasoft channel?",
            moreThanOneChannelError: "You cannot create more than one Ideasoft channel",
            websiteAddress: "Website address",
            ideasoftConnectedSucs: "Ideasoft successfully connected",
            failedToConnectIdeasoft: "Failed to connect to Ideasoft",
            redirectURLcopiedToClipboard: "Redirect URL copied to clipboard",
            openAIChannels: "OpenAI Channels",
            newOpenAiChannel: "New OpenAI Channel",
            createNewChannelOpenAi: "Create a new channel for OpenAI",
            updateChannelDesc3: "Update WhatsApp Business API channel",
            openAiIntegration: "OpenAI Integration",
            sureDeleteOpenAiChannel: "Are you sure you want to delete the OpenAI channel?",
            createMoreThenOneOpenAiChannel: "You cannot create more than one OpenAI channel",
            postaCellChannels: "PostaCell Channels",
            newPostaCellChannel: "New PostaCell Channels",
            createNewPostaCellChannel: "Create a new channel for PostaCell sms provider",
            updateChannelDesc4: "Update Whatsapp business api channel",
            leads: "Leads",
            ensureFacebookAccount: "Make sure you have a Facebook account and page",
            ensureAdAccount: "Make sure you have an advertising account",
            page: "Page",
            leadCount: "Lead Count",
            showLeads: "Show Leads",
            syncLeeds: "Synchronize Leads",
            wpStartChat: "WhatsApp Chat Launcher",
            archivedIn: "Archived?",
            makeSelect: "Make Selection",
            newLead: "New Lead",
            initialContact: "First Contact",
            needsAssessment: "Needs Assessment",
            proposalSent: "Proposal Sent",
            proposalReview: "Proposal Review",
            negotiation: "Negotiation",
            decisionStage: "Decision Stage",
            closure: "Closure",
            followUp: "Follow-up",
            campaign: "Campaign",
            adSet: "Ad Set",
            ad: "Advertisement",
            inArchived: "Archived",
            deletedSelectedPerson: "Delete Selected People",
            sureDelSelectedPerson: "Are you sure you want to delete the selected people?",
            deletePerson: "Delete Person",
            sureDeletePerson: "Are you sure you want to delete this person?",
            phoneNumberNotAvailable: "Phone number not available",
            statusSucsUpdated: "Status updated successfully",
            statusUpdatedFailed: "An error occurred while updating status",
            archivedContact: "Archive contact",
            sureWantArchivePerson: "Are you sure you want to archive this person?",
            personArchived: "Person Archived",
            personArchivedHead: "Archiving operation failed",
            metaLeadChannels: "Meta Lead Channels",
            wpStartSpeech: "WhatsApp Chat Starter",
            pleaseSelectStartChat: "Please select the channel on which you want to start the chat:",
            phoneNumber: "Phone Number",
            phoneNumberDesc: "Country code with numbers only, no spaces",
            channelDesc: "Select the channel you want to start the chat on",
            pleaseSelectStartChatOn: "Please select the channel you want to start the chat on",
            notAuthorizedChannel: "You are not authorized to access this channel.",
            phoneNumberError: "Phone Number Error",
            chatStartError: "There was an error starting the chat. Please try again.",
            noRecordFailed: "No record found",
            metaLeadsChannel: "Meta Leads Channel",
            mlChannelDetails: "Meta Leads Channel Details",
            manageMlChannel: "Manage your Meta Leads",
            deleteMetaLeadsChannelInfo: "Are you sure you want to delete the Meta Leads channel?",
            contactPage: "Contact Page",
            addRouted: "Add Routed",
            otherEmailProviders: "Other Email Providers",
            visitorScreenNaming: "Visitor Screen Naming",
            enterCatalogTitle: "Enter Catalog Title...",
            passwordUpdate: "Update Password",
            showCenterScreen: "Show in the Center of the Screen",
            skipNow: "Skip Now",
            confirm: "Confirim",
            newTable: "New Table",
            actions: "Transactions",
            integrationsTrendyol: "Connect your Trendyol store and automatically respond to your customers' inquiries.",
            integrationsHoliday: "Integrate Holiday+ to provide hotels and rooms via chatbot!",
            integrationsTeamgram:
                "Transfer your customers from Supsis to Teamgram to streamline your customer management!",
            integrationsTicimax: "Send automated message to segmented ticimax members.",
            integrationsBitrix24: "Activate Bitrix24 API for enhanced chatbot experience to your ",
            integrationsIdeasoft: "Activate Ideasoft API for enhanced chatbot experience to your customers.",
            integrationsOpenAI:
                "Activate OpenAI Services - Chatbot AI Response - AI Assistant CoPilot - Chatbot AI Knowledge Base",
            integrationsSMSPostacell: "Activate sending SMS via PostaCELL SMS Provider.",
            integrationsMetaLeads:
                "Manage your Meta Leads via Supsis. Connect leads to Ticket or Chatbot or Live Support",
            integrationsZoho: "Integrate your business processes in Zoho CRM with Supsis.",
            integrationsYouTubeComments: "Manage YouTube comments from a single panel and engage with your customers.",
            integrationsGoogleBusinessReviews:
                "Manage Google Business reviews from a single panel and engage with your customers.",
            integrationsGooglePlayReviews:
                "Manage Google Play Store app reviews from a single panel and engage with your users.",
            integrationsAppStoreReviews: "Manage App Store app reviews from a single panel and engage with your users.",
            integrationsGoogleDrive: "Manage your Google Drive files within Supsis and share them in conversations.",
            integrationsPage: {
                compare: "Compare",
                dead: "Dead",
                whatsappV2Web: "WhatsApp V2 (Web)",
                whatsappV3QR: "WhatsApp V3 (QR Code)",
                whatsappBusinessAPI: "WhatsApp Business API",
                whatsappBusinessAPIv2: "WhatsApp Business API v2",
                instagram: "Instagram",
                instagramV2: "Instagram V2",
                instagramV2Desc: "Direct connection with Instagram Login. No Facebook account required.",
                messenger: "Messenger",
                linkedin: "LinkedIn",
                telegramQR: "Telegram (QR Code)",
                telegramBotFather: "Telegram (Bot Father)",
                youtubeComments: "YouTube Comments",
                googleBusinessReviews: "Google Business Reviews",
                googlePlayReviews: "Google Play Reviews",
                appStoreReviews: "App Store Reviews",
                googleDrive: "Google Drive",
                webTabs: "Web Tabs",
                webTabsDesc: "Open external apps inside Supsis by adding custom tabs to the sidebar menu",
                webApps: "Web Apps",
                webAppsDesc: "Upload and manage your own web applications",
                mail: "Mail",
                smsPostacell: "SMS - Postacell",
                zohoCRM: "Zoho CRM",
                teamgram: "Teamgram",
                ideasoft: "Ideasoft",
                ticimax: "Ticimax",
                ticimaxV2: "Ticimax-V2",
                ticimaxV2Desc: "Easily manage your Ticimax store and respond to customers in real time via Supsis.",
                tsoft: "T-SOFT",
                tsoftDesc: "Easily manage your T-SOFT store orders and shipping with SUPSIS AI.",
                ikas: "IKAS",
                ikasDesc: "Easily manage your Ikas store orders and shipping with SUPSIS AI.",
                cacheManager: "Cache Manager",
                cacheManagerDesc: "Cache management for data sharing between automation and chatbots",
                openai: "OpenAI",
                slack: "Slack",
                pushover: "Pushover",
                metaLeads: "Meta Leads",
                voice: "Voice",
                webphoneRedsantral: "Webphone (Red Central)",
                webphoneRedsantralDesc: "Web-based phone system integration",
                webphoneTelnyx: "Webphone (Telnyx)",
                webphoneTelnyxDesc: "Telnyx integration for global calling",
                webphoneNetgsm: "Webphone (NetGSM)",
                webphoneNetgsmDesc: "Web-based phone integration with NetGSM switchboard",
                aiVoiceAgent: "AI Voice Agent",
                aiVoiceAgentDesc:
                    "Manage your phones with AI voice assistant. You can also integrate voice assistant into your website.",
                artificialIntelligenceFallback: "Artificial Intelligence",
                openRouter: "OpenRouter",
                openRouterDesc: "Access all LLM models through a single API",
                openAIDesc: "GPT-4, GPT-4o and ChatGPT models",
                googleAIStudio: "Google AI Studio",
                googleAIStudioDesc: "Gemini models",
                anthropic: "Anthropic",
                anthropicDesc: "Claude 3.5 Sonnet and Claude models",
                mistral: "Mistral",
                mistralDesc: "Mistral Large and other models",
                microsoftAzure: "Microsoft Azure",
                microsoftAzureDesc: "Azure OpenAI services",
                amazonBedrock: "Amazon Bedrock",
                amazonBedrockDesc: "AWS LLM platform",
                cohere: "Cohere",
                cohereDesc: "Command R+ and NLP models",
                xai: "xAI",
                xaiDesc: "Grok models",
                deepInfra: "DeepInfra",
                deepInfraDesc: "LLM inference infrastructure",
                together: "Together",
                togetherDesc: "Open source LLM services",
                fireworks: "Fireworks",
                fireworksDesc: "Fast LLM inference",
                siliconFlow: "SiliconFlow",
                siliconFlowDesc: "AI model platform",
                parasail: "Parasail",
                parasailDesc: "LLM API service",
                nebius: "Nebius",
                nebiusDesc: "Cloud AI infrastructure",
                alibabaCloud: "Alibaba Cloud",
                alibabaCloudDesc: "Qwen models",
                xiaomi: "Xiaomi",
                xiaomiDesc: "MiLM models",
                sambaNova: "SambaNova",
                sambaNovaDesc: "AI hardware and software",
                moonshotAI: "Moonshot AI",
                moonshotAIDesc: "Kimi models",
                minimax: "Minimax",
                minimaxDesc: "Abab models",
                nvidia: "NVIDIA",
                nvidiaDesc: "NVIDIA NIM models",
                whatsappComparisonTitle: "WhatsApp Solutions Comparison",
            },
            forward: "Forward",
            trendyol: "Trendyol",
            packUpRequired: "Package Upgrade Required",
            upgradePack: "Upgrade Package",
            supsisMobilApp: "SUPSIS MOBİL APP",
            supsisMobilAppDesc: "IOS and Android App on the Market!",
            sendEmail: "Send Email",
            jumpToMessage: "Click to Jump to Message",
            doesntMatter: "Doesn't matter",
            designer: "Design",
            targetContacts: "Target Contacts",
            scheduler: "Scheduler",
            planAndTask: "Executions",
            insights: "Insights",
            createRole: "Create Role",
            addUserToRole: "Add user to role",
            moveToRole: "Move to role",
            noUsersInRole: "No users in this role",
            removeUserFromRole: "Remove user from role",
            removeUserFromRoleConfirm: " Are you sure you want to remove this user from the role?",
            selectNewRole: "Select new role",
            selectRole: "Select role",
            roleUsersUpdated: "Users updated",
            userNotFound: "User not found",
            unnamed: "Unnamed",
            createSubject: "Create Subject",
            createUser: "Create User",
            blockManuel: "Block Manuel",
            showHide: "Show/Hide",
            contactSearch: "Contact Search",
            favorites: "Favorites",
            downloadAllData: "Download All Data",
            downloadThePage: "Download The Page",
            choosePoints: "Choose Points",
            createdAt: "Created At",
            action: "Action",
            searchChannel: "Search Channel",
            activeChannels: "Active Channels",
            deleteChannels: "Deleted Channels",
            selectChannel: "Select Channel",
            channelFilter: "Channel Filter",
            noConversationDesc: "Here you can see active chats and chats assigned to you.",
            forMe: "For Me",
            unAssigned: "Unassigned",
            agentDetails: "Agent Details",
            contactProperties: "Contact Properties",
            goToProfile: "Go to Profile",
            addNote: "Add Note",
            noPreferredAgent: "No Preferred Agent Yet",
            toPrefer: "Prefer",
            inChat: "In Chat",
            watching: "Watching",
            chatsTitle: "Chats",
            dealyTimeMaxValueError: "Delay time can be a maximum of 15",
            dealyTimeTypeError: "Delay Time Value Must Be a Number",
            passedTimeHm: "{hour} Hours {min} Minutes",
            passedTimeMs: "{min} Minutes {sec} seconds",
            passedTimeSc: "{sec} Seconds",
            translateMessage: "Your message has been translated by artificial intelligence.",
            toneChanged: "Message tone changed to {tone}",
            aiResponseAdded: "AI Response Added to Message",
            messageLonger: "Message Made Longer",
            grammarFixed: "Grammar Fixed",
            aiTranslate: "Translation",
            other: "Other",
            yourLanguage: "Your language",
            contactLanguage: "Contact Language",
            myLanguage: "My language",
            forwardToChatbot: "Forward to Chatbot",
            friendly: "Friendly",
            confident: "Confident",
            straightForward: "Straightforward",
            casual: "Casual",
            professional: "Professional",
            longSentence: "Long Sentence",
            changeTone: "Change Tone",
            fixGrammar: "Fix Grammar",
            aiResponse: "AI Response",
            templateButtonNote:
                "To ban contact, be careful to use the following texts on the ban button. Regardless of uppercase or lowercase letters",
            templateButtonTags: "#Send Message# | #Unsubscribe# | #Ban# | #Block#",
            dashboard: "Dashboard",
            adminReports: "Admin Reports",
            calendarModule: "Calendar Module",
            taskModule: "Task Management Module",
            maxUrlButtonMessage: "You can add a maximum of 2 URL buttons.",
            noPreferredDepartment: "No Preferred Department",
            searchForDepartment: "Search for Department",
            departmentAssignedToTheVisitor: "Select the department you want to assign to the visitor.",
            assignPreferredDepartment: "Assign Preferred Department",
            smsChannel: "SMS Channel: ",
            whatsappv2Channel: "Whatsapp V2 Channel: ",
            whatsappv1Channel: "Whatsapp V1 Channel: ",
            wBChannel: "Whatsapp Business Channel: ",
            linkedinChannel: "Linkedin Channel: ",
            telegramChannel: "Telegram Channel: ",
            messengerChannel: "Messenger Channel: ",
            instagramChannel: "Instagram Channel: ",
            allPlatforms: "All Platforms",
            cbStartMessage: "Chatbot Start Message",
            cbStartMessageDesc:
                "The first message entered by the user is automatically processed by the chatbot and directed to the relevant address.",
            messengerUserProfile: "Messenger User Profile",
            instagramUserProfile: "Instagram User Profile",
            linkedinUserProfile: "Linkedin User Profile",
            telegramUserProfile: "Telegram User Profile",
            noEventFound: "No Event Found",
            visitorMails: "Visitor Mails",
            visitorActions: "Visitor Actions",
            notVerified: "Not Verified",
            visitorEvents: "Visitor Events",
            assignedTasks: "Assigned Tasks",
            mails: "Mails",
            prefferedAgents: "Preferred Agents",
            createEvent: "Create Event",
            blockManagement: "Block Management",
            deleteUser: "Delete User",
            blocked: "Blocked",
            profiles: "Profiles",
            similiarProfiles: "Similar Profiles Found",
            ReplyAsAPm: "Reply as Private and Close",
            replyAsAComment: "Reply Comment and Close",
            messengerAddDesc: "Click on the Connect button below & login to your Facebook account.",
            instaAddPrivacyCheckDesc: "I read and agree to {Privacy} and {Terms and Conditions}",
            instaAddDesc5: "Click on the Connect button below & login to your Facebook account.",
            instaAddDesc4: "Register as a Facebook Developer",
            instaAddDesc3: "Ensure that the <b>'Allow access to messages'</b> toggle is switched on",
            instaAddDesc2: "Ensure that your Instagram professional account is connected to your Facebook page",
            instaAddDesc1: "Ensure that your Instagram account is an Instagram professional (Business) account.",
            selectedDepartment: "Selected Department",
            departmentForwardEnable: "Department Forwarding Rule Enabled",
            departmentForwardRule: "Department Forwarding Rule",
            departmentForwardDesc: "Choose which department the chats coming to the channel will be directed to.",
            channelName: "Channel Name",
            forwardToLiveAgents: " 👉 Forward to Live Agents",
            manageIgChannel: "Manage Your Instagram Channel",
            igDetail: "Instagram Detail",
            manageVisibilityDesc: "Manage who can see this channel visibility",
            selectAnIgAccount: "Select an Instagram Account to connect to Supsis",
            connectToInsta: "Connect to Instagram",
            connectToMetaLeads: "Connect to Meta Leads",
            deleteInstaChannelInfo: "Are you sure you want to delete the Instagram channel?",
            instagramChannels: "Instagram Channels",
            suspendedDescription: "Your account has been suspended due to unpaid invoices",
            onlyChatbot: "Only Chatbot",
            onlyAgents: "Only Agents",
            checkboxWarning: "This field is required to be checked",
            sendingAllow: "Sending",
            receiving: "Receiving",
            platform: "Platform",
            banModalTitle: "Visitor Ban Modal",
            selectDepartmentDesc: "Select the departments you want to change the visibility of",
            selectAgentDesc: "Select the agents you want to change the visibility of",
            selectDepartment: "Select Department",
            selectAgent: "Select Agent",
            visibleDepartments: "Visible Departments",
            visibleAgents: "Visible Agents",
            visibilityInfoCont: "All agents and departments can see this channel",
            editDepartmentVisibility: "Edit Department Permissions",
            editAgentVisibility: "Edit Agent Permissions",
            typeSTToSearch: "Type something to search for users",
            exportToCSV: "Export to CSV",
            clear: "Clear",
            usedSessionCount: "Used Session Count",
            maxSessionCount: "Maximum Session Count",
            leftSessionCount: "Remaining Session Count",
            planManagement: "Plan Management",
            maxAutomationTask: "Maximum Automation Task",
            teamChat: "Team Chat",
            templateNameIsNotValid: "Template Name Is Not Valid",
            relatedAdvertisement: "Related Advertisement",
            whatsappNumber: "Whatsapp number",
            createTask: "Create Task",
            integrationsWhatsappV1:
                "A WhatsApp Plan is required for seamless communication between Supsis and WhatsApp.",
            integrationsWhatsappV2: "You can easily share chat information between Supsis and WhatsApp.",
            integrationsWhatsappBusiness:
                "You can quickly and conveniently transmit chat information between Supsis and WhatsApp.",
            selectDays: "Select Days",
            addTime: "Add Time",
            instagramContactList: "Instagram Contact List",
            archiveAllRated: "Retrieve all chats with any ratings.",
            allChannels: "All channels",
            comment: "Comment",
            news: "What's New",
            conversation: "Team Chat",
            speechTermination: "End chat",
            noSystemMessage: "There are no messages in the system yet!",
            supsisCustomerService: "Customer services provided by Supsis,",
            supsisClickExperience: "You can try the experience by clicking.",
            customerPage: "Go to Customer Page",
            buttonTitle: "Button title",
            buttonType: "Button type",
            buttonSendMessage: "Send Message",
            buttonGoToBlock: "Go to block",
            buttonOpenUrl: "Open URL",
            buttonPhoneCall: "Phone Call",
            buttonOpenMoment: "Open Moment",
            buttonCloseChat: "Close Chat",
            buttonTransferChat: "Transfer Chat",
            buttonCreateTicket: "Create Ticket",
            deleteVisitor: "Are you sure you want to delete user? This operation cannot be undone.",
            deleteThread: "Are you sure you want to delete all mails? This operation cannot be undone.",
            deleteMail: "Are you sure you want to delete mail? This operation cannot be undone.",
            userProfile: "Profile",
            addCalendarEvent: "Event +",
            you: "You",
            apiIntegration: "Developer",
            generateToken: "Generate Token",
            copyToken: "Copy Token",
            dndBlocked: "File sending settings turned off.",
            labels: "Labels",
            noData: "No Data",
            color: "Color",
            titleColor: "Title Color",
            secondTitleColor: "Second Title Color",
            tag_name_indicator: "Tag Name",
            sendMessage: "Send Message",
            removeFromG: "Remove from the group",
            delChannel: "Are you sure you want to delete this channel?",
            new_name: "New Name",
            set_group_info: "Edit group information",
            shortcut_desc_num: "Switch between active chats with numeric digits",
            copilot_desc_num: "Allows you to open Copilot on the Chat Screen",
            typing_w_chat: "typing...",
            edit_group_info: "Edit Group Information",
            notif_sound: "Turn on Notification Sounds",
            notif_mute: "Mute Notifications",
            leave: "Leave",
            group: "Group",
            updateTag: "Update Tag",
            ordered_desc: "Assigns chats to representatives in order.",
            random_desc: "Assigns chats to representatives randomly.",
            Rrobin_desc:
                "Assigns chats to representatives in a round-robin fashion. (Prioritizes least busy representatives)",
            RrobinRev_desc:
                "Assigns chats to representatives in a reverse round-robin fashion. (Prioritizes most busy representatives)",
            algo_desc: "Select the algorithm for automatic chat assignment",
            algorithm: "Algorithm",
            os_browser: "Operating System and Browser",
            addTag: "Add Tag",
            tags: "Tags",
            searchRepresentative: "Search Representative",
            voting: "Voting",
            chatWidget: "Supsis Chat Widget",
            webhooks: "Webhooks",
            selectHooks: "Select Web Hooks",
            planRequired: "{integratable} Plan Required",
            allIntegrations: "All Integrations",
            disableAgentSystemMessages: "Hide agent system messages",
            disableAgentSystemMessagesDesc: "Hide Agent System Messages.",
            disableAutoTranslate: "Auto Translate",
            disableAutoTranslateDesc:
                "It automatically translates messages from different languages. So you can communicate with your customers more easily.",
            shouldAddMethod:
                "You must fill in the Payment Method and Billing Address field!\n No money will be withdrawn from your account.\nAt the end of the month, an invoice will be created according to your usage amount.",
            approveSelection: "Approve Selection",
            trialDaysEndSelectPlan: "Confirm Plan Selection",
            trialDaysEndSelectPlanDesc: "Your trial version is over. You need to confirm by selecting the plan below.",
            infoAboutAnnouncement: "Brief information about the announcement",
            announcement: "Announcement",
            newAnnouncementForm: "New Announcement Form",
            newAnnouncement: "New Announcement",
            announcements: "Announcements",
            languageSelection: "Language Selection",
            announcementTitle: "Announcement Title",
            infinitePlay: "Play continuously",
            newTicketSound: "New Ticket",
            vtippyDepartmentNotification: "Notification settings for messages from department chat",
            vtippyGroupNotification: "Notification settings for messages from created groups",
            vtippyAnnouncemenNotification: "Notification settings for new announcements",
            hideBubbleOnMobile: "Hide on mobile",
            cardInfos: "Card Infos",
            vtippyHideBubbleOnMobile: "Chat Bubble is hidden from mobile users.",
            deleteSystemLanguage: "Delete {code} language from the system",
            assignedChat: "Assigned Chat",
            CHAT: "Chat",
            check: "Check Box",
            systemStatus: "System Status",
            chatAssignedToUser: "New chat assigned",
            inactiveThresholdTime: "Inactive Chat Time (minute)",
            tippyInactiveThresholdTime:
                "If no message is sent within the given time, the chat is considered inactive. Enter the value (minutes). Must be range in 1min - 120min.",
            inactiveTerminateTime: "Inactive Chat Terminate Duration (minute)",
            tippyInactiveTerminateTime:
                "Inactive chat  will be terminated if it does not switch to active mode within a certain time. Enter the value (minutes). Must be range in 1min - 120min.",
            removePendingMessage: "Cancel message sending",
            disconnected: "Disconnected",
            visitorWriteEmptyChatTippy: "Customer can write to chat before agent connects.",
            visitorWriteEmptyChat: "Client can write without agent connected.",
            visitorConnectionEventSystemMessageEnabled: "Visitor connection status system messages enable",
            visitorConnectionEventSystemMessageEnabledTippy: "Visitor left and Visitor comeback system messages enable",
            openBubble: "Open Bubble",
            showHeaderImage: "Show Company Logo and Name",
            askQuestion: "Ask a question",
            locationPermsNeeded: "Location permissions are needed to use this feature",
            useMyLocation: "Use my location",
            acceptingChat: "Accepting chats",
            notAcceptingChat: "Not Accepting chats",
            blockBy: "Banned By",
            languageRemovalQuestion: "You are about to delete {code} language from the system!",
            loggedOut: "Logged out",
            vtippyNewVisitorNotification: "Audible notification for every new visitor to your website",
            vtippySelectnotification: "You can choose notification sound.",
            vtippyVoiceLevel: "you can adjust the volume",
            vtippyStartVoice: "Listen",
            vtippyInfiniteNotification:
                "If you are not active in the new Chats panel, it will continue to play. You can edit active-passive by clicking.",
            vtippyTranslateButton: "Translates the selected language to other languages",
            vtippyTranslateClearButton: "Cleans content in other languages.",
            vtippyTicketNotification: "Notification settings for every new ticket you receive",
            vtippyNewChatNotification:
                "You can select sound notification for new chats coming to the system and adjust the volume.",
            vtippyNewConversationNotification:
                "You can choose sound notification and adjust volume for when new incoming chats are assigned to you.",
            vtippyNewMessageNotification:
                "You can select notifications for incoming messages to your chats and adjust the volume.",
            vtippyPrivateMessageNotification:
                "You can select a notification for the incoming message to the team talk.",
            hideInactiveAgents: "Hide Inactive Agents",
            hideMinorValues: "Hide Minor Values",
            hashHintMessage: "You can quickly enter hashtag shortcuts with {shortcut}",
            pmHintMessage: "Did you know that you can send a keyword private message?. eg pm: Hi",
            billingAddress: "Billing Address",
            addNewAddress: "Add New Address",
            adressTitle: "Address Title",
            address: "Address",
            shortcutHintMessage: "Did you know that you can send messages faster with shortcut messages?",
            switchBetweenConversations: "Did you know that you can quickly switch between chats with abc shortcuts? ",
            atNameHintMessage: "Did you know you can quickly enter the visitor name with {shortcut}?",
            dndHintMessage: "You can upload files with drag and drop.",
            pasteFile: "you can send files. {shortcut}",
            atEmailHintMessage: "Did you know you can quickly enter the visitor mail with {email} ?",
            pastePlainText: "Paste from clipboard as plain text, {shortcut}",
            pressAndTalk: "Press and talk",
            agentActivities: "Agent Activities",
            listStatuses: "Statuses",
            newHASHContent: "#Add Hash",
            hash: "Hash Tag",
            hashText: "Hash Text",
            exampleHash: "order-tracking",
            notValidHash: "Must not contain spaces.",
            websiteChatWidgetIntegration: "Website Chat Widget Integration",
            videoCallEnabledDesc: "Activate to enable the video call feature.",
            videoCallEnabled: "Video Call Feature",
            audioCallDesc: "Activate to enable voice search feature.",
            audioCallEnabled: "Voice Search Feature",
            assignPreferredAgent: "Assign Preferred Agent",
            representativeAssignedToTheVisitor: "Select the preferred agent you want to assign to the visitor.",
            agentFileSendEnabledDesc: "Enables the ability to send files to delegates",
            agentFileSendEnabled: "Representatives Can Submit Files",
            visitorFileSendEnabledDesc: "Allows you to turn the visitors file sending feature on or off",
            visitorFileSendEnabled: "Visitors Can Submit Files",
            visitorAutoLogin: "Visitor Auto Login",
            visitorAutoLoginDesc: "Auto start chat when visitor click on chat bubble",
            agentVoiceRecordEnabledDesc: "Enables agents to record audio",
            agentVoiceRecordEnabled: "Agents Can Record Audio",
            visitorVoiceRecordEnabledDesc: "Enables visitors to record audio",
            visitorVoiceRecordEnabled: "Visitors Can Record Audio",
            startVideoCall: "Video call",
            startAudioCall: "Voice Call",
            visitorGDPRDeleteEnabledDesc: "Allows you to toggle the ability to delete all visitors information",
            visitorGDPRDeleteEnabled: "Visitors can delete all their information",
            visitorLocationEnabled: "Visitors can share location",
            visitorLocationEnabledDesc: "Allows visitors to turn location sharing on or off",
            customerLocationEnabled: "Representatives can share location",
            customerAutoMergeEnabled: "Automatically merges the same individuals",
            customerAutoMergeEnabledDesc:
                "This feature performs automatic merging to effectively bring together data related to the same individuals. This ensures that users with similar profiles are represented more consistently and orderly in data sets.",
            chatAiCopilot: "Chat AI Copilot",
            chatAiCopilotDesc: "Automatically Respond to Your Customers' Questions Using Chat AI Copilot",
            customerLocationEnabledDesc: "Allows representatives to turn location sharing on or off",
            thoesNotOwners: "Keep non-owners in the queue",
            thoesNotOwnersDesc: "Enable this feature to keep people who do not own the chat in the queue.",
            hideContactInfo: "Hide contact information",
            hideContactInfoDesc:
                "When you enable this feature, your customers' phone numbers and emails will be hidden from agents.",
            triggerAlreadyExists: "Trigger already exists",
            ticketStatusForm: "Ticket Status Form",
            statusFormTitle: "Ticket Status Title",
            allStatus: "All Statuses",
            triggers: "Triggers",
            trigger: "Trigger",
            noTrigger: "You Haven't Added Any Triggers Yet",
            triggerSkipLoginForm: "Login Form",
            triggerSkipLoginFormTrue: "Show Login Form",
            triggerSkipLoginFormFalse: "Skip Login Form and Go Directly to the Message",
            noContent: "no content",
            toCreate: "To create",
            clickTheButton: "click the button",
            triggerContent:
                "Type the description you want to appear in the modal that opens. You only need to write in one language and the translation into other languages is done automatically.",
            triggerDrag: "You can adjust the message duration by dragging or clicking the bar.",
            triggerNewCondition: "You can add a new condition with the button.",
            triggerNoConditionDescription1:
                "You can create the conditions you want from the options. If you do not create any conditions for any trigger, the first trigger will be active.",
            triggerNoConditionDescription2:
                "Only one of the triggers with the same conditions appears on the Visitor page.",
            triggerShowAndHide: "You can show or hide triggers whenever you want.",
            countryLanguage: "Country/Language",
            addTrigger: "Add Trigger",
            yesPlease: "Yes, please!",
            noThanks: "No, thanks.",
            firstAnswer: "Question Dialogue Confirm Answer",
            secondAnswer: "Question Dialogue Dismiss Answer",
            noTitle: "No Tittle",
            sumChat_MediaFile: "Media and Documents",
            importantWarning: "IMPORTANT WARNING!",
            images: "Images",
            URLS: "Links",
            files: "Files",
            noCondition: "No Condition! You can add Conditions by clicking the plus icon.",
            showTriggers: "Click to Show Triggers",
            showThisTrigger: "Click to Show This Trigger",
            hideTriggers: "Click to Hide Triggers",
            hideThisTrigger: "Click to Hide This Trigger",
            updateTrigger: "Update Trigger",
            conditions: "Conditions",
            messageDurationPerRow: "Message Duration Per Row",
            updateCompleted: "Update Completed",
            CatalogUpdatedSuccessfully: "Catalog Updated Successfully",
            integrateSupsiswithIntegratable: "Pass chat information between Supsis and {integratable} with ease.",
            installationOK: "Installed",
            dayTime: "Hour",
            weekDay: "Day of Week",
            spendTimePage: "Spent Time on Page",
            spendTimeSite: "Spent Time on Site",
            pageUrl: "Page URL",
            pageTitle: "Page Title",
            equal: "Equal",
            not_equal: "Not Equal",
            less_than: "Less Than",
            greater_than: "Greater Than",
            less_than_or_equal: "Less Than or Equal",
            greater_than_or_equal: "Greater Than or Equal",
            visitorName: "Visitor Name",
            seconds10: "10 seconds",
            seconds30: "30 seconds",
            minute1: "1 minute",
            minutes5: "5 minutes",
            minutes10: "10 minutes",
            minutes30: "30 minutes",
            hour1: "1 hour",
            hours2: "2 hours",
            hours4: "4 hours",
            hours8: "8 hours",
            hours12: "12 hours",
            hours24: "24 hours",
            maxCondition: "Max Condition",
            doYouWishToDeleteTrigger: "Do You Wish To Delete Trigger",
            contains: "Contains",
            not_contains: "Does Not Contain",
            chatLanguage: "Chat Language",
            translating: "Translating",
            buyWhatsapp: "Purchase WhatsApp integration",
            liveSupportStartingWait: "Starting Live Support, Please Wait",
            noConnection: "No Connection!",
            integrations: "Integrations",
            refundInvoiceSure: "Are you sure you want to return the invoice?",
            invoiceMarkedAsPaidSuccess: "Invoice has marked as paid successfully",
            invoiceMarkedAsPaidError: "Error, Invoice has not marked paid",
            deleteConfirm: "Do you want to delete this {object}?",
            markPaidConfirm: "Are you sure mark as paid this invoice?",
            addLink: "Link",
            startChatDesc: "Start Chat",
            selectStep: "Select a step:",
            addGOTO: "Go to",
            sendFastLink: "Send Fast Link",
            or: "Or",
            allTags: "All Tags",
            showDetail: "Show Detail",
            hideDetail: "Hide Detail",
            weLlSendPhone: "We'll Send to Your Phone",
            weLlSendEmail: "We'll Send to Your e-Mail",
            linkSentToPhone: "Link sent as sms",
            offerlinkSendToPhone: "We will send you the download link of our application via SMS.",
            offerlinkSendToMail: "We will send you the download link of our application via e-mail.",
            theEmail: "My Registered Email",
            differentEmail: "Another Different Email",
            linkSentToMailBox: "Link was sent to your mail adress",
            errorOccurred: "Error occured !",
            clickStoreIcon: "You can access the mobile application by clicking the icon suitable for your phone.",
            meetWithSupsis: "Would you like to meet our SUPSIS mobile application?",
            downloadMobileApps: "Download Mobile App",
            getApps: "Get Apps",
            info: "Information",
            conversationHistory: "Chat History",
            events: "Calendar Events",
            reservations: "Reservations",
            planInfoHeader: "Plan Information",
            planInformation: "Your plan is {selectedPlan} ({detailMaxAgentCount} Agent) ({freeAgent} Free Agent)",
            creditAvailable: "Your Agent credit available in your plan: ",
            upDownGradePlan: "If you want to upgrade/downgrade your plan, please",
            click: "Click",
            autoStartChat: "Automatic Chat Start",
            bubbleColor: "Chat Bubble Color",
            openFolder: "Open Folder",
            preDefined: "Themes",
            customIcon: "Install from your computer",
            theme: "Theme",
            themeSettings: "Theme Settings",
            chatThemeSettings: "Chat Theme Settings",
            bubbleSettings: "Chat Bubble Settings",
            inputHeightOfBubble: "Bubble Size",
            inputPixelsOfChatBubble: "Click to Edit Distances of Chat Bubble to Edges",
            modalTitleIsMarginAsPixelInfo: "Distances of Chat Bubble to Edges : ",
            inputPxOfXaxis: "Horizontal Position",
            inputPxOfYaxis: "Vertical Position",
            inputPxOfMobileXaxis: "(Mobil) Horizontal Position",
            inputPxOfMobileYaxis: "(Mobil) Vertical Position",
            animations: "Animations",
            preferredAnimation: "Preferred Animation",
            selectAnAnimation: "Select an Animation",
            inputOfBubbleMessage: "Add content to large chat bubbles.\n{contentOfChatBubble}",
            showChatBubbleOnlyLoggedUserToolTip:
                "It is the Setting to Hide the Chat Bubble Based on Login Status.Showed to all visitors in case Off.",
            showChatBubbleOnlyLoggedUser: "Show Bubble to Only Logged in User. (ideasoft)",
            helloDoUNeedHelp: "Hi, Do you need help?",
            bubbleIcon: "Chat Bubble Image",
            overrideMargins: "Customize Margins",
            autoHideBubble: "Hide Chat Bubble",
            vtippyAutoHideBubble: "Hides chat bubble when agents are offline",
            hideBubble: "Disable Chat Bubble",
            vtippyHideBubble: "Disables the chat bubble.",
            overrideMobileMargin: "Customize Margins for Mobile",
            vtippyMobileMargin: "Customize Margins for Mobile",
            isFabsActive: "Show Floating Action Button",
            isAlwaysActive: "Menu is always open",
            isAlwaysActiveDesc: "Would you like the chat bubble menu to always remain open in the web view?",
            bubbleOpenableMenu: "Chat Bubble Dropdown",
            vtippyIsFabsActive: "Setting of Show / Hide Floating Action Button",
            vtippyIsFabsAsIcon: "It is the setting of whether the icons will appear in the drop-down menu.",
            isFabsAsIcon: "Show Menu Icons.",
            setMarginAsPixel: "Set as pixel",
            returnDefaultMargins: "Default Margin Settings",
            deleteSite: 'Do you want to Delete the site " {siteName} " ?',
            deleteThisSite: "Delete the site",
            assetOversizeWithExt: "File size must be less than 10mb and in png,jpg format.",
            closeChat: "End Messaging",
            ticket: "Ticket",
            formStep: "Form Step",
            menuStep: "Menu Step",
            contentStep: "Content Step",
            menuTitle: "Menu Title",
            messageContent: "Message Content",
            goToLive: "Transfer to Representative",
            prevStep: "Return to Previous Step",
            button: "Button",
            addImage: "Image",
            addText: "Text",
            stepTitle: "Step Title",
            addTicket: "Ticket",
            formDescription: "Question",
            addInput: "Question",
            addRandomText: "Random Text",
            calendarPassedTimeMinSec: "{min} minute {sec} second {name}",
            calendarPassedTimeSec: "{hour} hour {min} minute {sec} second {name}",
            updateUserName: "Update Username",
            forgotPassword: "Forgot Password",
            osrFromMessageSaved: "Offline message saved.",
            requiredField: "This field is required.",
            nightModeOn: "Night Mode On",
            catalogMenu: "Menu",
            catalogContent: "Content",
            all: "All",
            preferredLanguage: "Preferred Language",
            kmkAutoDepartmentBind: "KMK Auto Deparment Find",
            kmkAutoDepartmentBindDesc: "Search Seller on KMK Customer Sites and set to login page as a department",
            visitorEmailUpdated: "Visitor email  updated",
            visitorEmailIsNotValid: "Visitor email is not valid",
            visitorNameUpdated: "Visitor name updated",
            clickToEdit: "Click to edit",
            addEmail: "+ Add Email",
            addFullname: "+ Add Fullname",
            partner: "Ref?",
            isIntegrated: "Integration?",
            agentCount: "Agent Count",
            closePreviewColors: "Close Theme Preview",
            previewColors: "Open Theme Preview",
            videoCalls: "Video Calls",
            filterLost: "Lost Chats",
            vtipyCustomLogin:
                "You can customize the information that will be requested in the login form when your visitors connect to the system.",
            vtipyLoginlessChat: "Visitor login form will be hidden. Visitor can connect to chat directly. ",
            loginlessChat: "Visitor Login Form",
            imageUrl: "Image Url",
            replied: "Replied",
            solved: "Solved",
            openImage: "Open Image",
            writeFeedback: "You can write your feedback about Supsis here.",
            feedbackFailed: "An error occurred while sending feedback.",
            feedbackSuccessful: "Feedback submission successful.",
            sendFeedback: "Send Feedback",
            errorReport: "You can give us feedback about the problems you have about the SUPSIS.",
            sendErrorFeedBack: "Give us feedback on the issue you are experiencing.",
            successImgUpload: "Your image has been uploaded successfully.",
            successImgDelete: "Image successfully deleted.",
            errorImgUpload: "An error occurred while uploading your image.",
            errorImgDelete: "An error occurred while deleting the image",
            chatBotEndStatics: "Chatbot Chat Success Rate",
            videoCallDist: "Video Call Distribution",
            departmentInfo: "Department Info",
            infoAboutDepartment: "Give brief information about the department",
            deleteDepartmentQuestion: "Do you really want to delete this department?",
            departmentDeleted: "Department Deleted",
            departmentTitle: "Department Title",
            updateDepartmentForm: "Department Update Form",
            newDepartmentForm: "New Department Form",
            department: "Department",
            newDepartment: "New Department",
            departmentSaved: "Department Saved",
            sameDepartment: "There is a department with the same name",
            sameValue: "There is a value with the same name!",
            sameRole: "There is a role with the same name!",
            sameTag: "There is a tag with this name!",
            departments: "Departments",
            chatTimingSettings: "Chat Timing Settings",
            assetOversize: "The size of the file you want to send should not exceed 2mb.",
            assetOversizeMB: "The size of the file you want to send should not exceed {mb}MB.",
            messageDeleted: "This message is deleted",
            filterLostChat: "Filter Lost Chats",
            filterClosedByAgent: "Filter Closed By Agent",
            filterVideoCall: "Video Call Filter",
            notificationText: "Supsis need permission to ",
            notificationTitle: "Notifications Off",
            deniedText:
                "Your notifications are closed, you need to turn on your notifications so that you do not miss your customers.",
            deniedTitle: "Click to Open Your Notifications!",
            deniedHeader: "In order not to miss your customers, you need to turn on your notifications!",
            showNotificationGuide: "Click for details",
            howToEnableNotification: "How Can I Enable Notifications",
            notificationOK: "Ok",
            notificationUnderstood: "Understood!",
            notificationCancel: "Cancel",
            howToEnableNotificationInstruction1: "Click on the lock icon in the address bar of the browser",
            howToEnableNotificationInstruction2: "If 'Notifications' is disabled in the Permissions section, enable it",
            howToEnableNotificationInstruction3:
                'If "Notifications" does not appear in the Permissions section, click on "Site Settings"',
            howToEnableNotificationInstruction4:
                'Turn on the "Notifications" permission from the "Permissions" section of the site settings page',
            checkPaymentMethod: "Please check your payment method",
            pushNotificationEnabled: "Great, Push notification enabled",
            pushNotificationDenied: "You have denied the notification permission",
            suspendedMessage: "Your account has been suspended",
            enableNotification: "Enable Desktop Notifications.",
            languageSettings: "Selected Language",
            problemsSound:
                "If you have problems with notifications,You can click lock image from your browser search box (Shown in Picture) click 'Site Settings' and change 'Sound ' to Allow",
            betweenRepresentative: "There is a new message from a Representative",
            desktopNotifications: "Desktop Notifications",
            notificationEnabled: "Supsis desktop notifications is enabled.",
            newMessageAlert: "You have a new message.",
            notificationDisable: "You can disable notification from Representative settings",
            newConversationAlert: "You have a new visitor.",
            chatBot: "ChatBot",
            ticketResponse: "Representative's Response:",
            archived: "archive",
            chatbotChatCount: "CHATBOT",
            changeTitle: "Change Title",
            changeVisitorTitle: "Change Visitor Title",
            catalog: "Catalog Title",
            openTheCatalog: "Open Catalog",
            catalogNotOpen:
                "The catalog feature is disabled. You can turn on the catalog feature to support your customers with pre-prepared content.",
            showCatalogCategories: "Set whether catalog menu will show up on Chat bubble",
            showChatBot: "Set whether ChatBot will show up on Chat bubble",
            openCatalog: "Catalog Visibility",
            unreadMessages: "Unread Messages",
            personalFirstMsg: "Agent First Response Time Average (sec)",
            personalRating: "Staff Score Avg",
            soundSettings: "Notification Settings",
            newPrivateMessage: "Private Message",
            addNewGroup: "Create A New Group",
            teamChatTeam: "Team Messages",
            teamChatDm: "Dm Messages",
            teamChatDepartment: "Department Messages",
            teamChatGroup: "Group Messages",
            newMessage: "New Message",
            newConversation: "New Chat",
            newVisitor: "New Visitor",
            chatPosition: "Chat Position",
            bottomLeftCorner: "Bottom Left Corner",
            leftDocked: "Left Docked",
            bottomRightCorner: "Bottom Right Corner",
            rightDocked: "Right Docked",
            chatPositionSelect: "Choose Position",
            bottomLeft: "Bottom Left",
            left: "Left",
            cardNumber: "Card Number",
            cardType: "Card Type",
            skt: "ED",
            cvv: "CVV",
            saveCard: "Save Card",
            cardNameSurname: "Card Holder's Name and Surname",
            confidentialityAgreementCheck: "I Accept the Confidentiality Agreement",
            confidentialityAgreement: "Confidentiality Agreement",
            bottomRight: "Bottom Right",
            right: "Right",
            mailorname: "E-Mail or Name",
            fieldName: "Key Name",
            value: "Value",
            addSetting: "Add a Settings",
            globalSettings: "Global Settings",
            breaksByTime: "Break count by time",
            clPlaceholder: "Name that will appear on the customer form",
            target: "Load Test Address",
            duration: "Load Test Duration(sec)",
            arrivalCount: "Chat Count",
            bootMaxLife: "Chat Max Life Time(sec)",
            startLoadTest: "Start Load Test",
            noClusterInstanceFound: "There is no server",
            stopLoadTest: "Stop Load Test",
            integrationDesc: "Just add the one-line code below to your site.",
            integrationDemoCode: "Simple integration demo code",
            integrationWindow: "How Do I Integrate To My Site ?",
            notIntegrated: "Integration",
            help: "Help",
            notIntegratedDesc:
                "We noticed that you did not add the chat system to your site. When you integrate it into your site and start the first chat, you will complete the integration. Click for INTEGRATION SCRIPT",
            backToLogin: "Go Back To Login Screen",
            passwordlessLoginUnsuccessful: "Login is not successful.Url could be expired or used before",
            passwordlessLogin: "Login Without Password",
            loginWithEmail: "Login With Email",
            loginWithPassword: "Login With Password",
            enteringPasswordless: "Login Without Password...",
            toMainPath: "Redirect to Main Page",
            userRoleChanged: "Your permissions changed. You will be redirected to main page.",
            passwordChangeSuccess: "Your Password Changed Successfully  ",
            feedback: "Show Feedback",
            showFeedbackHistory: "Show messages that have been sent feedback",
            newSelfServiceSite: "New Self Service Site",
            subdomain: "Subdomain",
            rootUserEmail: "Email",
            rootUserName: "Name",
            newVersion: "New Version Available",
            closeLiveSupport: "Close Live Support",
            newVersionShort: "New Version",
            bannedWordRestrict: "Banned Word Blocking",
            ticketShow: "Allow Customers to Create Tickets",
            ticketShowDesc: "Enable the Ticket Creation Option in the Chat Menu",
            autoLoadIframe: "Live Traffic",
            autoLoadIframeDesc: "Auto Load Iframe , Pass All Visitor Traffic",
            bannedWordRestrictDesc:
                "When the Forbidden Word Blocking is turned on, representatives are prevented from typing the prohibited words defined in the system to the visitors.",
            agentDown: "Agent Down",
            delayChat: "Delayed Chat",
            tableSettingTippy: "You can change the information that will appear in the table.",
            tableSettings: "Table Settings",
            tableSettingsInfo:
                "You can change the information that will appear in the table. You can select 7 column at most",
            privateParametry: "Customized User Parameters",
            systemOperetor: "System Information",
            cityAndDistrict: "City/District",
            general: "General",
            availability: "Availability",
            home: "Home",
            successful: "Succesfull",
            forgetPasswordSent: "Reset password link email was sent , check your inbox",
            saturday: "Saturday",
            friday: "Friday",
            thursday: "Thursday",
            wednesday: "Wednesday",
            tuesday: "Tuesday",
            monday: "Monday",
            sunday: "Sunday",
            download: "Download File",
            calendarPassedTimeHour: "{name} for {hour} hour",
            calendarPassedTime: "{name} for {hour} hour {min} min",
            calendarPassedTimeMin: "{name} for {value} min",
            workScheduleOneDay: "{name}'s working schedule on {sDate}",
            workSchedule: "{name}'s working schedule between {sDate} - {eDate}",
            calendar: "Calendar",
            noRating: "There is no Rating to Show",
            rateDist: "Distribution of  Rates",
            distConversation: "Chat distribution by representatives",
            distributionConversa: "Scoring Distribution",
            distChatbotAgent: "Communication channels",
            distAgent: "Chatbot & Agent",
            distFugitive: "Missed Chat & Received Chat",
            distLive: "Live chat",
            distChatbot: "Chatbot",
            distComplex: "Chatbot + Live chat",
            distHandled: "Answered Chat",
            distMissed: "missed Chat",
            distWeb: "WebSite",
            distWhatsapp: "Whatsapp",
            distTelegram: "Telegram",
            distInstagram: "Instagram",
            totalWhatsappChatCount: "Whatsapp Chat Count",
            statsByTime: "Number of Chat by Time",
            selectRep: "Select a representative",
            allRepresentatives: "All Representatives",
            avgRating: "Rating Score({point}) ({count} Rating) ",
            avgFirstMessageTime: "Average Response Time",
            totalBreakTime: "System Break Time",
            totalBreakNum: "Break Count",
            averageConTime: "Average Chat Time",
            multiWpReportTitle: "Number of Multiple WhatsApp Chats",
            multiWpReport: "Multiple Whatsapp Chat Distribution",
            multiWpReportExplanation: "You Can See the Chat Amount of Your  Whatsapp Channels.",
            longestConTime: "Longest Chat Time",
            shortestConTime: "Shortest Chat Time",
            refresh: "Refresh",
            waitingReply: "Pending Messages",
            organizationName: "Organization Name",
            companySlogan: "Company Slogan",
            messageSentErr: "Message not send, Try again.",
            messageSent: "Message Sent.",
            openPrivateChat: "Open Representative Chat {shortcut}",
            escKey: "Hides active chat {shortcut}",
            archiveChatKey: "Allows you to join the chat at the bottom of the Archive Page.",
            chatCopilot: "Turns on Chat CoPilot {shortcut}",
            privateChat: "Inter-Agents Chat Panel",
            multiModeAlertDesc: 'SUPSIS is open in another window. Click "Use Here" to use SUPSIS in this window.',
            useHereText: "Use Here",
            brandVisibility: "SUPSIS brand label show up on chat bubble",
            focusInput: "Focus cursor active chat's input field {shortcut} ",
            send: "Send",
            notYet: "Not yet",
            sending: "Sending",
            onlyRepresentative: "Your message can seen only by representatives",
            yourMessage: "Your message",
            liveFabListDescription: "Live Support",
            messengerIntegrationDesc:
                "Chat with your customers via Facebook page, send automated messages with chatbot.",
            checkDepartmentToAgent: "Department where the online representative will be checked",
            ifAllOfflineStory: "Story to redirect if there is no online representative.",
            AssignMessagesToAgents: "Handle chats via live agents",
            firstChatbotAndAssign: "Handle chats via chatbots",
            hybridAssign:
                "If exists any live agent than on selected department  then handle  with live agents otherwise handle with chatbot.",
            ticketFabListDescription: "Ticket",
            whatsappFabListDescription: "Whatsapp",
            phoneFabListDescription: "Phone",
            emailFabListDescription: "E-mail",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "Type your {channelLink} channel link in this field.",
            typeYourAccountLink: "Type your {accountLink} account link in this field.",
            typeYourMessage: "Type your message here",
            typeYourMessageMail:
                "The message entered in this field will be sent by the Customer to the above mail address as the first message.",
            typeYourMessageDesc:
                "The message entered in this field will be sent by the Customer to the above phone number as the first message.",
            sendNumber: "Telephone number to send the message to: {path}",
            callNumber: "Phone number for your customer to call: {phoneNumber}",
            numberIsNotCorrect: "Missing number entered!!",
            emailIsNotCorrect: "E-mail Is Not Correct !",
            selectFab: "Select a Fab",
            notValid: "You can only enter letters. (Single character).e,d,f,z,a,x,c,v,w,t,n letters are invalid",
            forMacUsers: " Mac users can use  Control(⌃) shortcut",
            basePriceValue: "Base Price",
            basePriceDiscount: "Discount",
            basePriceCurrency: "Currency",
            customerDBEnabled: "Database Selection: Use Customer Database Server",
            customerDBDisabled: "Database Selection:  Use Supsis Database Server",
            mongoConnectionString: "Mongo Connection",
            whatsappBasePriceValue: "Whatsapp Base Price",
            whatsappPlusBasePriceValue: "Whatsapp Plus Base Price",
            instagramBasePriceValue: "Instagram Base Price",
            instagramPlusBasePriceValue: "Instagram Plus Base Price",
            clientAddress: "Client Address",
            customerClientAddress: "Customer Client Address",
            apiAddress: "Api Address",
            socketAddress: "Socket Address",
            backendAddress: "backend Address",
            panelLogoUrl: "Panel Logo Url",
            panelCustomCssUrl: "Panel Custom Css Url",
            customerLogoUrl: "Customer Logo Url",
            customerCssUrl: "Customer Css Url",
            siteAlias: "Site Alias",
            language: "Language",
            features: "Features",
            interactionPopularity: "Popularity of interactions",
            interactionCount: "Number of Interaction",
            uniqueUserCount: "Number of Unique User",
            allUserPercentage: "(%) Percent of All User",
            represantativeSettings: "User Settings",
            documentTitle: "Supsis Document Form",
            supsisDocument: "Supsis Document",
            ApiDoc: "API Documentation",
            chatBalloonTehemeSettings: "Chat Balloon & Theme Settings",
            customLoginFormSettingsTitle: "Customize Visitor Login Form",
            addNewField: "Add New Field",
            editField: "Edit Field",
            typeHere: "Type the content here!",
            pco: "Cap. Uti. Rate",
            perPage: "/page",
            perPageInFilter: "Piece",
            noUserInfoFound: "No User Information Found",
            startFilter: "Start filter",
            showMyChats: "Show My Chats",
            showOnlineAgents: "Show Only Online Agents",
            showWaitingChats: "Show Waiting Chats",
            addNewStatus: "Add Status",
            newTitleContent: "New Title",
            newCTRLContent: "New CTRL Content",
            newALTContent: "New ALT Content",
            newTABContent: "New TAB Content",
            roleName: "Role Name",
            error: "Error",
            contentTitle: "Content Title",
            contentType: "Content Type",
            cannotMoveFullParent: "Cannot move this item",
            newSiteForm: "New Site Register Form",
            updateSiteForm: "Site Update Form",
            newBannedWordForm: "New Banned Word Register Form",
            updateBannedWordForm: "Banned Word Update Form",
            newWelcomeMessageForm: "New Welcome Message Register Form",
            updateWelcomeMessageForm: "System Message Update Form",
            newDefaultContentForm: "New Default Content Register Form",
            updateDefaultContentForm: "Default Content Update Form",
            newSubjectForm: "New Subject Register Form",
            updateSubjectForm: "Subject Update Form",
            showChatColorMeaning: "Chat Colors",
            showIntro: "Show Intro",
            options: "Options",
            resetPassword: "Reset Password",
            audioLevel: "Volume of audio alert",
            privateChatNotificationSound: "Notification sound",
            continue: "Continue",
            newRoleForm: "New Role Register Form",
            updateRoleForm: "Role Update Form",
            newRolePlaceHolder: "Click to new role",
            newUserForm: "New User Register Form",
            updateUserForm: "User Update Form",
            changeOSRForm: "Change Offline Message",
            tooltipOSRForm: "You can change the offline message.",
            newOSRForm: "Offline Support Form",
            newOSRMessages: "Add Offline Message",
            updateOSRForm: "Offline Update Form",
            osrTitle: "Title",
            osrTitleDescription: "You can add offline support form title",
            osrContent: "Content",
            osrContentDescription: "You can add offline support form content",
            hello: "Hello",
            cantProceedPayment: "Cause of we couldn't proceed payment",
            and: "and",
            suspendedPlan: " features are suspended",
            payNow: "PAY NOW",
            KeepUsingFeatures: "For Keep Using Your Features",
            date: "Date",
            startDate: "Start Date",
            finish: "Finish",
            start: "Start",
            endDate: "End Date",
            representative: "Representatives",
            representative_: "Representative",
            star: "Star",
            filter: "FILTER",
            reset: "RESET",
            dailyChatList: "Daily Chat List",
            dailyChatDuration: "Daily Chat Duration",
            chatDuration: "Chat Duration",
            dailyChatGraph: "daily Chat Graph",
            ok: "OK",
            chatCount: "Chat Count",
            shortest: "Shortest",
            longest: "Longest",
            average: "Average",
            count: "Count",
            averagePoint: "Average Point",
            pointDist: "Point Distribution",
            point: "Point",
            filters: "Filters",
            totalCustomer: "Total Customer",
            avResponseTime: "Average Reponse Time",
            breakDuration: "Break Duration",
            breakCount: "Break Count",
            lastLoginPlatform: "Platform",
            active: "Active",
            passive: "Passive",
            userForm: "User Form",
            sender: "Sender",
            profile: "Profile",
            name: "Name",
            number: "Number",
            username: "User name",
            password: "Password",
            oldPassword: "Old Password",
            newPassword: "New Password",
            passwordAtLeast: "Password (at least {num} character)",
            passwordRepeat: "Repeat Password",
            changePassword: "Change Password",
            status: "Status",
            enableState: "Active?",
            douYouWishToDeleteUser: "Dou you wish to delete this user?",
            userDeleted: "User Deleted",
            userSaved: "User saved.",
            oldPasswordError: "The old password is incorrect, please check.",
            chooseAnOption: "Please select a notification sound.",
            userVolumeUpdated: "Volume settings updated.",
            addNewMenu: "Add New Menu",
            addNewContent: "Add New Content",
            pleaseTitleEnter: "Please title enter",
            like: "Like",
            disLike: "Dislike",
            users: "Users",
            visitor: "Visitors",
            allContacts: "All Contacts",
            allUsers: "All Representatives",
            allSites: "All Domains",
            newUser: "New User",
            noNewUser: "There is no user yet.",
            noNewAdminUser: "There is no admin user yet.",
            noRoleFound: "There is no role yet.",
            noBannedWordFound: "There is no banned word yet.",
            noWelcomeMessageFound: "There is no system message yet.",
            noSubjectFound: "There is no subject yet.",
            noVisitorFound: "There is no visitor.",
            noContactFound: "There is no contact.",
            sendResponse: "Write a Response",
            delete: "Delete",
            noLiveSupportFound: "There is no visitor connect to live support",
            noLiveSupportFoundWithDepartment: "There is no chat belonging to the department",
            duplicate: "Duplicate",
            makeDefault: "Make Default",
            checkMore: "Check More",
            useReadyTemplates: "Use Ready Templates",
            useAITemplates: "Use GPT-4 AI Ready Templates",
            noRePresentativeFound: "There is no representative",
            noBannedVisitorFound: "There is no banned visitor yet.",
            removeBanDescription: "Remove ban",
            editThisItem: "Update this item",
            removeThisItem: "Remove this item",
            role: "Role",
            autoChatAssignLimit: "Auto Chat Assign Limit",
            chatAssignInfo: "-1 = System Default, 0 = No Assign, >0 = Assign as given value.",
            relatedDepartments: "Related Departments",
            subjectInfo: "If there is no selected subject, all subjects are allowed.",
            archive: "Archive",
            offlineSupportRequests: "Offline Supports",
            first: "First",
            last: "Last",
            query: "Search",
            clean: "Clean",
            loading: "Loading",
            loadMore: "Load More",
            noMessage: "Is not any message",
            selectChat: "Pick a Chat",
            noMessageInChat: "There is no message in this chat",
            noMediaToShow: "No Media to Show",
            userInfo: "User Info",
            firstSeen: "First Seen",
            chatId: "Chat ID",
            visitorId: "Visitor ID",
            visitingPage: "Visiting Page",
            osAndBrowser: "Operating System & Browser",
            customerClientVersion: "Customer Client Version",
            visitorFeedback: "Visitor Feedback",
            notes: "Notes",
            nameSurname: "Name & Surname",
            chats: "Chats",
            bannedVisitors: "Banned Visitors",
            country: "Country",
            city: "City",
            cityDistrict: "City District",
            browser: "Browser",
            os: "Operating System",
            ipAddress: "IP Address",
            connectionDate: "Connection Date",
            transaction: "Transaction",
            banRemoved: "Ban Removed.",
            bannedWords: "Banned Words",
            newBannedWord: "New Banned Word",
            noBannedWord: "No banned word yet.",
            bannedWordForm: "Banned Work Form",
            word: "Word",
            bannedWordAndWordGroup: "Banned word / work group",
            doYouWishToDeleteBannedWord: "Dou you really wish to delete this banned word?",
            doYouWishToOfflineSupportRequest: "Dou you really wish to delete this message?",
            bannedWordSaved: "Banned word saved",
            deletedSuccessfully: "Deleted Successfully",
            deleteErrorMsg: "Error: It's not deleted, try again",
            socketError: "Socket connection error. Please refresh page and try again.",
            socketConnecting: "Connecting to server",
            offlineModeDescription: "System down, customers will not be able to access live support.",
            offlineModeSettingsDescription: "Check the Offline Mode feature in the settings menu.",
            offlineModeUser: "There must be at least one online representative in the system.",
            offlineModeMessage: "Offline Message",
            offlineMode: "Offline Mode",
            adminCannotConnectSocket: "Admin cannot connect to socket.",
            liveSupport: "Live Support",
            siteVisitors: "Site Visitors",
            visitors: "Visitors",
            mail: "Mails",
            thoseConnectedToLiveSupport: "Those who connected to live support",
            visitorHistory: "Visitor History",
            visitorHistoryDescription: "You can view and download visitor chat history.",
            privateMessage: "Private Message",
            addRepresentative: "Add Representative",
            forwardRepresentative: "Forward Representative",
            keyboardShortcuts: "Keyboard Shortcuts",
            chatColorMeanings: "Chat color meanings",
            connLostCheckInternet: "Connection lost, please check your internet connection.",
            wishToEndThisChat: "Dou you wish to end this chat?",
            defaultContents: "Templates",
            contents: "Contents",
            newDefaultContent: "New Default Content",
            shortcutChar: "Shortcut Character",
            pickOne: "Pick one",
            writeSomething: "Write a character (a-z|0-9)",
            letterSequence: "Letter Sequence",
            exampleText: "Example: soc -> soccer",
            anyChar: "Any character",
            shorcutKey: "Shortcut Key",
            content: "Content",
            shortcutName: "Shortcut Name",
            type: "Type",
            shortcut: "Shortcut",
            defaultContentForm: "Default Content Form",
            titleContentForm: "Ready Content Header",
            deleteContentQuestion: "Do you really wish delete this Default Content?",
            defaultContentDeleted: "Default Content deleted",
            defaultContentSaved: "Default Content saved.",
            contentMoved: "Content Moved.",
            yourEmail: "Email Address",
            yourName: "Your Name and Surname",
            login: "Login",
            lostPassword: "Forgot Password",
            multipleSession: "You are signed in elsewhere.",
            notAuthorizedToDisplayPage: "You are not authorized to see this page!",
            permissions: "Permissions",
            newPermission: "New Permission",
            permissionForm: "Permission Form",
            displayTitle: "Display Title",
            key: "Key",
            keyToUseInSystem: "Key value to use in the system",
            deletePermissionQuestion: "Do you really wish to delete this permission?",
            permissionDeleted: "Permission deleted.",
            permissionSaved: "Permission Saved.",
            newRole: "New Role",
            selectARole: "Select a Role",
            yes: "Yes",
            no: "No",
            fullAuth: "Full Authorization",
            roleDeleted: "Role deleted.",
            roleForm: "Role Form",
            roles: "Roles",
            settings: "Settings",
            selectTopic: "Select Department",
            autoCallTransfer: "Auto Call Transfer",
            customerTyping: "Customer typing",
            typing: "Typing",
            agentTyping: "Representative typing",
            disconnectTime: "Max Reconnection Time (sec)",
            tippyDissconnectTime: "When a chat inactive after how many seconds chat will end.",
            queueNumberVisibleFeature: "Show Queue Number to Visitor",
            privateChatEnabled: "Show The Chat Between Representatives",
            delayedTalkTime: "Delay Time (sec)",
            employeeAverageChatCount: "Average chat number for employee chat rate",
            customerDownTimeWhenRepExit: "Customer downtime when representative leaves (sn.)",
            autoAssignLimit: "Auto Assign Limit",
            wasted: "Chat Lost Time (sec)",
            settingFormWrong: "Form data is wrong, try again after check it",
            settingsSaved: "Settings saved.",
            settingsCannotSaved: "Settings Cannot Be Saved",
            noAuthorization: "No Authorization",
            warningBadInput: "It is recommended to enter a number between 0 and 70.",
            warning: "WARNING!",
            warningBadInputMarginY: "Warning About Vertical Margin Input ⚠️",
            warningBadInputMarginX: "Warning About Horizontal Margin Input ⚠️",
            warningBadInputBubbleSize: "Warning About Chat Bubble Input ⚠️",
            delayTime: "Delay Time (sec)",
            sites: "Sites",
            newSite: "New Site",
            noSiteYet: "There is no site yet.",
            siteAddress: "Site Address",
            turnBack: "Return Back",
            customerRepLimit: "Customer Representative Limit",
            siteSaved: "Site saved.",
            siteSaveError: "An error occured during creating site",
            subjects: "Subjects",
            newSubject: "New Subject",
            noSubject: "No subject yet.",
            subject: "Subject",
            subjectTitle: "Subject Title",
            infoAboutSubject: "Information about subject",
            deleteSubjectQuestion: "Do you really wish to delete this subject?",
            subjectDeleted: "Subject deleted.",
            subjectSaved: "Subject saved.",
            welcomeMessages: "System Messages",
            newWelcomeMessages: "New Welcome Message",
            noWelcomeMessage: "No System Message.",
            welcomeMessageContent: "System message content",
            makeChoice: "Make a choice...",
            welcomeMessage: "Welcome Message",
            repLoggedIn: "Representative logged in",
            loginMessage: "Log in message",
            message: "Message",
            deleteWelcomeMessageQuestion: "Do you really wish to delete this system message?",
            welcomeMessageDeleted: "System message deleted",
            welcomeMessageSaved: "System message saved.",
            welcomeMessageForm: "System Message Form",
            noRep: "There is no representative yet.",
            addChat: "Add Chat",
            forwardChat: "Forward Chat",
            ago: "ago",
            repName: "Representative Name",
            lastOnline: "Last Connection/Online time",
            lastStatusChange: "Last Status Change",
            activeChat: "Active Chat",
            userMaxCapacity: "Max Chat Capacity",
            noActiveChat: "No active chat",
            watch: "WATCH",
            join: "JOIN",
            open: "OPEN CHAT",
            directMessage: "PRIVATE MESSAGE",
            block: "BLOCK",
            transactions: "Transactions",
            informations: "Informations",
            visitStart: "Visit Start",
            fullName: "Fullname",
            waitChatTime: "Waiting/Chatting Time",
            blockUserConfirm: "Do you want to block this user?",
            messaging: "Messaging",
            hideChat: "Hide Chat",
            block_: "Block",
            privateMessage_: "Private Message",
            assignRep: "Assign Representative",
            joinChat: "Join Chat",
            forwardRep: "Forward",
            leaveChat: "Leave Chat",
            endChat: "End Chat",
            translatedTextDescription: "Amazon translated this message {from} -> {to}.",
            autoTranslate: "Auto Translate",
            translateThisMessage: "Translate this message",
            autoTranslateDetectedDesc:
                "Visitor language is {visitorLanguage}. Click Here to Activate Automatic Translation",
            on: "on",
            off: "off",
            prevChats: "Previous Chats",
            noShortCut: "No shortcut",
            leaveChartConfirm: "Dou you really wish to leave the chat?",
            endChatConfirm: "Dou you wish to end the chat?",
            endConversation: "End Chat",
            onlyOneRep: "You are the only representative in this chat!",
            chatList: "Chat List",
            chatBar: "Chat Bar",
            unreadTitle: "Unread",
            visitorLeftTitle: "Visitor Left",
            activeChatTitle: "Active Chat",
            autoAssignedTitle: "Auto Assigned Chat",
            watchModeTitle: "Watch Mode",
            lostChat: "Representative Connection Lost",
            chatWidthDelay: "Chat with Delay",
            repChatWidthDelay:
                "When there is no active representative in the system or all of our representatives full due to high traffic, chat background will be green  ",
            repLostConn: "If customer representative has lost connection, chat background will be pink.",
            unreadMsg: "If there are unread messages, the background will be light blue.",
            visitorLeftChat: "If the visitor left the chat, the background becomes dark gray.",
            activeChatMsg: "Background is green if chat is active",
            autoAssignMsg:
                "The background becomes mustard if assigned by automatic assignment and the chat is not looked further",
            watchModeMsg: "If turned on in playback mode, the background becomes red",
            online: "Online",
            beRightBack: "Away",
            away: "Away",
            busy: "Busy",
            offline: "Offline",
            logout: "Log out",
            forWindows: "For Windows",
            forMac: "For Mac",
            nextChatFromActive: "Switch from active to next chat {shortcut}",
            previousChatFromActive: "Switch from active to previous {shortcut}",
            hideActiveChat: "Hide active chat {shortcut}",
            closeActiveChat: "Close active chat {shortcut}",
            firsthiddenChat: "Join most waited customer's chat {shortcut}",
            firstChatWaiting: "Switch to waiting chat {shortcut}",
            previousOpenedChat: "Regardless of the order, skip to the previously opened chat {shortcut}",
            historyDetails: "History Details",
            chat: "Chat",
            chatNotFound: "Chat Not Found.",
            dataNotFound: "No Data Found.",
            visitorInfo: "Visitor Info",
            timeSpent: "TimeSpent",
            noActiveVisitors: "No active visitors",
            totalConnected: "Chat Count",
            missedChat: "Missed Chat Count",
            workTime: "Work Time",
            closedChatCount: "Closed Chat",
            activeConvo: "Active chat",
            notAnswered: "Not yet answered",
            delayedConvo: "Delayed",
            leavingRep: "Leaving representative",
            staffRate: "Staff Working Rate",
            select: "Dropdown Menu",
            fullname: "Full Name",
            text: "Text",
            numeric: "Number",
            phone: "Phone",
            optionsPlaceholder: "Option value",
            selectField: "Click if you want to add a dropdown menu",
            fullnameField: "Click if you want to add a full name field.",
            textField: "Click if you want to add a text field.",
            labelField: "Click if you want to add a description field.",
            numericField: "Click if you want to add a numeric field.",
            phoneField: "Click if you want to add a phone field.",
            departmentField: "Click if you want to add a department field.",
            emailField: "Click if you want to add a email field.",
            visible: "Visible",
            required: "Required",
            label: "Comment",
            customLoginAlert: "Your Login Form must contain least one  visible field.",
            atLeastOneLanguage: "You must feel at least one language",
            requiredFieldField: "This field is required",
            notRequiredField: "This field is not required",
            visibleField: "This field is visible",
            notVisibleField: "This field does not appear in the form.",
            connectServer: "You are connected to the server",
            disconnectServer: "You are not connected to the server",
            liveChatOff: "Live chat is off",
            visitorScreen: "Visitor Screen",
            viewOnTheSite: "View On The Page",
            viewOnTheSiteTippy: "Click Here To See How Your Changes Hold Up.",
            showHint: "Show Hint",
            dontShowHint: "Don't Show Hint",
            liveChatOn: "Live chat is on",
            nightModeOff: "Night mode off",
            doubleClickEdit: "Double click or press the edit button to edit.",
            deleteField: "Delete",
            arrow_upward: "Arrow Upward",
            arrow_downward: "Arrow Downward",
            newCatalogCategory: "New Catalog Category",
            childCreate: "Double click to create a new child",
            updateCatalogCategoryFrom: "Update Catalog Category Form",
            newCatalogCategoryFrom: "New Catalog Category Form",
            catalogCategoryMenu: "Add catalog category menu",
            catalogCategoryLeaf: "Add catalog category submenu",
            catalogCategoryName: "Catalog category name",
            newCatalogContentFrom: "New Catalog Content Form",
            catalogContentName: "Catalog content name",
            catalogCategorySaved: "Catalog category saved",
            catalogCategoryDeleted: "Catalog category deleted",
            catalogCategoryRate: "Content Rate",
            catalogContentFeature: "Catalog Content feature",
            vtipyAudioLevel: "Used to mute or unmute notification sounds.",
            vtipyOrganizationName: "You can change the organization name and update it.",
            vtipyBrandVisibility: "Supsis is the setting whether the tag can be displayed in the chat bubble.",
            vtipyBrandVisibilityForced: "Only ProPlan users can change!!",
            vtipyClientDefault: "You can change the agent page language here.",
            vtipyCustomerClientDefault: "You can change the language of the customer (Chat) page here.",
            vtipyVisitorPreferredLang: "The customer can select the spoken language on the (Chat) page.",
            vtipyCustomerClientLanguageDetect: "You can change the language of the customer (Chat) page here.",
            vtipySelectTopic: "Automatic assignments to existing representatives in the selected department occur.",
            vtipyAutoCallTransfer: "Automatically assigns waiting calls to available agents.",
            vtipyCustomerTyping:
                "It allows you to see what the customer wrote on the chat screen on the representative chat screen.",
            vtipyAgentTyping: "It give information when representative typing to customer in chat buble",
            vtipyQueueNumberVisibleFeature:
                "When representatives are busy, it shows customers who want to connect, in what order they are.",
            vtipyPrivateChatEnabled: "Shows the inter-agent chat panel.",
            vtipyDelayedTalkTime:
                'If no delegates are connected to the chat during this time, it will be labeled \\ "Delayed Chat \\',
            vtipyOfflineMode: "Allows you to put the system in offline mode.",
            vtipyAutoAssignLimit:
                "It determines how many customers (chat) will be assigned to the representative automatically.",
            vtipyCustomerDownTimeWhenRepExit: "Customer idle time when the representative exits (sec.)",
            tippyDisconnectTime: "The chat close time after disconnect the customer (sec).",
            changeSettings: "Change Global Settings",
            totalBg: "TOTAL CHATS",
            activeBg: "YOUR CHATS",
            watchBg: "WATCH",
            waitingBg: "QUEUE CHATS",
            lateBg: "MOST WAITING CHATS",
            freeBg: "FREE",
            maxCapacityBg: "MAX CAPACITY",
            addNewSettings: "Add a New Global Settings",
            darkMode: "Dark Mode",
            clientDefault: "Panel default language",
            customerClientDefault: "Customer client default language",
            customerClientLanguageDetect: "Customer Client Language Auto Detect",
            visitorPreferredLang: "Let the customer choose the spoken language",
            preferredThemeColor: "Preferred Theme Color For Client Chat Screen",
            detail: "Detail",
            supportUs: "Contact Us (Live Support)",
            contactUs: "Contact Us",
            langSetting: "Language Setting",
            changeLang: "Change Language",
            fontSizeSetting: "Screen Zoom Setting",
            changeLangDesc: "Changes application language to {code}",
            trLang: "Turkish",
            enLang: "English",
            fieldRequired: "{field} field is required",
            selectALanguage: "Select a Language",
            selectATheme: "Select a Theme",
            responseForm: "Response Form",
            clientRequestInfo: "Client Request Info",
            createdDate: "Created Date",
            descMessage: "Messages",
            new: "New",
            selectAllPermission: "Select All",
            catalogCategories: "Catalog",
            copiedClipboard: "Copied to clipboard",
            changeLogo: "Change Logo",
            changePhoto: "Change the Photo",
            addPhoto: "Add a Photo",
            seePhoto: "See The Photo",
            deletePhoto: "Delete the Photo",
            organizationLogo: "Organization Logo",
            changePlan: "Change Plan",
            close: "Close",
            vtipyUploadLogo:
                "By uploading your company logo from this area, you can use your own logo in customer emails and customer pages.",
            tagName: "Tag Name",
            tagDescription: "Label Description",
            tagColor: "Label Color",
            userInformations: "User Informations",
            incomingChat: "Incoming Chat",
            support: "Support",
            team: "Team",
            groups: "Groups",
            newConversationStarted: "New converstaion started",
            allHistoryLoaded: "All history loaded",
            chatCreator: "Chat Creator",
            enterGroupTitle: "Enter group title",
            requiredTitle: "Title cannot be empty",
            requiredChannel: "Channel name cannot be empty",
            next: "Next",
            selectPeople: "Select people",
            textLimitAlertMessage:
                "The character limit in WhatsApp is 19 characters and beyond this limit it will not be displayed. However, on the web, texts exceeding the 19-character limit are automatically moved to the next line and displayed.",
            placeholders: "Placeholders",
            dropdown: "Selectable",
            selectRepresentativeChatbot: "Select Representative/Chatbot",
            selectDomain: "Select Domain",
            aiClassificationTextMode: "Text Classification",
            aiClassificationImageMode: "Image Classification",
            aiClassificationImageUrlLabel: "Image to Classify (URL)",
            aiClassificationImageUrlPlaceholder: "Enter an image URL like https://...",
            deleteFiles: "Delete Files",
            sureDeleteMultipleFiles: "Are you sure you want to delete the selected files?",
            selectAll: "Select All",
            cancelSelection: "Cancel selection",
            accessControl: "Access Control",
            initalContact: "Initial Contact",
            needsAssessnment: "Needs Analysis",
            campagin: "Campaign",
            whatsappv3Channel: "Whatsapp V3 Channel: ",
            integrationsInstagram:
                "Manage your Instagram messages from a single panel, provide seamless customer communication on social media.",
            integrationsLinkedin:
                "Manage LinkedIn messages and comments, establish fast customer interaction with automated responses.",
            integrationsTelegram: "Manage your Telegram channel from a single platform, easily control all messages.",
            integrationsWebchat:
                "Increase conversion with 24/7 active chatbot, FAQ answers, and lead tracking on your website.",
            tokenCopied: "Access token copied.",
            saveSystemCardInfo: "Your card is saved to our system and paid automatically when the due date arrives.",
            announcementInfo: "Announcement Info",
            deleteAnnouncementQuestion: "Do you really want to delete this announcement?",
            announcementDeleted: "Announcement deleted",
            updateAnnouncementForm: "Announcement Update Form",
            announcementSaved: "Announcement saved.",
            newOsrMessageTitle: "Offline Message Title",
            startChat: "Start Chat",
            douYouWishToDeleteAnnouncement: "Do you really want to delete this announcement?",
            noNewAnnouncement: "No announcements yet.",
            messageTitle: "Title",
            Aufgabe: "Task",
            FromName: "Sender Name",
            ImportFromReadyTemplates: "Import from Ready Templates",
            anWarteschlange: "Queue",
            aprobado: "Approved",
            beginsWith: "Starts with",
            chatbotScenarioHasBeenCancelled: "Chatbot scenario has been cancelled",
            chatbotTickets: "Chatbot tickets",
            completado: "Completed",
            configureTrendyolStoreStoreIntegrationDetail: "Configure your Trendyol store integration",
            connectZohoZoho: "Connect to Zoho CRM",
            createMoreThanOneOpenAiChannel: "You cannot create more than one OpenAI channel",
            deleteModalModalFormDesc:
                "If you delete this form, all form data will be permanently deleted. Are you sure you want to continue?",
            deleteZohoLinkbulkSms: "Bulk SMS",
            deselectAll: "Deselect All",
            failToDeleteGroup: "Failed to delete group",
            failToDeleteGroups: "Failed to delete groups",
            failToFetchGroupContacts: "Failed to fetch group contacts",
            favorite: "Favorites",
            featureIsNotAvailable: "Feature is not available.",
            ifYouSendThisConversationToTheQue:
                "If you send this conversation to the queue, it will remove you from the chat and place the conversation in the queue. If automatic chat assignment is enabled, the conversation will be assigned to an appropriate agent and may be assigned back to you.",
            isOneOff: "One-off",
            manageYourYourTeamGramIntegration: "Manage your TeamGram integration",
            notAuthorisedChannel: "You are not authorized to access this channel.",
            notCreateMoreThanOneChannel: "You cannot create more than one Ideasoft channel",
            offlineTickets: "Offline tickets",
            removeZohoLinkbulkSms: "Send bulk SMS",
            saveAsAsEmailCustomerGroup: "Save as Email Customer Group",
            saveAsAsWhatsAppCustomerGroup: "Save as WhatsApp Customer Group",
            saving: "Saving...",
            sendBulkBulkSmsCustomers: "Send bulk SMS to your customers",
            supprimerZohoLinkbulkSms: "Bulk SMS",
            sureDeleteDeleteZohoChannel: "Are you sure you want to delete the Zoho CRM channel?",
            temperatura: "Temperature",
            ticketSettings: "Ticket Settings",
            trendyolStoreConnection: "Connect your Trendyol store",
            usageLimitExceeded: "Usage limit exceeded",
            utoForwardToOwnerForce: "Auto forward to owner (even with active chatbot)",
            visitorScreenLabel: "Visitor screen label",
        },
        telegram: {
            typeInTelegramToken: "Type In Telegram Token",
            token: "Token",
            telegram: "Telegram",
            telegramTokenTitle: "Telegram Supsis Integration",
            telegramAlertForm: "You can get telegram bot token from",
            telegramAlertTitle: "Do you really want to delete the token?",
            telegramAlertText: "The token will be lost permanently!",
        },
        wp: {
            sendingStatus: "In Sending",
            sent: "Sent",
            allErrors: "All Errors",
            inProcess: "In Process",
            sendingStatuses: "Sending Statuses",
            downloadCSV: "Download CSV",
            errorMessage: "Error Message",
            noNumbersAdded: "No Numbers Added",
            downloadDetails: "Download Details",
            broadcastFound: "{count} broadcast(s) found",
            resendForFailedNumbersTooltip: "Start Resend for Remaining Recipients",
            date: "Date",
            walletBalanceInsufficient: "Insufficient wallet balance.",
            broadcastCreatedSuccess: "Broadcast created successfully.",
            broadcastCreateFailed: "Broadcast could not be created.",
            resendTitlePrefix: "Resend ({count} recipients): ",
            duplicateTitlePrefix: "Duplicate: ",
            broadcastClonedSuccess: "Broadcast cloned successfully.",
            broadcastCloneFailed: "Broadcast could not be cloned.",
            broadcastCancelRequestSent: "Broadcast cancel request was sent. Please wait...",
            broadcastCancelledSuccess: "Broadcast was successfully cancelled.",
            downloadError: "An error occurred while downloading!",
            progressTooltipFormat: "{percent}% ({sent} sent/{total} contacts)",
            successRatioTooltipFormat:
                "Total Send Message = {total} \n Success Message = {success} \n Failed Message = {failed}",
            notAvailable: "N/A",
            fieldRequired: "{field} field is required.",
            defaultBroadcastMessageText: "Hello {{name}}, thank you for choosing us.",
            sendAgain: "Send Again",
            shippingDetails: "Shipping Details",
            importContactsFromFile: "Import Contacts From File",
            chatStarted: "Chat Started",
            chatNotStarted: "Chat Not Started",
            contactSelected: "contact selected",
            startChatWithAnyNo: "Start Chat with Any Number",
            toLittleChar: "Missing number !",
            typeInANumberDesc: "Type in number to starting chat with:",
            wpPlusAndLicenceRequired: "Whatsapp Plus Plan and Licence Required.",
            wpPlusAndLicenceRequiredDesc:
                "Before you can start chats with numbers that are not registered in your contacts, you must upgrade your whatsapp plan and get a license..",
            chatStartingWait: "Chat starting, Please wait",
            whatsapp: "Whatsapp",
            agreement: "Agreement",
            purchase: "Purchase",
            activating: "Whatsapp Service Activation",
            authenticating: "QR Code Authentication",
            ready: "Ready",
            enableFeature: "Enable Whatsapp Feature",
            readAndAgree: "I have read and agree",
            subscribe: "Subscribe",
            subscribed: "Subscribed",
            toEnableWpDescription: "To enable Whatsapp Features , click on the button below.",
            waitForWpActivationDescription:
                "Your whatsapp account service is activating. Please wait for a while. It takes about 10-30seconds.",
            greatWpActivatedDescription: "Great, Your whatsapp account service is activated!",
            unsubscribe: "Unsubscribe",
            planDetails: "Features",
            sendReceiveMessage: "Send & Receive Text Messages",
            sendReceiveImage: "Send & Receive Image Files",
            sendReceiveAudio: "Send & Receive Audio Files",
            sendReceiveGif: "Send & Receive GIF Files",
            startChat: "Start Chat on Supsis",
            supsisFunctionality: "Useful Supsis Chat Functionality",
            onePhoneMultiAgent: "One Phone and Multiple Agents",
            basicIntegration: "Basic Integration and Zero Configuration",
            activationTitle: "To activate whatsapp integration on supsis:",
            wpIntegrationInstruction1: "Open WhatsApp on your phone",
            wpIntegrationInstruction2: "Tap Menu or Setting. Click Linked Devices",
            wpIntegrationInstruction3: "Point your phone to this screen to capture the code",
            qrGeneratingWait: "QR Code Generating please wait...",
            pleaseContinueToWaitUntilCompleted:
                "After the QR Code is verified, it will automatically switch to the completed field. Please wait...",
            authenticatingWait: "Authenticating, please wait...",
            unsubscribeWpInetgration: "Unsubscribe Whatsapp Integration",
            unsubscribeIGIntegration: "Unsubscribe Instagram Integration",
            wpBack: "Back",
            terminatelWpInetgration: "When clicked the 'Unsubscribe' button, your whatsapp integration will terminate",
            cancelWpInetgration: "Do you want to cancel whatsapp integration?",
            terminatelIGIntegration: "When clicked the 'Unsubscribe' button, your instagram integration will terminate",
            cancelIGIntegration: "Do you want to cancel instagram integration?",
            startChatWp: "Start Chat",
            purchaseHeader: "Supsis-Whatsapp Integration Purchase",
            wpServices: "Whatsapp Service",
            wpServicesIntegrationCompleted: "Your whatsapp integration is completed. You can now use the service.",
            purchasePaymentDescription:
                "Whatsapp Feature billed month-to-month. Your whatsapp service will be activated after you accept subscription.",
            wpIntegrationFeatures: "Whatsapp Integration Features",
            saveChanges: "Save Changes",
            contactList: "Contact List",
            broadcast: {
                broadcast: "Broadcast",
                detail: "Broadcast Detail",
                customer: "Customer",
                phoneNumbers: "Contact Numbers",
                showMore: "Show More",
                groupName: "Group Name",
                messages: "Messages",
                status: "Status",
                usageCost: "Usage Cost",
                sendingTime: "Sending Time",
                progress: "Progress",
                groupDetail: "Group Detail",
                messagesPerContact: "Messages Per Contact",
                successRatio: "Success Ratio",
                showLess: "Show Less",
                message: "Message",
            },
            messages: "Messages",
            broadcastRequests: "Broadcast Requests",
            customerGroups: "Customer Groups",
            messageTemplates: "Message Templates",
            plans: "Plans",
            wpIntegrationRequired: "Whatsapp Integration Required",
            wpRequiredIntegrationDescription:
                "Sorry, the page you visited will be activated when integrate your whatsapp.",
            integrateWp: "Let's go, Integrate Whatsapp",
            active: "Active",
            archived: "Archived",
            createBroadcastMessage: "Create Broadcast Message",
            title: "Title",
            description: "Description",
            createdAt: "Created At",
            numbers: "Numbers",
            actions: "Actions",
            action: "Action",
            createCustomerGroup: "Create a custom customer group",
            search: "Search",
            name: "NAME",
            contacts: "Contacts",
            noContactFound: "No Contact Found",
            broadcastTitle: "Give a title your broadcast.",
            recipients: "Recipients",
            selectRecipients: "Select Recipients",
            writeYourMessage: "Write your message.",
            schedule: "Schedule",
            scheduleNowOrLater: "Schedule now or later",
            summary: "Summary",
            cancel: "Cancel",
            send: "Send",
            sending: "Sending",
            deleteCustomerGroup: "Are you sure delete this customer group? {name}",
            customerGroupDeleting: "Customer group deleting ...",
            customerGroupDeletingSuccess: "Customer group deleted successfully",
            customerGroupDeletingError: "Error while deleting customer group",
            wpPlusRequired: "Whatsapp Plus Plan Required.",
            broadcastMessageArchived: "Broadcast Message as archived",
            broadcastMessageNotArchived: "Broadcast Message is not archived",
            groupNameSearch: "Type Customer Group Name",
            groupNameDesc: "Customer group name identify your customer groups",
            save: "Save",
            number: "NUMBER",
            addColumn: "Add Column",
            addColumnDesc: "Add a column to table",
            addNewContact: "Add New Contact",
            addNewContactDesc: "Add a contact to table",
            importFile: "Import From File",
            importFileDesc: "Import contacts from excel or csv file",
            contactAdded: "Contact added",
            updateCustomerGroup: "Updating customer group...",
            updateCustomerGroupSuccess: "Customer group updated successfully",
            sendBroadcastMessage: "Send Broadcast Message",
            columnName: "Column Name",
            columnType: "Column Type",
            defaultValue: "Default Value",
            setDefaultValue: "Set the default value to exists  contacts",
            age: "Age",
            location: "Location",
            gender: "Gender",
            selectContactFile: "Select Contact File",
            selectContactCsvOrExcel: "Select a CSV or EXCEL file.",
            importConfiguration: "Import Configuration",
            customizeFile: "Customize your import configuration.",
            sendMessageTo: "Who do you want to send the message to?",
            allContact: "All Contact",
            messageTypes: "Message Types",
            whenSendMessage: "When do you want to send the message to?",
            instantlyRightNow: "Instantly Right Now",
            completed: "Completed",
            scheduleFuture: "Schedule for a future date",
            messageDesc: "Your message will be sent instantly to all the recipients",
            messageSendAt: "Your message will be sent to all the recipients at",
            estimatedPrice: "Estimated Price",
            estimatedTime: "Estimated Time",
            now: "Now",
            tenMinute: "10 Minute",
            cancelled: "Cancelled",
            failed: "Failed",
            running: "Running",
            queued: "Queued",
            scheduled: "Scheduled",
            noNumberAdded: "No Numbers Added",
            csvOrExcelFile: "CSV or Excel File",
            broadcastMessagesToContactFile: "Broadcast Messages to Contact List",
            broadcastMessageTemplates: "Broadcast Message Templates",
            messageFlow: "Message Flow",
            textMessageSupport: "Text Message Support",
            imageMessageSupport: "Image Message Support",
            spamPreventions: "Spam Preventions",
            includesAllBasicPlans: "Includes all in Basic Plan",
            chatbotIntegration: "Chatbot Integration",
            messageToNewNumbers: "Message to New Numbers",
            broadcastMessageToEveryone: "Broadcast Messages to Everyone",
            personalizedBroadcastMessage: "Personalized Broadcast Messages",
            customerGroupSegmentation: "Customer Group Segmentation",
            scheduleBroadcastMessage: "Schedule Broadcast Message",
            locationMessageSupport: "Location Message Support",
            advancedSpamPreventions: "Advanced Spam Preventions",
            whatsappPlans: "Whatsapp Plans",
            selectBestPlan: "Choose the plan that suits you",
            comingSoon: "Coming Soon...",
            selectFile: "Select a file",
            uploadFromComputer: "Upload from Computer",
            created: "Created",
            message: "Message",
            cancelIGIntgeration: "Do you want to cancel the Instagram integration?",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            placeholders: "Placeholders",
            trendyolQandA: "Trendyol Q&A",
            offlineTickets: "Offline Tickets",
            chatbotTickets: "Chatbot Tickets",
            ticketSettings: "Ticket Settings",
            instagramComments: "Instagram Comments",
            messengerComments: "Messenger Comments",
            trendyolComments: "Trendyol Comments",
            facebookComments: "Facebook Comments",
            ticketSelection: "Ticket Selected",
            bulkClose: "Bulk Close",
            igComment: "Instagram Comment",
            igMentioned: "Instagram Mentioned",
            incomingReqChatbot: "Incoming Requests with Chatbot",
            incomingReqWebForm: "Incoming Requests with Web Form",
            incomingReqAutomation: "Incoming Requests with Automation",
            thisPersonEmailAnswered: "This person wants to be answered by email",
            thisPersonWpAnswered: "This person is waiting for an answer via WhatsApp.",
            clickStartWpChat: "Click to start WhatsApp chat",
            requestProgress: "Request Progress",
            requestMessage: "Request Message",
            clickAddMailAddress: "Click to add mail address",
            sendReplyCloseTicket: "Send Reply and Close Ticket",
            closeTicket: "Close Ticket",
            selectEmailSender: "Select Email Sender",
            withEmailWillNotRecievice:
                "You will not be able to receive replies to the mail when sending with this mail address!",
            deleteCommentAndClose: "Delete comment and close",
            sendReplyAndClose: "Send Reply and Close",
            startChatWp: "Start WhatsApp Chat",
            sureWantToDeleteTicket: "Are you sure you want to delete a ticket?",
            bulkDeleteConfirmation: "Bulk Delete Confirmation",
            selectedTicketSucsDelete: "Selected tickets were deleted successfully.",
            thereErrorDeletingTicket: "An error occurred while deleting tickets.",
            deleteConfirm: "Confirm Deletion",
            sureDeleteTicket: "Are you sure you want to delete this ticket?",
            ticketSucsDelete: "Ticket deleted successfully.",
            represantiveSucsAppoint: "The agent has been successfully assigned.",
            ticketClosedSucs: "Ticket closed successfully.",
            ticketCloureFailed: "Ticket closure failed.",
            unprocessed: "Unprocessed",
            pleaseSelectValidStatus: "Please select a valid status.",
            ticketStatusBeenUpdatd: "Ticket Status has been updated.",
            doYouWantCloseTicket: "Do you want to close the ticket?",
            ticketWillMarkedClosed: "Ticket will be marked as closed and archived.",
            errorUpdatingTicketFailed: "An error occurred while updating ticket status.",
            igCommentDeleteIgPost: "Instagram comment has been deleted from your IG post.",
            igCommentHideChange: "Instagram comment hide status has been changed.",
            pleaseChooseRepresent: "Please select a representative.",
            selectedTicketSucsDelegated: "Selected tickets were delegated successfully.",
            errorOccuredDuringDelegation: "An error occurred during the delegation process.",
            bulkTicketClosing: "Bulk Ticket Closing",
            sureWantCloseTicket: "Are you sure you want to close the ticket?",
            selectedTicketSucsClosed: "The selected tickets were closed successfully.",
            thereErrorClosingTicket: "An error occurred while closing tickets.",
            changeFilterTicketPage: "Change the filters on the Tickets page.",
            nameOfFilter: "Name of the filter.",
            filterValue: "Filter value",
            deletesSelectedTickets: "Deletes selected tickets",
            idTicketBeDelete: "The IDs of the tickets to be deleted (selected ticket IDs or all listed ticket IDs).",
            assignsAgentSelectedTickets: "Assigns an agent to the selected tickets",
            idTicketBeAssigned: "The IDs of the tickets to be assigned (selected ticket IDs or all listed ticket IDs)",
            idAgentAssigned: "ID of the agent to be assigned",
            changesStatusSelectedTicket: "Changes the status of selected tickets",
            idTicketWhoseStatus:
                "The IDs of the tickets whose status will be changed (selected ticket IDs or all listed ticket IDs)",
            newStatus: "New Status",
            selectedTicketsSucsUpdated: "The status of the selected tickets was updated successfully.",
            errorWhileChangingStatus: "An error occurred while changing the status of tickets.",
            thisPageVoiceAssistant: "This page has a voice assistant.",
            hello: "Hello!",
            voiceAssistantContent:
                "Did you know that there is an <strong>AI Assistant</strong> to help you on this page?\n                You can try the following methods to use the assistant:",
            commandHoldingDownTheKey: "You can give a command by holding down the key combination and speaking.",
            topRightContent: "top right corner",
            clickOnTheIcon: "You can launch the assistant by clicking on the icon.",
            sampleVoiceCommands: "Sample Voice Commands:",
            showMyTickets: "Show my tickets",
            showMeZeynepsOpenTicket: "Show Zeynep's open tickets today.",
            deleteTicketsScreen: "Delete tickets on the screen",
            assignLastTicketAli: "Assign the last ticket to Ali.",
            changeStatusAllTicket: "Change the status of all tickets to done.",
            setStatusTicketsScreen: "Set the status of tickets on the screen to .......",
            assignUserTicketScreen: "Assign the tickets on the screen to the user .....",
            assignFirstTicket: "Assign the first ticket to me.",
            showIgTickets: "Show last month's Instagram tickets.",
            makeChoice: "Make selection",
            makeAssignment: "Make assignment",
            tickets: "Tickets",
            instagramTickets: "Instagram Tickets",
            facebookTickets: "Facebook Tickets",
            trendyolTickets: "Trendyol Tickets",
            automationTickets: "Automation Tickets",
            supsisFormTickets: "Supsis Form Tickets",
            columnSettings: "Column Settings",
            ticketField: "Ticket Field",
            contactPropertyFields: "Contact Property Fields",
            ticketFilterList: {
                archivedRequests: "Archived Requests",
                comingFromFacebook: "Coming from Facebook",
                comingFromInstagram: "Coming from Instagram",
                unassignedOpenRequests: "Unassigned Open Requests",
                openRequests: "Open Requests",
                requestsOpenedThisWeek: "Requests Opened This Week",
                specialList: "Special List",
                creationDate: "Creation Date",
                supsisFromTheForm: "Supsis From The Form",
                fromTrendyol: "From Trendyol",
                comesWithAutomation: "Comes With Automations",
                label: "Label",
                status: "Status",
                subject: "Subject",
                email: "Email",
                name: "Name",
                phone: "Phone",
                type: "Type",
                assignedUser: "Assigned User",
            },
            appointingRepresentative: "Appoint a representative",
            ticketTagFilter: "Ticket Filter Tag",
            ticketEmails: "Ticket Forwarding Email List",
            save: "Save",
            delete: "Delete",
            transactions: "Options",
            noEmailTicketNotifications: "There is no data",
            emailIsNotValid: "Email is not valid",
            emailNotificationDeleted: "Item deleted successfully",
            emailNotificationDeleteError: "An error occurred",
            tagFilterRequired: "Ticket Filter Tag Required, Use *(wildcard) tag for all tickets",
            emailsRequired: "Forwarding Emails must not be null",
            emailNotificationCreated: "Ticket Forwading Rule Created",
            emailNotificationCreateError: "An error occurred",
            ticketForwarding: "Ticket Email Forwarding",
            ticketTagFilterDesc:
                "It uses the ticket topics you used in the chatbot design to filter the tickets. You can write a different tag and press enter to add it. If you select the '*' tag it will select all tickets",
            ticketEmailsDesc:
                "Email list to which tickets will be forwarded. You can add the addresses of the representatives in the system by selecting them. You can also add non-system email/s.",
            ticketList: "Ticket Forwarding Rules",
            ticketTagFilterPlaceHolder: "Ticket filter, select '*' for all",
            ticketEmailsPlaceHolder: "Forwarding email list",
            assigntLastTicketAli: "Assign the last ticket to Ali.",
            assigntUserTicketScreen: "Assign the tickets on the screen to user ....",
            assigntFirstTicket: "Assign the first ticket to me.",
            ticketStatusBeenUpdated: "Ticket status has been updated.",
        },
        theme: {
            opacity: "Opacity",
            headerColor1: "Hader Section Color 1",
            headerColor1A: "Hader Section Opacity 1",
            headerColor2: "Header Section Color 2",
            headerColor2A: "Header Section Opacity 2",
            backgroundColor: "Background Color 1",
            backgroundColorA: "Background Opacity 1",
            backgroundColor2: "Background Color 2",
            backgroundColor2A: "Background Opacity 2",
            textColor: "Text Color",
            errorTheme: "Error Color",
            bubbleBackground: "Representative bubble color",
            bubbleVisitorBackground: "Customer bubble color",
            bubbleBackgroundA: "Representative bubble opacity",
            bubbleVisitorBackgroundA: "Customer bubble opacity",
            bubbleText: "Representative text color",
            bubbleVisitorText: "Customer text color",
            textFormColor: "Form color",
            selectCustom: "Select Custom Theme",
            headerColorSecond: "Header Top Color",
            headerColorFirst: "Title Bottom Color",
            backgroundColorFirst: "Background Top Color",
            formColor: "Form Text Color",
            buttonColor: "Button Color",
            backgroundColorSecond: "Background Bottom Color",
            chatBotButtonText: "Chatbot Font Color",
            chatBotButtonColor: "Chatbot Button Color",
            font: "Font",
        },
        billing: {
            paymentId: "Payment ID",
            billType: "Bill Type",
            invoiceId: "Invoice No",
            invoiceAmount: "Invoice Amount",
            invoiceDate: "Invoice Date",
            invoiceStatus: "Invoice Status",
            invalidBill: "Invalid Bill",
            invalidBillNotPossible: "This bill has not been created yet, so it cannot be marked as invalid.",
            myInvoices: "My Invoices",
            allInvoices: "All Invoices",
            manualInvoices: "Manual Invoices",
            endOfPeriodInvoices: "End of Period Invoices",
            purchaseInvoices: "Purchase Invoices",
            paidInvoices: "Paid Invoices",
            unpaidInvoices: "Unpaid Invoices",
            walletDeposit: "Wallet Deposit",
            updateBillingInfo: "Update Billing Information",
            notFoundSavedBillingAddress: "No saved billing address found",
            notFoundSavedCard: "No saved card found",
            cardInfoIsStoredSecurelyByIyzico: "Card information is securely stored by Iyzico",
            paymentMethodAndInvoiceAddress: "Payment Method & Invoice Address",
            unpaidInvoiceBannerMessage:
                "You have an unpaid invoice. Please pay your invoice to avoid service interruption.",
            unpaidInvoiceBannerMessageWithDate:
                "You have an unpaid invoice. If you do not pay before {date}, your account will be suspended.",
            clickToPay: "Go to payment page",
            packageDescriptions: {
                whatsapp: "Integrate your regular WhatsApp account to respond to customers across all channels.",
                whatsappBusiness:
                    "Integrate your WhatsApp Business account to respond to customers across all channels.",
                supsis: "With more representatives, you can respond to your customers faster and more efficiently.",
                chatbot: "Chatbot integration allows you to serve your customers 24/7.",
                instagram: "Integrate your Instagram account to respond to customers across all channels.",
                telegram: "Integrate your Telegram account to respond to customers across all channels.",
                custom: "Choose one of our custom plans to get tailored solutions for your business.",
                messenger: "Integrate your Messenger account to respond to customers across all channels.",
                trendyol: "Integrate your Trendyol account to quickly respond to customer inquiries.",
                metaLead: "Integrate your Meta Lead account to manage leads directly from the dashboard.",
                customerTables: "Create dynamic tables to manage customer information, orders, and more.",
                form: "Create forms to collect information from your customers and analyze the data.",
                automation: "Set up automations to streamline your processes and enhance your service.",
                mail: "Email integration allows you to send and receive emails from your customers.",
                tasks: "Create tasks to plan and manage your workflows.",
                artificialIntelligence: "AI integration helps you respond to customers faster and more efficiently.",
                webhook: "Integrate your applications with Supsis using webhooks.",
                default: "Explore our packages for more details.",
            },
            autoRenew: "Auto Renew",
            purchased: "Purchased",
            currentPlans: "My Plans",
            individual: "Individual",
            expirationDate: "EXP",
            yourNameSurname: "Your Name and Surname",
            editCardInformation: "Edit Card Information",
            billingContactInfo: "Billing contact information updated successfully.",
            defaultRootEmail: "Default: Basic email",
            invoiceEmailAddress: "Invoice Email Address",
            invoiceSettings: "Invoice Settings",
            popular: "Popular",
            selectedPlan: "Selected Plan",
            editPlan: "Edit Plan",
            removePlan: "Remove Plan",
            showPlan: "Show Plan",
            hiddenPlan: "Hide Plan",
            contactSales: "Contact Sales",
            showLess: "Show less",
            more: "More",
            selectTransactionType: "Transaction type",
            walletLogs: "Wallet Logs",
            addBalance: "Add Balance",
            availableBalance: "Available Balance",
            walletTransactions: "Wallet Transactions",
            autoReload: "Auto Reload",
            transactionTypes: "Transaction Types:",
            transactionTypesHint: "(Click for single selection, Ctrl+click for multiple selection)",
            importantInfo: "Important Information",
            walletImportantPoint1:
                "If payment cannot be received from your card, the system will automatically become inactive; you must activate it yourself.",
            walletImportantPoint2: "Only 1 reload per 10 minutes. Keep the target balance high for heavy usage.",
            walletImportantPoint3: "You can enable more notifications from Notification Settings.",
            walletImportantPoint3Before: "You can enable more notifications from ",
            walletImportantPoint3After: ".",
            walletImportantPoint4: 'You can view auto reloads in the "Wallet Transactions" tab.',
            walletImportantPoint5:
                "There is no limit on the number or amount of reloads; make sure you enter the correct settings.",
            autoBalanceReload: "Auto Balance Reload",
            autoBalanceReloadDesc:
                "Automatically loads balance when your wallet balance falls below the threshold you set.",
            autoReloadToggle: "Auto Reload",
            autoReloadToggleDesc: "You can enable/disable this feature",
            disabledDueToFailure: "Disabled due to failure",
            thresholdValue: "Threshold Value (TL)",
            thresholdValueDesc: "Auto reload is performed when balance falls below this value",
            reloadMode: "Reload Mode",
            reloadModeDesc: "What should happen when balance falls below the threshold?",
            addFixedAmount: "Add fixed amount",
            fixBalance: "Fix balance",
            modeAddDesc:
                "When balance falls below threshold, the specified amount is added. E.g.: Threshold 50 TL, Balance 30 TL → 200 TL added → Balance becomes 230 TL.",
            modeFixedDesc:
                "When balance falls below threshold, balance is topped up to the specified amount. E.g.: Threshold 50 TL, Balance 30 TL → 170 TL added → Balance becomes 200 TL.",
            amountToAdd: "Amount to Add (TL)",
            targetBalance: "Target Balance (TL)",
            amountToAddDesc: "This amount will be added when balance falls below threshold",
            targetBalanceDesc:
                "Balance will be topped up to this amount when it falls below threshold (must be greater than threshold)",
            panelNotifications: "Panel Notifications",
            panelNotificationsDesc: "In which cases do you want to receive notifications?",
            notifyOnRecharge: "Successful reload notification",
            notifyOnFailure: "Failure notification",
            notifyOnDisabled: "Disabled notification",
            emailNotifications: "Email Notifications",
            emailNotificationsDesc: "Who should receive email notifications (optional)",
            emailPlaceholder: "Enter email addresses (separate with comma)",
            emailHint: "If left empty, email will only be sent to site owner",
            lastTrigger: "Last Trigger:",
            neverTriggered: "Not triggered yet",
            failedAttempt: "Failed Attempt:",
            saveSettings: "Save Settings",
            tabAll: "All",
            tabAiUsage: "AI Usage",
            tabVoiceAgent: "Voice Agent",
            tabAutomation: "Automation",
            balanceAddedSuccess: "{price}TL balance has been added to your WhatsApp account",
            balanceAddFailed: "Could not add balance to your account.",
            autoRebalanceLoadError: "Could not load auto rebalance settings",
            thresholdMinError: "Threshold value must be 0 or greater",
            targetBalanceMinError: "Target balance must be greater than 0",
            targetBalanceThresholdError: "Target balance must be greater than threshold",
            autoRebalanceSaveSuccess: "Auto rebalance settings saved successfully",
            settingsSaveFailed: "Could not save settings",
            testFailed: "Test failed",
            creditCardRequiredForAutoReload: "You must add your credit card information first for auto reload",
            notificationSettings: "Notification Settings",
            appsumoPack: "Appsumo Package",
            updatePlan: "Update Plan",
            createPlan: "Create Plan",
            freePack: "Free Package",
            instantFee: "Instant Fee Will Be Charged",
            planSequence: "Plan Sequence",
            requiredCodes: "Number of Codes Required",
            subHeading: "Sub Heading",
            featureKey: "Feature Key",
            customerKey: "Customer Key",
            monthlyPrice: "Monthly Price",
            monthlyNonDiscounted: "Monthly Non-Discounted Price (Non-functional Display)",
            twoYearDiscount: "2 Year Discount",
            yearDisccount: "Annual Discount",
            sixMonthDiscount: "6 Month",
            threeMonthDiscount: "3 Month",
            features: "Properties",
            sessionCount: "Session Count",
            subType: "Subscription Type",
            skipTrialVersion: "Skip Trial Version",
            skipTrialVersionDesc:
                "You can skip the trial version and continue by selecting the appropriate package for your business. If you skip the trial version, this action cannot be undone.",
            skipStep: "Skip This Step",
            switchToPay: "Switch to Pay",
            forward: "Forward",
            pleaseFillInCard: "Please fill in the card information!",
            fillInTheBillingAddress: "Please fill in the billing address information!",
            cardNumberWrong: "Card Number is Wrong!",
            pleaseConfirmTheUser: "Please confirm the user agreement.",
            pleaseCheckYourCard: "Please check your card and information.",
            site: "Site",
            period: "Period",
            billStatus: "Bill Status",
            totalPrice: "Total Price + VAT",
            depotMoneyWallet: "Deposit to Wallet",
            threeMonthly: "3 Monthly",
            sixMonthly: "6 Monthly",
            twoYearly: "2 Years",
            forever: "Forever",
            extraPackage: "Extra Package",
            teamPackage: "Team Packages",
            adventPackage: "Advantageous Packages",
            cupponError: "The coupon code is incorrect or expired.",
            enterYourCard: "Please enter your Credit Card",
            invalidCard: "Invalid credit card, Payment Not Received",
            calculateThis: "Calculate for:",
            adventageousPackage: "Advantageous package discounts!",
            cupponApplied: "Coupon successfully applied",
            subStart: "Subscription Started",
            subSuccessStart: "Your subscription has started successfully.",
            success: "Successful",
            succesDesc: "Successfully created subscription.",
            successDesc: "Your feature has been successfully activated.",
            maxNumber: "Maximun number of representatives to speak",
            currentAmountDetails: "Dettagli dell'importo attuale",
            endOfMonthForecastDetails: "Dettagli della previsione di fine mese",
            totalAmount: "Total Amount",
            vatAmount: "VAT Amount (20%)",
            totalAmountIncludingVAT: "Total Amount Including VAT",
            hideDetails: "Hide Details",
            createInvoice: "Create Invoice",
            reimbursementMade: "Reimbursement Made",
            invalidInvoice: "Invalid Invoice",
            balanceTopUp: "WhatsApp Balance Deposit",
            paidSuccesfully: "The invoice was paid successfully.",
            paymentFailed: "The invoice payment process failed.",
            areYouSurePaid: "Are you sure you want to make this invoice marked as paid?",
            invoiceMarkedPaid: "The invoice has been marked as paid.",
            invoiceMarkedFailed: "An error occurred and the invoice could not be marked as paid.",
            areYouSoreRefundInvoice: "Are you sure you want to process a refund for this invoice?",
            copied: "Copied",
            copiedToClipboard: "Content copied to clipboard.",
            copyFailed: "Copy operation failed.",
            invoiceGenerated: "Invoice generated",
            invoiceNotGenerated: "Invoice not generated",
            notAvailable: "N/A",
            estimated: "Estimated",
            dueDate: "Due Date",
            markAsPaid: "Mark as Paid",
            refundPayment: "Process Refund",
            editInvoice: "Edit Invoice",
            deleteInvoice: "Delete Invoice",
            adminGroup: "Admin",
            billTypeNone: "None",
            billTypeManual: "Manual",
            billTypeMonthly3: "3 Monthly",
            billTypeMonthly6: "6 Monthly",
            billTypeAnnual: "Annual",
            billTypeAnnual2: "2 Yearly",
            billTypeEducation: "Education",
            billTypeConsultancy: "Consultancy",
            billTypeInstallation: "Installation",
            billTypeOther: "Other",
            paymentNotPossible: "Payment Not Possible",
            saveCardFirst: "Please save your credit card first to make a payment.",
            youMustFillInEmpty: "You must fill in all blank spaces.",
            createdNewInvoice: "New Invoice was created successfully.",
            createdNewInvoiceFailed: "An error occurred while creating the invoice.",
            invoiceUpdated: "The invoice amount was updated successfully...",
            invoiceUpdatedFailed: "There was a problem updating the invoice.",
            plans: "Plans",
            companyName: "Company Name",
            compony: "Company",
            person: "Person",
            invoiceAddressInfo: "Invoice Address Information",
            idNo: "Turkish ID",
            taxOffice: "Tax Office",
            taxNumber: "Tax Number",
            packageCanNotDownSupsis:
                "Your package cannot be downgraded. Please delete or deactivate several of your Agents to downgrade your package.",
            packageCanNotDownWp:
                "Your package cannot be downgraded. Please delete a few of your Whatsapp Channels to downgrade your package.",
            packageCanNotDownWPBussiness:
                "Your package cannot be downgraded. Please delete a few of your Whatsapp Business Channels to downgrade your package.",
            chooseYourPlan: "Choose Plan",
            numberOfRepresentatives: "Number of Representatives",
            numberOfChannels: "Number of Channels",
            wpNumberOfChannels: "Number of Whatsapp Channels",
            igNumberOfChannels: "Number of Instagram Channels",
            msNumberOfChannels: "Number of Messenger Channels",
            cancelIt: "Cancel it",
            activePlan: "Active Plan",
            activate: "Activate",
            noTransition: "No Transition",
            daysLater: "Days Latter",
            payBack: "Pay Back",
            paid: "Paid",
            unPaid: "Unpaid",
            editPrice: "Edit Price",
            payNow: "Pay Now",
            youAreCurrentlyOnTrial: "You are currently on trial. You can skip the trial now to see exclusive packages.",
            youAreCurrentlyLimited: "You are currently limited by the system because your packages are unconditional.",
            youHaveOneRepresentative: "You have one representative.",
            deactivateOrDeleteYourPiece: "Deactivate or delete your Piece Representative or buy a representative.",
            youHaveOneWhatsappQRChannel: "You have one Whatsapp QR channel.",
            deleteYourWhatsAppQR: "Delete your Whatsapp QR channel or buy a channel.",
            youHaveAWhatsappBusiness: "You have one Whatsapp Business channel.",
            deleteYourWhatsapp: "Delete your Whatsapp Business channel or buy a channel.",
            youHaveAnInstagram: "You have an Instagram channel.",
            deleteYourInstagram: "Delete your Instagram channel or buy a channel.",
            youHaveAMessenger: "You have one Messenger channel.",
            deleteYourMessenger: "Delete your Messenger channel or purchase a channel.",
            additionalPackages: "Additional Packages",
            availablePackages: "Available Packages",
            buyNow: "Buy Now",
            invoiceInformation: "Invoice Information",
            invoiceAddress: "Invoice Address",
            invoiceType: "Invoice Type",
            review: "Review",
            viewDetails: "View Details",
            addNewAddress: "Add New Address",
            enterYourBillingAddress: "Enter Your Billing Address",
            selectPlan: "Select Plan",
            paymentStatus: "Payment Status",
            amount: "Amount",
            invoiceID: "Invoice ID",
            expected: "Expected..",
            currentAmount: "Current Amount",
            monthlyEstimatedAmount: "Monthly Estimated Amount",
            creationDate: "Creation Date",
            invoicePeriod: "Invoice Period",
            newPaymentMethod: "New Payment Method",
            channelCount: "Channel Count",
            remainingTime: "Remaining Time",
            chatbotLimit: "Chatbot Limit",
            free: "Free",
            maxChatbotSession: "Maximum Chatbot Sessions",
            buyIt: "Buy It",
            renewalDate: "Renewal Date",
            monthly: "Monthly",
            yearly: "Yearly",
            packagePeriod: "Package Period",
            packageType: "Package Type",
            packageManagement: "Package Management",
            invoiceManagement: "Invoice Management",
            futureInvoice: "Future Invoice",
            pastInvoices: "Past Invoices",
            creditCard: "Credit card",
            invoice: "Invoice",
            mustBeUpgradePlanForChatBot: "To activate the ChatBot feature, you must switch to the Pro Plan!",
            incorrect: "Incorrect",
            cardInfo: "Card Info",
            billingDetails: "Billing Details",
            firstPreferredCard: "Set as Primary Card",
            primary: "Primary",
            addCardIyzico:
                "You do not have a registered card. In order to pay your monthly usage fees, you need to add a card. The payment system is provided by iyzico.",
            billingPlanSettings: "Billing & Invoice",
            startWith: "{cardFamily} card starts with {binNumber}",
            paymentMethod: "Payment Method",
            billingDate: "Billing Date",
            isPaid: "Is Paid?",
            billingHistory: "Invoice History",
            markPaid: "Mark as Paid",
            paymentDate: "Payment Date",
            pay: "Pay",
            newInvoice: "Create Invoice",
            updateBilling: "Update Billing Detail",
            updateCard: "Change Credit Card",
            paymentBilling: "Payment Method & Billing Details",
            price: "Price",
            billingAddress: "Billing Address",
            billingCity: "City",
            billingCountry: "Country",
            contactName: "Billing Contact Name",
            expireMonth: "Expire Month",
            expireYear: "Expire Year",
            expireDate: "Expire Date",
            cardNumber: "Card Number",
            cardHolderName: "Card Holder Name",
            cardAlias: "Card Alias",
            identityNumber: "Identity Number",
            name: "Name",
            surname: "Surname",
            email: "Email",
            addCard: "Add Card",
            update: "Update",
            cancel: "Cancel",
            save: "Save",
            saving: "Saving",
            noInvoiceFound: "There is no invoice",
            year: "Year",
            updating: "Updating...",
            newInvoiceForm: "New Invoice Create Form",
            error: "Error",
            transactions: "Options",
            paymentMethodAdded: "Payment method has successfully added",
            paymentMethodAddError: "Payment method has not added, An error occurred",
            creditCardChanged: "Credit card has successfully changed ",
            errorOccurred: "An error occurred , try again",
            billingDetailUpdated: "Billing detail has successfully updated",
            invoiceCreated: "Invoice has successfully created",
            paymentSuccess: "Payment successfully , thank you",
            paymentFail: "Payment fail, try again",
            billingAddressChanged: "Billing address has successfully changed ",
            hidePlan: "Hide Plan",
            informationShopping:
                "Your payment information, billing information, credit card information are controlled by Shopify.",
            trialTimeInformation:
                "Trial ends {dayCount} days after. If you do not enter a payment method until the expiry of this period, you will be automatically switched to the FREE PLAN by the system.",
            trialTimeInformationShort: "Trial: Last {dayCount} Day",
            currentPlanLabel: "Current Plan: {planName} ({agentCount} Agent)",
            changeCancelPlan: "Change/Cancel Plan",
            oneAgent: "Agent",
            agent: "Agent",
            yourCurrentPlan: "Current Plan",
            month: "Month",
            billedMonthToMonth: "(billed month-to-month)",
            selectAgentCount: "Select Agent Count",
            selectFreePlan: "Select Free Plan",
            planDetails: "Plan Details",
            multiAgent: "(Multi Agent)",
            selectProPlan: "Select Pro Plan",
            foreverFree: "Forever Free",
            websiteIntegration: "Website Integration",
            websiteIntegrationUnlimited: "Website Integration",
            ChatBotUnlimited: "ChatBot",
            videoCallUnlimited: "Video Call",
            multiAgentUpTo: "Multi Agent (up to {agentCount} Agent)",
            audioCallUnlimited: "Audio Call",
            screenSharingUnlimited: "Screen Sharing",
            fileTransferUnlimited: "File Transfer",
            autoChatAssignerUnlimited: "Auto Chat Assigner",
            multiLanguageTranslationUnlimited: "Auto Translate",
            detailedReporting: "Reporting",
            days30TrialsAvailable: "30-days trials available",
            limitedArchiveLookupLastMo: "Limited Archive Lookup (Last {monthCount}-mo)",
            fullCustomizationUnlimited: "Customization",
            planUpdated: "Great, your plan is updated.",
            planUpdating: "Your Plan is Updating...",
            planUpdatingDescription: "Please wait during your plan updating",
            done: "Done",
            freePlanUpdated: "Your plan updated as a Free Plan. (Max Agent Credit: 1)",
            proPlanUpdated: "Your plan updated as a PRO Plan. (Max Agent Credit: {agentCount})",
            canNotDwnGrade:
                "Cannot downgrade your plan from PRO {agentCountFirst} Agent(s) to {valNewPlnToUppr} {agentCountSecond}. Your agent credits in use.  ",
            deleteWarning: "You must delete or disable {valDif} Agent(s)",
            warnMessage: "Selected plan must be different than current plan",
            add: "Add",
            cancelYourPlan: "Cancel Your Plan",
            upgradeYourPlan: "Upgrade Your Plan",
            downgradeYourPlan: "Downgrade Your Plan",
            agree: "AGREE",
            disagree: "DISAGREE",
            invoices: "Invoices",
            priceIntervals: "Price Interval",
            selectSiteAlias: "Select or Enter Site Name",
            selectPriceInterval: "Select or Enter Price Interval",
            isRefunded: "Is Refunded?",
            siteId: "Site No",
            createdDate: "Created Date",
            failCount: "Number of Failed Payment Fetch Attempts",
            failDate: "Failed Payment Date",
            Dashboard: "Dashboard",
            Agents: "Agents",
            Integration: "Integration",
            Settings: "Settings",
            Contacts: "Contacts",
            Domain: "Domain",
            lastActivity: "Last Activity",
            basePrice: "Base Price",
            packagePrice: "Package Price",
            whatsappPrice: "Whatsapp Price",
            realtimeVisitorCount: "Real Time Visitor",
            suspend: "Suspend",
            partner: "Partner",
            plan: "Plan",
            trialDay: "Trial Days",
            mobile: "Mobile",
            webSite: "Web Site",
            websiteOrigins: "Web Site Origin",
            ownerName: "Owner Name",
            ownerEmailAddress: "Owner Email",
            discount: "Discount",
            daysLeft: "Days Left",
            newTrialPopUp: "How Many Days Should the New Trial Period Be?",
            newWpPricePopUp: "How Much Is The New Whatsapp Fee?",
            newIGPricePopUp: "How Much Is The New Instagram Fee?",
            newBasePricePopUp: "How Much Is The New Base Price?",
            siteInfoUpdated: "Site Information Updated",
            siteInfoNotUpdated: "Site Information Not Updated",
            siteInfoNotUpdatedErr: "Error Occured! Site Information Not Updated.",
            depositMoneyWallet: "Deposit Money to Wallet",
            couponError: "Coupon code is incorrect or expired.",
            paidSuccessfully: "Invoice paid successfully.",
            areYouSureRefundInvoice: "Are you sure you want to process a refund for this invoice?",
            company: "Company",
            cuponApplied: "Coupon successfully applied",
            deleteYourWhatsApp: "Delete your WhatsApp Business channel or buy a channel.",
            newWabaChannel: "New WhatsApp Business Channel",
            newWabaChannelDesc: "Create a new WhatsApp Business API channel",
            packageCanotDownSupsis:
                "Your package cannot be downgraded. Please delete or deactivate several of your agents to downgrade your package.",
            packageCanotDownWPBussiness:
                "Your package cannot be downgraded. Please delete several of your Whatsapp Business channels to downgrade your package.",
            packageCanotDownWp:
                "Your package cannot be downgraded. Please delete several of your Whatsapp channels to downgrade your package.",
            planes: "Plans",
            sito: "Site",
            updateChannelDesc6: "Update WhatsApp Business Channel",
            yearDiscount: "Yearly Discount",
            youHaveAWhatsAppBusiness: "You have one WhatsApp Business channel.",
            youHaveOneWhatsAppQRChannel: "You have one WhatsApp QR channel.",
        },
        tour: {
            closeChat: "Close Chat",
            ticket: "Ticket",
            formStep: "Form Step",
            menuStep: "Menu Step",
            contentStep: "Content Step",
            menuTitle: "Menu Title",
            messageContent: "Message Content",
            goToLive: "Connect Representative",
            stats: "STATISTICS PANEL",
            settings: "SETTINGS",
            status: "STATUS",
            prevStep: "Previous Step",
            nextStep: "Next Step",
            finish: "Finish",
            skip: "Skip",
            skip2: "Skip, I know system",
            startTour: "Start Tour",
            firstTimeIntro:
                "You are entering the system for the first time, I want to introduce the application if you allow",
            hi: "Hi",
            welcomeTo: "Welcome to Supsis Live Support",
            statsPanel:
                "It is the status bar showing the total and active chat numbers that are waiting instantly with the system..",
            sidebarMenu: "MENU",
            sidebarMenuContent: "You can switch between pages here.",
            representativePrivateMessage: "INTER-REPRESENTATIVE CHAT PANEL",
            representativePrivateMessageContent: "You can see private chats between agents here.",
            helpMenu: "HELP MENU",
            helpMenuContent: "You can find help information about the system here..",
            settingsMenu: "SETTINGS MENU",
            settingsMenuContent: "You can do the language, night mode and screen magnification steps here..",
            startChat: "Start Chat",
            profileMenu: "PROFILE MENU",
            profileMenuContent: "You can change your availability and set your agent settings here..",
            visitorsTab: "Visitors",
            visitorsTabContent: "You can see visitors here.",
            visitorTabHistory: "Visitor History",
            visitorTabHistoryContent: "You can see the visitor history here.",
            representativeTab: "Representatives",
            representativeTabContent: "You can see the representatives here.",
            liveSupport: "Live support",
            liveSupportContent: "You can see the number of customers receiving Live Support here..",
            siteVisitors: "Site Visitors",
            siteVisitorsContent: "You can see the number of site visitors here.",
            tableSettings: "Table Settings",
            tableSettingsContent: "You can show or hide columns in the table here.",
            selectColumnsToDisplay: "Select columns to display",
            selectAll: "Select All",
            deselectAll: "Deselect All",
            resetToDefault: "Reset to Default",
            settingsSaved: "Settings saved",
            watchModeButton: "Viewer Button",
            watchModeContent: "You can join here as a viewer mode and you can only view what is posted.",
            popoverInfo: "Visitor Details",
            popoverInfoContent: "It gives information about the visitor.",
            popoverButton: "Advanced Chat Settings",
            popoverButtonContent:
                "You can open the chat, send a message directly to the representative or block the visitor.",
            openChat: "Join Chat Button",
            openChatContent: "You can open the chat here",
            pagination: "Paging Menu.",
            paginationContent: "You can increase the number of pages here.",
            changeLang: "Can change system language",
            changeTheme: "Can switch dark and light theme",
            changeStatus: "Can change your availability status",
            logout: "Can logout system from here",
            chatwindow: {
                chatWindowActionButtons: "CHAT WINDOW ACTION BUTTONS",
                chatPanelActions: "CHAT PANEL ACTIONS",
                otherPanels: "OTHER PANELS",
                chatColorButton: "Show meaning of chat bar colors",
                keyboardShortcutButton: "Show keybpard shortcuts functions",
                hideButton: "Minimize current chat without exit",
                closeButton: "Force close and exit from current chat",
                ellipsisButton:
                    "More actions of chat. Minimize,close, Ban Visitor , Send Private Message , Assign Representative",
                userInfoWidget: "Show detail of owner visitor of current chat user",
                preparedContentWidget:
                    "Prepared Message Templates Widget, can select fastly insert a message template to current chat ",
                chatHistoryWidget: "If there are  some chat history of current visitor , can view them",
                chatWindowSettingsButtons: "TALK WINDOW SETTINGS BUTTON",
                settingsButton: "You can block chat, forward, confidential message and assign delegates.",
                chatBarButton:
                    "Here you can block active chat, send a private message to the agent and leave the chat..",
            },
            chats: "CHAT PANEL",
            representativ_eTab: "Representatives",
        },
        adminUser: {
            newAdminUserForm: "New Admin User Register Form",
            updateAdminUserForm: "Admin User Update Form",
            adminUsers: "Admin Users",
            newAdminUser: "New Admin User",
            noAdminUser: "No Admin Users Yet",
            adminUserName: "Admin User Name",
        },
        report: {
            channel: "Channel",
            channelType: "Channel Type",
            contactCount: "Contact Count",
            tag: "Tag",
            owner: "Owner",
            email: "Email",
            language: "Language",
            approvalCount: "Approval Count",
            adTitle: "Add Title",
            sourceType: "Source Type",
            mostUsedTag: "Most Used Tag",
            leastUsedTag: "Least Used Tag",
            timeDistribution: "Contact Distribution by Time",
            channelDistribution: "Contact Distribution by Channel",
            tagDistribution: "Contact Distribution by Tags",
            platformDistribution: "Contact Distribution by Platform",
            ownerDistribution: "Contact Distribution by Owner",
            languageDistribution: "Contact Distribution by Language",
            adsDistribution: "Contact Distribution by Ads",
            adNameDistribution: "Contact Distribution by Ad Name",
            adsetDistribution: "Contact Distribution by Ad Set Name",
            campaignDistribution: "Contact Distribution by Campaign Name",
            contactPropertyDistribution: "Contact Distribution by Contact Properties",
            mostEffectiveAd: "Most Effective Ad",
            leastEffectiveAd: "Least Effective Ad",
            totalPersonCount: "Total Contact Count",
            mostUsedChannel: "Most Used Channel",
            leastUsedChannel: "Least Used Channel",
            columnChart: "Column Chart",
            pieChart: "Pie Chart",
            mostUsed: "Most Used",
            leastUsed: "Least Used",
            mostUsedLanguage: "Most Used Language",
            leastUsedLanguage: "Least Used Language",
            mostAssigned: "Most Assigned",
            leastAssigned: "Least Assigned",
            averagePersonCount: "Average Contact Count",
            mostUsedPlatform: "Most Used Platform",
            leastUsedPlatform: "Least Used Platform",
            personCount: "Contact Count",
            person: "Contact",
            commentAnalysis: "Comment Analysis",
            whatsappChannelDistribution: "Chat Distribution by WhatsApp Channels",
            instagramChannelDistribution: "Chat Distribution by Instagram Channels",
            messengerChannelDistribution: "Chat Distribution by Messenger Channels",
            trendyolChannelDistribution: "Chat Distribution by Trendyol Channels",
            metaLeadsChannelDistribution: "Chat Distribution by Meta Leads Channels",
            chatDistributionByTelegramChannels: "Chat Distribution by Telegram Channels",
            chatDistributionByLinkedinChannels: "Chat Distribution by Linkedin Channels",
            channelTimeseries: "Channel Timeline",
            channelPies: "Channel Distribution",
            date: "Date",
            incomingMessages: "Incoming Messages",
            outgoingMessages: "Outgoing Messages",
            customerCount: "Customer Count",
            mailCount: "Mail Count",
            answered: "Answered",
            unanswered: "Unanswered",
            selectaChannel: "Select a Channel",
            sentMails: "Sent Mails",
            sentMailCount: "Sent Mail Count",
            ticketDistribution: "Ticket Distribution",
            selectWorkflow: "Select Your Workflow",
            distributionOfTasks: "Distribution of Tasks",
            mostMissioned: "Most Missioned",
            leastTasked: "Least Tasked",
            totalNumberTasks: "Total Number of Tasks",
            errorFetchingTask: "Error receiving task data:",
            pipelinePhase: "Pipeline Phase",
            status: "Status",
            numberOfTasks: "Number of Tasks",
            insufficientData: "Not Enough Data",
            hourly: "(Hourly)",
            hourlyAverage: "Hourly Average",
            hourlyMax: "Hourly Maximum",
            hourlyMin: "Hourly Minimum",
            totalAmount: "Total Amount",
            averageAmount: "Average Amount",
            minAmount: "Minimum Amount",
            maxAmount: "Maximum Amount",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "Channels Time Series",
            channelPies2: "Channel Pies",
            pieView: "Pie Chart",
            topVisitorCountry: "Top Visitor Country",
            websiteTrafficByCountry: "Website Traffic by Country",
            visitorCount: "Visitor Count",
            websiteVisitorTraffic: "Website Visitor Traffic",
            websiteTraffic: "Website Traffic",
            author: "Author",
            topWorstComments: "Top Worst Comments",
            topBestComments: "Top Best Comments",
            topComments: "Top Comments",
            noComment: "No Comments Yet",
            minWaitingTime: "Minimum Waiting Time",
            maxWaitingTime: "Maximum Waiting Time",
            averageWaitTime: "Average Waiting Time",
            waitTime: "Bekleme Süresi (Saniye)",
            agentWaitDurationTitle: "Agent Wait Duration TimeSeries",
            incomingMessage: "Incoming Message(s)",
            outgoingMessage: "Outgoing Message(s)",
            totalSpent: "Total Spent",
            avgSpent: "Average Spent",
            totalPayment: "Total Payment",
            walletStatus: "Wallet Status",
            walletBalanceStatus: "Wallet Balance Status",
            messageTraffic: "Message Traffic",
            breakCount: "Break Count",
            agentBreakTime: "Agent's Break Counts ☕",
            agentWorkTimeCalendar: "Agent Work Time Calendar",
            agentStatusHour: "Agent's Statusses (In Hour Unit)",
            agentActivity: "Agent Activity",
            noEnoughtData: "Not Enough Data",
            averageFirstResponse: "Average First Response Time",
            slowestResponser: "Slowest Responder",
            fastestResponder: "Fastest Responder",
            firstAnswerTimeSec: "First Message Time (in Seconds)",
            firstAnswerByAgent: "First Message Time by Agent",
            averageSolutionTime: "Average Solution Time",
            slowestSolver: "Slowest Solver",
            fastestSolver: "Fastest Solver",
            averageChat: "Average Chat",
            leastChatReceiver: "Least Chat Receiver",
            mostChatRecipients: "Most Chat Recipients",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "Resolution Time (min)",
            resolveTimeByUser: "Chat Resolution Time by User (in minutes)",
            chatResolveTimeByAgent: "Chat Resolution Time by Agents",
            chatDistByHandleType: "Chat Distribution by Handler",
            chatDistByHandDesc: "How many chats were handled by agents, chatbots, and hybrid?",
            chatCountsByHandleType: "Chat Counts by Handle Type",
            missed: "Missed",
            chatDistByAnsDesc: "How many chats were answered or missed?",
            chatCountsByAns: "Chat Counts by Answer",
            chatCountByPlatform: "Chat Counts by Platform",
            chatDistByPDesc: "How many chats came to which platform?",
            chatDistByPlatform: "Chat Distribution by Platform",
            ticketCountByUser: "Ticket Counts by Agents",
            ticketCountByStatus: "Ticket Counts by Response Status",
            user: "User",
            saveAsImage: "Save as Image",
            fullScreen: "Full Screen",
            download: "Download",
            tableView: "Table View",
            chartView: "Chart View",
            chatDistByUsers: "Chat Distribution by Agents",
            chatCountsByUsers: "Chat Counts by Agents",
            minDuration: "Minimum Duration",
            maxDuration: "Maximum Duration",
            totalDurationByAgent: "Total Session Duration by Agent",
            averageDurationByAgent: "Average Session Duration by Agent",
            totalDurationByCB: "Total Session Duration by Chatbot",
            averageDurationByCB: "Average Session Duration by Chatbot",
            viewUnitAs: "View Unit As",
            hybrid: "Hybrid",
            handledBy: "Handled By",
            sessionDurationOverall: "Overall Session Duration",
            allChannels: "All Channels",
            sessionsDurationOverall: "Overall Session Durations",
            sessionsOverall: "Overall Sessions",
            calendarEvents: "Calendar Events",
            reservationEvents: "Reservation Events",
            incomingMails: "Incoming Mails",
            incomingMailCount: "Incoming Mail Count",
            reservation: "Reservation",
            event: "Event",
            reservationEventCount: "Reservation Event Count",
            eventCount: "Event Counts",
            channelBreakdown: "Channel Breakdown",
            websiteAnalysis: "Website Analysis",
            customerSatisfaction: "Customer Satisfaction",
            teamBreakAnalysis: "Team Work / Break Analysis",
            dailyAgentActivity: "Daily Agent Activity",
            agentPerformance: "Agent Performance",
            chatDistributions: "Chat Distributions",
            contactDistributions: "Contact Distributions",
            users: "Users",
            segmentTimeseries: "Segment Time Series",
            segmentsOverall: "Segments Overall",
            unmatchRatio: "Unmatch Ratio",
            totalMatchCount: "Total Match Count",
            totalUnmatchCount: "Total Unmatch Count",
            matchRatio: "Match Ratio",
            matched: "Matched",
            trainingOverall: "Training Overall",
            trainingStatusTimeseries: "Training Status Time Series",
            duration: "Duration",
            totalSessionDuration: "Total Session Duration",
            averageSessionDuration: "Average Session Duration",
            second: "Second",
            minute: "Minute",
            hour: "Hour",
            aggregateAs: "Aggregate as",
            chatbotSessionDurationOverall: " Overall Chatbot Session Duration",
            ratingTimeSeries: "Rating Time Series",
            chatCountTimeseries: "Chat Count Time Series",
            notRated: "Not Rated",
            totalRatingCount: "Total Rating Count",
            averageRating: "Average Rating",
            weightedAverageRating: "Weighted Average Rating",
            rate: "Rateing",
            ratingOverall: "Customer Ratings Overall",
            session: "Session",
            total: "Total",
            average: "Average",
            max: "Maximum",
            min: "Minimum",
            sessionCount: "Session Count",
            uniqueUsers: "Unique Users",
            viewAs: "View as:",
            overall: "Overall",
            detailReport: "Detailed Report",
            dailyReports: "Daily Reports",
            pointBasedReports: "Point Based Reports",
            personDateBasedPointReport: "Person and Date Based Point Report",
            personDateBasedReport: "Person and Date Based Report",
            personBasedReport: "Person Based Reports",
            personAndDateBasedGraph: "Person and Date Based Graph",
            noReport: "No Report",
            reports: "Reports",
            totalBar: "Total",
            ticketCount: "Ticket Count",
            selectChannel: "Select a Channel",
            leastTask: "Least Task",
            dailyAverage: "Daily Average",
            dailyMax: "Daily Maximum",
            dalyMin: "Daily Minimum",
            topBestWorstComments: "Top Best/Worst Comments",
            erorFetchingTask: "Error fetching task data:",
        },
        stats: {
            total: "Number of  all  open chats",
            active: "Number of   assigned active chats to you",
            waiting: "Number of visitors waiting for a representative to enter",
            late: "Number of visitors waiting more than a certain period",
            free: "Number of free visitors waiting for the new representative to enter",
            pco: "[Capacity Utilization Rate] Rate of work load of active representative chat capacity",
            maxCapacity: "Maximum number of chat that the system can assign representatives without waiting",
            chatbot: "Number of active chat with chatbot",
        },
        time: {
            lastYear: "Last Year",
            thisYear: "This Year",
            last3Months: "Last 3 Months",
            last7: "Last 7 Days",
            today: "Today",
            yesterday: "Yesterday",
            lastWeek: "Last Week",
            currentWeek: "This Week",
            currentMonth: "This Month",
            lastMonth: "Last Month",
            last30Day: "Last 30-day",
            allTime: "All Times",
            custom: "Custom Date",
        },
        fastWizard: {
            generalColors: "General Colors",
            tellUsMore: "Tell us more , so we can personalize your experience",
            moreInfo: "More Info",
            display: "Display",
            availability: "Availability",
            preview: "Preview",
            installCode: "Install Code",
            previous: "Previous",
            setupSupsisLiveChat: "Setup SUPSIS LIVE Chat ",
            continue: "Next Step",
            completeInitialize: "Complete Setup",
            completedMessage: "SUPSIS Live Chat Setup Successfully  Completed.",
            websiteIntegration: "Your website address to integrate supsis live chat",
            customizeLiveChat: "Customize Your Live Chat",
            createBrandedExperience: "Create a branded chat experience for your visitors.",
            chatColor: "Chat Color",
            chooseChatColor: "Choose an accent color.",
            chatBubble: "Chat Bubble",
            selectBubble: "Select a chat bubble",
            chatBubbleColor: "Chat Bubble Color",
            selectChatBubbleColor: "Select a chat bubble color",
            customSelection: "Custom Selection:",
            chatAvailability: "Chat Availability",
            onlineSupportVisitorTime: "When are you online to support your visitors?",
            channelAvailability: "Channel Availability",
            availability724: "Chat is available 7/24",
            basedOnTeam: "Based on Team Member Status",
            basedOnTeamExplanation: "Chat will appear online when at least 1 member is set to available",
            customHours: "Custom Business Hours",
            customHoursExplanation: "Configure your business hours",
            customHoursTimezone: "Timezone:",
            customHoursFrom: "From:",
            customHoursTo: "To:",
            customHoursAddHours: "+Add Hours",
            previewDesktop: "Desktop",
            previewIpad: "Ipad",
            installationAndInstructions: "Installation & Instructions",
            installationTrackingCode: "Install the tracking code on your website",
            installationTrackingCodePlease:
                "Please paste the code in accordance with the instructions below, just before the end of the {bodyTag} tag on any page where you want to enable SUPSIS Live chat.",
            installationInstructionsJavascript:
                " Paste the integration code given above in the {bodyTag} tag just before the closing.",
            installationInstructionsCopy: "Copy",
            installationInstructionsCoppyMessage: "Integration script copied to clipboard",
            installationInstructionsShopify1: "1. Login to your Shopify panel",
            installationInstructionsShopify2:
                "2. Go to Online Store > Themes > Actions drop-down menu under Current Theme > Edit code > theme.liquid",
            installationInstructionsShopify3:
                "3. Place paste the integration code given above just before the  {bodyTag}  tag at the end of the theme.liquid script.",
            installationInstructionsIdeaSoft1: "1. Login to your dealer panel.",
            installationInstructionsIdeaSoft2: "2. Go to Settings -> SEO -> Search Engine Services.",
            installationInstructionsIdeaSoft3:
                '3. Select "Site Verification with Meta Tag" from the Tracking Code section.',
            installationInstructionsIdeaSoft4:
                "4. Copy and paste the integration code above into the opened box and save.",
            installationInstructionsIdeaSoft5:
                '5. Inside Settings -> Optimizations click to "Clear Cache" button. Thus integration is completed.',
            installationInstructionsWordPress1: "1. Login to your WordPress admin panel",
            installationInstructionsWordPress2: "2. Go to Appearance > Theme Editor",
            installationInstructionsWordPress3:
                "3. Under Theme Files (far right), find the Theme Footer (footer.php) and select it",
            installationInstructionsWordPress4:
                "4.Paste the integration code above before the {bodyTag} tag at the bottom.",
            installationInstructionsWordPress5: "5. Click Update File to save changes",
            installationInstructionsOpenCart1: "1. Login to your Opencart admin panel",
            installationInstructionsOpenCart2: "2. Go to Design > Theme Editor",
            installationInstructionsOpenCart3: "3. Select 'common' folder and open 'header.twig' file.",
            installationInstructionsOpenCart4:
                "4.Paste the integration code above before the {headTag} tag at the bottom.",
            installationInstructionsOpenCart5: "5. Click save button.",
            installationInstructionsTicimax1: "1. Login to your Ticimax administration panel",
            installationInstructionsTicimax2: "2. Open Design > Design > Header Footer Design settings",
            installationInstructionsTicimax3: "3. Click the 'Source' button in the logo design section.",
            installationInstructionsTicimax4: "4. Paste the integration code above below the HTML code.",
            installationInstructionsEticaretteyim1: "1. Login to your Eticaretteyim administration panel",
            installationInstructionsEticaretteyim2:
                "2. Just Name SUPSIS from Plugins > Generate HTML > and Copy the Code.",
            installationInstructions: "Instructions",
            installationVerify: "Verify Your Website Installation of Supsis",
            installationVerifyChecking: "Checking",
            installationVerifyCheck: "Check",
            installationVerifyCheckingStatus: "Checking SUPSIS integration status on {website}",
            installationCheckingStatusMessageYes: "Great, SUPSIS is integrated to {website} website !!",
            installationCheckingStatusMessageNo:
                "SUPSIS is not currently integrated with {website} website. You can complete your integration process now or later.",
            vtippyPreferredLanguage: "Preferred Language",
        },
        akinon: {
            typeOrSelectSKU: "Type or select SKU",
            akinonUserId: "Akinon User Id",
            userEmail: "User Email",
            userEmailDesc: "Type or select user email...",
            send: "Send",
            selectCity: "Select City",
            city: "City",
            selectState: "Select State",
            state: "State",
            useMap: "Use Map",
            chooseAddress: "Choose Address",
            selectCountry: "Select Country",
            country: "Country",
            productIdDesc: "Type or select product...",
            productId: "Product Id",
            userIdDesc: "Type Akinon user id...",
            productSKU: "Product SKU",
            latitudeDesc: "Type or select target location latitude...",
            longitudeDesc: "Type or select target location longitude...",
            orderNumber: "Your order number",
            orderDesc: "Type order number...",
            longitude: "Longitude",
            latitude: "Latitude",
        },
        headBar: {
            source: "Source",
            label: "Label",
            completed: "Completed?",
            Email: "E-mail",
            phone: "Phone",
            name: "Name",
            date: "Date",
            subject: "Subject",
            situation: "Situation",
            representative: "Representative",
            transactions: "Transactions",
            channel: "Contact Channel",
            email: "E-mail",
        },
        login: {
            loginTitle1: "Welcome to",
            loginTitle2: "Supsis AI",
            email: "Your email adress",
            emailPlaceholder: "Please enter your e-mail address.",
            emailError: "Please Enter Valid Email",
            password: "Your password",
            passwordLogin: "Password Free Login",
            passwordAndLogin: "Login with Password",
            passwordNew: "Reset My Password",
            loginAnd: "Or",
            passwordPlaceholder: "Please enter your password.",
            loginMemory: "Remember this device",
            passwordForget: "I forgot my password",
            passwordNewAgain: "New Password",
            passwordNewAgainTwo: "New Password Repeat",
            passwordNewAgainPlaceholder: "Please enter your new password.",
            passwordNewAgainPlaceholderTwo: "Please re-enter your new password.",
            login: "Login",
            loginFooter: "Or, Sign In With Email",
            emailLogin: "Sign in with Email",
            welcomeTitle: "Welcome",
            welcomeMorning: "Good Morning",
            welcomeAfternoon: "Good Afternoon",
            welcomeEvening: "Good Evening",
            welcomeNight: "Good Night",
        },
        settings: {
            ipWhitelist: "IP Access List",
            loadMore: "Load More...",
            detectIpAddress: "Detect My IP Address",
            addWighteListAddress: "Add IP Address to Whitelist",
            accessControlSubTitles:
                "Access Control provides an additional security layer that allows only authorized IPs to access the system.",
            companyInformation: "Company Information",
            ipAddress: "My IP Address",
            whiteList: "Secure IP List",
            whiteListAdd: "Add Safe IP",
            whiteListDeletedSuccessfully: "Access Control deleted successfully",
            whiteListDeletedFailed: "Access Control failed to delete",
            whiteListAddedSuccessfully: "Access Control added successfully",
            whiteListAddedFailed: "Access Control failed to add",
            deleteWhiteListTitle: "Are you sure you want to delete this access control?",
            talkSettings: "Chat Settings",
            talkSubtitles: "Manage Your Chat Settings",
            dateAndTime: "Date and Time",
            actor: "Actor",
            event: "Event",
            accessControl: "Access Control",
            rulesGroup: "Rules",
            organizationLongName: "Organization Long Name",
            visitorNewDesc: "You can use the new version of the visitor theme.",
            transactionType: "Transaction Type",
            priorBalance: "Previous Balance",
            nextBalance: "Next Balance",
            amount: "Amount",
            phoneNumber: "Phone Number",
            profileInfoRemoved: "Profile information removed.",
            newValueUpdated: "New Value Updated.",
            balanceToTransferred: "Balance to be transferred",
            availableBalance: "Available Balance",
            balanceReceived: "Balance Received",
            totalBalance: "Total Balance",
            paymentCard: "Payment Card",
            wpPhoneNumber: "Whatsapp Phone Number",
            wpSendingMessage: "Whatsapp Sending First Message",
            auditlogs: "Audit Logs",
            myaccount: "My Account",
            notifications: "Notifications",
            company: "Company",
            features: "Features",
            general: "General",
            chat: "Chat",
            timings: "Timings",
            wallet: "Wallet",
            language: "Language",
            "bubble-settings": "Bubble Settings",
            "bubble-actions": "Bubble Actions",
            "theme-settings": "Theme Settings",
            visitorLoginForm: "Visitor Login Form",
            visitorAttribute: "Visitor Profile Information",
            timing_settings: "Chat Timing Settings",
            auto_assign: "Auto Assign",
            availability: "Availability",
            "website-integration": "Website Integration",
            General: "General",
            Chat: "Chat",
            Timings: "Timings",
            Integration: "Integration",
            developer: "Developer",
            visitorNew: "Visitor Transition to New Design",
            companySubtitles: "Manage your company information.",
            featuresSubtitles: "Manage the smart features of Supsis.",
            languageSubtitles: "Set your business' preferred language & time zone.",
            bubbleSettings: "Bubble Settings",
            bubbleSettingsSubtitles: "Manage your bubble settings.",
            bubbleActionsSubtitles: "Manage your bubble actions.",
            chatThemeSettingsSubtitles: "Manage your chat theme settings.",
            visitorLoginFormSubtitles: "Manage your visitor login form settings.",
            chatTimingSettingsSubtitles: "Manage your chat timing settings.",
            webSiteIntegrationSubtitles: "Manage your website integration settings.",
            apiAccessTitle: "API Access",
            apiAccessSubtitles: "Manage your API access settings.",
            youTubeActionForm: "Add Your Youtube Channel",
            linkedinActionForm: "Add Your Linkedin Account",
            telegramActionForm: "Add Telegram Account",
            facebookActionForm: "Add Your Facebook Page",
            tiwitterActionForm: "Add Your Twitter Page",
            instagramActionForm: "Add Your Instagram Page",
            liveSupportDescription: "Open a live chat with your customers",
            ticketDescription: "Create a ticket for your customers",
            whatsappDescription: "Let your customers reach you via Whatsapp",
            phoneDescription: "Let your customers reach you via phone",
            emailDescription: "Let your customers reach you via email",
            facebookDescription: "Let your customers reach you via Facebook",
            twitterDescription: "Let your customers reach you via Twitter",
            instagramDescription: "Let your customers reach you via Instagram",
            youtubeDescription: "Let your customers reach you via Youtube",
            linkedinDescription: "Let your customers reach you with LinkedIn",
            telegramDescription: "Let your customers reach size with Telegram",
            whatsappModalTitle: "Whatsapp Transaction Form",
            whatsappModalDescription: "Please fill out the form below to connect your Whatsapp account.",
            phoneModalTitle: "Phone Transaction Form",
            phoneModalDescription: "Please fill out the form below to connect your phone account.",
            emailModalTitle: "E-mail Transaction Form",
            emailModalDescription: "Please fill out the form below to connect your e-mail account.",
            facebookModalTitle: "Facebook Transaction Form",
            facebookModalDescription: "Please fill out the form below to connect your Facebook account.",
            twitterModalTitle: "Twitter Transaction Form",
            twitterModalDescription: "Please fill out the form below to connect your Twitter account.",
            instagramModalTitle: "Instagram Transaction Form",
            instagramModalDescription: "Please fill out the form below to connect your Instagram account.",
            youtubeModalTitle: "Youtube Transaction Form",
            youtubeModalDescription: "Please fill out the form below to connect your Youtube account.",
            linkedinModalTitle: "LinkeIn Transaction Form",
            linkedinModalDescription: "Please fill out the form below to link your LinkedIn account.",
            telegramModalTitle: "Telegram Transaction Form",
            telegramModalDescription:
                "Enter your Telegram profile link in the form below to link your Telegram Account",
            instagramAlertTitle: "Instagram Integration Required",
            instagramAlertDesc: "Sorry, the page you visited will be activated when you integrate your Instagram.",
            instagramActivateText: "Let's go, Integrate Instagram",
            remove: "Remove",
            edit: "Edit",
            connected: "Connected",
            add: "Add",
            themeDescription: "Manage your theme settings.",
            fontDescription: "Manage your font settings.",
            isFabsAsIcon: "Show Menu Icon Texts.",
            chatBubbleTextSetting: "Chat Bubble Text Setting",
            textOnChatBubble: "You can adjust the text settings that will appear on the Chat Bubble.",
            textToAppearOnChatBubble: "Text to Appear on Chat Bubble",
            newVisitorProfileInformation: "New Visitor Profile Information",
            newVisitorProfileInformationDescription: "Adds new value to visitor profile information",
            create: "Create",
            newAdd: "Add New",
            toInform: "To inform",
            toInformDescription: "You can match the values you add on this page with the visitor login form.",
            showVisitor: "Show Visitor",
            label: "Label",
            text: "Text",
            email: "Mail",
            phone: "Phone",
            number: "Number",
            url: "URL",
            date: "Date",
            dropdown: "Dropdown",
            languageTimeZone: "Language and Region",
            timeZoneTitle: "Region & Time Zone",
            timeZoneDescription: "Region and time zone settings",
            ballanceToTransferred: "Balance to be Transferred",
            integration: "Integration",
            emailTitle: "Enter Your E-mail Address",
            emailMessage: "Email Initial Send Message",
            advertising: "Advertising",
            ballanceToTransfer: "Balance to Transfer",
            changeSettings: "Change Auto Chat Assignment Settings",
            crm: "CRM",
            ecommerce: "E-commerce",
            sms: "SMS",
            socialMedia: "Social Media",
            utilities: "Utilità",
            web: "Web",
        },
        userInfoWidget: {
            zohoInfo: "Zoho Information",
            messageSearch: "Search Message",
            userInformation: "User information",
            fullName: "Name and surname",
            newValue: "New Value",
            newProfileInfo: "New Profile Info",
            affiliatedRepresentatives: "Representatives",
            preferredAgents: "Preferred Agent(s)",
            labels: "Labels",
            agentNotes: "Agent Notes",
            newNote: "New Note",
            note: "Note",
            available: "There are notes available.",
            systemInformation: "System Information",
            speechID: "Chat ID",
            customerVersion: "Customer Version",
            IPAddress: "IP Address",
            pageVisited: "Page Visited",
            systemAndBrowser: "Operating System & Browser",
            countryAndLanguage: "Country and language",
            clickToEdit: "Edit Click inside the post",
            adsYouAreInterestedIn: "Ads You Are Interested In",
            detail: "Detail",
            adsTitle: "Title",
            adUrl: "Ad URL",
            sourceID: "Source ID",
            resourceType: "Resource Type",
            adsBody: "Content",
            adsCreateDate: "Creation Date",
            adsUpdateDate: "Update Date",
        },
        newWizartV2: {
            generalSettings: "General Settings",
            themeSettings: "Theme Settings",
            representativeWorkingHours: "Representative Working Hours",
            preview: "Preview",
            setup: "Setup",
            formStepTitle: "Give us more information so we can personalize your experience",
            supsisEntergation: "Where will you use Supsis on your website?:",
            goToNextStep: "Take Next Step",
            readytemplate: "Use Ready Color Template",
            customSettings: "Custom Settings",
            customerMessageView: "Customer message View",
            backcgroundColor: "Background Color",
            textColor: "Font Color",
            agentMessageView: "Agent Message View",
            workingHours: "What time intervals do you provide services to your visitors?",
            continuousService: "Continuous Service",
            continuousServiceDescription: "The chat bubble is always active. Even if you are not in the system.",
            vote: "Make your choice",
            representativeWorking: "Representative Working Hours",
            representativeWorkingDescription:
                "The chat appears online when at least 1 agent is online. If there is no online representative, it will appear as offline.",
            computer: "Computer",
            tablet: "Tablet",
            uploadTrackingCodeToYourWebsite: "Upload Tracking Code to Your Website",
            password: "Set new password",
        },
        whatsappChannel: {
            whatsappTitleV1: "Whatsapp V1 Channels (QR)",
            whatsappTitleV2: "Whatsapp V2 Channels (QR)",
            channelName: "Channel",
            phoneNumber: "Phone Number",
            forwardToChatbot: "Forward to Chatbot",
            forwardingChatbotOrLiveAgent: "Forwarding (Chatbot or Live Agent)",
            addChannel: "Add Channel",
            newWhatsappChannel: "New WhatsApp Channel",
            newWhatsappChannelDescription: "Create a new WhatsApp channel by scanning the QR code",
            editWhatsappChannel: "Edit WhatsApp Channel",
            editWhatsappChannelDescription: "Edit WhatsApp channel",
            whatsappChannel: "WhatsApp Channel",
            deleteWhatsappChannelDescription: "Are you sure you want to delete this channel?",
            whatsappIntegration: "WhatsApp Integration",
            deleteChannel: "Delete Channel",
            restartChannel: "Restart Channel",
            wantRestartChannel: "Do you want to restart the channel?",
            deleteSMSChannelDescription: "Are you sure you want to delete the SMS channel?",
            smsChannel: "SMS Channel",
            maxChannelCount: "You Cannot Create More than One SMS Channel!",
            smsModalText:
                "Our integration with modern communication solutions gives you the opportunity to send SMS easily and effectively. Remove boundaries in communication, connect directly with your customers!",
            smsModalBtn: "Click to Open SMS Channel...",
            postaCellDetail: "PostaCell Channel Detail",
            phoneNummer: "Phone Number",
        },
        noPermission: "You do not have permission to perform this operation. Please contact your manager.",
        mail_integration_detail: {
            title: "Mail Detail",
            integration: "Integration",
            sender: "Sender Mail",
            signature: "Signature",
            inbox: "Inbox",
            medias: "Media",
            visibility: "Visibility",
            settings_group: "Settings",
            contacts: "Contacts",
        },
        whatsapp_business_api: {
            userVisibility: "User Visibility",
            userVisibilityDesc:
                "The channels that users can access depend on their role and the visibility settings of the channel. Users with the Full Admin or root role can see all channels. If a channel's visibility settings are empty, the channel is public. However, if the channel is defined for specific users or departments, only those users or department members can see the channel.",
            searchTemplate: "Search template...",
            forwardToChatbot: "Forward to chatbot",
            forwarding: "Forwarding (Chatbot or Live Agent)",
            forwardLiveAgents: "👉 Forward to live support",
            forwardingToDepartment: "Forwarding to department",
            selectDepartment: "Select department",
            createWbChannel:
                "To create a WhatsApp Business channel, you need to purchase a WhatsApp Business package. You can immediately access affordable packages.",
            wbCreateChannelMax: "You have reached the WhatsApp Business channel creation limit. Maximum",
            wbContinue:
                "You can create a WhatsApp Business channel. To continue, update your package or delete some of your WhatsApp Business channels.",
            chatInitiatorTemplate: "Chat Initiator Template",
            selectChatInitiatorTemplate: "Select chat initiator template.",
            dailyUsageReport: "Daily usage report",
            metaInsightsTitle: "Meta Insights",
            metaInsightsSubtitle: "View WhatsApp Business API statistics",
            metaInsightsDateRange: "Date Range",
            metaInsightsDateStart: "Start",
            metaInsightsDateEnd: "End",
            metaInsightsGranularity: "Granularity",
            metaInsightsGranularityDay: "Daily",
            metaInsightsGranularityMonth: "Monthly",
            metaInsightsGranularityHalfHour: "Half Hour",
            metaInsightsRefresh: "Refresh",
            metaInsightsTabMessaging: "Messaging Analytics",
            metaInsightsTabConversation: "Conversation Analytics",
            metaInsightsTabPricing: "Pricing Analytics",
            metaInsightsTabTemplate: "Template Analytics",
            metaInsightsTabTemplateGroup: "Template Group Analytics",
            metaInsightsErrorMessaging: "Failed to load messaging analytics data",
            metaInsightsErrorConversation: "Failed to load conversation analytics data",
            metaInsightsErrorPricing: "Failed to load pricing analytics data",
            metaInsightsErrorTemplate: "Failed to load template analytics data",
            metaInsightsErrorTemplateGroup: "Failed to load template group analytics data",
            metaInsightsViewChart: "Chart View",
            metaInsightsViewTable: "Table View",
            metaInsightsDownloadExcel: "Download Excel",
            metaInsightsTotalSent: "Total Sent",
            metaInsightsTotalDelivered: "Total Delivered",
            metaInsightsDeliveryRate: "Delivery Rate",
            metaInsightsUnitMessage: "messages",
            metaInsightsMessageStats: "Message Statistics",
            metaInsightsSent: "Sent",
            metaInsightsDelivered: "Delivered",
            metaInsightsDateColumn: "Date",
            metaInsightsCountryBreakdown: "Country Breakdown",
            metaInsightsNoData: "No data found. Please check the date range.",
            metaInsightsPieChart: "Pie Chart",
            metaInsightsTotalConversations: "Total Conversations",
            metaInsightsTotalCost: "Total Cost",
            metaInsightsAvgCost: "Average Cost",
            metaInsightsUnitConversation: "conversations",
            metaInsightsCostPerConversation: "$/conversation",
            metaInsightsCategoryBreakdown: "Category Breakdown",
            metaInsightsConversationStats: "Conversation Statistics",
            metaInsightsCategoryDistribution: "Category Distribution",
            metaInsightsConversationCount: "Conversation Count",
            metaInsightsCost: "Cost",
            metaInsightsCategory: "Category",
            metaInsightsType: "Type",
            metaInsightsConversationCategoryAuth: "Authentication",
            metaInsightsConversationCategoryMarketing: "Marketing",
            metaInsightsConversationCategoryService: "Service",
            metaInsightsConversationCategoryUtility: "Utility",
            metaInsightsConversationCategoryOther: "Other",
            metaInsightsConversationDistribution: "Conversation Distribution",
            metaInsightsTotalVolume: "Total Volume",
            metaInsightsAvgUnitCost: "Average Unit Cost",
            metaInsightsCostPerMessage: "$/message",
            metaInsightsPricingCategoryBreakdown: "Pricing Category Breakdown",
            metaInsightsPricingTypeBreakdown: "Pricing Type Breakdown",
            metaInsightsPricingStats: "Pricing Statistics",
            metaInsightsCostDistribution: "Cost Distribution",
            metaInsightsCountry: "Country",
            metaInsightsVolume: "Volume",
            metaInsightsTier: "Tier",
            metaInsightsPricingCategoryAuth: "Authentication",
            metaInsightsPricingCategoryAuthInternational: "International Authentication",
            metaInsightsPricingCategoryMarketing: "Marketing",
            metaInsightsPricingCategoryService: "Service",
            metaInsightsPricingCategoryUtility: "Utility",
            metaInsightsPricingCategoryReferral: "Referral Conversion",
            metaInsightsPricingTypeRegular: "Regular",
            metaInsightsPricingTypeFreeCustomerService: "Free Customer Service",
            metaInsightsPricingTypeFreeEntryPoint: "Free Entry Point",
            metaInsightsTemplateAboutTitle: "About Template Analytics",
            metaInsightsTemplateAboutDesc:
                "You need to select templates for template analytics. You can select up to 10 templates. Analytics data is returned with daily granularity and you can access 90 days of historical data.",
            metaInsightsTemplateSelectLabel: "Select Templates (Max 10)",
            metaInsightsTemplateSelectPlaceholder: "Select templates...",
            metaInsightsFetchData: "Fetch Data",
            metaInsightsTotalRead: "Total Read",
            metaInsightsReadRate: "Read Rate",
            metaInsightsRead: "Read",
            metaInsightsTemplatePerformance: "Template Performance",
            metaInsightsCostInfo: "Cost Information",
            metaInsightsTotalSpent: "Total Spent",
            metaInsightsCostPerDelivered: "Cost Per Delivered",
            metaInsightsClickInfo: "Click Information",
            metaInsightsClickInfoDesc:
                "URL and Quick Reply button clicks are only available for templates in the MARKETING and UTILITY categories.",
            metaInsightsTemplateNoData:
                "No template analytics data found. You can fetch data by selecting template IDs.",
            metaInsightsTemplateId: "Template ID",
            metaInsightsTemplateGroupAboutTitle: "About Template Group Analytics",
            metaInsightsTemplateGroupAboutDesc:
                "You need to enter template group IDs created in Meta for template group analytics. You can enter up to 10 groups. Analytics data is returned with daily granularity and you can access 90 days of historical data.",
            metaInsightsTemplateGroupIdsLabel: "Template Group IDs (comma-separated, max 10)",
            metaInsightsTemplateGroupIdsPlaceholder: "E.g.: 1044106240855852, 1044106240855853",
            metaInsightsTemplateGroupPerformance: "Template Group Performance",
            metaInsightsGroupBreakdownTitle: "Performance by Group",
            metaInsightsGroupLabel: "Group",
            metaInsightsTemplateGroupNoData:
                "No template group analytics data found. You can fetch data by entering template group IDs.",
            metaInsightsGroupId: "Group ID",
            capiStatus: "CAPI Status",
            capiActive: "Active",
            capiPassive: "Inactive",
            capiConnectionMethod: "Connection Method",
            capiConnectThroughMeta: "Connect through Meta",
            capiWithDatasetAndToken: "With Dataset and Token",
            capiOauthInfoDesc:
                "You need to re-authorize to connect through Meta. This does not break your existing channel, it only adds additional permissions.",
            capiConnecting: "Connecting...",
            capiConnectWithMeta: "Connect with Meta",
            capiDatasetSelection: "Dataset Selection",
            capiSelectDataset: "Select a dataset",
            capiCreating: "Creating...",
            capiCreateNewDataset: "Create New Dataset",
            capiDatasetId: "Dataset ID",
            capiEnterDatasetId: "Enter dataset ID",
            capiAccessToken: "Access Token",
            capiEnterAccessToken: "Enter access token",
            capiTesting: "Testing...",
            capiTestConnection: "Test Connection",
            capiConnectionSuccess: "Connection successful",
            capiConnectionFailed: "Connection failed",
            capiAutoEventSend: "Automatic Event Sending",
            capiEventInitiateCheckout: "Chat Started",
            capiEventInitiateCheckoutDesc: "When a new conversation is created",
            capiEventPurchase: "Purchase",
            capiEventPurchaseDesc: "When purchase is completed",
            capiEventAppointmentBooked: "Appointment Booked",
            capiEventAppointmentBookedDesc: "When an appointment is reserved",
            capiEventAddToCart: "Added to Cart",
            capiEventAddToCartDesc: "When a product is added to cart",
            capiEventViewContent: "Content Viewed",
            capiEventViewContentDesc: "When a page or product is viewed",
            capiEventOrderCreated: "Order Created",
            capiEventOrderCreatedDesc: "When order is successfully created",
            capiEventOrderShipped: "Order Shipped",
            capiEventOrderShippedDesc: "When order is shipped",
            capiMetaConnectionSuccess: "Meta connection successful",
            capiMetaConnectionFailed: "Meta connection failed",
            capiDatasetsLoadError: "Failed to load datasets",
            capiDatasetCreated: "New dataset created",
            capiDatasetCreateError: "Failed to create dataset",
            capiConnectionTestSuccess: "CAPI connection successful!",
            capiConnectionTestFailed: "CAPI connection failed",
            capiConnectionTestError: "Connection test could not be performed",
            wabaMovementsTitle: "Webhook Activities",
            wabaMovementsSubtitle: "Track WhatsApp Business API channel activities",
            wabaMovementsTotalActivity: "total activities",
            wabaMovementsEmailNotifications: "Email Notifications",
            wabaMovementsActive: "Active",
            wabaMovementsOff: "Off",
            wabaMovementsEmailSettingTitle: "Receive account notifications by email",
            wabaMovementsEmailSettingDesc: "Send email notifications for webhook activities",
            wabaMovementsEmailListHeader: "Email addresses to send notifications to",
            wabaMovementsEmailPlaceholder: "Enter email address",
            wabaMovementsNoEmailsYet: "No email addresses added yet",
            wabaMovementsActivityLoadError: "An error occurred while loading activity logs",
            wabaMovementsNotificationsOn: "Email notifications enabled",
            wabaMovementsNotificationsOff: "Email notifications disabled",
            wabaMovementsUpdateError: "An error occurred during update",
            wabaMovementsEmailAlreadyAdded: "This email address is already added",
            wabaMovementsEmailAdded: "Email address added",
            wabaMovementsEmailAddError: "An error occurred while adding email",
            wabaMovementsEmailRemoved: "Email address removed",
            wabaMovementsEmailRemoveError: "An error occurred while removing email",
            freeChat: "Free chat",
            paidChat: "Paid chat",
            templateMessage: "Template message",
            outgoingSession: "Outgoing session",
            incomingSession: "Incoming session",
            totalCost: "Total cost",
            allOptNumbers: "All opt-in numbers.",
            startChat: "Start chat",
            lastMessageDate: "Last message date",
            sureDeleteTemplate: "Are you sure you want to delete this template?",
            manageWhoChannelChat: "Manage who can see these channel chats",
            profileImageDesc: "This will be the WhatsApp screenshot of your business",
            bussinesDescription: "Business description",
            descOfWork: "Description of your business in a few words (Maximum 512 characters)",
            accountStatus: "Account status",
            dockerStatus: "Docker status",
            phoneQuality: "Phone quality",
            customersOrDay: "Customers/Day",
            messagingLimit: "Messaging limit",
            canSendMessage: "Message can be sent",
            officialDetails: "Official details",
            officialDetailsDesc:
                "These addresses will always be shown in the profile section to users who chat with you on WhatsApp. After editing, we will send them to WhatsApp for approval.",
            addressLine: "Address line",
            stateIfApplic: "State (if applicable)",
            zipCodeOrPostCode: "Zip code/Postal code",
            selectCountry: "Select country",
            selectBussVertical: "Select business area",
            saveInfo: "Save information",
            active: "Active",
            banned: "Banned",
            low: "Low",
            medium: "Medium",
            high: "High",
            connected: "Connected",
            disConnected: "Disconnected",
            flagged: "Flagged",
            pending: "Pending",
            restricted: "Restricted",
            unknown: "Unknown",
            available: "Available",
            limited: "Limited",
            blocked: "Blocked",
            loadingProfile: "Loading profile information...",
            businessProfileTitle: "Business Profile",
            lastUpdate: "Last update:",
            updateFromMeta: "Update from Meta",
            waitSeconds: "Wait {n}s",
            wabaInfoTitle: "WhatsApp Business Account Information",
            phoneInfo: "Phone Information",
            phoneNumberLabel: "Phone Number:",
            codeVerificationLabel: "Code Verification:",
            platformSettings: "Platform Settings",
            platformTypeLabel: "Platform Type:",
            throughputLevelLabel: "Throughput Level:",
            twoFaPinLabel: "2FA PIN:",
            enabled: "Enabled",
            disabled: "Disabled",
            dailyLimit: "Daily Limit",
            messageSending: "Message Sending",
            businessInfoTitle: "Business Information",
            profilePhoto: "Profile Photo",
            change: "Change",
            profilePhotoNote: "JPG or PNG (max 5MB, recommended: 640x640px)",
            aboutText: "About Text",
            aboutPlaceholder: "Write a short description about your business...",
            aboutHint: "Short description that will appear on your WhatsApp profile (max 139 characters)",
            businessDescriptionLabel: "Business Description",
            businessDescriptionPlaceholder: "Write your business detailed description...",
            descriptionHint: "Your business detailed description",
            contactEmail: "Contact Email",
            emailPlaceholder: "example@company.com",
            businessAddress: "Business Address",
            addressPlaceholder: "Full address",
            website1: "Website 1",
            website2: "Website 2",
            website1Placeholder: "https://www.company.com",
            website2Placeholder: "https://www.facebook.com/company",
            businessCategory: "Business Category",
            selectBusinessCategory: "Select business category",
            categoryHint: "Select your business activity area",
            revertChanges: "Revert Changes",
            updateButton: "Update",
            accountModeLabel: "Account Mode:",
            na: "N/A",
            verticalOther: "Other",
            verticalAuto: "Automotive",
            verticalBeauty: "Beauty, Spa and Salon",
            verticalApparel: "Clothing and Apparel",
            verticalEdu: "Education",
            verticalEntertain: "Entertainment",
            verticalEventPlan: "Event Planning and Service",
            verticalFinance: "Finance and Banking",
            verticalGrocery: "Food and Grocery",
            verticalGovt: "Public Service",
            verticalHotel: "Hotel and Lodging",
            verticalHealth: "Medical and Health",
            verticalNonprofit: "Non-profit",
            verticalProfServices: "Professional Services",
            verticalRetail: "Shopping and Retail",
            verticalTravel: "Travel and Transportation",
            verticalRestaurant: "Restaurant",
            verticalAlcohol: "Alcohol",
            verticalOnlineGambling: "Online Gambling",
            verticalPhysicalGambling: "Physical Gambling",
            verticalOtcDrugs: "OTC Drugs",
            verticalMatrimonyService: "Matrimony Service",
            success: "Success",
            successDesc: "Your profile information was successfully updated.",
            wabaOverview: "WABA Health Overview",
            manageChannelDetail: "Manage your channel information",
            wpBussChannelDetail: "WhatsApp Business Channel Detail",
            manageWpBussChannel: "Manage your WhatsApp business channel",
            channelName: "Channel name",
            phoneNumberE164: "Phone number",
            phoneNumberE164Place: "Phone number e.g. 908501234455",
            channelUpdatedSucs: "Channel updated successfully",
            faieldUpdateChannel: "Failed to update channel",
            completeSetup: "Complete Setup",
            completeSetupDescription:
                "To complete the WhatsApp Business API setup, please click the button below to go to the connection page.",
            connectWhatsAppBusinessAccount: "Connect WhatsApp Business Account",
            infoLabel: "Information",
            onboardingInfoDescription:
                "Your Facebook Business account and WhatsApp number must be ready for WhatsApp Business API setup.",
            businessId: "Business ID",
            phoneNumberId: "Phone Number ID",
            wabaId: "WABA ID",
            verifiedNameLabel: "Verified Name",
            userAccessibility: "User Accessibility",
            userAccessibilityDesc:
                "The people specified below can see contacts and chats in this channel (cannot access if ownership is set). This setting is used in: <ul><li><strong>Automatic chat assignment:</strong> Incoming customers to this channel are assigned according to visibility; chats are not assigned to those without access</li><li><strong>Forwarding:</strong> Forwarding a chat from elsewhere or adding another agent to a chat must match these settings; forwarding is not allowed to unauthorized users</li><li><strong>Contact/customer lists:</strong> The lists you see are based on this setting; if you cannot see some contacts, it may be related to this</li><li><strong>Ownership:</strong> You can assign a customer to an agent within this setting</li></ul>",
            makePublicButton: "Make Public",
            channelOwners: "Channel Owners",
            channelOwnersDesc:
                "Channel owners have permission to view all conversations in this channel. They can read all messages regardless of visibility settings.",
            editChannelOwners: "Edit Channel Owners",
            selectChannelOwner: "Select Channel Owner",
            selectChannelOwnerDesc: "Select the agents who will own this channel",
            makePublicConfirmTitle: "Are you sure you want to make this channel public?",
            makePublicConfirmContent:
                "After this action, all agents will be able to see conversations in this channel.",
            makePublicConfirmOk: "Yes, Make Public",
            makePublicSuccessMessage: "Channel has been made public",
            stepSetupTemplate: "Set up template",
            stepEditTemplate: "Edit template",
            stepSubmitReview: "Submit for Review",
            templateNameAndLanguage: "Template name and language",
            editModeNoticeText:
                "In edit mode, template name and language cannot be changed. Only category (if not approved), components, and time-to-live can be edited.",
            nameYourTemplate: "Name your template",
            enterTemplateNamePlaceholder: "Enter a template name",
            selectLanguage: "Select language",
            content: "Content",
            footerOptional: "Footer • Optional",
            enterTextPlaceholder: "Enter text",
            bodyLabel: "Body",
            bodyPlaceholder: "Enter your message body text",
            bold: "Bold",
            italic: "Italic",
            strikethrough: "Strikethrough",
            headerLabelRecommended: "Recommended",
            headerLabelOptionalTextOnly: "Optional (Text only)",
            headerLabelRequiredProduct: "Required (Product)",
            headerLabelOptional: "Optional",
            headerNone: "None",
            headerTextOption: "Text",
            headerDocument: "Document",
            headerProduct: "Product",
            productHeaderAutoSet: "Product header is automatically set when using product templates.",
            headerTextPlaceholder: "Add a short line of text to the header of your message",
            mediaHintNote: "Note:",
            mediaHintIntro: "Following are the file formats and sizes accepted:",
            mediaHintImage: "Image: JPEG, PNG (Max 5 MB)",
            mediaHintVideo: "Video: MP4 (Max 16 MB)",
            mediaHintDocument: "Document: PDF (Max 100 MB)",
            productHeaderAutoInfo:
                "Product header is automatically added from your catalog. No manual configuration needed.",
            carouselContentDescription:
                "Create two separate messages: First the general text message (body). Second, the carousel cards with image/video. Each carousel card can have its own body text (optional) and buttons (required, at least 1). The main body message cannot have buttons; only carousel cards can have buttons.",
            contentDescriptionProduct:
                "Add body text for your product message template. Product header is automatically added from your catalog. Cloud API hosted by Meta will review template variables and content.",
            contentDescriptionLTO:
                "Add header and body for your limited time offer template. Footer is not supported for this template type. Cloud API hosted by Meta will review template variables and content.",
            contentDescriptionCarousel:
                "Add general body text and carousel cards. Each carousel card has its own header, optional body text, and buttons. The main body message cannot have buttons; only carousel cards can have buttons. Cloud API hosted by Meta will review template variables and content.",
            contentDescriptionDefault:
                "Add header, body, and footer for your template. Cloud API hosted by Meta will review template variables and content.",
            readyToSubmit: "Ready to submit",
            submitReviewDescription:
                "Your template will be submitted for Meta review. This usually takes a few minutes but can take up to 24 hours.",
            bodyContentAdded: "Body content added",
            buttonsAddedCount: "{count} buttons added",
            previous: "Previous",
            discard: "Discard",
            next: "Next",
            submitForReview: "Submit for Review",
            updateTemplate: "Update Template",
            cannotProceed: "Cannot Proceed",
            noChangesReason:
                "No changes have been made to the template. Please make at least one change before proceeding.",
            categoryCannotChangeWarning: "Category cannot be changed for approved templates.",
            setupYourTemplate: "Set up your template",
            setupDescription:
                "Choose the category that best describes your message template. Then select the type of message you want to send.",
            learnMoreCategories: "Learn more about categories.",
            marketing: "Marketing",
            utility: "Utility",
            authentication: "Authentication",
            categoryCannotChangeApproved: "Category cannot be changed for approved templates",
            categoryCannotEditApproved:
                "Category cannot be edited for approved templates. Only components and time-to-live can be edited.",
            notSupported: "Not Supported",
            selectProductMessageType: "Select product message type",
            selectOtpAutofillType: "Select OTP autofill type",
            templatePreview: "Template preview",
            previewAlt: "Preview",
            previewAltCallPermission: "Call Permission Request",
            previewSampleCard: "Sample Card",
            previewCardPreview: "Card Preview",
            previewBodyMarketingDefault:
                "Hey there! Check out our fresh groceries now! Use code HEALTH to get additional 10% off on your entire purchase.",
            previewBodyCarouselStep0: "Check out our featured products! Swipe to explore amazing deals.",
            previewSpecialOffer: "Special Offer",
            previewEndsIn2Days: "Ends in 2 days",
            previewExpiresLabel: "Expires: ",
            previewSeeAllOptions: "See all options",
            previewBodyLto:
                "Starting now! Buy two, get one free on our new soap collection. Make this Black Friday unforgettable with artisanal, handmade soaps.",
            previewWinterSaleHeader: "Our Winter Sale is on!",
            previewBodyCoupon:
                "Shop now through the end of December and use the one-time use code WINTER25 to get 25% off of your entire order!",
            previewViewBizCatalog: "View {BIZ_NAME}'s Catalog on WhatsApp",
            previewBrowseCatalogueDetails: "Browse pictures and details of their offerings.",
            previewBodyCatalogue:
                "Now shop for your favorite products right here on WhatsApp! Browse our full catalogue.",
            previewBodyCatalogueSingle: "Check out this amazing product! Perfect for your needs.",
            previewBodyCatalogueMulti: "Forget something? Looks like you left these items in your cart.",
            previewBodyCatalogueCarousel:
                "Discover our latest products! Browse our catalogue and find exactly what you're looking for.",
            previewBodyUtility:
                "Good news! Your order 23KFEJJ2312 has shipped! Here's your tracking information, please check link below.",
            previewBodyAuth: "123456 is your verification code. For your security, do not share this code.",
            previewBodyPlaceholder: "Your message body will appear here",
            previewBodyCarouselPlaceholder: "Your carousel message body will appear here",
            previewButtonN: "Button {n}",
            previewProductNDescription: "Product {n} description",
            previewTemplateGoodFor: "This template is good for",
            previewTemplateAreasCustomise: "Template areas that you can customise",
            previewDescCatalogue: "Product/service discovery, sales, offers, targeted marketing, personalised shopping",
            previewDescCoupon:
                "Send promotional codes with a copy button for easy redemption. Limited to one copy code button.",
            previewDescCarousel:
                "Showcase multiple products or services in a horizontally scrollable view. Each card can have its own image, description, and call-to-action buttons.",
            previewDescMarketing: "Welcome messages, promotions, offers, coupons, newsletters, announcements",
            previewDescUtility: "Order confirmations, account update, receipts, appointment reminders, billing",
            previewDescAuth: "One-time password, account recovery code, account verification, integrity challenges",
            previewCustomisableCallPermission: "Header, body, footer",
            previewCustomisableCoupon: "Header (text), body, button (except copy code text)",
            previewCustomisableCarousel: "General body message, carousel cards (each with media, body, buttons)",
            previewCustomisableMarketing: "Media, header, body, footer, button",
            previewCustomisableUtility: "Header, body, footer",
            previewCustomisableAuth: "Body",
            productMessage: "Product Message",
            callUs: "Call Us",
            unsubscribe: "Unsubscribe",
            trackShipment: "Track shipment",
            choosePreference: "Choose preference",
            autoVerify: "Auto-verify",
            yourTemplateNamePlaceholder: "your_template_name",
            templateNameLabel: "Template name",
            categoryLabel: "Category",
            languageLabel: "Language",
            templateCreatedSuccess: "Template created successfully and submitted for review!",
            templateUpdatedSuccess: "Template updated successfully!",
            mediaUploadedSuccess: "Media uploaded successfully",
            mediaUploadFailedPrefix: "Media upload failed: ",
            nameRequired: "Template name is required",
            nameInvalidChars: "Only lowercase letters, numbers, and underscores are allowed",
            nameMaxLength: "Template name must be 512 characters or less",
            bodyRequired: "Body content is required",
            ltoRequiresOneButton: "Limited Time Offer requires at least one button",
            ltoRequiresUrlButton: "Limited Time Offer requires a URL button",
            carouselRequiresOneCard: "Carousel template requires at least one card",
            cardMustHaveButton: "Card {index} must have at least one button",
            cardMustHaveHeaderMedia: "Card {index} must have a header image or video",
            ltoUrlButtonCannotRemove: "Limited Time Offer requires at least one URL button and it cannot be removed",
            ltoRequiresOneButtonWarning: "Limited Time Offer requires at least one button",
            copyCodeButtonRequired: "Copy Code button is required for Coupon Code templates and cannot be removed",
            carouselCardMustHaveButton: "Each carousel card must have at least one button",
            imageMaxSize: "Image must be less than 5 MB",
            videoMaxSize: "Video must be less than 16 MB",
            documentMaxSize: "Document must be less than 100 MB",
            fileUploadFailed: "File upload failed",
            uploadFileLoading: "Uploading file...",
            templateTypeDefault: "Default",
            templateTypeDefaultDesc: "Send messages with media and customised buttons to engage your customers.",
            templateTypeLimitedTimeOffer: "Limited Time Offer",
            templateTypeLimitedTimeOfferDesc: "Create urgency with time-sensitive promotions and offer codes.",
            templateTypeCarousel: "Carousel",
            templateTypeCarouselDesc:
                "Send a carousel of cards with images and buttons to showcase multiple products or offers.",
            templateTypeProductMessage: "Product Message",
            templateTypeProductMessageDesc: "Send messages that drive sales by connecting your product catalogue.",
            templateTypeCallPermission: "Calling permissions request",
            templateTypeCallPermissionDesc: "Ask customers if you can call them on WhatsApp.",
            templateTypeCouponCode: "Coupon Code",
            templateTypeCouponCodeDesc: "Send promotional codes with a copy button for easy redemption.",
            templateTypeUtilityDefault: "Default",
            templateTypeUtilityDefaultDesc: "Send messages about an existing order or account.",
            templateTypeOtp: "One-time passcode",
            templateTypeOtpDesc: "Send codes to verify a transaction or login.",
            catalogueSubtypeCatalogue: "Catalogue Message",
            catalogueSubtypeCatalogueDesc: "Display your full product catalogue with a view catalog button.",
            catalogueSubtypeMultiProduct: "Multi-Product Message",
            catalogueSubtypeMultiProductDesc: "Show up to 30 products from your catalogue in a single message.",
            catalogueSubtypeSingleProduct: "Single-Product Message",
            catalogueSubtypeSingleProductDesc: "Highlight a single product with details and call-to-action button.",
            catalogueSubtypeProductCardCarousel: "Product Card Carousel",
            catalogueSubtypeProductCardCarouselDesc: "Display up to 10 product cards in a carousel view.",
            catalogueSubtypeDisabledReason:
                "Currently not supported. This template type requires a product catalogue integration.",
            authSubtypeCopyCode: "Copy Code",
            authSubtypeCopyCodeDesc: "User manually copies the code (standard OTP).",
            authSubtypeOneTap: "One Tap",
            authSubtypeOneTapDesc: "Auto-fill code with one tap on supported Android devices.",
            authSubtypeZeroTap: "Zero Tap",
            authSubtypeZeroTapDesc: "Auto-fill code automatically without user interaction (requires user consent).",
            viewCatalog: "View Catalog",
            viewProduct: "View Product",
            viewProducts: "View Products",
            view: "View",
            copyOfferCode: "Copy Offer Code",
            oneTapAutofill: "One Tap Autofill",
            zeroTapAutofill: "Zero Tap Autofill",
            shopNow: "Shop now",
            viewItems: "View items",
            autofill: "Autofill",
            messageTtlOptional: "Message Time-to-Live (TTL) • Optional",
            selectTtlPlaceholder: "Select TTL or leave default",
            ttlDescMarketing: "If we cannot deliver your marketing message, we will retry for the specified duration.",
            ttlDescUtility: "Set how long we will deliver utility messages such as order confirmations or receipts.",
            ttlDescAuthentication: "Define how long authentication codes are valid for delivery.",
            ttlInfoMarketing: "Marketing templates: 12 hours to 30 days. Default is system-defined.",
            ttlInfoUtility: "Utility templates: 30 seconds to 12 hours, or -1 for 30 days. Default is system-defined.",
            ttlInfoAuthentication:
                "Authentication templates: 30 seconds to 15 minutes, or -1 for 30 days. Default is system-defined.",
            ttlOption12Hours: "12 hours (43,200 seconds)",
            ttlOption1Day: "1 day (86,400 seconds)",
            ttlOption3Days: "3 days (259,200 seconds)",
            ttlOption7Days: "7 days (604,800 seconds)",
            ttlOption15Days: "15 days (1,296,000 seconds)",
            ttlOption30Days: "30 days (2,592,000 seconds)",
            ttlOption30Seconds: "30 seconds",
            ttlOption1Minute: "1 minute (60 seconds)",
            ttlOption2Minutes: "2 minutes (120 seconds)",
            ttlOption3Minutes: "3 minutes (180 seconds)",
            ttlOption5Minutes: "5 minutes (300 seconds)",
            ttlOption10Minutes: "10 minutes (600 seconds)",
            ttlOption15Minutes: "15 minutes (900 seconds)",
            ttlOption30Minutes: "30 minutes (1,800 seconds)",
            ttlOption1Hour: "1 hour (3,600 seconds)",
            ttlOption2Hours: "2 hours (7,200 seconds)",
            ttlOption4Hours: "4 hours (14,400 seconds)",
            ttlOption6Hours: "6 hours (21,600 seconds)",
            ttlOption30DaysSpecial: "30 days (special value: -1)",
            authSettings: "Authentication Settings",
            addSecurityRecommendation: "Add security recommendation",
            securityRecommendationHint: 'Adds the message "For your security, do not share this code".',
            authMessageTtlHint: "Time limit for message delivery (60-600 seconds). Leave empty for default.",
            authTtlPlaceholder: "60-600",
            authCodeExpPlaceholder: "1-90",
            authPackagePlaceholder: "com.example.app",
            authSignatureHash: "Signature hash",
            messageTtlSecondsOptional: "Message TTL (seconds) • Optional",
            codeExpirationOptional: "Code expiration (minutes) • Optional",
            codeExpirationHint: "How long the OTP code is valid. Shown in footer.",
            zeroTapTerms: "I accept Zero Tap terms and conditions",
            zeroTapTermsHint: "Required for Zero Tap autofill to work.",
            supportedAndroidAppsOptional: "Supported Android Apps • Optional",
            addApp: "Add app",
            limitedTimeOfferLabel: "Limited Time Offer",
            ltoDescription:
                "Add text that will create urgency for your offer. Expiration time will be set when the message is sent.",
            ltoPlaceholder: "e.g., Expiring offer!, Flash sale!",
            showExpirationTimer: "Show expiration timer",
            ltoExpirationHint: "When enabled, WhatsApp will display a countdown based on when the message was sent.",
            carouselCards: "Carousel Cards",
            carouselCardsDescription:
                "These cards will appear as a second message after the general body text. Each card must have an image/video header and at least one button (up to 2 buttons). Card body text is optional and supports variables. You can add up to 10 cards.",
            carouselCardN: "Card {n}",
            carouselButtonsLabel: "Buttons * (at least 1, up to 2)",
            cardHeaderRequired: "Card Header",
            cardBodyOptional: "Card Body • Optional",
            cardBodyPlaceholder: "Enter card body text (optional)",
            image: "Image",
            video: "Video",
            moveUp: "Move up",
            moveDown: "Move down",
            remove: "Remove",
            dragDropUpload: "Drag and drop to upload",
            orChooseFiles: "Or choose files on your device",
            uploadingToMeta: "Uploading to Meta...",
            uploadedSuccessfully: "Uploaded successfully",
            addQuickReplyButton: "Add Quick Reply Button",
            addCtaButton: "Add CTA Button",
            urlButtonRequiredLto: "URL button is required for Limited Time Offer",
            copyCodeButtonFixed: "Copy code button text cannot be customized in coupon code templates",
            copyCode: "Copy code",
            fixed: "Fixed",
            buttonsHeading: "Buttons",
            buttonLabelAutoAdded: "Auto-added",
            buttonLabelRequiredCopyCode: "Required (1 Copy Code + Optional)",
            buttonLabelRequiredUrl: "Required (1 URL + Optional)",
            buttonLabelOptional: "Optional",
            buttonDescCatalogue: "A product button is automatically added. You can customize the button text.",
            buttonDescCallPermission:
                "A call permission button is automatically added. No additional buttons can be added.",
            buttonDescAuth: "An authentication button is automatically added. You can customize the button text.",
            buttonDescCoupon:
                "One Copy Code button is required and its text cannot be customized. You can add additional Quick Reply or CTA buttons up to 10 total.",
            buttonDescLto:
                "Limited time offers require at least one URL button (required). You can add additional CTA buttons (Phone, Copy Offer Code) or Quick Reply buttons.",
            buttonDescDefault:
                "Add Quick Reply buttons for quick responses or CTA buttons for actions. Maximum 10 buttons total.",
            buttonPlaceholderText: "Button text",
            buttonMax10Warning: "Maximum 10 buttons allowed",
            buttonCopyCodeAutoAddedWarning: "Copy Code button is automatically added and cannot be manually added",
            exampleValuePlaceholder: "example_value",
            copyCodeExamplePlaceholder: "SUMMER20",
            quickReply: "Quick Reply",
            visitWebsite: "Visit Website",
            callPhone: "Call Phone",
            addCard: "Add Card",
            title: "WhatsApp Business API Channels",
            integration: "Integration",
            detail: "Detail",
            visibility: "Visibility",
            templates: "All template messages",
            settings_group: "Settings",
            template_message_group: "Template messages",
            chat_initiator_template: "Chat initiator template",
            contacts: "Contacts",
            numbers: "Numbers",
            all_contacts: "All contacts",
            new_template: "Create new template",
            broadcast_group: "Broadcast",
            broadcast_requests: "Broadcast requests",
            customer_groups: "Customer groups",
            businessChannelDetail: "WhatsApp Business Channel Detail",
            wallet: "Wallet",
            postacellMessage: "Send SMS",
            postacellAllMessage: "Send bulk SMS",
            message_group: "Message",
            createNewTemplate: "Create a new template message",
            templateName: "Template name",
            templateNameDesc: "Give a name to your message template.",
            templateInfo: "Template information",
            viewTemplates: "View templates",
            templateListTitle: "Message templates",
            templateListShownTotal: "{shown} templates shown (total: {total})",
            templateListCreateButton: "Create Template",
            templateListSearchPlaceholder: "Search templates...",
            templateListAllCategories: "All Categories",
            templateListAllStatus: "All Status",
            templateListStatusApproved: "Approved",
            templateListStatusPending: "In Review",
            templateListRefresh: "Refresh",
            templateListTotalTemplates: "Total {count} templates",
            templateListCopied: "Copied!",
            templateListCopy: "Copy",
            templateListIdLabel: "ID:",
            templateListPreview: "Preview",
            templateListEdit: "Edit",
            templateListDelete: "Delete",
            templateListPreviewTitle: "Template Preview",
            templateListNameLabel: "Name:",
            templateListCategoryLabel: "Category:",
            templateListLanguageLabel: "Language:",
            templateListStatusLabel: "Status:",
            templateListReasonLabel: "Reason:",
            templateListRecommendationLabel: "Recommendation:",
            templateListColumnName: "TEMPLATE NAME",
            templateListColumnCategory: "CATEGORY",
            templateListColumnStatus: "STATUS",
            templateListColumnLastEdited: "LAST EDITED",
            templateListStatusActive: "Active",
            templateListStatusInReview: "In review",
            templateListStatusRejected: "Rejected",
            templateListStatusFailed: "Failed",
            templateListQualityHigh: "High Quality",
            templateListQualityMedium: "Medium Quality",
            templateListQualityLow: "Low Quality",
            templateListDeleteConfirmTitle: "Delete Template",
            templateListDeleteConfirmContent: 'Are you sure you want to delete "{{name}}"?',
            templateListDeleteConfirmOk: "Delete",
            templateListDeleteConfirmCancel: "Cancel",
            templateListCopyIdError: "An error occurred while copying the ID",
            templateListDeletedSuccess: "{{name}} deleted successfully.",
            templateListDeleteFailed: "Failed to delete template.",
            templateNameRules: "Template name can only include lowercase letters, numbers, and underscores.",
            category: "Category",
            categoryDesc: "Select what type of template you want to create",
            categoryUtility: "Utility",
            categoryUtilityDesc: "Send utility information such as account updates, order updates, alerts, and more.",
            categoryMarketing: "Marketing",
            categoryMarketingDesc:
                "Send promotional offers, product offers, and more to increase awareness and engagement.",
            categoryAuth: "Authentication",
            categoryAuthDesc: "Send codes for your customers to access their accounts.",
            optional: "Optional",
            languageDesc: "Select the language in which your template message will be sent",
            header: "Header",
            headerRules: "Add a 60-character header to your message. Only one variable is supported in the header.",
            headerOptionMedia: "Media",
            headerOptionText: "Text",
            none: "None",
            headerType: "Header type",
            headerText: "Header text",
            body: "Body",
            bodyRules: "Enter text in the language you selected for your message",
            addVariable: "Add variable",
            variables: "Variables",
            variable: "Variable",
            defaultVariableName: "Default variable name",
            defaultVariableToolTip:
                "Your variable appears in the template with this name. <br><br> Additionally, this value is sent as the default in case of other situations.",
            selectATemplate: "Select a message template",
            variableSettings: "Variable settings",
            example: "Example",
            dynamicUrlSampleNote:
                "Sample dynamic URL with variable (Note: Do not add the URL in your sample message body above)",
            footer: "Footer",
            footerDesc: "Add a 60-character footer to your message. Variables are not supported in the footer.",
            buttons: "Buttons",
            buttonType: "Button type",
            buttonTypeReply: "Reply",
            submit: "Save",
            submitting: "Submitting",
            addButton: "Add button",
            rejectWhatsapp: "Rejected by WhatsApp.",
            approvedWhatsapp: "Approved by WhatsApp.",
            pendingWhatsapp: "Pending approval",
            daily_usages: "Daily usages",
            bussinesDesciption: "Business Description",
            succesDesc: "Your profile information has been successfully updated.",
            reports: "Reports",
            businessDescription: "Description of your business.",
            failedUpdateChannel: "Failed to update channel",
            postacellMessagepostacellMessage: "Send SMS",
            selectBusinessVertical: "Select Business Area",
            stateIfApplicable: "State (if applicable)",
        },
        multi_whatsapp_api: {
            profile: "Profile",
            integration: "Integration",
            detail: "Detail",
            visibility: "Visibility",
            templates: "Template",
            settings_group: "Settings",
            template_message_group: "Template Messages",
            new_template: "New Template",
            broadcast_group: "Broad Cast",
            broadcast_requests: "Broad Cast Request",
            customer_groups: "Customer Groups",
            chat_initiator_template: "Chat İnitiator Template",
            contacts: "Contacts",
            numbers: "Numbers",
            all_contacts: "All Contacts",
        },
        archive: {
            destroyedBy: {
                agent: "Agent",
                visitor: "Visitor",
                system: "System",
                chatbot: "Chatbot",
            },
        },
        waba: {
            templateCreationFailed: "Template Creation Failed",
            templateError_2388040: "Character Limit Exceeded",
            templateErrorDesc_2388040: "A field in your template has exceeded the maximum character limit allowed.",
            templateError_2388047: "Message Header Format is Incorrect",
            templateErrorDesc_2388047: "Your message header contains invalid formatting.",
            templateError_2388072: "Message Body Format is Incorrect",
            templateErrorDesc_2388072: "Your message body contains invalid formatting.",
            templateError_2388073: "Message Footer Format is Incorrect",
            templateErrorDesc_2388073: "Your message footer contains invalid formatting.",
            templateError_2388293: "Parameters Words Ratio Exceeds Limit",
            templateErrorDesc_2388293:
                "This template has too many variables for its length. Reduce the number of variables or increase the message length.",
            templateError_2388299: "Leading or Trailing Parameters Not Allowed",
            templateErrorDesc_2388299: "Variables cannot be at the start or end of the template.",
        },
        upgradeMessages: {
            ticket: "Even if you are offline, your requests are recorded instantly with artificial intelligence and chatbot. Always keep your customers satisfied!",
            tasks: "Easily manage your tasks and projects. Collaborate with your team and deliver projects on time!",
            calendar:
                "Easily plan your appointments and meetings. Stay in sync with your team and manage your time more efficiently!",
            mail_integration:
                "Easily manage your emails. Strengthen communication with your customers and improve collaboration!",
            team_integration:
                "Communicate faster and more effectively with your team. Enhance collaboration and ensure timely project delivery!",
            webhook_integration: "Connect your applications using Webhook integration and simplify data exchange!",
            whatsapp_v2:
                "Improve communication with your customers through WhatsApp integration for faster and more efficient communication!",
            whatsapp:
                "Enhance communication with your customers using WhatsApp integration for faster and more effective communication!",
            whatsapp_business_api:
                "Take advantage of WhatsApp Business API to communicate with your customers more efficiently and effectively!",
            instagram: "Engage with your customers more effectively using Instagram integration!",
            messenger: "Communicate with your customers easily via Messenger integration!",
            sms_postacell: "Communicate quickly and effectively with your customers using SMS integration!",
            ready_contents: "Ready Contents help you communicate with your customers faster and more effectively.",
            automation: "Automate your workflows to save time and manage tasks more efficiently!",
            form: "Use the Form Builder to streamline customer interactions, collect valuable information, and enhance collaboration!",
            customer_tables: "Create custom tables and manage customer information efficiently!",
            trendyol:
                "Enhance communication with your customers through Trendyol integration for seamless interaction!",
            access_control: "Protect your data and prevent unauthorized access with access control features!",
            upgrade: "Upgrade My Subscription",
            upgradeFeature: "Buy Additional Package",
            featureNotAvailable: "feature not available.",
            usageLimitExceeded: "Usage limit exceeded.",
            maxAgentCount: "Upgrade your plan to serve more customers by adding additional agents.",
            maxTriggerCount: "Upgrade your plan to create more interactions by adding additional triggers.",
            visitorStartChat: "Upgrade your plan to initiate chats with visitors who haven't interacted before.",
            voiceCalling: "Upgrade your plan to communicate more effectively with customers through voice calls.",
            videoCalling: "Upgrade your plan to communicate more effectively with customers through video calls.",
            fileAndVoiceMessage: "Upgrade your plan to send files and voice messages to your customers.",
            autoTranslation: "Upgrade your plan to serve more customers with automatic message translation.",
            telegramEntegration: "Upgrade your plan to enable Telegram integration.",
            chatCopilot: "Upgrade your plan to provide better service with AI-powered Chat Copilot.",
            calenderEntegration:
                "Upgrade your plan to synchronize with other applications through calendar integration.",
            mailEntegration: "Upgrade your plan to manage emails more effectively and improve customer communication.",
            smsEntegration: "Upgrade your plan to reach customers faster with SMS integration.",
            ticketSystem: "Upgrade your plan to manage customer requests more efficiently with a ticket system.",
            taskManagementEntegration: "Upgrade your plan to streamline workflows with task management integration.",
            webhookEntegration: "Upgrade your plan to synchronize with other applications via webhook integration.",
            readyContents: "Upgrade your plan to enhance customer communication with ready-made content.",
            automationEntegration: "Upgrade your plan to streamline workflows with automation integration.",
            customerTablesEntegration:
                "Upgrade your plan to manage customer data more effectively with customer tables.",
            formEntegration: "Upgrade your plan to manage customer requests more efficiently using forms.",
            maxFormLimit: "Upgrade your plan to create more forms and manage customer requests more effectively.",
            maxFormFieldLimit: "Upgrade your plan to add more form fields and manage customer requests efficiently.",
            maxCustomerTableCount: "Upgrade your plan to add more customer tables.",
            maxCustomerTableFieldCount: "Upgrade your plan to add more customer table fields.",
            maxCustomerTableViewCount: "Upgrade your plan to save more customer table views.",
            maxCustomerTableRecordCount: "Upgrade your plan to add more customer table records.",
            maxAutomationButton: "Upgrade your plan to add more automation blocks.",
            automationTimerBase: "Upgrade your plan to use automation timers.",
            automationEventBase: "Upgrade your plan to use automation events.",
            automationWebhookBase: "Upgrade your plan to use automation webhooks.",
            automationButtonBase: "Upgrade your plan to use automation buttons.",
            liveScore: "Upgrade your plan to enable live monitoring.",
            multipleChatWindow: "Upgrade your plan to open multiple chat windows simultaneously.",
            maxTaskWorkflowLimit: "Upgrade your plan to add more task workflows.",
            maxTaskColumnLimit: "Upgrade your plan to add more task columns.",
            maxTaskRowLimit: "Upgrade your plan to add more task rows.",
            maxDepartmentLimit: "Upgrade your plan to add more departments.",
            maxRoleLimit: "Upgrade your plan to add more roles.",
            maxReadyContentsLimit: "Upgrade your plan to add more ready-made content.",
            excelDownload: "Upgrade your plan to enable Excel download functionality.",
            customerGroup: "Upgrade your plan to utilize customer group features.",
            maxMailCount: "Upgrade your plan to send more emails.",
            maxWhatsappChannel: "Upgrade your plan to add more WhatsApp channels.",
            maxBusinessWhatsappChannel: "Upgrade your plan to add more WhatsApp Business channels.",
            maxInstagramChannel: "Upgrade your plan to add more Instagram channels.",
            maxMessengerChannel: "Upgrade your plan to add more Messenger channels.",
            maxTelegramChannel: "Upgrade your plan to add more Telegram channels.",
            maxTrendyolChannel: "Upgrade your plan to add more Trendyol channels.",
            maxMetaLeadChannel: "Upgrade your plan to add more Meta Lead channels.",
        },
        setupWizard: {
            finishModalVideos: "Training Videos",
            finishModalDoc: "Documentation",
            finsihModalLiveSupport: "Live Support",
            completed: "Got it",
            completedWarning: "Click the button to complete the setup and finish the guide",
            supsisSetupGuide: "Supsis Setup Guide",
            supsisSetupGuideDescription: "Please complete these steps to fully utilize Supsis.",
            goToSetup: "Go to Setup",
            completionPercentageDescription: "You are using only % {percentage} of the features offered by Supsis.",
            aiChatbot: {
                title: "AI Chatbot",
                content:
                    "Respond to incoming messages automatically, instantly, and intelligently with Supsis AI Chatbot.",
                steps: {
                    step1: {
                        title: "Create Chatbot",
                        content:
                            "Use this button to create a new <b>chatbot scenario</b>. You can either quickly start by selecting one of the specially prepared templates for you, or design a completely original scenario from scratch to create a chatbot that fully meets your business needs.",
                    },
                    step2: {
                        title: "Ready-Made Scenarios",
                        content:
                            "Easily understand the basic working logic of the chatbot with the <b>ready-made templates</b> here. Save time by customizing these templates according to your needs and develop tailored solutions. You can start by choosing any of the templates listed below, suitable for different use cases.",
                    },
                    step3: {
                        title: "Chatbot Integrations",
                        content:
                            "Integrate your prepared chatbot with <b>popular social media platforms such as WhatsApp, Instagram, and Facebook</b>. In this way, you can activate your chatbot directly on the channels your customers use, increasing your accessibility and engagement rates.",
                    },
                    step4: {
                        title: "Chatbot Analytics",
                        content:
                            "View and analyze your chatbot's <b>performance with detailed charts and statistics</b>. By filtering according to specific time periods or the platforms you have integrated, you can measure your chatbot's effectiveness, identify areas for improvement, and optimize your strategies.",
                    },
                },
            },
            aiAssistant: {
                title: "AI Assistant",
                content: "Activate the digital assistant to help your support team.",
                steps: {
                    step1: {
                        title: "OpenAI Integration",
                        content:
                            "<p>Establish a <b>seamless integration</b> between OpenAI and Supsis AI to increase your business efficiency. This way, your powerful AI assistant will be activated and start optimizing your processes. To complete the integration, all you need to do is enter your OpenAI API key. <br> <br> <b>To get your OpenAI API key, <a href='https://platform.openai.com/account/api-keys' target='_blank'>click here</a>.</b></p>",
                    },
                },
            },
            aiLiveSupport: {
                title: "AI Live Support",
                content: "Activate the AI-powered live chat system.",
                steps: {
                    step1: {
                        title: "Filter Conversations",
                        content:
                            "Easily manage <b>all customer conversations</b> from this area. You can prioritize conversations by filtering them into different categories such as unread, pending, or those ongoing with the chatbot, ensuring that no request is overlooked.",
                    },
                    step2: {
                        title: "More Detailed View",
                        content:
                            "Use these options to examine customer conversations in more depth. You can apply <b>more detailed filters</b> such as unanswered conversations from yesterday or specific customers who have contacted you, or create your own custom filters to personalize your workflow.",
                    },
                    step3: {
                        title: "Live Support Screen",
                        content:
                            "Switch to this view to <b>efficiently manage all your live support conversations from a centralized screen</b>. View all messages, agent responses, current statuses, and date information for each conversation in one place, enabling you to make quick and accurate decisions.",
                    },
                    step4: {
                        title: "Test Page",
                        content:
                            "Access this section to test the performance and operation of your created chatbot in real time. By sending messages as a visitor, you can <b>closely observe your chatbot's responses and behaviors</b>, allowing you to make all necessary improvements before presenting it to end users.",
                    },
                },
            },
            aiAutomation: {
                title: "AI Automation",
                content: "Automate your support processes and save time.",
                steps: {
                    step1: {
                        title: "Create New Automation",
                        content:
                            "Use this button to create a new automation to streamline your business processes. You can design automations that are event-based (e.g., when a new message arrives), time-based (e.g., at a specific time every morning), or <b>Webhook-based</b> to make your workflows smarter.",
                    },
                    step2: {
                        title: "Automation Categories",
                        content:
                            "When you have many automations, create <b>automation categories</b> from this section to make management easier. Categorization helps you keep your automations organized and find them quickly when needed. Use this button to create a new category.",
                    },
                    step3: {
                        title: "Executed Tasks",
                        content:
                            "After creating and publishing your automations, you can <b>instantly track how many tasks your automations have executed</b> from this section. This allows you to observe how active your automations are and which processes they affect.",
                    },
                    step4: {
                        title: "Automation Statistics",
                        content:
                            "Review <b>comprehensive performance statistics</b> of your automations in this section. See how often each automation runs, the number of successful tasks, the success rate, and any error rates to optimize your automation strategies.",
                    },
                },
            },
            aiDynamicCrm: {
                title: "AI CRM",
                content: "Analyze and manage your customer interactions with artificial intelligence.",
                steps: {
                    step1: {
                        title: "Filter Visitors",
                        content:
                            "Easily <b>filter visitors</b> in your customer database. You can search for visitors by name, email address, phone number, tag, or custom profile fields. You can also access this section for more detailed viewing and analysis.",
                    },
                    step2: {
                        title: "View Visitors",
                        content:
                            "All your visitors are listed in this table. <b>Double-click the relevant row to access more information and take action on a visitor</b>. In the opened window, you can access the visitor's communication history, notes, and other detailed information.",
                    },
                    step3: {
                        title: "Manual Blocking",
                        content:
                            "You can <b>manually block visitors</b> who exhibit unwanted or inappropriate behavior. Blocked visitors are displayed in a separate list, and you can remove the block from this section if needed.",
                    },
                    step4: {
                        title: "Tags",
                        content:
                            "Make your CRM more organized and manageable by <b>categorizing your visitors with tags</b>. To assign tags to visitors, you first need to create your own tags. Use this button to create a new tag.",
                    },
                    step5: {
                        title: "Profile Fields",
                        content:
                            "<b>Profile fields</b> allow you to collect additional information about your visitors and manage this information in an organized way. This way, you can deepen your customer segmentation, offer personalized service, and make your customer relationships more effective.",
                    },
                },
            },
            whatsappBusiness: {
                title: "WhatsApp Business",
                content: "Manage your support messages by connecting your WhatsApp Business account.",
                steps: {
                    step1: {
                        title: "WhatsApp Business Integration",
                        content:
                            "<p><b>Connect your WhatsApp Business account to Supsis</b> and manage all your customer support messages from a single central panel. With this integration, you can send instant messages via WhatsApp, make bulk announcements, set up automated replies, and comprehensively track your customer interactions.</p>",
                    },
                },
            },
            whatsappWeb: {
                title: "WhatsApp Web",
                content: "Manage messages received via WhatsApp Web with Supsis AI.",
                steps: {
                    step1: {
                        title: "WhatsApp Web Integration",
                        content:
                            "<p><b>Seamlessly manage all messages received via WhatsApp Web with Supsis AI.</b> With this integration, you can send instant messages via WhatsApp, create bulk messages, set up automated replies, and easily track your customer interactions. This way, you make your customer communication more efficient.</p>",
                    },
                },
            },
            instagram: {
                title: "Instagram",
                content: "Reply to Instagram DMs via Supsis AI.",
                steps: {
                    step1: {
                        title: "Instagram Integration",
                        content:
                            "<p><b>Centralize your customer communication by replying directly to Instagram DMs via Supsis AI.</b> With this integration, you can send instant messages via Instagram, make bulk announcements, set up automated replies, and comprehensively track your customer interactions.</p>",
                    },
                },
            },
            facebook: {
                title: "Facebook",
                content: "Manage messages from your Facebook page in a single panel.",
                steps: {
                    step1: {
                        title: "Facebook Integration",
                        content:
                            "<p><b>Effectively manage all messages from your Facebook page with Supsis AI.</b> With this integration, you can send instant messages via Facebook Messenger, create bulk messages, set up automated replies, and track your customer interactions.</p>",
                    },
                },
            },
            telegram: {
                title: "Telegram",
                content: "Integrate Telegram messages with Supsis AI.",
                steps: {
                    step1: {
                        title: "Telegram Integration",
                        content:
                            "<p><b>Integrate Telegram messages with Supsis AI</b> and manage your customer communication from a single panel. With this integration, you can send instant messages via Telegram, create bulk messages, set up automated replies, and effortlessly track all your customer interactions.</p>",
                    },
                },
            },
            mail: {
                title: "Mail",
                content: "Integrate your support emails into the Supsis AI system.",
                steps: {
                    step1: {
                        title: "Create a New Email",
                        content:
                            "<p>Use this button to send a new email. <b>By filling in the email content, recipients, and other necessary information</b>, you can quickly send your personal or bulk emails.</p>",
                    },
                    step2: {
                        title: "Email Templates",
                        content:
                            "<p><b>Manage</b> your email templates from this section. You can edit, delete, or create new templates. By using pre-prepared templates, you can speed up your email sending processes and ensure consistent communication.</p>",
                    },
                    step3: {
                        title: "Send Bulk Emails",
                        content:
                            "<p>Use this area to <b>send bulk emails</b> to reach large audiences. By filling in the required fields, you can easily send bulk emails to your customer list or specific groups in Supsis.</p>",
                    },
                    step4: {
                        title: "Manage Your Customer Groups",
                        content:
                            "<p><b>Effectively manage</b> your customer groups from this section. You can edit, delete, or create new groups. With these groups, you can organize targeted email campaigns and personalize your communication even more.</p>",
                    },
                },
            },
            metaLead: {
                title: "Meta Lead",
                content: "Manage forms received from your Facebook and Instagram ads.",
                steps: {
                    step1: {
                        title: "Meta Lead Integration",
                        content:
                            "<p>With <b>Meta Lead Integration</b>, manage potential customer forms received from your Facebook and Instagram ads directly through Supsis. Thanks to this integration, you can track the leads you obtain from your ad campaigns more efficiently, speed up your communication with potential customers, and increase your conversion rates.</p>",
                    },
                },
            },
            trendyol: {
                title: "Trendyol",
                content: "Manage your Trendyol orders and customer messages.",
                steps: {
                    step1: {
                        title: "Trendyol Integration",
                        content:
                            "<p>Thanks to <b>Trendyol Integration Operations</b>, centrally manage your orders received via Trendyol through Supsis. After completing this integration, you can make your order processes more efficient, facilitate your customer communication, and reduce your operational workload.</p>",
                    },
                },
            },
            formSurvey: {
                title: "Form Surveys",
                content: "Create forms to collect feedback from customers.",
                steps: {
                    step1: {
                        title: "Create a New Form",
                        content:
                            "<p>Use this button to <b>create a new form or survey</b> to collect feedback from your customers. With the forms you create, you can gather valuable customer feedback and make your communication more efficient.</p>",
                    },
                    step2: {
                        title: "Manage Your Forms",
                        content:
                            "<p><b>Manage all your forms effectively</b> from this area. You can edit, archive, delete, or create new forms. You can also track the performance of your published forms, view response rates, and make instant edits when necessary. With form management, you can collect and analyze customer feedback more effectively.</p>",
                    },
                },
            },
            processManagement: {
                title: "Process Management",
                content: "Plan and manage your support processes step by step.",
                steps: {
                    step1: {
                        title: "Manage Your Business Processes",
                        content:
                            "<p>This section allows you to effectively manage all your business processes. <b>You can create tasks, assign them to your team members, and optimize your workflows.</b> In this way, you can make your processes more efficient, track the status of tasks instantly, and increase your team's performance.</p>",
                    },
                    step2: {
                        title: "List Tasks",
                        content:
                            "<p><b>View all your tasks in a list view</b> from this section. You can filter, delete, or create new tasks. Easily track your workload with a comprehensive list view.</p>",
                    },
                    step3: {
                        title: "Task Labels",
                        content:
                            "<p><b>Create labels</b> to better organize and manage your tasks. By using these labels, you can easily categorize tasks and speed up your search processes. You can use this button to create labels.</p>",
                    },
                    step4: {
                        title: "Archive Tasks",
                        content:
                            "<p><b>Archive completed or inactive tasks to keep your workspace organized</b>. Archived tasks are listed here and can be easily restored when needed.</p>",
                    },
                    step5: {
                        title: "Completed Tasks",
                        content:
                            "<p>View your <b>completed tasks</b> from this section. You can change the status of completed tasks and archive them if you wish. In this way, you can keep a record of your completed work and analyze past performance.</p>",
                    },
                },
            },
            calendar: {
                title: "Calendar",
                content: "Manage your meeting and task calendar.",
                steps: {
                    step1: {
                        title: "Calendar",
                        content:
                            "<p>Easily plan your meetings daily with this interactive <b>calendar</b>. You can create new appointments, update existing meetings through the calendar, or cancel them. Optimize your appointment management and effectively control your schedule.</p>",
                    },
                    step2: {
                        title: "Reservation Website",
                        content:
                            "<p>Allow your customers to easily make appointments by using your own <b>reservation website</b>. Your customers can make reservations, view, update, or cancel their existing appointments through this site.</p>",
                    },
                    step3: {
                        title: "View Your Website",
                        content:
                            "<p>Use this button to instantly view the reservation website you created. <b>Check the final version of your website</b> and experience how your customers will see their reservations. All your active reservations will be listed on your website.</p>",
                    },
                    step4: {
                        title: "Create a New Reservation",
                        content:
                            "<p>Use this button to <b>manually create a new reservation</b>. By filling in all the necessary information, you can quickly add the appointment to your calendar and plan your meetings with your customers.</p>",
                    },
                },
            },
            websiteAnalysis: {
                title: "Website Analysis",
                content: "Analyze visitor behavior and gain insights.",
                steps: {
                    step1: {
                        title: "Total Visitors",
                        content:
                            "<p>View the <b>total number of visitors</b> to your website from this area. This metric shows the overall number of unique visitors to your site within a specific time period and helps you understand your site's total reach.</p>",
                    },
                    step2: {
                        title: "Average Visitors",
                        content:
                            "<p>Track the <b>average daily or periodical number of visitors</b> to your website here. This metric is a critical indicator for evaluating your site's consistent performance over time.</p>",
                    },
                    step3: {
                        title: "Maximum Visitors",
                        content:
                            "<p>Observe the <b>times when your website reached the highest number of visitors</b> with this metric. It shows the highest number of visitors to your site within a specific time period, helping you identify peak periods for campaigns or content.</p>",
                    },
                    step4: {
                        title: "Minimum Visitors",
                        content:
                            "<p>Track the <b>times when your website received the fewest visitors</b> with this metric. It shows the lowest number of visitors to your site within a specific time period, helping you identify low-performance periods and take necessary actions.</p>",
                    },
                },
            },
            ticketSystem: {
                title: "Support Ticket System",
                content: "Organize customer requests with a ticket system.",
                steps: {
                    step1: {
                        title: "New Status",
                        content:
                            '<p><b>Create new statuses</b> to facilitate the management of your support requests. For example, by defining customized statuses such as "In Progress", "Resolved", "Pending", you can make the flow of requests more transparent.</p>',
                    },
                    step2: {
                        title: "Statuses",
                        content:
                            '<p><b>View the current statuses</b> for each support request opened here. By tracking statuses such as "Read", "Answered", "Cancelled", you can easily see the current stages of requests and enable effective process management.</p>',
                    },
                    step3: {
                        title: "View Mode",
                        content:
                            "<p>You can switch between <b>list or kanban view</b> to manage your support requests more effectively. By changing the view mode, you can visually track the statuses of requests and choose the layout that best suits your workflow.</p>",
                    },
                },
            },
            dynamicTables: {
                title: "Dynamic Tables",
                content: "Customize and manage your data by filtering.",
                steps: {
                    step1: {
                        title: "Create Category",
                        content:
                            "<p><b>Organize and manage your data better by categorizing your tables</b>. By using the category creation button, you can define new categories, group your tables, and access the data you are looking for more quickly.</p>",
                    },
                    step2: {
                        title: "Create New Table",
                        content:
                            "<p>Use this button to <b>create a new dynamic table tailored to your needs</b>. By filling in the required information on the table creation screen, you can store and manage your data in a personalized structure.</p>",
                    },
                    step3: {
                        title: "Create Table with AI",
                        content:
                            "<p>Use this button to <b>quickly create new tables with AI support</b>. It is enough to enter the relevant information to create a table with AI; the system will help you design efficient tables with smart suggestions.</p>",
                    },
                },
            },
            aiVoice: {
                title: "AI Voice Agent",
                content: "Manage your users' conversations with AI-powered voice agents.",
                steps: {
                    step1: {
                        title: "AI Voice Agent Integration",
                        content:
                            "<p><b>Integrate your AI voice agent into Supsis</b> to automate and improve your customer communication processes. After completing the integration, you can manage voice interactions more efficiently and increase customer satisfaction.</p>",
                    },
                },
            },
        },
        sessions: {
            mySessions: "My Sessions",
            mySessionsDesc: "View and manage your active sessions connected to your account.",
            allSessions: "All Sessions",
            sessionManagement: "Session Management",
            allSessionsDesc: "View and manage all active sessions in the system.",
            noActiveSessions: "No active sessions found",
            currentSession: "Current Session",
            lastAccess: "Last Access",
            createdAt: "Created",
            revoke: "Revoke",
            revokeConfirm: "Are you sure you want to revoke this session?",
            revokeAllConfirm: "Are you sure you want to revoke all other sessions?",
            revokeSuccess: "Session revoked successfully",
            revokeAllSuccess: "All sessions revoked successfully",
            revokeFailed: "Failed to revoke session",
            revokeAllOther: "Revoke All Other Sessions",
            unknownLocation: "Unknown Location",
            unknownDevice: "Unknown Device",
            filterByUser: "Filter by user",
            mobile: "Mobile",
            supsisMobileApp: "Supsis Mobile App",
            httpClient: "HTTP Client",
            unknown: "Unknown",
            ios: "iOS",
            android: "Android",
        },
        contactModuleRules: {
            title: "Contact Module Rules",
            description: "Define automatic actions when a customer card is created or chat is opened",
            active: "Active",
            passive: "Passive",
            when: "When:",
            conditions: "Conditions:",
            actions: "Actions:",
            elseTitle: "Else (When No Rule Matches)",
            noActionsDefined: "No actions defined",
            addNewRule: "Add New Rule",
            rulesDisabled: "Contact Module Rules Disabled",
            enableHint: "Turn on the switch above to enable automatic actions",
            rulesEnabledSuccess: "Contact module rules enabled",
            rulesDisabledSuccess: "Contact module rules disabled",
            ruleEnabledSuccess: "Rule enabled",
            ruleDisabledSuccess: "Rule disabled",
            ruleUpdateError: "Error updating rule",
            orderUpdatedSuccess: "Rule order updated",
            orderUpdateError: "Error updating order",
            ruleNameTemplate: "Rule {n}",
            ruleSavedSuccess: "Rule saved",
            ruleSaveError: "Error saving rule",
            deleteRuleTitle: "Delete Rule",
            deleteRuleConfirm: 'Are you sure you want to delete the rule "{name}"?',
            delete: "Delete",
            ruleDeletedSuccess: "Rule deleted",
            ruleDeleteError: "Error deleting rule",
            elseActionsSavedSuccess: "Else actions saved",
            actionsSaveError: "Error saving actions",
            whenContactCreated: "When Customer Card Created",
            whenChatOpened: "When Chat Opened",
            noCondition: "No condition",
            and: "and",
            or: "or",
            AND: "AND",
            OR: "OR",
            fieldNotSelected: "Field not selected",
            noAction: "No action",
            doNothing: "Do nothing",
            assignToOwnerless: "unassigned",
            assignOwnerlessAction: "Assign to <strong>{ownerless}</strong>",
            assignTo: "assign to",
            assignToUser: "Assign to <strong>{name}</strong>",
            unknown: "Unknown",
            leastContact: "Least conversations",
            roundRobin: "Round robin",
            today: "today",
            last7Days: "last 7 days",
            last30Days: "last 30 days",
            channelAccessUsers: "users with channel access",
            usersCount: "{n} users",
            allUsers: "all users",
            random: "Random",
            algorithmic: "Algorithmic",
            addTagNotSelected: "Add tag (not selected)",
            tagsLabel: "tags",
            tagLabel: "tag",
            addDepartmentNotSelected: "Add department (not selected)",
            addDepartmentTo: "department",
            applyToConversation: "(also apply to conversation)",
            updatePropertyNotSelected: "Update property (not selected)",
            changeOwner: "Change Owner",
            addTag: "Add Tag",
            addDepartment: "Add Department",
            updateProperty: "Update Property",
            yes: "Yes",
            no: "No",
            fields: {
                fullname: "Name",
                email: "Email",
                phone: "Phone",
                whatsappNumber: "WhatsApp",
                whatsappCountry: "WhatsApp Country",
                platform: "Platform",
                ownerExists: "Owner",
                ownerIsOnline: "Owner Online",
                ownerStatus: "Owner Status",
                uptime: "Age (min)",
                tags: "Tags",
                channel: "Channel",
                preferredDepartment: "Department",
                hour: "Hour",
                day: "Day",
                conversationStatus: "Chat Status",
                conversationSubject: "Chat Department",
            },
            operators: {
                equals: "equals",
                not_equals: "not equals",
                contains: "contains",
                not_contains: "does not contain",
                gt: "greater than",
                gte: "≥",
                lt: "less than",
                lte: "≤",
                in: "contains",
                not_in: "does not contain",
                exists: "exists",
                not_exists: "does not exist",
            },
            ruleEditor: {
                editTitle: "Edit Rule",
                createTitle: "Create New Rule",
                stepWhen: "When?",
                stepConditions: "Conditions",
                stepActions: "Actions",
                whenQuestion: "When Should the Rule Run?",
                ruleName: "Rule Name",
                ruleNamePlaceholder: "Enter a name for the rule",
                contactCreatedTitle: "When Customer Card Created",
                contactCreatedDesc: "Runs when a new customer record is created",
                chatOpenedTitle: "When Chat Opened",
                chatOpenedDesc: "Runs when the customer starts a new conversation",
                conditionsQuestion: "What Conditions Must Be Met?",
                actionsQuestion: "What Actions Should Run?",
                back: "Back",
                cancel: "Cancel",
                next: "Next",
                save: "Save",
                newRule: "New Rule",
            },
            elseEditor: {
                title: "Edit Else Actions",
                description: "Define default actions to run when no rule matches",
            },
            ruleTester: {
                title: "Test Rule",
                description: "You can test how many contacts your rule will match",
                selectRule: "Select Rule",
                selectRulePlaceholder: "Select the rule to test",
                test: "Test",
                ruleInfo: "Rule Information",
                conditionCount: "Condition Count:",
                actionCount: "Action Count:",
                ruleNotFound: "Rule not found",
                testComingSoon: "Test feature coming soon. You can currently only view rule information.",
                testError: "Error during test",
            },
            filterBuilder: {
                noConditions: "No conditions added yet",
                addFirstCondition: "Add First Condition",
                groupTitle: "Group {n}",
                deleteGroup: "Delete Group",
                if: "If",
                selectField: "select field",
                operator: "operator",
                select: "select",
                selectValue: "select value",
                enterValue: "enter value",
                addCondition: "Add condition",
                addFilterGroup: "Add Filter Group",
                andOption: "and",
                orOption: "or",
                fieldLabels: {
                    fullname: "Contact Name",
                    email: "Contact Email",
                    phone: "Contact Phone",
                    whatsappNumber: "Contact WhatsApp Number",
                    whatsappCountry: "Contact WhatsApp Country",
                    platform: "Contact Platform",
                    ownerExists: "Contact Has Owner",
                    ownerIsOnline: "Contact Owner Online",
                    ownerStatus: "Contact Owner Status",
                    uptime: "Contact Age (minutes)",
                    tags: "Contact Tags",
                    channel: "Contact Channel",
                    preferredDepartment: "Contact Preferred Department",
                    hour: "Current Hour",
                    day: "Current Day",
                    conversationStatus: "Conversation Status",
                    conversationSubject: "Conversation Department",
                },
                operators: {
                    equals: "equals",
                    not_equals: "not equals",
                    contains: "contains",
                    not_contains: "does not contain",
                    gt: "greater than",
                    gte: "greater or equal",
                    lt: "less than",
                    lte: "less or equal",
                    between: "between",
                    exists: "exists",
                    not_exists: "does not exist",
                    in: "contains",
                    not_in: "does not contain",
                },
            },
            actionsEditor: {
                noActions: "No actions added yet",
                addFirstAction: "Add First Action",
                actionNumber: "Action {n}",
                actionType: "Action Type",
                addAction: "Add Action",
            },
            changeOwnerConfig: {
                method: "Assignment Method",
                static: "Static",
                algorithmic: "Algorithmic",
                random: "Random",
                userSelect: "User Selection",
                assignOwnerless: "Assign as unassigned",
                selectUser: "Select user",
                userList: "User List",
                channelAccessUsers: "All users with channel access",
                selectUsers: "Select users",
                algorithm: "Algorithm",
                leastContact: "Least Conversations",
                roundRobin: "Round Robin",
                dateRange: "Date Range",
                today: "Today",
                last7Days: "Last 7 Days",
                last30Days: "Last 30 Days",
                onlyOnline: "Include only online users",
            },
            addTagConfig: {
                tagsToAdd: "Tags to Add",
                selectTag: "Select tag",
                selectedTagsHint: "Selected tags will be added to the contact",
            },
            addDepartmentConfig: {
                departmentSelect: "Department Selection",
                selectDepartment: "Select department",
                departmentHint: "Selected department will be added to the contact's department list",
                applyToConversation: "Also apply to conversation",
                applyToConversationHint:
                    "If enabled, the opened conversation's department will also be set to this department",
            },
            upsertContactPropertyConfig: {
                propertySelect: "Property Selection",
                selectProperty: "Select property",
                propertyHint: "Property to update or create",
                value: "Value",
                valuePlaceholder: "Enter property value",
                valueHint: "This value will be assigned to the property",
            },
        },
        taskModuleRules: {
            title: "Task Module Rules",
            description: "Define automatic actions when a task is created, updated or a comment is added",
            settingsTitle: "Task Module Rules",
            settingsDescription: "Define automatic task rules for each workflow",
            selectWorkflow: "Select Workflow",
            selectWorkflowPlaceholder: "Select workflow",
            selectWorkflowHint: "Select a workflow to edit task module rules",
            active: "Active",
            passive: "Passive",
            when: "When:",
            conditions: "Conditions:",
            actions: "Actions:",
            elseTitle: "Else (When No Rule Matches)",
            noActionsDefined: "No actions defined",
            addNewRule: "Add New Rule",
            rulesDisabled: "Task Module Rules Disabled",
            enableHint: "Turn on the switch above to enable automatic actions",
            rulesEnabledSuccess: "Task module rules enabled",
            rulesDisabledSuccess: "Task module rules disabled",
            ruleEnabledSuccess: "Rule enabled",
            ruleDisabledSuccess: "Rule disabled",
            ruleUpdateError: "Error during operation",
            orderUpdatedSuccess: "Rule order updated",
            orderUpdateError: "Error updating order",
            ruleNameTemplate: "Rule {n}",
            ruleSavedSuccess: "Rule saved",
            ruleSaveError: "Error saving rule",
            deleteRuleTitle: "Delete Rule",
            deleteRuleConfirm: 'Are you sure you want to delete the rule "{name}"?',
            delete: "Delete",
            ruleDeletedSuccess: "Rule deleted",
            ruleDeleteError: "Error deleting rule",
            elseActionsSavedSuccess: "Else actions saved",
            actionsSaveError: "Error saving actions",
            noCondition: "No condition",
            and: "and",
            or: "or",
            AND: "AND",
            OR: "OR",
            fieldNotSelected: "Field not selected",
            noAction: "No action",
            chainBadge: "Chaining",
            chainBadgeTooltip: "This rule can trigger other rules",
            automationOffBadge: "Automation Off",
            automationOffTooltip: "Not reported to Supsis Automations",
            yes: "Yes",
            no: "No",
            unknown: "Unknown",
            cancel: "Cancel",
        },
        profile: {
            subtitle: "Manage your account settings and sessions",
        },
        integrations: {
            requiredField: "This field is required",
            existingChannels: "Existing Channels",
            createNewChannel: "Create New Channel",
            channelName: "Channel Name",
            createChannel: "Create Channel",
            channelCreated: "Channel created successfully",
            channelCreateError: "An error occurred while creating the channel",
            channelActivated: "Channel activated",
            channelDeactivated: "Channel deactivated",
            channelUpdateError: "An error occurred while updating the channel",
            deleteChannelConfirm: "Delete Channel",
            deleteChannelConfirmContent: "Are you sure you want to delete the {name} channel?",
            channelDeleted: "Channel deleted successfully",
            channelDeleteError: "An error occurred while deleting the channel",
            slackIntegration: "Slack Integration",
            slackDescription: "Send messages to your Slack workspace via Supsis automation and chatbot.",
            slackSetupTitle: "Setup Steps:",
            slackStep1: "Go to api.slack.com/apps",
            slackStep2: "Select your existing Slack App or create a new one",
            slackStep3: "Click 'Incoming Webhooks' from the left menu and turn it 'On'",
            slackStep4: "Click 'Add New Webhook to Workspace' and select the channel you want to send messages to",
            slackCardDescription: "Send messages to your Slack channels via automation and chatbot",
            slackChannelNamePlaceholder: "E.g.: Support Notifications",
            slackWebhookUrl: "Webhook URL",
            slackWebhookUrlPlaceholder: "https://hooks.slack.com/services/...",
            slackWebhookUrlHelper: "Go to Slack App > Incoming Webhooks > Add New Webhook to Workspace",
            slackWebhookUrlInvalid: "Please enter a valid Slack webhook URL",
            slackDefaultChannel: "Default Channel (Optional)",
            slackDefaultChannelPlaceholder: "#general",
            slackDefaultChannelHelper: "If not specified, the channel connected to the webhook will be used",
            pushoverIntegration: "Pushover Integration",
            pushoverCardDescription: "Send push notifications to your mobile devices via automation and chatbot",
            pushoverDescription:
                "Send push notifications to your mobile devices via Supsis automation and chatbot. You can create an account and get User Key and Application Token from pushover.net.",
            pushoverChannelNamePlaceholder: "E.g.: Mobile Notifications",
            pushoverUserKey: "User Key",
            pushoverUserKeyPlaceholder: "Pushover User Key",
            pushoverUserKeyHelper: "You can get this from your pushover.net account page",
            pushoverAppToken: "App Token",
            pushoverAppTokenPlaceholder: "Pushover Application Token",
            pushoverAppTokenHelper: "You can create an application on pushover.net to get the token",
        },
        announcements: {
            menu: "Announcements",
            newAnnouncementForm: "New Announcement Registration Form",
            updateAnnouncementForm: "Announcement Update Form",
        },
        packages: {
            mostPopular: "MOST PREFERRED",
            currency: "₺",
            activePlan: "ACTIVE PLAN",
        },
        totalCost: {
            title: "SUPSIS COST",
            monthlyPayments: "Monthly Payments",
            currency: "₺",
            currencyMonthly: "₺ / Monthly",
            oneTimePayments: "One-Time Payments",
            oneTimeDiscount: "Annual Package Discount",
            currencyYearly: "₺ / Yearly",
            totalOneTimeCost: "Total Amount to be Paid at First Time",
            totalTax: "Tax ( %18 )",
            referenceCode: "Do you have a Reference Code?",
            referencePlaceholder: "Please Enter Code",
            codeButton: "Apply",
            monthlyCost: "Amount to be Withdrawn Monthly from Your Account?",
            oneTimeFullCost: "One-Time All Inclusive Amount?",
            payment: "Make Payment",
        },
        probel: {
            branchCode: "Branch Code",
            branchCodeDesc: "Type or select branch code...",
            hospitalBranchCode: "Branch Code",
            hospitalBranchCodeDesc: "Type or select branch code...",
            clinicCode: "Polyclinic Code",
            clinicCodeDesc: "Type or select polyclinic code...",
            date: "Appointment Date",
            dateDesc: "Enter or select appointment date...",
            patientToken: "Patient Token",
            patientTokenDesc: "Type or select patient token...",
            appointmentId: "Appointment Id",
            appointmentIdDesc: "Type or select appointment id...",
            identityType: "Identity Type",
            identityNumber: "Identity Number",
            name: "Patient Name",
            surname: "Patient Surname",
            gender: "Patient Gender",
            birthDay: "Patient Birth Date",
            phoneNumber: "Patient Phone Number",
            identityTypeDesc: "Type or select identity type...",
            identityNumberDesc: "Type or select identity number...",
            nameDesc: "Type or select patient name...",
            surnameDesc: "Type or select patient surname...",
            genderDesc: "Type or select patient gender...",
            birthDayDesc: "Type or select patient birth date...",
            phoneNumberDesc: "Type or select patient phone number...",
        },
        "At the end of the month, an invoice will be created according to your usage amount": {
            "": "#VALUE!",
        },
        "No money will be withdrawn from your account": {
            "": "#VALUE!",
        },
        "Would you like to make default this story?": "#VALUE!",
        addWebhook: "Add Webhook",
        allIntegrations: "All Integrations",
        editWebhook: "Edit Webhook",
        integrateYourCBwithChatGpt3: "Chatbot can be integrated with GPT-4. GPT-4 API key required.",
        integrateYourCBwithChatWidget: "Integrate your chatbot with the chat widget.",
        integrateYourCBwithIntegratable: "Easily pass chat information between ChatBot and {integratable}.",
        integrateYourCBwithWebHook: "Easily pass chat information between ChatBot and your web services.",
        newWebhook: "New Webhook",
        shouldAddMethod:
            "You must fill in the Payment Method and Billing Address fields!\nNo money will be withdrawn from your account.\nAt the end of the month, an invoice will be created according to your usage amount.",
        webhookPassword: "Webhook Password",
        webhookTitle: "Webhook Title",
        webhookToken: "Webhook Token",
        webhookUrl: "Webhook URL",
        webhookUsername: "Webhook Username",
        "{contentOfChatBubble}": "#VALUE!",
        task_reports: {
            title: "Task Reports",
            date: "Date",
            workflow: "Workflow",
            select: "Select",
            agent: "Agent",
            all: "All",
            select_workflow_to_view_reports: "Select a workflow to view reports.",
            created_task: "Created Task",
            updated_task: "Updated Task",
            assigned_tasks_by_personnel: "Assigned Tasks by Personnel",
            assigned_task: "Assigned Task",
            no_assigned_task_found_in_date_range: "No assigned tasks found in the selected date range.",
            updated_tasks: "Updated Tasks",
            task: "Task",
            current_stage: "Current Stage",
            assigned: "Assigned",
            update: "Update",
            no_updated_task_found_in_date_range: "No updated tasks found in the selected date range.",
            task_distribution_by_agent: "Task Distribution by Agent",
            total: "Total",
            no_assigned_task_found: "No assigned tasks found.",
            timeline: "Timeline",
            unassigned_tasks: "Unassigned Tasks",
            transition_process: "Transition Process",
            no_active_task_found_for_agent: "No active tasks found for this agent.",
            select_agent_to_view_timeline: "Select an agent to view the timeline.",
            entry: "Entry",
            exit: "Exit",
            still_in_this_stage: "Still in this stage",
            duration: "Duration",
            day: "day",
            hour: "hour",
            max_30_days_range_warning: "You can select a date range of up to 30 days.",
            today: "Today",
            this_week: "This Week",
            this_month: "This Month",
            last_month: "Last Month",
            unknown: "Unknown",
            unassigned: "Unassigned",
            gantt: "Gantt",
            table: "Table",
        },
    },
};

export default messagesEN;
